/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * CloudQuery Platform OpenAPI Spec
 * Welcome to the CloudQuery Platform API documentation! This API can be used to interact with the CloudQuery platform. As a user, the API allows you to search the CloudQuery asset inventory, run SQL queries against the data warehouse, save and load searches, and much more. As an administrator, it allows you to manage your teams, syncs, and other objects.
### Authentication
The API is secured using bearer tokens. To get started, you can generate an API key for your Platform deployment from your platform dashboard. For a step-by-step guide, see: https://www.cloudquery.io/docs/cli/managing-cloudquery/deployments/generate-api-key.
The base URL for the API depends on where your CloudQuery Platform is hosted. If running locally, this is usually http://localhost:3000/api. In a production deployment it should be an HTTPS URL. For purposes of illustration, we will assume the platform instance is available at https://cloudquery.mycompany.com. In this case, the base API endpoint will be https://cloudquery.mycompany.com/api.
### Example Request
To test your connection to the API, we can use the `/plugins` endpoint. For example:
`curl -v -H "Authorization: Bearer $CLOUDQUERY_API_KEY" \ https://cloudquery.mycompany.com/api/plugins`

 * OpenAPI spec version: 1.0.0
 */

//@ts-nocheck 

 import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PlatformAPIKey,
  PlatformAcceptTeamInvitationBody,
  PlatformAddLocalUserBody,
  PlatformAlertCreate,
  PlatformAssetViewGetStatus200,
  PlatformAssetViewListLogs200,
  PlatformAssetViewListLogsParams,
  PlatformAuditLogEvent,
  PlatformAuthRegistryRequestParams,
  PlatformAuthenticateLocalUser200,
  PlatformAuthenticateLocalUserBody,
  PlatformBadRequestResponse,
  PlatformBatchTableSchemasTeam200,
  PlatformBatchTableSchemasTeamParams,
  PlatformChangeLocalUserPasswordBody,
  PlatformConflictResponse,
  PlatformConnector,
  PlatformConnectorAuthFinishRequestAWS,
  PlatformConnectorAuthFinishRequestOAuth,
  PlatformConnectorAuthRequestAWS,
  PlatformConnectorAuthRequestGCP,
  PlatformConnectorAuthRequestOAuth,
  PlatformConnectorAuthResponseAWS,
  PlatformConnectorAuthResponseGCP,
  PlatformConnectorAuthResponseOAuth,
  PlatformConnectorCreate,
  PlatformConnectorUpdate,
  PlatformConversation,
  PlatformConversationCreate,
  PlatformConversationMessage,
  PlatformConversationSendMessage,
  PlatformCreateAWSOnboardingBody,
  PlatformCreateLocalUserResetToken200,
  PlatformCreateOrUpdatePolicy,
  PlatformCreatePluginVersionBody,
  PlatformCreatePluginVersionDocs201,
  PlatformCreatePluginVersionDocsBody,
  PlatformCreatePluginVersionTables201,
  PlatformCreatePluginVersionTablesBody,
  PlatformCreatePolicy201,
  PlatformCreateReport201,
  PlatformCreateReportTemplate201,
  PlatformCreateSyncDestinationTestConnectionV2,
  PlatformCreateSyncDestinationV2,
  PlatformCreateSyncRunProgressBody,
  PlatformCreateTeamAPIKeyBody,
  PlatformCreateTeamBody,
  PlatformCreateTeamImages201,
  PlatformCreateTeamImagesBody,
  PlatformCreateUserToken201,
  PlatformCustomColumn,
  PlatformCustomColumnCreateOrUpdate,
  PlatformCustomColumnDataImport,
  PlatformCustomColumnDataValues,
  PlatformDeletePluginVersionDocsBody,
  PlatformDeletePluginVersionTablesBody,
  PlatformDeleteTeamInvitationBody,
  PlatformDockerErrorResponse,
  PlatformExecuteAdHocQueryTeam200,
  PlatformExecuteAdHocQueryTeamBody,
  PlatformExecuteAdHocQueryTeamParams,
  PlatformExecuteSavedQueryTeam200,
  PlatformExecuteSavedQueryTeamParams,
  PlatformFilter,
  PlatformFilterCreate,
  PlatformFilterUpdate,
  PlatformFinalizePluginUIAssetUploadBody,
  PlatformForbiddenResponse,
  PlatformGetConnectorAuthStatusAWS200,
  PlatformGetConnectorAuthStatusGCP200,
  PlatformGetCurrentUser200,
  PlatformGetCurrentUser401,
  PlatformGetCurrentUserMemberships200,
  PlatformGetCurrentUserMembershipsParams,
  PlatformGetGroupedTeamUsageSummaryParams,
  PlatformGetNotificationDestinationAlerts200,
  PlatformGetNotificationDestinationAlertsParams,
  PlatformGetOpenAPIJSON200,
  PlatformGetPlatformInfo200,
  PlatformGetPolicy200,
  PlatformGetPolicyViolationsHistory200,
  PlatformGetPolicyViolationsHistoryParams,
  PlatformGetReport200,
  PlatformGetReportTemplate200,
  PlatformGetSyncDestinationTestConnectionLogs200One,
  PlatformGetSyncDestinationTestConnectionLogsQuery200One,
  PlatformGetSyncDestinationTestConnectionLogsQueryParams,
  PlatformGetSyncRunConnectorCredentials200,
  PlatformGetSyncRunConnectorIdentity200,
  PlatformGetSyncRunLogs200One,
  PlatformGetSyncRunLogsLiveParams,
  PlatformGetSyncRunLogsParams,
  PlatformGetSyncRunLogsQuery200One,
  PlatformGetSyncRunLogsQueryParams,
  PlatformGetSyncRunTables200,
  PlatformGetSyncRunTablesParams,
  PlatformGetSyncSourceTestConnectionLogs200One,
  PlatformGetSyncSourceTestConnectionLogsQuery200One,
  PlatformGetSyncSourceTestConnectionLogsQueryParams,
  PlatformGetTeamMemberships200,
  PlatformGetTeamMembershipsParams,
  PlatformGetTeamUsageSummaryParams,
  PlatformGetTestConnectionConnectorCredentials200,
  PlatformGetTestConnectionConnectorIdentity200,
  PlatformGetV2SyncDestinations200,
  PlatformGetV2SyncDestinationsParams,
  PlatformImageURL,
  PlatformIndex400,
  PlatformInternalErrorResponse,
  PlatformListAllAlerts200,
  PlatformListAllAlertsParams,
  PlatformListAllCustomColumns200,
  PlatformListAllCustomColumnsParams,
  PlatformListAllFrameworks200,
  PlatformListAllFrameworksParams,
  PlatformListAllNotificationDestinations200,
  PlatformListAllNotificationDestinationsParams,
  PlatformListAllQueriesTeam200,
  PlatformListAllQueriesTeamParams,
  PlatformListAllRBACPermissions200,
  PlatformListAllRBACPermissionsParams,
  PlatformListAllRBACRoles200,
  PlatformListAllRBACRolesParams,
  PlatformListAuditLogs200,
  PlatformListAuditLogsParams,
  PlatformListConnectors200,
  PlatformListConnectorsParams,
  PlatformListCurrentUserInvitations200,
  PlatformListCurrentUserInvitationsParams,
  PlatformListFilterTagsTeam200,
  PlatformListFilterTagsTeamParams,
  PlatformListFiltersTeam200,
  PlatformListFiltersTeamParams,
  PlatformListLocalUsers200,
  PlatformListLocalUsersParams,
  PlatformListPlatformVersions200,
  PlatformListPlatformVersionsParams,
  PlatformListPlugin,
  PlatformListPluginVersionDocs200,
  PlatformListPluginVersionDocsParams,
  PlatformListPluginVersionTables200,
  PlatformListPluginVersionTablesParams,
  PlatformListPluginVersions200,
  PlatformListPluginVersionsParams,
  PlatformListPlugins200,
  PlatformListPluginsByTeam200,
  PlatformListPluginsByTeamParams,
  PlatformListPluginsParams,
  PlatformListPolicies200,
  PlatformListPoliciesParams,
  PlatformListPolicyFrameworks200,
  PlatformListPolicyFrameworksParams,
  PlatformListPolicyRuleDetails200,
  PlatformListPolicyRuleDetailsParams,
  PlatformListPolicyRules200,
  PlatformListPolicyRulesParams,
  PlatformListQueryTagsTeam200,
  PlatformListQueryTagsTeamParams,
  PlatformListReportTemplates200,
  PlatformListReportTemplatesParams,
  PlatformListReports200,
  PlatformListReportsParams,
  PlatformListSyncDestinationSyncs200,
  PlatformListSyncDestinationSyncsParams,
  PlatformListSyncDestinations200,
  PlatformListSyncDestinationsParams,
  PlatformListSyncRuns200,
  PlatformListSyncRunsParams,
  PlatformListSyncSourceSyncs200,
  PlatformListSyncSourceSyncsParams,
  PlatformListSyncSources200,
  PlatformListSyncSourcesParams,
  PlatformListSyncTransformerSyncDestinations200,
  PlatformListSyncTransformerSyncDestinationsParams,
  PlatformListSyncTransformerSyncs200,
  PlatformListSyncTransformerSyncsParams,
  PlatformListSyncTransformers200,
  PlatformListSyncTransformersParams,
  PlatformListSyncUpgrades200,
  PlatformListSyncUpgradesParams,
  PlatformListSyncs200,
  PlatformListSyncsParams,
  PlatformListTablesTeam200,
  PlatformListTablesTeamParams,
  PlatformListTeamAPIKeys200,
  PlatformListTeamAPIKeysParams,
  PlatformListTeamInvitations200,
  PlatformListTeamInvitationsParams,
  PlatformListTeams200,
  PlatformListTeamsParams,
  PlatformListUsersByTeam200,
  PlatformListUsersByTeamParams,
  PlatformListV2SyncIntegrations200,
  PlatformListV2SyncIntegrationsParams,
  PlatformLocalUser,
  PlatformLocalUserWithTeams,
  PlatformLoginUserBody,
  PlatformManageAddTeamMemberBody,
  PlatformManageGetPlatformRegistry200,
  PlatformManageListAllTeams200,
  PlatformManageListAllTeamsParams,
  PlatformManageListTeamMembers200,
  PlatformManageListTeamMembersParams,
  PlatformManageRegisterPlatform200,
  PlatformManageRegisterPlatform205,
  PlatformManageRegisterPlatformBody,
  PlatformManageRegisterPlatformWithOfflineLicense200,
  PlatformManageRegisterPlatformWithOfflineLicenseBody,
  PlatformManageRemoveTeamMemberBody,
  PlatformMembershipWithTeam,
  PlatformMethodNotAllowedResponse,
  PlatformNotFoundResponse,
  PlatformNotificationDestination,
  PlatformNotificationDestinationCreate,
  PlatformNotificationDestinationData,
  PlatformNotificationDestinationTestResponse,
  PlatformNotificationDestinationUpdate,
  PlatformOnboardingAWS,
  PlatformOnboardingAWSAccounts,
  PlatformOnboardingAWSCreateResponse,
  PlatformOnboardingAWSNotification,
  PlatformOnboardingAWSProvision,
  PlatformPlugin,
  PlatformPluginAsset,
  PlatformPluginCreate,
  PlatformPluginTableDetails,
  PlatformPluginUpdate,
  PlatformPluginVersion,
  PlatformPluginVersionDetails,
  PlatformPluginVersionUpdate,
  PlatformPromoteSyncDestinationTestConnection,
  PlatformPromoteSyncSourceTestConnection,
  PlatformPutCustomColumnData202,
  PlatformPutCustomColumnValues200,
  PlatformQueryCreate,
  PlatformQueryDetail,
  PlatformQueryListFilterTagsTeam200,
  PlatformQueryListFilterTagsTeamParams,
  PlatformQueryListFiltersTeam200,
  PlatformQueryListFiltersTeamParams,
  PlatformQueryUpdate,
  PlatformRBACPermission,
  PlatformRBACPermissionCreate,
  PlatformRBACPermissionUpdate,
  PlatformRBACRole,
  PlatformRBACRoleCreate,
  PlatformRBACRoleUpdate,
  PlatformRegistryAuthToken,
  PlatformReleaseURL,
  PlatformRemoveTeamMembershipBody,
  PlatformReplacePluginVersionDocs201,
  PlatformReplacePluginVersionDocsBody,
  PlatformReportCreate,
  PlatformReportTemplateCreateOrUpdate,
  PlatformReportUpdate,
  PlatformRequiresAuthenticationResponse,
  PlatformResetLocalUserPasswordBody,
  PlatformSAMLConfig,
  PlatformSAMLConfigUpdate,
  PlatformSendAnonymousEventBody,
  PlatformSendUserEventBody,
  PlatformServiceUnavailableResponse,
  PlatformSettings,
  PlatformSettingsUpdate,
  PlatformSync,
  PlatformSyncCreate,
  PlatformSyncDestination,
  PlatformSyncDestinationTestConnection,
  PlatformSyncDestinationTestConnectionCreate,
  PlatformSyncDestinationTestConnectionV2,
  PlatformSyncDestinationUpdate,
  PlatformSyncDestinationUpdateV2,
  PlatformSyncDestinationV2,
  PlatformSyncIntegrationCreateV2,
  PlatformSyncIntegrationExpandedV2,
  PlatformSyncIntegrationTestConnectionCreateV2,
  PlatformSyncIntegrationTestConnectionV2,
  PlatformSyncIntegrationUpdateV2,
  PlatformSyncIntegrationV2,
  PlatformSyncRun,
  PlatformSyncRunDetails,
  PlatformSyncRunStats,
  PlatformSyncSource,
  PlatformSyncSourceTestConnection,
  PlatformSyncSourceTestConnectionCreate,
  PlatformSyncSourceUpdate,
  PlatformSyncTestConnection,
  PlatformSyncTransformer,
  PlatformSyncTransformerUpdate,
  PlatformSyncUpdate,
  PlatformTableColumnListValuesTeam200,
  PlatformTableColumnListValuesTeamParams,
  PlatformTableListColumnsTeam200,
  PlatformTableListColumnsTeamParams,
  PlatformTableListFilterTagsTeam200,
  PlatformTableListFilterTagsTeamParams,
  PlatformTableListFiltersTeam200,
  PlatformTableListFiltersTeamParams,
  PlatformTableListRelationsTeam200,
  PlatformTableListRelationsTeamParams,
  PlatformTableListRowsTeam200,
  PlatformTableListRowsTeamParams,
  PlatformTableRowByIdTeam200,
  PlatformTableRowByIdTeamParams,
  PlatformTableSchemaTeam200,
  PlatformTeam,
  PlatformTestUnsavedAlert200,
  PlatformTestUnsavedAlertParams,
  PlatformTogglePolicyParams,
  PlatformTooManyRequestsResponse,
  PlatformUnprocessableEntityResponse,
  PlatformUpdateCurrentUserBody,
  PlatformUpdateCustomerBody,
  PlatformUpdateLocalUserBody,
  PlatformUpdatePolicy200,
  PlatformUpdateReport200,
  PlatformUpdateReportTemplate200,
  PlatformUpdateSyncRunBody,
  PlatformUpdateSyncTestConnectionForSyncDestinationBody,
  PlatformUpdateSyncTestConnectionForSyncSourceBody,
  PlatformUpdateTeamBody,
  PlatformUploadImageBody,
  PlatformUploadPluginUIAssets201,
  PlatformUploadPluginUIAssetsBody,
  PlatformUsageSummary,
  PlatformUser,
  PlatformUserTOTPSetup200,
  PlatformUserTOTPVerifyBody
} from './models';

import {
  faker
} from '@faker-js/faker';

import {
  HttpResponse,
  delay,
  http
} from 'msw';
import type {
  RequestHandlerOptions
} from 'msw';

import {
  PlatformAPIKeyRole,
  PlatformAlertSeverity,
  PlatformAlertState,
  PlatformAssetViewRunType,
  PlatformConnectorStatus,
  PlatformCustomColumnColumnType,
  PlatformCustomColumnValueType,
  PlatformLocalUserProvider,
  PlatformPluginCategory,
  PlatformPluginKind,
  PlatformPluginPackageType,
  PlatformPluginPriceCategory,
  PlatformPluginReleaseStage,
  PlatformPluginTier,
  PlatformRBACDefaultRole,
  PlatformSyncDestinationMigrateMode,
  PlatformSyncDestinationWriteMode,
  PlatformSyncLastUpdateSource,
  PlatformSyncRunStatus,
  PlatformSyncRunStatusReason,
  PlatformSyncRunWorkerPhase,
  PlatformSyncTestConnectionStatus,
  PlatformTableSchemaColumnKind,
  PlatformTeamPlan
} from './models';

import { customFetch } from '../../../custom-fetch/src/customFetch';
type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Index endpoint, returns 200
 */
export const getPlatformIndexUrl = () => {




  return `/`
}

export const platformIndex = async ( options?: RequestInit) => {

  return customFetch<void>(getPlatformIndexUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformIndexQueryKey = () => {
    return [
    `/`
    ] as const;
    }


export const getPlatformIndexQueryOptions = <TData = Awaited<ReturnType<typeof platformIndex>>, TError = PlatformIndex400>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformIndex>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformIndexQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformIndex>>> = ({ signal }) => platformIndex({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformIndex>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformIndexQueryResult = NonNullable<Awaited<ReturnType<typeof platformIndex>>>
export type PlatformIndexQueryError = PlatformIndex400



export function usePlatformIndex<TData = Awaited<ReturnType<typeof platformIndex>>, TError = PlatformIndex400>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformIndex>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformIndexQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List audit log events with pagination and filtering
 */
export const getPlatformListAuditLogsUrl = (params?: PlatformListAuditLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/audit-logs?${stringifiedParams}` : `/audit-logs`
}

export const platformListAuditLogs = async (params?: PlatformListAuditLogsParams, options?: RequestInit) => {

  return customFetch<PlatformListAuditLogs200>(getPlatformListAuditLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListAuditLogsQueryKey = (params?: PlatformListAuditLogsParams,) => {
    return [
    `/audit-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof platformListAuditLogs>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(params?: PlatformListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAuditLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAuditLogs>>> = ({ signal }) => platformListAuditLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAuditLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAuditLogs>>>
export type PlatformListAuditLogsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformListAuditLogs<TData = Awaited<ReturnType<typeof platformListAuditLogs>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(
 params?: PlatformListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAuditLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a specific audit log event by ID
 */
export const getPlatformGetAuditLogUrl = (id: string,) => {




  return `/audit-logs/${id}`
}

export const platformGetAuditLog = async (id: string, options?: RequestInit) => {

  return customFetch<PlatformAuditLogEvent>(getPlatformGetAuditLogUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetAuditLogQueryKey = (id: string,) => {
    return [
    `/audit-logs/${id}`
    ] as const;
    }


export const getPlatformGetAuditLogQueryOptions = <TData = Awaited<ReturnType<typeof platformGetAuditLog>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAuditLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetAuditLogQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetAuditLog>>> = ({ signal }) => platformGetAuditLog(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetAuditLog>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetAuditLogQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetAuditLog>>>
export type PlatformGetAuditLogQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetAuditLog<TData = Awaited<ReturnType<typeof platformGetAuditLog>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAuditLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetAuditLogQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Health check endpoint, returns 200
 */
export const getPlatformHealthCheckHeadUrl = () => {




  return `/healthcheck`
}

export const platformHealthCheckHead = async ( options?: RequestInit) => {

  return customFetch<void>(getPlatformHealthCheckHeadUrl(),
  {
    ...options,
    method: 'HEAD'


  }
);}




export const getPlatformHealthCheckHeadMutationOptions = <TError = PlatformBadRequestResponse | PlatformInternalErrorResponse | PlatformServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformHealthCheckHead>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformHealthCheckHead>>, TError,void, TContext> => {

const mutationKey = ['platformHealthCheckHead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformHealthCheckHead>>, void> = () => {


          return  platformHealthCheckHead(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformHealthCheckHeadMutationResult = NonNullable<Awaited<ReturnType<typeof platformHealthCheckHead>>>

    export type PlatformHealthCheckHeadMutationError = PlatformBadRequestResponse | PlatformInternalErrorResponse | PlatformServiceUnavailableResponse

    export const usePlatformHealthCheckHead = <TError = PlatformBadRequestResponse | PlatformInternalErrorResponse | PlatformServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformHealthCheckHead>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformHealthCheckHead>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPlatformHealthCheckHeadMutationOptions(options));
    }

/**
 * Health check endpoint, returns 200
 */
export const getPlatformHealthCheckUrl = () => {




  return `/healthcheck`
}

export const platformHealthCheck = async ( options?: RequestInit) => {

  return customFetch<void>(getPlatformHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformHealthCheckQueryKey = () => {
    return [
    `/healthcheck`
    ] as const;
    }


export const getPlatformHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof platformHealthCheck>>, TError = PlatformBadRequestResponse | PlatformInternalErrorResponse | PlatformServiceUnavailableResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformHealthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformHealthCheck>>> = ({ signal }) => platformHealthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformHealthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformHealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof platformHealthCheck>>>
export type PlatformHealthCheckQueryError = PlatformBadRequestResponse | PlatformInternalErrorResponse | PlatformServiceUnavailableResponse



export function usePlatformHealthCheck<TData = Awaited<ReturnType<typeof platformHealthCheck>>, TError = PlatformBadRequestResponse | PlatformInternalErrorResponse | PlatformServiceUnavailableResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformHealthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Returns the OpenAPI definition in JSON format.
 * @summary Get OpenAPI JSON
 */
export const getPlatformGetOpenAPIJSONUrl = () => {




  return `/openapi.json`
}

export const platformGetOpenAPIJSON = async ( options?: RequestInit) => {

  return customFetch<PlatformGetOpenAPIJSON200>(getPlatformGetOpenAPIJSONUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetOpenAPIJSONQueryKey = () => {
    return [
    `/openapi.json`
    ] as const;
    }


export const getPlatformGetOpenAPIJSONQueryOptions = <TData = Awaited<ReturnType<typeof platformGetOpenAPIJSON>>, TError = PlatformBadRequestResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetOpenAPIJSON>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetOpenAPIJSONQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetOpenAPIJSON>>> = ({ signal }) => platformGetOpenAPIJSON({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetOpenAPIJSON>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetOpenAPIJSONQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetOpenAPIJSON>>>
export type PlatformGetOpenAPIJSONQueryError = PlatformBadRequestResponse


/**
 * @summary Get OpenAPI JSON
 */

export function usePlatformGetOpenAPIJSON<TData = Awaited<ReturnType<typeof platformGetOpenAPIJSON>>, TError = PlatformBadRequestResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetOpenAPIJSON>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetOpenAPIJSONQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get assetview status
 */
export const getPlatformAssetViewGetStatusUrl = () => {




  return `/manage/assetview`
}

export const platformAssetViewGetStatus = async ( options?: RequestInit) => {

  return customFetch<PlatformAssetViewGetStatus200>(getPlatformAssetViewGetStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformAssetViewGetStatusQueryKey = () => {
    return [
    `/manage/assetview`
    ] as const;
    }


export const getPlatformAssetViewGetStatusQueryOptions = <TData = Awaited<ReturnType<typeof platformAssetViewGetStatus>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewGetStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformAssetViewGetStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAssetViewGetStatus>>> = ({ signal }) => platformAssetViewGetStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewGetStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformAssetViewGetStatusQueryResult = NonNullable<Awaited<ReturnType<typeof platformAssetViewGetStatus>>>
export type PlatformAssetViewGetStatusQueryError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformAssetViewGetStatus<TData = Awaited<ReturnType<typeof platformAssetViewGetStatus>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewGetStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformAssetViewGetStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Trigger assetview run
 */
export const getPlatformAssetViewTriggerUrl = () => {




  return `/manage/assetview`
}

export const platformAssetViewTrigger = async ( options?: RequestInit) => {

  return customFetch<void>(getPlatformAssetViewTriggerUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformAssetViewTriggerMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAssetViewTrigger>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAssetViewTrigger>>, TError,void, TContext> => {

const mutationKey = ['platformAssetViewTrigger'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAssetViewTrigger>>, void> = () => {


          return  platformAssetViewTrigger(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAssetViewTriggerMutationResult = NonNullable<Awaited<ReturnType<typeof platformAssetViewTrigger>>>

    export type PlatformAssetViewTriggerMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAssetViewTrigger = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAssetViewTrigger>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAssetViewTrigger>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPlatformAssetViewTriggerMutationOptions(options));
    }

/**
 * List asset view logs
 */
export const getPlatformAssetViewListLogsUrl = (params?: PlatformAssetViewListLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["type"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/manage/assetview/logs?${stringifiedParams}` : `/manage/assetview/logs`
}

export const platformAssetViewListLogs = async (params?: PlatformAssetViewListLogsParams, options?: RequestInit) => {

  return customFetch<PlatformAssetViewListLogs200>(getPlatformAssetViewListLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformAssetViewListLogsQueryKey = (params?: PlatformAssetViewListLogsParams,) => {
    return [
    `/manage/assetview/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformAssetViewListLogsQueryOptions = <TData = Awaited<ReturnType<typeof platformAssetViewListLogs>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(params?: PlatformAssetViewListLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewListLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformAssetViewListLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAssetViewListLogs>>> = ({ signal }) => platformAssetViewListLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewListLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformAssetViewListLogsQueryResult = NonNullable<Awaited<ReturnType<typeof platformAssetViewListLogs>>>
export type PlatformAssetViewListLogsQueryError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformAssetViewListLogs<TData = Awaited<ReturnType<typeof platformAssetViewListLogs>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(
 params?: PlatformAssetViewListLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewListLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformAssetViewListLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get SAML integration information
 */
export const getPlatformManageGetSAMLUrl = () => {




  return `/manage/auth/saml`
}

export const platformManageGetSAML = async ( options?: RequestInit) => {

  return customFetch<PlatformSAMLConfig>(getPlatformManageGetSAMLUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformManageGetSAMLQueryKey = () => {
    return [
    `/manage/auth/saml`
    ] as const;
    }


export const getPlatformManageGetSAMLQueryOptions = <TData = Awaited<ReturnType<typeof platformManageGetSAML>>, TError = PlatformBadRequestResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetSAML>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformManageGetSAMLQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformManageGetSAML>>> = ({ signal }) => platformManageGetSAML({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformManageGetSAML>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformManageGetSAMLQueryResult = NonNullable<Awaited<ReturnType<typeof platformManageGetSAML>>>
export type PlatformManageGetSAMLQueryError = PlatformBadRequestResponse | PlatformInternalErrorResponse



export function usePlatformManageGetSAML<TData = Awaited<ReturnType<typeof platformManageGetSAML>>, TError = PlatformBadRequestResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetSAML>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformManageGetSAMLQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update SAML integration information
 */
export const getPlatformManageUpdateSAMLUrl = () => {




  return `/manage/auth/saml`
}

export const platformManageUpdateSAML = async (platformSAMLConfigUpdate: PlatformSAMLConfigUpdate, options?: RequestInit) => {

  return customFetch<PlatformSAMLConfig>(getPlatformManageUpdateSAMLUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSAMLConfigUpdate,)
  }
);}




export const getPlatformManageUpdateSAMLMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageUpdateSAML>>, TError,{data: PlatformSAMLConfigUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformManageUpdateSAML>>, TError,{data: PlatformSAMLConfigUpdate}, TContext> => {

const mutationKey = ['platformManageUpdateSAML'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageUpdateSAML>>, {data: PlatformSAMLConfigUpdate}> = (props) => {
          const {data} = props ?? {};

          return  platformManageUpdateSAML(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageUpdateSAMLMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageUpdateSAML>>>
    export type PlatformManageUpdateSAMLMutationBody = PlatformSAMLConfigUpdate
    export type PlatformManageUpdateSAMLMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformManageUpdateSAML = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageUpdateSAML>>, TError,{data: PlatformSAMLConfigUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageUpdateSAML>>,
        TError,
        {data: PlatformSAMLConfigUpdate},
        TContext
      > => {
      return useMutation(getPlatformManageUpdateSAMLMutationOptions(options));
    }

/**
 * Get platform registry information
 */
export const getPlatformManageGetPlatformRegistryUrl = () => {




  return `/manage/register-platform`
}

export const platformManageGetPlatformRegistry = async ( options?: RequestInit) => {

  return customFetch<PlatformManageGetPlatformRegistry200>(getPlatformManageGetPlatformRegistryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformManageGetPlatformRegistryQueryKey = () => {
    return [
    `/manage/register-platform`
    ] as const;
    }


export const getPlatformManageGetPlatformRegistryQueryOptions = <TData = Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformManageGetPlatformRegistryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>> = ({ signal }) => platformManageGetPlatformRegistry({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformManageGetPlatformRegistryQueryResult = NonNullable<Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>>
export type PlatformManageGetPlatformRegistryQueryError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse



export function usePlatformManageGetPlatformRegistry<TData = Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformManageGetPlatformRegistryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Register platform usage by API key
 */
export const getPlatformManageRegisterPlatformUrl = () => {




  return `/manage/register-platform`
}

export const platformManageRegisterPlatform = async (platformManageRegisterPlatformBody: PlatformManageRegisterPlatformBody, options?: RequestInit) => {

  return customFetch<PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205>(getPlatformManageRegisterPlatformUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformManageRegisterPlatformBody,)
  }
);}




export const getPlatformManageRegisterPlatformMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatform>>, TError,{data: PlatformManageRegisterPlatformBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatform>>, TError,{data: PlatformManageRegisterPlatformBody}, TContext> => {

const mutationKey = ['platformManageRegisterPlatform'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageRegisterPlatform>>, {data: PlatformManageRegisterPlatformBody}> = (props) => {
          const {data} = props ?? {};

          return  platformManageRegisterPlatform(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageRegisterPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageRegisterPlatform>>>
    export type PlatformManageRegisterPlatformMutationBody = PlatformManageRegisterPlatformBody
    export type PlatformManageRegisterPlatformMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformManageRegisterPlatform = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatform>>, TError,{data: PlatformManageRegisterPlatformBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageRegisterPlatform>>,
        TError,
        {data: PlatformManageRegisterPlatformBody},
        TContext
      > => {
      return useMutation(getPlatformManageRegisterPlatformMutationOptions(options));
    }

/**
 * Register platform usage by offline license
 */
export const getPlatformManageRegisterPlatformWithOfflineLicenseUrl = () => {




  return `/manage/register-platform/offline`
}

export const platformManageRegisterPlatformWithOfflineLicense = async (platformManageRegisterPlatformWithOfflineLicenseBody: PlatformManageRegisterPlatformWithOfflineLicenseBody, options?: RequestInit) => {

  return customFetch<PlatformManageRegisterPlatformWithOfflineLicense200>(getPlatformManageRegisterPlatformWithOfflineLicenseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformManageRegisterPlatformWithOfflineLicenseBody,)
  }
);}




export const getPlatformManageRegisterPlatformWithOfflineLicenseMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>, TError,{data: PlatformManageRegisterPlatformWithOfflineLicenseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>, TError,{data: PlatformManageRegisterPlatformWithOfflineLicenseBody}, TContext> => {

const mutationKey = ['platformManageRegisterPlatformWithOfflineLicense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>, {data: PlatformManageRegisterPlatformWithOfflineLicenseBody}> = (props) => {
          const {data} = props ?? {};

          return  platformManageRegisterPlatformWithOfflineLicense(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageRegisterPlatformWithOfflineLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>>
    export type PlatformManageRegisterPlatformWithOfflineLicenseMutationBody = PlatformManageRegisterPlatformWithOfflineLicenseBody
    export type PlatformManageRegisterPlatformWithOfflineLicenseMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformManageRegisterPlatformWithOfflineLicense = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>, TError,{data: PlatformManageRegisterPlatformWithOfflineLicenseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>,
        TError,
        {data: PlatformManageRegisterPlatformWithOfflineLicenseBody},
        TContext
      > => {
      return useMutation(getPlatformManageRegisterPlatformWithOfflineLicenseMutationOptions(options));
    }

/**
 * Show current platform settings
 */
export const getPlatformGetSettingsUrl = () => {




  return `/manage/settings`
}

export const platformGetSettings = async ( options?: RequestInit) => {

  return customFetch<PlatformSettings>(getPlatformGetSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSettingsQueryKey = () => {
    return [
    `/manage/settings`
    ] as const;
    }


export const getPlatformGetSettingsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSettings>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSettings>>> = ({ signal }) => platformGetSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSettings>>>
export type PlatformGetSettingsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSettings<TData = Awaited<ReturnType<typeof platformGetSettings>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update platform settings
 */
export const getPlatformUpdateSettingsUrl = () => {




  return `/manage/settings`
}

export const platformUpdateSettings = async (platformSettingsUpdate: PlatformSettingsUpdate, options?: RequestInit) => {

  return customFetch<PlatformSettings>(getPlatformUpdateSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSettingsUpdate,)
  }
);}




export const getPlatformUpdateSettingsMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSettings>>, TError,{data: PlatformSettingsUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSettings>>, TError,{data: PlatformSettingsUpdate}, TContext> => {

const mutationKey = ['platformUpdateSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSettings>>, {data: PlatformSettingsUpdate}> = (props) => {
          const {data} = props ?? {};

          return  platformUpdateSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSettings>>>
    export type PlatformUpdateSettingsMutationBody = PlatformSettingsUpdate
    export type PlatformUpdateSettingsMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSettings = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSettings>>, TError,{data: PlatformSettingsUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSettings>>,
        TError,
        {data: PlatformSettingsUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateSettingsMutationOptions(options));
    }

/**
 * List all teams
 */
export const getPlatformManageListAllTeamsUrl = (params?: PlatformManageListAllTeamsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/manage/teams?${stringifiedParams}` : `/manage/teams`
}

export const platformManageListAllTeams = async (params?: PlatformManageListAllTeamsParams, options?: RequestInit) => {

  return customFetch<PlatformManageListAllTeams200>(getPlatformManageListAllTeamsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformManageListAllTeamsQueryKey = (params?: PlatformManageListAllTeamsParams,) => {
    return [
    `/manage/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformManageListAllTeamsQueryOptions = <TData = Awaited<ReturnType<typeof platformManageListAllTeams>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(params?: PlatformManageListAllTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageListAllTeams>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformManageListAllTeamsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformManageListAllTeams>>> = ({ signal }) => platformManageListAllTeams(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformManageListAllTeams>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformManageListAllTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof platformManageListAllTeams>>>
export type PlatformManageListAllTeamsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformManageListAllTeams<TData = Awaited<ReturnType<typeof platformManageListAllTeams>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 params?: PlatformManageListAllTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageListAllTeams>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformManageListAllTeamsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a team
 */
export const getPlatformManageGetTeamUrl = (teamName: string,) => {




  return `/manage/teams/${teamName}`
}

export const platformManageGetTeam = async (teamName: string, options?: RequestInit) => {

  return customFetch<PlatformTeam>(getPlatformManageGetTeamUrl(teamName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformManageGetTeamQueryKey = (teamName: string,) => {
    return [
    `/manage/teams/${teamName}`
    ] as const;
    }


export const getPlatformManageGetTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformManageGetTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformManageGetTeamQueryKey(teamName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformManageGetTeam>>> = ({ signal }) => platformManageGetTeam(teamName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformManageGetTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformManageGetTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformManageGetTeam>>>
export type PlatformManageGetTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformManageGetTeam<TData = Awaited<ReturnType<typeof platformManageGetTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformManageGetTeamQueryOptions(teamName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Delete a team
 */
export const getPlatformManageDeleteTeamUrl = (teamName: string,) => {




  return `/manage/teams/${teamName}`
}

export const platformManageDeleteTeam = async (teamName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformManageDeleteTeamUrl(teamName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformManageDeleteTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageDeleteTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformManageDeleteTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['platformManageDeleteTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageDeleteTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  platformManageDeleteTeam(teamName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageDeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageDeleteTeam>>>

    export type PlatformManageDeleteTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformManageDeleteTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageDeleteTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageDeleteTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {
      return useMutation(getPlatformManageDeleteTeamMutationOptions(options));
    }

/**
 * List team members
 */
export const getPlatformManageListTeamMembersUrl = (teamName: string,
    params?: PlatformManageListTeamMembersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/manage/teams/${teamName}/members?${stringifiedParams}` : `/manage/teams/${teamName}/members`
}

export const platformManageListTeamMembers = async (teamName: string,
    params?: PlatformManageListTeamMembersParams, options?: RequestInit) => {

  return customFetch<PlatformManageListTeamMembers200>(getPlatformManageListTeamMembersUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformManageListTeamMembersQueryKey = (teamName: string,
    params?: PlatformManageListTeamMembersParams,) => {
    return [
    `/manage/teams/${teamName}/members`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformManageListTeamMembersQueryOptions = <TData = Awaited<ReturnType<typeof platformManageListTeamMembers>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformManageListTeamMembersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageListTeamMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformManageListTeamMembersQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformManageListTeamMembers>>> = ({ signal }) => platformManageListTeamMembers(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformManageListTeamMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformManageListTeamMembersQueryResult = NonNullable<Awaited<ReturnType<typeof platformManageListTeamMembers>>>
export type PlatformManageListTeamMembersQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformManageListTeamMembers<TData = Awaited<ReturnType<typeof platformManageListTeamMembers>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformManageListTeamMembersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageListTeamMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformManageListTeamMembersQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Add team member
 */
export const getPlatformManageAddTeamMemberUrl = (teamName: string,) => {




  return `/manage/teams/${teamName}/members`
}

export const platformManageAddTeamMember = async (teamName: string,
    platformManageAddTeamMemberBody: PlatformManageAddTeamMemberBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformManageAddTeamMemberUrl(teamName),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformManageAddTeamMemberBody,)
  }
);}




export const getPlatformManageAddTeamMemberMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageAddTeamMember>>, TError,{teamName: string;data: PlatformManageAddTeamMemberBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformManageAddTeamMember>>, TError,{teamName: string;data: PlatformManageAddTeamMemberBody}, TContext> => {

const mutationKey = ['platformManageAddTeamMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageAddTeamMember>>, {teamName: string;data: PlatformManageAddTeamMemberBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformManageAddTeamMember(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageAddTeamMemberMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageAddTeamMember>>>
    export type PlatformManageAddTeamMemberMutationBody = PlatformManageAddTeamMemberBody
    export type PlatformManageAddTeamMemberMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformManageAddTeamMember = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageAddTeamMember>>, TError,{teamName: string;data: PlatformManageAddTeamMemberBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageAddTeamMember>>,
        TError,
        {teamName: string;data: PlatformManageAddTeamMemberBody},
        TContext
      > => {
      return useMutation(getPlatformManageAddTeamMemberMutationOptions(options));
    }

/**
 * Remove team member
 */
export const getPlatformManageRemoveTeamMemberUrl = (teamName: string,) => {




  return `/manage/teams/${teamName}/members`
}

export const platformManageRemoveTeamMember = async (teamName: string,
    platformManageRemoveTeamMemberBody: PlatformManageRemoveTeamMemberBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformManageRemoveTeamMemberUrl(teamName),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformManageRemoveTeamMemberBody,)
  }
);}




export const getPlatformManageRemoveTeamMemberMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRemoveTeamMember>>, TError,{teamName: string;data: PlatformManageRemoveTeamMemberBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformManageRemoveTeamMember>>, TError,{teamName: string;data: PlatformManageRemoveTeamMemberBody}, TContext> => {

const mutationKey = ['platformManageRemoveTeamMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageRemoveTeamMember>>, {teamName: string;data: PlatformManageRemoveTeamMemberBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformManageRemoveTeamMember(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageRemoveTeamMemberMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageRemoveTeamMember>>>
    export type PlatformManageRemoveTeamMemberMutationBody = PlatformManageRemoveTeamMemberBody
    export type PlatformManageRemoveTeamMemberMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformManageRemoveTeamMember = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRemoveTeamMember>>, TError,{teamName: string;data: PlatformManageRemoveTeamMemberBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageRemoveTeamMember>>,
        TError,
        {teamName: string;data: PlatformManageRemoveTeamMemberBody},
        TContext
      > => {
      return useMutation(getPlatformManageRemoveTeamMemberMutationOptions(options));
    }

/**
 * List all users
 */
export const getPlatformListLocalUsersUrl = (params?: PlatformListLocalUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/manage/users?${stringifiedParams}` : `/manage/users`
}

export const platformListLocalUsers = async (params?: PlatformListLocalUsersParams, options?: RequestInit) => {

  return customFetch<PlatformListLocalUsers200>(getPlatformListLocalUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListLocalUsersQueryKey = (params?: PlatformListLocalUsersParams,) => {
    return [
    `/manage/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListLocalUsersQueryOptions = <TData = Awaited<ReturnType<typeof platformListLocalUsers>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(params?: PlatformListLocalUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListLocalUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListLocalUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListLocalUsers>>> = ({ signal }) => platformListLocalUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListLocalUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListLocalUsersQueryResult = NonNullable<Awaited<ReturnType<typeof platformListLocalUsers>>>
export type PlatformListLocalUsersQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListLocalUsers<TData = Awaited<ReturnType<typeof platformListLocalUsers>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 params?: PlatformListLocalUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListLocalUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListLocalUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Add new user
 */
export const getPlatformAddLocalUserUrl = () => {




  return `/manage/users/add`
}

export const platformAddLocalUser = async (platformAddLocalUserBody: PlatformAddLocalUserBody, options?: RequestInit) => {

  return customFetch<PlatformLocalUser>(getPlatformAddLocalUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformAddLocalUserBody,)
  }
);}




export const getPlatformAddLocalUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAddLocalUser>>, TError,{data: PlatformAddLocalUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAddLocalUser>>, TError,{data: PlatformAddLocalUserBody}, TContext> => {

const mutationKey = ['platformAddLocalUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAddLocalUser>>, {data: PlatformAddLocalUserBody}> = (props) => {
          const {data} = props ?? {};

          return  platformAddLocalUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAddLocalUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformAddLocalUser>>>
    export type PlatformAddLocalUserMutationBody = PlatformAddLocalUserBody
    export type PlatformAddLocalUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAddLocalUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAddLocalUser>>, TError,{data: PlatformAddLocalUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAddLocalUser>>,
        TError,
        {data: PlatformAddLocalUserBody},
        TContext
      > => {
      return useMutation(getPlatformAddLocalUserMutationOptions(options));
    }

/**
 * Get user details
 */
export const getPlatformGetLocalUserUrl = (userId: string,) => {




  return `/manage/users/${userId}`
}

export const platformGetLocalUser = async (userId: string, options?: RequestInit) => {

  return customFetch<PlatformLocalUserWithTeams>(getPlatformGetLocalUserUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetLocalUserQueryKey = (userId: string,) => {
    return [
    `/manage/users/${userId}`
    ] as const;
    }


export const getPlatformGetLocalUserQueryOptions = <TData = Awaited<ReturnType<typeof platformGetLocalUser>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetLocalUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetLocalUserQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetLocalUser>>> = ({ signal }) => platformGetLocalUser(userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetLocalUser>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetLocalUserQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetLocalUser>>>
export type PlatformGetLocalUserQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetLocalUser<TData = Awaited<ReturnType<typeof platformGetLocalUser>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetLocalUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetLocalUserQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update user
 */
export const getPlatformUpdateLocalUserUrl = (userId: string,) => {




  return `/manage/users/${userId}`
}

export const platformUpdateLocalUser = async (userId: string,
    platformUpdateLocalUserBody: PlatformUpdateLocalUserBody, options?: RequestInit) => {

  return customFetch<PlatformLocalUser>(getPlatformUpdateLocalUserUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformUpdateLocalUserBody,)
  }
);}




export const getPlatformUpdateLocalUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateLocalUser>>, TError,{userId: string;data: PlatformUpdateLocalUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateLocalUser>>, TError,{userId: string;data: PlatformUpdateLocalUserBody}, TContext> => {

const mutationKey = ['platformUpdateLocalUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateLocalUser>>, {userId: string;data: PlatformUpdateLocalUserBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  platformUpdateLocalUser(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateLocalUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateLocalUser>>>
    export type PlatformUpdateLocalUserMutationBody = PlatformUpdateLocalUserBody
    export type PlatformUpdateLocalUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateLocalUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateLocalUser>>, TError,{userId: string;data: PlatformUpdateLocalUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateLocalUser>>,
        TError,
        {userId: string;data: PlatformUpdateLocalUserBody},
        TContext
      > => {
      return useMutation(getPlatformUpdateLocalUserMutationOptions(options));
    }

/**
 * Delete user
 */
export const getPlatformDeleteLocalUserUrl = (userId: string,) => {




  return `/manage/users/${userId}`
}

export const platformDeleteLocalUser = async (userId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteLocalUserUrl(userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteLocalUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteLocalUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteLocalUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['platformDeleteLocalUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteLocalUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  platformDeleteLocalUser(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteLocalUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteLocalUser>>>

    export type PlatformDeleteLocalUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteLocalUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteLocalUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteLocalUser>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteLocalUserMutationOptions(options));
    }

/**
 * Create password reset token for user
 */
export const getPlatformCreateLocalUserResetTokenUrl = (userId: string,) => {




  return `/manage/users/${userId}/reset`
}

export const platformCreateLocalUserResetToken = async (userId: string, options?: RequestInit) => {

  return customFetch<PlatformCreateLocalUserResetToken200>(getPlatformCreateLocalUserResetTokenUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformCreateLocalUserResetTokenMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>, TError,{userId: string}, TContext> => {

const mutationKey = ['platformCreateLocalUserResetToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  platformCreateLocalUserResetToken(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateLocalUserResetTokenMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>>

    export type PlatformCreateLocalUserResetTokenMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateLocalUserResetToken = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getPlatformCreateLocalUserResetTokenMutationOptions(options));
    }

/**
 * Disable/Reset MFA for a specific user
 */
export const getPlatformManageUserTOTPDeleteUrl = (userId: string,) => {




  return `/manage/users/${userId}/totp`
}

export const platformManageUserTOTPDelete = async (userId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformManageUserTOTPDeleteUrl(userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformManageUserTOTPDeleteMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageUserTOTPDelete>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformManageUserTOTPDelete>>, TError,{userId: string}, TContext> => {

const mutationKey = ['platformManageUserTOTPDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageUserTOTPDelete>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  platformManageUserTOTPDelete(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageUserTOTPDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageUserTOTPDelete>>>

    export type PlatformManageUserTOTPDeleteMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse

    export const usePlatformManageUserTOTPDelete = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageUserTOTPDelete>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageUserTOTPDelete>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getPlatformManageUserTOTPDeleteMutationOptions(options));
    }

/**
 * Information about the platform
 */
export const getPlatformGetPlatformInfoUrl = () => {




  return `/platform-info`
}

export const platformGetPlatformInfo = async ( options?: RequestInit) => {

  return customFetch<PlatformGetPlatformInfo200>(getPlatformGetPlatformInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetPlatformInfoQueryKey = () => {
    return [
    `/platform-info`
    ] as const;
    }


export const getPlatformGetPlatformInfoQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPlatformInfo>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformInfo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPlatformInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPlatformInfo>>> = ({ signal }) => platformGetPlatformInfo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPlatformInfoQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPlatformInfo>>>
export type PlatformGetPlatformInfoQueryError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse



export function usePlatformGetPlatformInfo<TData = Awaited<ReturnType<typeof platformGetPlatformInfo>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformInfo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPlatformInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List platform versions
 */
export const getPlatformListPlatformVersionsUrl = (params?: PlatformListPlatformVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/platform-versions?${stringifiedParams}` : `/platform-versions`
}

export const platformListPlatformVersions = async (params?: PlatformListPlatformVersionsParams, options?: RequestInit) => {

  return customFetch<PlatformListPlatformVersions200>(getPlatformListPlatformVersionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListPlatformVersionsQueryKey = (params?: PlatformListPlatformVersionsParams,) => {
    return [
    `/platform-versions`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListPlatformVersionsQueryOptions = <TData = Awaited<ReturnType<typeof platformListPlatformVersions>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>(params?: PlatformListPlatformVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPlatformVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPlatformVersionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPlatformVersions>>> = ({ signal }) => platformListPlatformVersions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPlatformVersions>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPlatformVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPlatformVersions>>>
export type PlatformListPlatformVersionsQueryError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse



export function usePlatformListPlatformVersions<TData = Awaited<ReturnType<typeof platformListPlatformVersions>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>(
 params?: PlatformListPlatformVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPlatformVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPlatformVersionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List all plugins
 */
export const getPlatformListPluginsUrl = (params?: PlatformListPluginsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["include_release_stages","exclude_release_stages"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plugins?${stringifiedParams}` : `/plugins`
}

export const platformListPlugins = async (params?: PlatformListPluginsParams, options?: RequestInit) => {

  return customFetch<PlatformListPlugins200>(getPlatformListPluginsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListPluginsQueryKey = (params?: PlatformListPluginsParams,) => {
    return [
    `/plugins`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListPluginsQueryOptions = <TData = Awaited<ReturnType<typeof platformListPlugins>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>(params?: PlatformListPluginsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPlugins>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPluginsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPlugins>>> = ({ signal }) => platformListPlugins(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPlugins>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPluginsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPlugins>>>
export type PlatformListPluginsQueryError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse



export function usePlatformListPlugins<TData = Awaited<ReturnType<typeof platformListPlugins>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>(
 params?: PlatformListPluginsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPlugins>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPluginsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a plugin owned by the specified team. User must be part of that team.
 */
export const getPlatformCreatePluginUrl = () => {




  return `/plugins`
}

export const platformCreatePlugin = async (platformPluginCreate: PlatformPluginCreate, options?: RequestInit) => {

  return customFetch<PlatformPlugin>(getPlatformCreatePluginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformPluginCreate,)
  }
);}




export const getPlatformCreatePluginMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePlugin>>, TError,{data: PlatformPluginCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreatePlugin>>, TError,{data: PlatformPluginCreate}, TContext> => {

const mutationKey = ['platformCreatePlugin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreatePlugin>>, {data: PlatformPluginCreate}> = (props) => {
          const {data} = props ?? {};

          return  platformCreatePlugin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreatePluginMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreatePlugin>>>
    export type PlatformCreatePluginMutationBody = PlatformPluginCreate
    export type PlatformCreatePluginMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreatePlugin = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePlugin>>, TError,{data: PlatformPluginCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreatePlugin>>,
        TError,
        {data: PlatformPluginCreate},
        TContext
      > => {
      return useMutation(getPlatformCreatePluginMutationOptions(options));
    }

/**
 * Get details about a given plugin.
 */
export const getPlatformGetPluginUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}`
}

export const platformGetPlugin = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: RequestInit) => {

  return customFetch<PlatformListPlugin>(getPlatformGetPluginUrl(teamName,pluginKind,pluginName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetPluginQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}`
    ] as const;
    }


export const getPlatformGetPluginQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPlugin>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPlugin>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPluginQueryKey(teamName,pluginKind,pluginName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPlugin>>> = ({ signal }) => platformGetPlugin(teamName,pluginKind,pluginName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPlugin>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPluginQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPlugin>>>
export type PlatformGetPluginQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetPlugin<TData = Awaited<ReturnType<typeof platformGetPlugin>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPlugin>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPluginQueryOptions(teamName,pluginKind,pluginName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a plugin
 */
export const getPlatformUpdatePluginUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}`
}

export const platformUpdatePlugin = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    platformPluginUpdate: PlatformPluginUpdate, options?: RequestInit) => {

  return customFetch<PlatformPlugin>(getPlatformUpdatePluginUrl(teamName,pluginKind,pluginName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformPluginUpdate,)
  }
);}




export const getPlatformUpdatePluginMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PlatformPluginUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PlatformPluginUpdate}, TContext> => {

const mutationKey = ['platformUpdatePlugin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdatePlugin>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PlatformPluginUpdate}> = (props) => {
          const {teamName,pluginKind,pluginName,data} = props ?? {};

          return  platformUpdatePlugin(teamName,pluginKind,pluginName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdatePluginMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdatePlugin>>>
    export type PlatformUpdatePluginMutationBody = PlatformPluginUpdate
    export type PlatformUpdatePluginMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdatePlugin = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PlatformPluginUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdatePlugin>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PlatformPluginUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdatePluginMutationOptions(options));
    }

/**
 * Delete plugin by team and plugin name
 */
export const getPlatformDeletePluginByTeamAndPluginNameUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}`
}

export const platformDeletePluginByTeamAndPluginName = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeletePluginByTeamAndPluginNameUrl(teamName,pluginKind,pluginName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeletePluginByTeamAndPluginNameMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext> => {

const mutationKey = ['platformDeletePluginByTeamAndPluginName'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}> = (props) => {
          const {teamName,pluginKind,pluginName} = props ?? {};

          return  platformDeletePluginByTeamAndPluginName(teamName,pluginKind,pluginName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeletePluginByTeamAndPluginNameMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>>

    export type PlatformDeletePluginByTeamAndPluginNameMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformDeletePluginByTeamAndPluginName = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string},
        TContext
      > => {
      return useMutation(getPlatformDeletePluginByTeamAndPluginNameMutationOptions(options));
    }

/**
 * List all versions for a given plugin
 */
export const getPlatformListPluginVersionsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: PlatformListPluginVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plugins/${teamName}/${pluginKind}/${pluginName}/versions?${stringifiedParams}` : `/plugins/${teamName}/${pluginKind}/${pluginName}/versions`
}

export const platformListPluginVersions = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: PlatformListPluginVersionsParams, options?: RequestInit) => {

  return customFetch<PlatformListPluginVersions200>(getPlatformListPluginVersionsUrl(teamName,pluginKind,pluginName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListPluginVersionsQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: PlatformListPluginVersionsParams,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListPluginVersionsQueryOptions = <TData = Awaited<ReturnType<typeof platformListPluginVersions>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: PlatformListPluginVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPluginVersionsQueryKey(teamName,pluginKind,pluginName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPluginVersions>>> = ({ signal }) => platformListPluginVersions(teamName,pluginKind,pluginName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersions>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPluginVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPluginVersions>>>
export type PlatformListPluginVersionsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListPluginVersions<TData = Awaited<ReturnType<typeof platformListPluginVersions>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: PlatformListPluginVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPluginVersionsQueryOptions(teamName,pluginKind,pluginName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get details about a given plugin version.
 */
export const getPlatformGetPluginVersionUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`
}

export const platformGetPluginVersion = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: RequestInit) => {

  return customFetch<PlatformPluginVersionDetails>(getPlatformGetPluginVersionUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetPluginVersionQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`
    ] as const;
    }


export const getPlatformGetPluginVersionQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPluginVersion>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPluginVersionQueryKey(teamName,pluginKind,pluginName,versionName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPluginVersion>>> = ({ signal }) => platformGetPluginVersion(teamName,pluginKind,pluginName,versionName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersion>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPluginVersionQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPluginVersion>>>
export type PlatformGetPluginVersionQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetPluginVersion<TData = Awaited<ReturnType<typeof platformGetPluginVersion>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPluginVersionQueryOptions(teamName,pluginKind,pluginName,versionName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a new plugin version, or update a draft version
 */
export const getPlatformCreatePluginVersionUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`
}

export const platformCreatePluginVersion = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformCreatePluginVersionBody: PlatformCreatePluginVersionBody, options?: RequestInit) => {

  return customFetch<PlatformPluginVersion>(getPlatformCreatePluginVersionUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreatePluginVersionBody,)
  }
);}




export const getPlatformCreatePluginVersionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionBody}, TContext> => {

const mutationKey = ['platformCreatePluginVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreatePluginVersion>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformCreatePluginVersion(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreatePluginVersionMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreatePluginVersion>>>
    export type PlatformCreatePluginVersionMutationBody = PlatformCreatePluginVersionBody
    export type PlatformCreatePluginVersionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse

    export const usePlatformCreatePluginVersion = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreatePluginVersion>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionBody},
        TContext
      > => {
      return useMutation(getPlatformCreatePluginVersionMutationOptions(options));
    }

/**
 * Update a given plugin version
 */
export const getPlatformUpdatePluginVersionUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`
}

export const platformUpdatePluginVersion = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformPluginVersionUpdate: PlatformPluginVersionUpdate, options?: RequestInit) => {

  return customFetch<PlatformPluginVersion>(getPlatformUpdatePluginVersionUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformPluginVersionUpdate,)
  }
);}




export const getPlatformUpdatePluginVersionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformPluginVersionUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformPluginVersionUpdate}, TContext> => {

const mutationKey = ['platformUpdatePluginVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdatePluginVersion>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformPluginVersionUpdate}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformUpdatePluginVersion(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdatePluginVersionMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdatePluginVersion>>>
    export type PlatformUpdatePluginVersionMutationBody = PlatformPluginVersionUpdate
    export type PlatformUpdatePluginVersionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformUpdatePluginVersion = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformPluginVersionUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdatePluginVersion>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformPluginVersionUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdatePluginVersionMutationOptions(options));
    }

/**
 * Download an asset for a given plugin version and target
 */
export const getPlatformDownloadPluginAssetUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`
}

export const platformDownloadPluginAsset = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: RequestInit) => {

  return customFetch<PlatformPluginAsset>(getPlatformDownloadPluginAssetUrl(teamName,pluginKind,pluginName,versionName,targetName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformDownloadPluginAssetQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`
    ] as const;
    }


export const getPlatformDownloadPluginAssetQueryOptions = <TData = Awaited<ReturnType<typeof platformDownloadPluginAsset>>, TError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformDownloadPluginAssetQueryKey(teamName,pluginKind,pluginName,versionName,targetName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformDownloadPluginAsset>>> = ({ signal }) => platformDownloadPluginAsset(teamName,pluginKind,pluginName,versionName,targetName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName && targetName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAsset>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformDownloadPluginAssetQueryResult = NonNullable<Awaited<ReturnType<typeof platformDownloadPluginAsset>>>
export type PlatformDownloadPluginAssetQueryError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse



export function usePlatformDownloadPluginAsset<TData = Awaited<ReturnType<typeof platformDownloadPluginAsset>>, TError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformDownloadPluginAssetQueryOptions(teamName,pluginKind,pluginName,versionName,targetName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a URL to upload an asset for a given plugin version and target
 */
export const getPlatformUploadPluginAssetUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`
}

export const platformUploadPluginAsset = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: RequestInit) => {

  return customFetch<PlatformReleaseURL>(getPlatformUploadPluginAssetUrl(teamName,pluginKind,pluginName,versionName,targetName),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformUploadPluginAssetMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext> => {

const mutationKey = ['platformUploadPluginAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUploadPluginAsset>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,targetName} = props ?? {};

          return  platformUploadPluginAsset(teamName,pluginKind,pluginName,versionName,targetName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUploadPluginAssetMutationResult = NonNullable<Awaited<ReturnType<typeof platformUploadPluginAsset>>>

    export type PlatformUploadPluginAssetMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse

    export const usePlatformUploadPluginAsset = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUploadPluginAsset>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string},
        TContext
      > => {
      return useMutation(getPlatformUploadPluginAssetMutationOptions(options));
    }

/**
 * List all documentation pages for a given plugin version
 */
export const getPlatformListPluginVersionDocsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionDocsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs?${stringifiedParams}` : `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`
}

export const platformListPluginVersionDocs = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionDocsParams, options?: RequestInit) => {

  return customFetch<PlatformListPluginVersionDocs200>(getPlatformListPluginVersionDocsUrl(teamName,pluginKind,pluginName,versionName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListPluginVersionDocsQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionDocsParams,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListPluginVersionDocsQueryOptions = <TData = Awaited<ReturnType<typeof platformListPluginVersionDocs>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionDocsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionDocs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPluginVersionDocsQueryKey(teamName,pluginKind,pluginName,versionName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPluginVersionDocs>>> = ({ signal }) => platformListPluginVersionDocs(teamName,pluginKind,pluginName,versionName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionDocs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPluginVersionDocsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPluginVersionDocs>>>
export type PlatformListPluginVersionDocsQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListPluginVersionDocs<TData = Awaited<ReturnType<typeof platformListPluginVersionDocs>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionDocsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionDocs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPluginVersionDocsQueryOptions(teamName,pluginKind,pluginName,versionName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create or update one or more plugin version docs pages
 */
export const getPlatformCreatePluginVersionDocsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`
}

export const platformCreatePluginVersionDocs = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformCreatePluginVersionDocsBody: PlatformCreatePluginVersionDocsBody, options?: RequestInit) => {

  return customFetch<PlatformCreatePluginVersionDocs201>(getPlatformCreatePluginVersionDocsUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreatePluginVersionDocsBody,)
  }
);}




export const getPlatformCreatePluginVersionDocsMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionDocsBody}, TContext> => {

const mutationKey = ['platformCreatePluginVersionDocs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformCreatePluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreatePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>>
    export type PlatformCreatePluginVersionDocsMutationBody = PlatformCreatePluginVersionDocsBody
    export type PlatformCreatePluginVersionDocsMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreatePluginVersionDocs = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionDocsBody},
        TContext
      > => {
      return useMutation(getPlatformCreatePluginVersionDocsMutationOptions(options));
    }

/**
 * Replace (override) multiple plugin version docs pages
 */
export const getPlatformReplacePluginVersionDocsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`
}

export const platformReplacePluginVersionDocs = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformReplacePluginVersionDocsBody: PlatformReplacePluginVersionDocsBody, options?: RequestInit) => {

  return customFetch<PlatformReplacePluginVersionDocs201>(getPlatformReplacePluginVersionDocsUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformReplacePluginVersionDocsBody,)
  }
);}




export const getPlatformReplacePluginVersionDocsMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformReplacePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformReplacePluginVersionDocsBody}, TContext> => {

const mutationKey = ['platformReplacePluginVersionDocs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformReplacePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformReplacePluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformReplacePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>>
    export type PlatformReplacePluginVersionDocsMutationBody = PlatformReplacePluginVersionDocsBody
    export type PlatformReplacePluginVersionDocsMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformReplacePluginVersionDocs = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformReplacePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformReplacePluginVersionDocsBody},
        TContext
      > => {
      return useMutation(getPlatformReplacePluginVersionDocsMutationOptions(options));
    }

/**
 * Delete one or more plugin version docs pages.
 */
export const getPlatformDeletePluginVersionDocsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`
}

export const platformDeletePluginVersionDocs = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformDeletePluginVersionDocsBody: PlatformDeletePluginVersionDocsBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeletePluginVersionDocsUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformDeletePluginVersionDocsBody,)
  }
);}




export const getPlatformDeletePluginVersionDocsMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionDocsBody}, TContext> => {

const mutationKey = ['platformDeletePluginVersionDocs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformDeletePluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeletePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>>
    export type PlatformDeletePluginVersionDocsMutationBody = PlatformDeletePluginVersionDocsBody
    export type PlatformDeletePluginVersionDocsMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeletePluginVersionDocs = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionDocsBody},
        TContext
      > => {
      return useMutation(getPlatformDeletePluginVersionDocsMutationOptions(options));
    }

/**
 * List tables for a given plugin version. This only applies to source plugins.
 */
export const getPlatformListPluginVersionTablesUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionTablesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables?${stringifiedParams}` : `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`
}

export const platformListPluginVersionTables = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionTablesParams, options?: RequestInit) => {

  return customFetch<PlatformListPluginVersionTables200>(getPlatformListPluginVersionTablesUrl(teamName,pluginKind,pluginName,versionName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListPluginVersionTablesQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionTablesParams,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListPluginVersionTablesQueryOptions = <TData = Awaited<ReturnType<typeof platformListPluginVersionTables>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionTables>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPluginVersionTablesQueryKey(teamName,pluginKind,pluginName,versionName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPluginVersionTables>>> = ({ signal }) => platformListPluginVersionTables(teamName,pluginKind,pluginName,versionName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionTables>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPluginVersionTablesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPluginVersionTables>>>
export type PlatformListPluginVersionTablesQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListPluginVersionTables<TData = Awaited<ReturnType<typeof platformListPluginVersionTables>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionTables>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPluginVersionTablesQueryOptions(teamName,pluginKind,pluginName,versionName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create or update one or more plugin version tables. This only applies to source plugins, and can only be done if the plugin version is in draft.
 */
export const getPlatformCreatePluginVersionTablesUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`
}

export const platformCreatePluginVersionTables = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformCreatePluginVersionTablesBody: PlatformCreatePluginVersionTablesBody, options?: RequestInit) => {

  return customFetch<PlatformCreatePluginVersionTables201>(getPlatformCreatePluginVersionTablesUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreatePluginVersionTablesBody,)
  }
);}




export const getPlatformCreatePluginVersionTablesMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionTablesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionTablesBody}, TContext> => {

const mutationKey = ['platformCreatePluginVersionTables'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreatePluginVersionTables>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionTablesBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformCreatePluginVersionTables(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreatePluginVersionTablesMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreatePluginVersionTables>>>
    export type PlatformCreatePluginVersionTablesMutationBody = PlatformCreatePluginVersionTablesBody
    export type PlatformCreatePluginVersionTablesMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreatePluginVersionTables = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionTablesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreatePluginVersionTables>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionTablesBody},
        TContext
      > => {
      return useMutation(getPlatformCreatePluginVersionTablesMutationOptions(options));
    }

/**
 * Delete one or more plugin version tables.
 */
export const getPlatformDeletePluginVersionTablesUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`
}

export const platformDeletePluginVersionTables = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformDeletePluginVersionTablesBody: PlatformDeletePluginVersionTablesBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeletePluginVersionTablesUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformDeletePluginVersionTablesBody,)
  }
);}




export const getPlatformDeletePluginVersionTablesMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionTablesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionTablesBody}, TContext> => {

const mutationKey = ['platformDeletePluginVersionTables'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeletePluginVersionTables>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionTablesBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformDeletePluginVersionTables(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeletePluginVersionTablesMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeletePluginVersionTables>>>
    export type PlatformDeletePluginVersionTablesMutationBody = PlatformDeletePluginVersionTablesBody
    export type PlatformDeletePluginVersionTablesMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeletePluginVersionTables = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionTablesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeletePluginVersionTables>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionTablesBody},
        TContext
      > => {
      return useMutation(getPlatformDeletePluginVersionTablesMutationOptions(options));
    }

/**
 * Get schema for a given table and plugin version. This only applies to source plugins.
 */
export const getPlatformGetPluginVersionTableUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables/${tableName}`
}

export const platformGetPluginVersionTable = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string, options?: RequestInit) => {

  return customFetch<PlatformPluginTableDetails>(getPlatformGetPluginVersionTableUrl(teamName,pluginKind,pluginName,versionName,tableName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetPluginVersionTableQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables/${tableName}`
    ] as const;
    }


export const getPlatformGetPluginVersionTableQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPluginVersionTable>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersionTable>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPluginVersionTableQueryKey(teamName,pluginKind,pluginName,versionName,tableName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPluginVersionTable>>> = ({ signal }) => platformGetPluginVersionTable(teamName,pluginKind,pluginName,versionName,tableName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersionTable>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPluginVersionTableQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPluginVersionTable>>>
export type PlatformGetPluginVersionTableQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetPluginVersionTable<TData = Awaited<ReturnType<typeof platformGetPluginVersionTable>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersionTable>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPluginVersionTableQueryOptions(teamName,pluginKind,pluginName,versionName,tableName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get URLs to upload UI assets for a given plugin version
 */
export const getPlatformUploadPluginUIAssetsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`
}

export const platformUploadPluginUIAssets = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformUploadPluginUIAssetsBody: PlatformUploadPluginUIAssetsBody, options?: RequestInit) => {

  return customFetch<PlatformUploadPluginUIAssets201>(getPlatformUploadPluginUIAssetsUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformUploadPluginUIAssetsBody,)
  }
);}




export const getPlatformUploadPluginUIAssetsMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformConflictResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformUploadPluginUIAssetsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformUploadPluginUIAssetsBody}, TContext> => {

const mutationKey = ['platformUploadPluginUIAssets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUploadPluginUIAssets>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformUploadPluginUIAssetsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformUploadPluginUIAssets(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUploadPluginUIAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof platformUploadPluginUIAssets>>>
    export type PlatformUploadPluginUIAssetsMutationBody = PlatformUploadPluginUIAssetsBody
    export type PlatformUploadPluginUIAssetsMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformConflictResponse | PlatformInternalErrorResponse

    export const usePlatformUploadPluginUIAssets = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformConflictResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformUploadPluginUIAssetsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUploadPluginUIAssets>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformUploadPluginUIAssetsBody},
        TContext
      > => {
      return useMutation(getPlatformUploadPluginUIAssetsMutationOptions(options));
    }

/**
 * Finalize UI asset upload
 */
export const getPlatformFinalizePluginUIAssetUploadUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`
}

export const platformFinalizePluginUIAssetUpload = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformFinalizePluginUIAssetUploadBody: PlatformFinalizePluginUIAssetUploadBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformFinalizePluginUIAssetUploadUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformFinalizePluginUIAssetUploadBody,)
  }
);}




export const getPlatformFinalizePluginUIAssetUploadMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformFinalizePluginUIAssetUploadBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformFinalizePluginUIAssetUploadBody}, TContext> => {

const mutationKey = ['platformFinalizePluginUIAssetUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformFinalizePluginUIAssetUploadBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformFinalizePluginUIAssetUpload(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformFinalizePluginUIAssetUploadMutationResult = NonNullable<Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>>
    export type PlatformFinalizePluginUIAssetUploadMutationBody = PlatformFinalizePluginUIAssetUploadBody
    export type PlatformFinalizePluginUIAssetUploadMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformFinalizePluginUIAssetUpload = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformFinalizePluginUIAssetUploadBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformFinalizePluginUIAssetUploadBody},
        TContext
      > => {
      return useMutation(getPlatformFinalizePluginUIAssetUploadMutationOptions(options));
    }

/**
 * Remove UI assets for a given plugin version
 */
export const getPlatformRemovePluginUIAssetsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`
}

export const platformRemovePluginUIAssets = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformRemovePluginUIAssetsUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformRemovePluginUIAssetsMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemovePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformRemovePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext> => {

const mutationKey = ['platformRemovePluginUIAssets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformRemovePluginUIAssets>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName} = props ?? {};

          return  platformRemovePluginUIAssets(teamName,pluginKind,pluginName,versionName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformRemovePluginUIAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof platformRemovePluginUIAssets>>>

    export type PlatformRemovePluginUIAssetsMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse

    export const usePlatformRemovePluginUIAssets = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemovePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformRemovePluginUIAssets>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string},
        TContext
      > => {
      return useMutation(getPlatformRemovePluginUIAssetsMutationOptions(options));
    }

/**
 * List all teams
 */
export const getPlatformListTeamsUrl = (params?: PlatformListTeamsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams?${stringifiedParams}` : `/teams`
}

export const platformListTeams = async (params?: PlatformListTeamsParams, options?: RequestInit) => {

  return customFetch<PlatformListTeams200>(getPlatformListTeamsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListTeamsQueryKey = (params?: PlatformListTeamsParams,) => {
    return [
    `/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListTeamsQueryOptions = <TData = Awaited<ReturnType<typeof platformListTeams>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(params?: PlatformListTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeams>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTeamsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTeams>>> = ({ signal }) => platformListTeams(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListTeams>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTeams>>>
export type PlatformListTeamsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListTeams<TData = Awaited<ReturnType<typeof platformListTeams>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 params?: PlatformListTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeams>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListTeamsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a team owned by the current user.
 */
export const getPlatformCreateTeamUrl = () => {




  return `/teams`
}

export const platformCreateTeam = async (platformCreateTeamBody: PlatformCreateTeamBody, options?: RequestInit) => {

  return customFetch<PlatformTeam>(getPlatformCreateTeamUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreateTeamBody,)
  }
);}




export const getPlatformCreateTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeam>>, TError,{data: PlatformCreateTeamBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeam>>, TError,{data: PlatformCreateTeamBody}, TContext> => {

const mutationKey = ['platformCreateTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateTeam>>, {data: PlatformCreateTeamBody}> = (props) => {
          const {data} = props ?? {};

          return  platformCreateTeam(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateTeam>>>
    export type PlatformCreateTeamMutationBody = PlatformCreateTeamBody
    export type PlatformCreateTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeam>>, TError,{data: PlatformCreateTeamBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateTeam>>,
        TError,
        {data: PlatformCreateTeamBody},
        TContext
      > => {
      return useMutation(getPlatformCreateTeamMutationOptions(options));
    }

/**
 * Get a team by name
 */
export const getPlatformGetTeamByNameUrl = (teamName: string,) => {




  return `/teams/${teamName}`
}

export const platformGetTeamByName = async (teamName: string, options?: RequestInit) => {

  return customFetch<PlatformTeam>(getPlatformGetTeamByNameUrl(teamName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetTeamByNameQueryKey = (teamName: string,) => {
    return [
    `/teams/${teamName}`
    ] as const;
    }


export const getPlatformGetTeamByNameQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTeamByName>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamByName>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTeamByNameQueryKey(teamName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTeamByName>>> = ({ signal }) => platformGetTeamByName(teamName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamByName>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTeamByNameQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTeamByName>>>
export type PlatformGetTeamByNameQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetTeamByName<TData = Awaited<ReturnType<typeof platformGetTeamByName>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamByName>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTeamByNameQueryOptions(teamName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update team attributes
 */
export const getPlatformUpdateTeamUrl = (teamName: string,) => {




  return `/teams/${teamName}`
}

export const platformUpdateTeam = async (teamName: string,
    platformUpdateTeamBody: PlatformUpdateTeamBody, options?: RequestInit) => {

  return customFetch<PlatformTeam>(getPlatformUpdateTeamUrl(teamName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformUpdateTeamBody,)
  }
);}




export const getPlatformUpdateTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateTeam>>, TError,{teamName: string;data: PlatformUpdateTeamBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateTeam>>, TError,{teamName: string;data: PlatformUpdateTeamBody}, TContext> => {

const mutationKey = ['platformUpdateTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateTeam>>, {teamName: string;data: PlatformUpdateTeamBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformUpdateTeam(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateTeam>>>
    export type PlatformUpdateTeamMutationBody = PlatformUpdateTeamBody
    export type PlatformUpdateTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateTeam>>, TError,{teamName: string;data: PlatformUpdateTeamBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateTeam>>,
        TError,
        {teamName: string;data: PlatformUpdateTeamBody},
        TContext
      > => {
      return useMutation(getPlatformUpdateTeamMutationOptions(options));
    }

/**
 * Delete team
 */
export const getPlatformDeleteTeamUrl = (teamName: string,) => {




  return `/teams/${teamName}`
}

export const platformDeleteTeam = async (teamName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteTeamUrl(teamName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['platformDeleteTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  platformDeleteTeam(teamName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteTeam>>>

    export type PlatformDeleteTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteTeamMutationOptions(options));
    }

/**
 * List all alerts
 */
export const getPlatformListAllAlertsUrl = (teamName: string,
    params?: PlatformListAllAlertsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["state"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/alerts?${stringifiedParams}` : `/teams/${teamName}/alerts`
}

export const platformListAllAlerts = async (teamName: string,
    params?: PlatformListAllAlertsParams, options?: RequestInit) => {

  return customFetch<PlatformListAllAlerts200>(getPlatformListAllAlertsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListAllAlertsQueryKey = (teamName: string,
    params?: PlatformListAllAlertsParams,) => {
    return [
    `/teams/${teamName}/alerts`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListAllAlertsQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllAlerts>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListAllAlertsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllAlerts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllAlertsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllAlerts>>> = ({ signal }) => platformListAllAlerts(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllAlerts>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllAlertsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllAlerts>>>
export type PlatformListAllAlertsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListAllAlerts<TData = Awaited<ReturnType<typeof platformListAllAlerts>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListAllAlertsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllAlerts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllAlertsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Test an unsaved alert
 */
export const getPlatformTestUnsavedAlertUrl = (teamName: string,
    params?: PlatformTestUnsavedAlertParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/alerts/test?${stringifiedParams}` : `/teams/${teamName}/alerts/test`
}

export const platformTestUnsavedAlert = async (teamName: string,
    platformAlertCreate: PlatformAlertCreate,
    params?: PlatformTestUnsavedAlertParams, options?: RequestInit) => {

  return customFetch<PlatformTestUnsavedAlert200>(getPlatformTestUnsavedAlertUrl(teamName,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformAlertCreate,)
  }
);}




export const getPlatformTestUnsavedAlertMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedAlert>>, TError,{teamName: string;data: PlatformAlertCreate;params?: PlatformTestUnsavedAlertParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedAlert>>, TError,{teamName: string;data: PlatformAlertCreate;params?: PlatformTestUnsavedAlertParams}, TContext> => {

const mutationKey = ['platformTestUnsavedAlert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformTestUnsavedAlert>>, {teamName: string;data: PlatformAlertCreate;params?: PlatformTestUnsavedAlertParams}> = (props) => {
          const {teamName,data,params} = props ?? {};

          return  platformTestUnsavedAlert(teamName,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformTestUnsavedAlertMutationResult = NonNullable<Awaited<ReturnType<typeof platformTestUnsavedAlert>>>
    export type PlatformTestUnsavedAlertMutationBody = PlatformAlertCreate
    export type PlatformTestUnsavedAlertMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformTestUnsavedAlert = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedAlert>>, TError,{teamName: string;data: PlatformAlertCreate;params?: PlatformTestUnsavedAlertParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformTestUnsavedAlert>>,
        TError,
        {teamName: string;data: PlatformAlertCreate;params?: PlatformTestUnsavedAlertParams},
        TContext
      > => {
      return useMutation(getPlatformTestUnsavedAlertMutationOptions(options));
    }

/**
 * List all team API Keys
 */
export const getPlatformListTeamAPIKeysUrl = (teamName: string,
    params?: PlatformListTeamAPIKeysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/apikeys?${stringifiedParams}` : `/teams/${teamName}/apikeys`
}

export const platformListTeamAPIKeys = async (teamName: string,
    params?: PlatformListTeamAPIKeysParams, options?: RequestInit) => {

  return customFetch<PlatformListTeamAPIKeys200>(getPlatformListTeamAPIKeysUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListTeamAPIKeysQueryKey = (teamName: string,
    params?: PlatformListTeamAPIKeysParams,) => {
    return [
    `/teams/${teamName}/apikeys`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListTeamAPIKeysQueryOptions = <TData = Awaited<ReturnType<typeof platformListTeamAPIKeys>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListTeamAPIKeysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeamAPIKeys>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTeamAPIKeysQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTeamAPIKeys>>> = ({ signal }) => platformListTeamAPIKeys(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListTeamAPIKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListTeamAPIKeysQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTeamAPIKeys>>>
export type PlatformListTeamAPIKeysQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListTeamAPIKeys<TData = Awaited<ReturnType<typeof platformListTeamAPIKeys>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListTeamAPIKeysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeamAPIKeys>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListTeamAPIKeysQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create new team API Key.
 */
export const getPlatformCreateTeamAPIKeyUrl = (teamName: string,) => {




  return `/teams/${teamName}/apikeys`
}

export const platformCreateTeamAPIKey = async (teamName: string,
    platformCreateTeamAPIKeyBody: PlatformCreateTeamAPIKeyBody, options?: RequestInit) => {

  return customFetch<PlatformAPIKey>(getPlatformCreateTeamAPIKeyUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreateTeamAPIKeyBody,)
  }
);}




export const getPlatformCreateTeamAPIKeyMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamAPIKey>>, TError,{teamName: string;data: PlatformCreateTeamAPIKeyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamAPIKey>>, TError,{teamName: string;data: PlatformCreateTeamAPIKeyBody}, TContext> => {

const mutationKey = ['platformCreateTeamAPIKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateTeamAPIKey>>, {teamName: string;data: PlatformCreateTeamAPIKeyBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateTeamAPIKey(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateTeamAPIKeyMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateTeamAPIKey>>>
    export type PlatformCreateTeamAPIKeyMutationBody = PlatformCreateTeamAPIKeyBody
    export type PlatformCreateTeamAPIKeyMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateTeamAPIKey = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamAPIKey>>, TError,{teamName: string;data: PlatformCreateTeamAPIKeyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateTeamAPIKey>>,
        TError,
        {teamName: string;data: PlatformCreateTeamAPIKeyBody},
        TContext
      > => {
      return useMutation(getPlatformCreateTeamAPIKeyMutationOptions(options));
    }

/**
 * Delete API Key. This will remove any future access by this API Key.
 */
export const getPlatformDeleteTeamAPIKeyUrl = (teamName: string,
    apikeyId: string,) => {




  return `/teams/${teamName}/apikeys/${apikeyId}`
}

export const platformDeleteTeamAPIKey = async (teamName: string,
    apikeyId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteTeamAPIKeyUrl(teamName,apikeyId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteTeamAPIKeyMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext> => {

const mutationKey = ['platformDeleteTeamAPIKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>, {teamName: string;apikeyId: string}> = (props) => {
          const {teamName,apikeyId} = props ?? {};

          return  platformDeleteTeamAPIKey(teamName,apikeyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteTeamAPIKeyMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>>

    export type PlatformDeleteTeamAPIKeyMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteTeamAPIKey = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>,
        TError,
        {teamName: string;apikeyId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteTeamAPIKeyMutationOptions(options));
    }

/**
 * List all configured connectors
 */
export const getPlatformListConnectorsUrl = (teamName: string,
    params?: PlatformListConnectorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/connectors?${stringifiedParams}` : `/teams/${teamName}/connectors`
}

export const platformListConnectors = async (teamName: string,
    params?: PlatformListConnectorsParams, options?: RequestInit) => {

  return customFetch<PlatformListConnectors200>(getPlatformListConnectorsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListConnectorsQueryKey = (teamName: string,
    params?: PlatformListConnectorsParams,) => {
    return [
    `/teams/${teamName}/connectors`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListConnectorsQueryOptions = <TData = Awaited<ReturnType<typeof platformListConnectors>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListConnectorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListConnectors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListConnectorsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListConnectors>>> = ({ signal }) => platformListConnectors(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListConnectors>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListConnectorsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListConnectors>>>
export type PlatformListConnectorsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListConnectors<TData = Awaited<ReturnType<typeof platformListConnectors>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListConnectorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListConnectors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListConnectorsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create new connector
 */
export const getPlatformCreateConnectorUrl = (teamName: string,) => {




  return `/teams/${teamName}/connectors`
}

export const platformCreateConnector = async (teamName: string,
    platformConnectorCreate: PlatformConnectorCreate, options?: RequestInit) => {

  return customFetch<PlatformConnector>(getPlatformCreateConnectorUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformConnectorCreate,)
  }
);}




export const getPlatformCreateConnectorMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateConnector>>, TError,{teamName: string;data: PlatformConnectorCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateConnector>>, TError,{teamName: string;data: PlatformConnectorCreate}, TContext> => {

const mutationKey = ['platformCreateConnector'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateConnector>>, {teamName: string;data: PlatformConnectorCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateConnector(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateConnectorMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateConnector>>>
    export type PlatformCreateConnectorMutationBody = PlatformConnectorCreate
    export type PlatformCreateConnectorMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateConnector = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateConnector>>, TError,{teamName: string;data: PlatformConnectorCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateConnector>>,
        TError,
        {teamName: string;data: PlatformConnectorCreate},
        TContext
      > => {
      return useMutation(getPlatformCreateConnectorMutationOptions(options));
    }

/**
 * Get a configured connector
 */
export const getPlatformGetConnectorUrl = (teamName: string,
    connectorId: string,) => {




  return `/teams/${teamName}/connectors/${connectorId}`
}

export const platformGetConnector = async (teamName: string,
    connectorId: string, options?: RequestInit) => {

  return customFetch<PlatformConnector>(getPlatformGetConnectorUrl(teamName,connectorId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetConnectorQueryKey = (teamName: string,
    connectorId: string,) => {
    return [
    `/teams/${teamName}/connectors/${connectorId}`
    ] as const;
    }


export const getPlatformGetConnectorQueryOptions = <TData = Awaited<ReturnType<typeof platformGetConnector>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnector>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetConnectorQueryKey(teamName,connectorId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetConnector>>> = ({ signal }) => platformGetConnector(teamName,connectorId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetConnector>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetConnectorQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetConnector>>>
export type PlatformGetConnectorQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetConnector<TData = Awaited<ReturnType<typeof platformGetConnector>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnector>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetConnectorQueryOptions(teamName,connectorId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a connector
 */
export const getPlatformUpdateConnectorUrl = (teamName: string,
    connectorId: string,) => {




  return `/teams/${teamName}/connectors/${connectorId}`
}

export const platformUpdateConnector = async (teamName: string,
    connectorId: string,
    platformConnectorUpdate: PlatformConnectorUpdate, options?: RequestInit) => {

  return customFetch<PlatformConnector>(getPlatformUpdateConnectorUrl(teamName,connectorId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformConnectorUpdate,)
  }
);}




export const getPlatformUpdateConnectorMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateConnector>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateConnector>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorUpdate}, TContext> => {

const mutationKey = ['platformUpdateConnector'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateConnector>>, {teamName: string;connectorId: string;data: PlatformConnectorUpdate}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformUpdateConnector(teamName,connectorId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateConnectorMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateConnector>>>
    export type PlatformUpdateConnectorMutationBody = PlatformConnectorUpdate
    export type PlatformUpdateConnectorMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateConnector = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateConnector>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateConnector>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateConnectorMutationOptions(options));
    }

/**
 * Revoke authentication for a given connector. Any syncs relying on this connector will stop running until the connector is reauthenticated or sync references are updated.
 */
export const getPlatformRevokeConnectorUrl = (teamName: string,
    connectorId: string,) => {




  return `/teams/${teamName}/connectors/${connectorId}/authenticate`
}

export const platformRevokeConnector = async (teamName: string,
    connectorId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformRevokeConnectorUrl(teamName,connectorId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformRevokeConnectorMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRevokeConnector>>, TError,{teamName: string;connectorId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformRevokeConnector>>, TError,{teamName: string;connectorId: string}, TContext> => {

const mutationKey = ['platformRevokeConnector'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformRevokeConnector>>, {teamName: string;connectorId: string}> = (props) => {
          const {teamName,connectorId} = props ?? {};

          return  platformRevokeConnector(teamName,connectorId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformRevokeConnectorMutationResult = NonNullable<Awaited<ReturnType<typeof platformRevokeConnector>>>

    export type PlatformRevokeConnectorMutationError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformRevokeConnector = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRevokeConnector>>, TError,{teamName: string;connectorId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformRevokeConnector>>,
        TError,
        {teamName: string;connectorId: string},
        TContext
      > => {
      return useMutation(getPlatformRevokeConnectorMutationOptions(options));
    }

/**
 * Get authentication status for the given AWS connector
 */
export const getPlatformGetConnectorAuthStatusAWSUrl = (teamName: string,
    connectorId: string,) => {




  return `/teams/${teamName}/connectors/${connectorId}/authenticate/aws`
}

export const platformGetConnectorAuthStatusAWS = async (teamName: string,
    connectorId: string, options?: RequestInit) => {

  return customFetch<PlatformGetConnectorAuthStatusAWS200>(getPlatformGetConnectorAuthStatusAWSUrl(teamName,connectorId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetConnectorAuthStatusAWSQueryKey = (teamName: string,
    connectorId: string,) => {
    return [
    `/teams/${teamName}/connectors/${connectorId}/authenticate/aws`
    ] as const;
    }


export const getPlatformGetConnectorAuthStatusAWSQueryOptions = <TData = Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetConnectorAuthStatusAWSQueryKey(teamName,connectorId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>> = ({ signal }) => platformGetConnectorAuthStatusAWS(teamName,connectorId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetConnectorAuthStatusAWSQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>>
export type PlatformGetConnectorAuthStatusAWSQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetConnectorAuthStatusAWS<TData = Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetConnectorAuthStatusAWSQueryOptions(teamName,connectorId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Authenticate or reauthenticate the given AWS connector
 */
export const getPlatformAuthenticateConnectorAWSUrl = (teamName: string,
    connectorId: string,) => {




  return `/teams/${teamName}/connectors/${connectorId}/authenticate/aws`
}

export const platformAuthenticateConnectorAWS = async (teamName: string,
    connectorId: string,
    platformConnectorAuthRequestAWS: PlatformConnectorAuthRequestAWS, options?: RequestInit) => {

  return customFetch<PlatformConnectorAuthResponseAWS>(getPlatformAuthenticateConnectorAWSUrl(teamName,connectorId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformConnectorAuthRequestAWS,)
  }
);}




export const getPlatformAuthenticateConnectorAWSMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestAWS}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestAWS}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorAWS'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>, {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestAWS}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformAuthenticateConnectorAWS(teamName,connectorId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorAWSMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>>
    export type PlatformAuthenticateConnectorAWSMutationBody = PlatformConnectorAuthRequestAWS
    export type PlatformAuthenticateConnectorAWSMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorAWS = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestAWS}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestAWS},
        TContext
      > => {
      return useMutation(getPlatformAuthenticateConnectorAWSMutationOptions(options));
    }

/**
 * Complete authentication for the given AWS connector
 */
export const getPlatformAuthenticateConnectorFinishAWSUrl = (teamName: string,
    connectorId: string,) => {




  return `/teams/${teamName}/connectors/${connectorId}/authenticate/aws`
}

export const platformAuthenticateConnectorFinishAWS = async (teamName: string,
    connectorId: string,
    platformConnectorAuthFinishRequestAWS: PlatformConnectorAuthFinishRequestAWS, options?: RequestInit) => {

  return customFetch<void>(getPlatformAuthenticateConnectorFinishAWSUrl(teamName,connectorId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformConnectorAuthFinishRequestAWS,)
  }
);}




export const getPlatformAuthenticateConnectorFinishAWSMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestAWS}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestAWS}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorFinishAWS'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>, {teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestAWS}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformAuthenticateConnectorFinishAWS(teamName,connectorId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorFinishAWSMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>>
    export type PlatformAuthenticateConnectorFinishAWSMutationBody = PlatformConnectorAuthFinishRequestAWS
    export type PlatformAuthenticateConnectorFinishAWSMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorFinishAWS = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestAWS}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestAWS},
        TContext
      > => {
      return useMutation(getPlatformAuthenticateConnectorFinishAWSMutationOptions(options));
    }

/**
 * Get authentication status for the given GCP connector
 */
export const getPlatformGetConnectorAuthStatusGCPUrl = (teamName: string,
    connectorId: string,) => {




  return `/teams/${teamName}/connectors/${connectorId}/authenticate/gcp`
}

export const platformGetConnectorAuthStatusGCP = async (teamName: string,
    connectorId: string, options?: RequestInit) => {

  return customFetch<PlatformGetConnectorAuthStatusGCP200>(getPlatformGetConnectorAuthStatusGCPUrl(teamName,connectorId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetConnectorAuthStatusGCPQueryKey = (teamName: string,
    connectorId: string,) => {
    return [
    `/teams/${teamName}/connectors/${connectorId}/authenticate/gcp`
    ] as const;
    }


export const getPlatformGetConnectorAuthStatusGCPQueryOptions = <TData = Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetConnectorAuthStatusGCPQueryKey(teamName,connectorId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>> = ({ signal }) => platformGetConnectorAuthStatusGCP(teamName,connectorId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetConnectorAuthStatusGCPQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>>
export type PlatformGetConnectorAuthStatusGCPQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetConnectorAuthStatusGCP<TData = Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetConnectorAuthStatusGCPQueryOptions(teamName,connectorId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Authenticate or reauthenticate the given GCP connector
 */
export const getPlatformAuthenticateConnectorGCPUrl = (teamName: string,
    connectorId: string,) => {




  return `/teams/${teamName}/connectors/${connectorId}/authenticate/gcp`
}

export const platformAuthenticateConnectorGCP = async (teamName: string,
    connectorId: string,
    platformConnectorAuthRequestGCP: PlatformConnectorAuthRequestGCP, options?: RequestInit) => {

  return customFetch<PlatformConnectorAuthResponseGCP>(getPlatformAuthenticateConnectorGCPUrl(teamName,connectorId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformConnectorAuthRequestGCP,)
  }
);}




export const getPlatformAuthenticateConnectorGCPMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestGCP}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestGCP}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorGCP'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>, {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestGCP}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformAuthenticateConnectorGCP(teamName,connectorId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorGCPMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>>
    export type PlatformAuthenticateConnectorGCPMutationBody = PlatformConnectorAuthRequestGCP
    export type PlatformAuthenticateConnectorGCPMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorGCP = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestGCP}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestGCP},
        TContext
      > => {
      return useMutation(getPlatformAuthenticateConnectorGCPMutationOptions(options));
    }

/**
 * Complete authentication for the given GCP connector
 */
export const getPlatformAuthenticateConnectorFinishGCPUrl = (teamName: string,
    connectorId: string,) => {




  return `/teams/${teamName}/connectors/${connectorId}/authenticate/gcp/finish`
}

export const platformAuthenticateConnectorFinishGCP = async (teamName: string,
    connectorId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformAuthenticateConnectorFinishGCPUrl(teamName,connectorId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformAuthenticateConnectorFinishGCPMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>, TError,{teamName: string;connectorId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>, TError,{teamName: string;connectorId: string}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorFinishGCP'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>, {teamName: string;connectorId: string}> = (props) => {
          const {teamName,connectorId} = props ?? {};

          return  platformAuthenticateConnectorFinishGCP(teamName,connectorId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorFinishGCPMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>>

    export type PlatformAuthenticateConnectorFinishGCPMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorFinishGCP = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>, TError,{teamName: string;connectorId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>,
        TError,
        {teamName: string;connectorId: string},
        TContext
      > => {
      return useMutation(getPlatformAuthenticateConnectorFinishGCPMutationOptions(options));
    }

/**
 * Authenticate or reauthenticate the given OAuth connector
 */
export const getPlatformAuthenticateConnectorOAuthUrl = (teamName: string,
    connectorId: string,) => {




  return `/teams/${teamName}/connectors/${connectorId}/authenticate/oauth`
}

export const platformAuthenticateConnectorOAuth = async (teamName: string,
    connectorId: string,
    platformConnectorAuthRequestOAuth: PlatformConnectorAuthRequestOAuth, options?: RequestInit) => {

  return customFetch<PlatformConnectorAuthResponseOAuth>(getPlatformAuthenticateConnectorOAuthUrl(teamName,connectorId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformConnectorAuthRequestOAuth,)
  }
);}




export const getPlatformAuthenticateConnectorOAuthMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestOAuth}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestOAuth}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorOAuth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>, {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestOAuth}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformAuthenticateConnectorOAuth(teamName,connectorId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorOAuthMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>>
    export type PlatformAuthenticateConnectorOAuthMutationBody = PlatformConnectorAuthRequestOAuth
    export type PlatformAuthenticateConnectorOAuthMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorOAuth = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestOAuth}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestOAuth},
        TContext
      > => {
      return useMutation(getPlatformAuthenticateConnectorOAuthMutationOptions(options));
    }

/**
 * Complete authentication for the given OAuth connector
 */
export const getPlatformAuthenticateConnectorFinishOAuthUrl = (teamName: string,
    connectorId: string,) => {




  return `/teams/${teamName}/connectors/${connectorId}/authenticate/oauth`
}

export const platformAuthenticateConnectorFinishOAuth = async (teamName: string,
    connectorId: string,
    platformConnectorAuthFinishRequestOAuth: PlatformConnectorAuthFinishRequestOAuth, options?: RequestInit) => {

  return customFetch<PlatformConnectorAuthResponseOAuth | void>(getPlatformAuthenticateConnectorFinishOAuthUrl(teamName,connectorId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformConnectorAuthFinishRequestOAuth,)
  }
);}




export const getPlatformAuthenticateConnectorFinishOAuthMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestOAuth}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestOAuth}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorFinishOAuth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>, {teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestOAuth}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformAuthenticateConnectorFinishOAuth(teamName,connectorId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorFinishOAuthMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>>
    export type PlatformAuthenticateConnectorFinishOAuthMutationBody = PlatformConnectorAuthFinishRequestOAuth
    export type PlatformAuthenticateConnectorFinishOAuthMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorFinishOAuth = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestOAuth}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestOAuth},
        TContext
      > => {
      return useMutation(getPlatformAuthenticateConnectorFinishOAuthMutationOptions(options));
    }

/**
 * Create a new AI chat conversation. Note that this endpoint does not currently support API key authentication.
 * @summary Start a new chat conversation
 */
export const getPlatformCreateConversationUrl = (teamName: string,) => {




  return `/teams/${teamName}/conversations`
}

export const platformCreateConversation = async (teamName: string,
    platformConversationCreate: PlatformConversationCreate, options?: RequestInit) => {

  return customFetch<PlatformConversation>(getPlatformCreateConversationUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformConversationCreate,)
  }
);}




export const getPlatformCreateConversationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateConversation>>, TError,{teamName: string;data: PlatformConversationCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateConversation>>, TError,{teamName: string;data: PlatformConversationCreate}, TContext> => {

const mutationKey = ['platformCreateConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateConversation>>, {teamName: string;data: PlatformConversationCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateConversation(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateConversationMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateConversation>>>
    export type PlatformCreateConversationMutationBody = PlatformConversationCreate
    export type PlatformCreateConversationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    /**
 * @summary Start a new chat conversation
 */
export const usePlatformCreateConversation = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateConversation>>, TError,{teamName: string;data: PlatformConversationCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateConversation>>,
        TError,
        {teamName: string;data: PlatformConversationCreate},
        TContext
      > => {
      return useMutation(getPlatformCreateConversationMutationOptions(options));
    }

/**
 * Get details of an existing AI chat conversation. Useful for polling for updates. Note that this endpoint does not currently support API key authentication.
 * @summary Retrieve a chat conversation
 */
export const getPlatformGetConversationUrl = (teamName: string,
    conversationId: string,) => {




  return `/teams/${teamName}/conversations/${conversationId}`
}

export const platformGetConversation = async (teamName: string,
    conversationId: string, options?: RequestInit) => {

  return customFetch<PlatformConversation>(getPlatformGetConversationUrl(teamName,conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetConversationQueryKey = (teamName: string,
    conversationId: string,) => {
    return [
    `/teams/${teamName}/conversations/${conversationId}`
    ] as const;
    }


export const getPlatformGetConversationQueryOptions = <TData = Awaited<ReturnType<typeof platformGetConversation>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    conversationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetConversationQueryKey(teamName,conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetConversation>>> = ({ signal }) => platformGetConversation(teamName,conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && conversationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetConversation>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetConversationQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetConversation>>>
export type PlatformGetConversationQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse


/**
 * @summary Retrieve a chat conversation
 */

export function usePlatformGetConversation<TData = Awaited<ReturnType<typeof platformGetConversation>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    conversationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetConversationQueryOptions(teamName,conversationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Send a new message to an existing AI chat conversation. Note that this endpoint does not currently support API key authentication.
 * @summary Add a message to an existing conversation
 */
export const getPlatformSendMessageUrl = (teamName: string,
    conversationId: string,) => {




  return `/teams/${teamName}/conversations/${conversationId}`
}

export const platformSendMessage = async (teamName: string,
    conversationId: string,
    platformConversationSendMessage: PlatformConversationSendMessage, options?: RequestInit) => {

  return customFetch<PlatformConversationMessage>(getPlatformSendMessageUrl(teamName,conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformConversationSendMessage,)
  }
);}




export const getPlatformSendMessageMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSendMessage>>, TError,{teamName: string;conversationId: string;data: PlatformConversationSendMessage}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformSendMessage>>, TError,{teamName: string;conversationId: string;data: PlatformConversationSendMessage}, TContext> => {

const mutationKey = ['platformSendMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformSendMessage>>, {teamName: string;conversationId: string;data: PlatformConversationSendMessage}> = (props) => {
          const {teamName,conversationId,data} = props ?? {};

          return  platformSendMessage(teamName,conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformSendMessageMutationResult = NonNullable<Awaited<ReturnType<typeof platformSendMessage>>>
    export type PlatformSendMessageMutationBody = PlatformConversationSendMessage
    export type PlatformSendMessageMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    /**
 * @summary Add a message to an existing conversation
 */
export const usePlatformSendMessage = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSendMessage>>, TError,{teamName: string;conversationId: string;data: PlatformConversationSendMessage}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformSendMessage>>,
        TError,
        {teamName: string;conversationId: string;data: PlatformConversationSendMessage},
        TContext
      > => {
      return useMutation(getPlatformSendMessageMutationOptions(options));
    }

/**
 * List all custom columns
 */
export const getPlatformListAllCustomColumnsUrl = (teamName: string,
    params?: PlatformListAllCustomColumnsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/custom-columns?${stringifiedParams}` : `/teams/${teamName}/custom-columns`
}

export const platformListAllCustomColumns = async (teamName: string,
    params?: PlatformListAllCustomColumnsParams, options?: RequestInit) => {

  return customFetch<PlatformListAllCustomColumns200>(getPlatformListAllCustomColumnsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListAllCustomColumnsQueryKey = (teamName: string,
    params?: PlatformListAllCustomColumnsParams,) => {
    return [
    `/teams/${teamName}/custom-columns`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListAllCustomColumnsQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllCustomColumns>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListAllCustomColumnsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllCustomColumns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllCustomColumnsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllCustomColumns>>> = ({ signal }) => platformListAllCustomColumns(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllCustomColumns>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllCustomColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllCustomColumns>>>
export type PlatformListAllCustomColumnsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListAllCustomColumns<TData = Awaited<ReturnType<typeof platformListAllCustomColumns>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListAllCustomColumnsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllCustomColumns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllCustomColumnsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Save a custom column
 */
export const getPlatformSaveCustomColumnUrl = (teamName: string,) => {




  return `/teams/${teamName}/custom-columns`
}

export const platformSaveCustomColumn = async (teamName: string,
    platformCustomColumnCreateOrUpdate: PlatformCustomColumnCreateOrUpdate, options?: RequestInit) => {

  return customFetch<PlatformCustomColumn>(getPlatformSaveCustomColumnUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCustomColumnCreateOrUpdate,)
  }
);}




export const getPlatformSaveCustomColumnMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSaveCustomColumn>>, TError,{teamName: string;data: PlatformCustomColumnCreateOrUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformSaveCustomColumn>>, TError,{teamName: string;data: PlatformCustomColumnCreateOrUpdate}, TContext> => {

const mutationKey = ['platformSaveCustomColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformSaveCustomColumn>>, {teamName: string;data: PlatformCustomColumnCreateOrUpdate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformSaveCustomColumn(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformSaveCustomColumnMutationResult = NonNullable<Awaited<ReturnType<typeof platformSaveCustomColumn>>>
    export type PlatformSaveCustomColumnMutationBody = PlatformCustomColumnCreateOrUpdate
    export type PlatformSaveCustomColumnMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformSaveCustomColumn = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSaveCustomColumn>>, TError,{teamName: string;data: PlatformCustomColumnCreateOrUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformSaveCustomColumn>>,
        TError,
        {teamName: string;data: PlatformCustomColumnCreateOrUpdate},
        TContext
      > => {
      return useMutation(getPlatformSaveCustomColumnMutationOptions(options));
    }

/**
 * Get a custom column
 */
export const getPlatformGetCustomColumnUrl = (teamName: string,
    customColumnId: string,) => {




  return `/teams/${teamName}/custom-columns/${customColumnId}`
}

export const platformGetCustomColumn = async (teamName: string,
    customColumnId: string, options?: RequestInit) => {

  return customFetch<PlatformCustomColumn>(getPlatformGetCustomColumnUrl(teamName,customColumnId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetCustomColumnQueryKey = (teamName: string,
    customColumnId: string,) => {
    return [
    `/teams/${teamName}/custom-columns/${customColumnId}`
    ] as const;
    }


export const getPlatformGetCustomColumnQueryOptions = <TData = Awaited<ReturnType<typeof platformGetCustomColumn>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    customColumnId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCustomColumn>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetCustomColumnQueryKey(teamName,customColumnId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetCustomColumn>>> = ({ signal }) => platformGetCustomColumn(teamName,customColumnId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && customColumnId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetCustomColumn>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetCustomColumnQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetCustomColumn>>>
export type PlatformGetCustomColumnQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetCustomColumn<TData = Awaited<ReturnType<typeof platformGetCustomColumn>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    customColumnId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCustomColumn>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetCustomColumnQueryOptions(teamName,customColumnId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a custom column
 */
export const getPlatformUpdateCustomColumnUrl = (teamName: string,
    customColumnId: string,) => {




  return `/teams/${teamName}/custom-columns/${customColumnId}`
}

export const platformUpdateCustomColumn = async (teamName: string,
    customColumnId: string,
    platformCustomColumnCreateOrUpdate: PlatformCustomColumnCreateOrUpdate, options?: RequestInit) => {

  return customFetch<PlatformCustomColumn>(getPlatformUpdateCustomColumnUrl(teamName,customColumnId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCustomColumnCreateOrUpdate,)
  }
);}




export const getPlatformUpdateCustomColumnMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomColumn>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnCreateOrUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomColumn>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnCreateOrUpdate}, TContext> => {

const mutationKey = ['platformUpdateCustomColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateCustomColumn>>, {teamName: string;customColumnId: string;data: PlatformCustomColumnCreateOrUpdate}> = (props) => {
          const {teamName,customColumnId,data} = props ?? {};

          return  platformUpdateCustomColumn(teamName,customColumnId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateCustomColumnMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateCustomColumn>>>
    export type PlatformUpdateCustomColumnMutationBody = PlatformCustomColumnCreateOrUpdate
    export type PlatformUpdateCustomColumnMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateCustomColumn = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomColumn>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnCreateOrUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateCustomColumn>>,
        TError,
        {teamName: string;customColumnId: string;data: PlatformCustomColumnCreateOrUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateCustomColumnMutationOptions(options));
    }

/**
 * Delete a custom column
 */
export const getPlatformDeleteCustomColumnUrl = (teamName: string,
    customColumnId: string,) => {




  return `/teams/${teamName}/custom-columns/${customColumnId}`
}

export const platformDeleteCustomColumn = async (teamName: string,
    customColumnId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteCustomColumnUrl(teamName,customColumnId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteCustomColumnMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteCustomColumn>>, TError,{teamName: string;customColumnId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteCustomColumn>>, TError,{teamName: string;customColumnId: string}, TContext> => {

const mutationKey = ['platformDeleteCustomColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteCustomColumn>>, {teamName: string;customColumnId: string}> = (props) => {
          const {teamName,customColumnId} = props ?? {};

          return  platformDeleteCustomColumn(teamName,customColumnId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteCustomColumnMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteCustomColumn>>>

    export type PlatformDeleteCustomColumnMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteCustomColumn = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteCustomColumn>>, TError,{teamName: string;customColumnId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteCustomColumn>>,
        TError,
        {teamName: string;customColumnId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteCustomColumnMutationOptions(options));
    }

/**
 * Import data into a Custom Column
 */
export const getPlatformPutCustomColumnDataUrl = (teamName: string,
    customColumnId: string,) => {




  return `/teams/${teamName}/custom-columns/${customColumnId}/import`
}

export const platformPutCustomColumnData = async (teamName: string,
    customColumnId: string,
    platformCustomColumnDataImport: PlatformCustomColumnDataImport, options?: RequestInit) => {

  return customFetch<PlatformPutCustomColumnData202>(getPlatformPutCustomColumnDataUrl(teamName,customColumnId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCustomColumnDataImport,)
  }
);}




export const getPlatformPutCustomColumnDataMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnData>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataImport}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnData>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataImport}, TContext> => {

const mutationKey = ['platformPutCustomColumnData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformPutCustomColumnData>>, {teamName: string;customColumnId: string;data: PlatformCustomColumnDataImport}> = (props) => {
          const {teamName,customColumnId,data} = props ?? {};

          return  platformPutCustomColumnData(teamName,customColumnId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformPutCustomColumnDataMutationResult = NonNullable<Awaited<ReturnType<typeof platformPutCustomColumnData>>>
    export type PlatformPutCustomColumnDataMutationBody = PlatformCustomColumnDataImport
    export type PlatformPutCustomColumnDataMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse

    export const usePlatformPutCustomColumnData = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnData>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataImport}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformPutCustomColumnData>>,
        TError,
        {teamName: string;customColumnId: string;data: PlatformCustomColumnDataImport},
        TContext
      > => {
      return useMutation(getPlatformPutCustomColumnDataMutationOptions(options));
    }

/**
 * Edit values within a Custom Column
 */
export const getPlatformPutCustomColumnValuesUrl = (teamName: string,
    customColumnId: string,) => {




  return `/teams/${teamName}/custom-columns/${customColumnId}/values`
}

export const platformPutCustomColumnValues = async (teamName: string,
    customColumnId: string,
    platformCustomColumnDataValues: PlatformCustomColumnDataValues, options?: RequestInit) => {

  return customFetch<PlatformPutCustomColumnValues200>(getPlatformPutCustomColumnValuesUrl(teamName,customColumnId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCustomColumnDataValues,)
  }
);}




export const getPlatformPutCustomColumnValuesMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnValues>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataValues}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnValues>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataValues}, TContext> => {

const mutationKey = ['platformPutCustomColumnValues'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformPutCustomColumnValues>>, {teamName: string;customColumnId: string;data: PlatformCustomColumnDataValues}> = (props) => {
          const {teamName,customColumnId,data} = props ?? {};

          return  platformPutCustomColumnValues(teamName,customColumnId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformPutCustomColumnValuesMutationResult = NonNullable<Awaited<ReturnType<typeof platformPutCustomColumnValues>>>
    export type PlatformPutCustomColumnValuesMutationBody = PlatformCustomColumnDataValues
    export type PlatformPutCustomColumnValuesMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse

    export const usePlatformPutCustomColumnValues = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnValues>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataValues}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformPutCustomColumnValues>>,
        TError,
        {teamName: string;customColumnId: string;data: PlatformCustomColumnDataValues},
        TContext
      > => {
      return useMutation(getPlatformPutCustomColumnValuesMutationOptions(options));
    }

/**
 * List Filters
 */
export const getPlatformListFiltersTeamUrl = (teamName: string,
    params?: PlatformListFiltersTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["tag"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/filters?${stringifiedParams}` : `/teams/${teamName}/filters`
}

export const platformListFiltersTeam = async (teamName: string,
    params?: PlatformListFiltersTeamParams, options?: RequestInit) => {

  return customFetch<PlatformListFiltersTeam200>(getPlatformListFiltersTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListFiltersTeamQueryKey = (teamName: string,
    params?: PlatformListFiltersTeamParams,) => {
    return [
    `/teams/${teamName}/filters`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListFiltersTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListFiltersTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFiltersTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListFiltersTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListFiltersTeam>>> = ({ signal }) => platformListFiltersTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListFiltersTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListFiltersTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListFiltersTeam>>>
export type PlatformListFiltersTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListFiltersTeam<TData = Awaited<ReturnType<typeof platformListFiltersTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFiltersTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListFiltersTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List Filter Tags
 */
export const getPlatformListFilterTagsTeamUrl = (teamName: string,
    params?: PlatformListFilterTagsTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/filters/tags?${stringifiedParams}` : `/teams/${teamName}/filters/tags`
}

export const platformListFilterTagsTeam = async (teamName: string,
    params?: PlatformListFilterTagsTeamParams, options?: RequestInit) => {

  return customFetch<PlatformListFilterTagsTeam200>(getPlatformListFilterTagsTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListFilterTagsTeamQueryKey = (teamName: string,
    params?: PlatformListFilterTagsTeamParams,) => {
    return [
    `/teams/${teamName}/filters/tags`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListFilterTagsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFilterTagsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListFilterTagsTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListFilterTagsTeam>>> = ({ signal }) => platformListFilterTagsTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListFilterTagsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListFilterTagsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListFilterTagsTeam>>>
export type PlatformListFilterTagsTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListFilterTagsTeam<TData = Awaited<ReturnType<typeof platformListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFilterTagsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListFilterTagsTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a table filter by ID
 */
export const getPlatformGetFilterByIDTeamUrl = (teamName: string,
    filterId: string,) => {




  return `/teams/${teamName}/filters/${filterId}`
}

export const platformGetFilterByIDTeam = async (teamName: string,
    filterId: string, options?: RequestInit) => {

  return customFetch<PlatformFilter>(getPlatformGetFilterByIDTeamUrl(teamName,filterId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetFilterByIDTeamQueryKey = (teamName: string,
    filterId: string,) => {
    return [
    `/teams/${teamName}/filters/${filterId}`
    ] as const;
    }


export const getPlatformGetFilterByIDTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformGetFilterByIDTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    filterId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetFilterByIDTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetFilterByIDTeamQueryKey(teamName,filterId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetFilterByIDTeam>>> = ({ signal }) => platformGetFilterByIDTeam(teamName,filterId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && filterId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetFilterByIDTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetFilterByIDTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetFilterByIDTeam>>>
export type PlatformGetFilterByIDTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetFilterByIDTeam<TData = Awaited<ReturnType<typeof platformGetFilterByIDTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    filterId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetFilterByIDTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetFilterByIDTeamQueryOptions(teamName,filterId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a table filter
 */
export const getPlatformUpdateFilterTeamUrl = (teamName: string,
    filterId: string,) => {




  return `/teams/${teamName}/filters/${filterId}`
}

export const platformUpdateFilterTeam = async (teamName: string,
    filterId: string,
    platformFilterUpdate: PlatformFilterUpdate, options?: RequestInit) => {

  return customFetch<PlatformFilter>(getPlatformUpdateFilterTeamUrl(teamName,filterId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformFilterUpdate,)
  }
);}




export const getPlatformUpdateFilterTeamMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateFilterTeam>>, TError,{teamName: string;filterId: string;data: PlatformFilterUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateFilterTeam>>, TError,{teamName: string;filterId: string;data: PlatformFilterUpdate}, TContext> => {

const mutationKey = ['platformUpdateFilterTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateFilterTeam>>, {teamName: string;filterId: string;data: PlatformFilterUpdate}> = (props) => {
          const {teamName,filterId,data} = props ?? {};

          return  platformUpdateFilterTeam(teamName,filterId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateFilterTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateFilterTeam>>>
    export type PlatformUpdateFilterTeamMutationBody = PlatformFilterUpdate
    export type PlatformUpdateFilterTeamMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateFilterTeam = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateFilterTeam>>, TError,{teamName: string;filterId: string;data: PlatformFilterUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateFilterTeam>>,
        TError,
        {teamName: string;filterId: string;data: PlatformFilterUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateFilterTeamMutationOptions(options));
    }

/**
 * Delete a table filter
 */
export const getPlatformDeleteFilterTeamUrl = (teamName: string,
    filterId: string,) => {




  return `/teams/${teamName}/filters/${filterId}`
}

export const platformDeleteFilterTeam = async (teamName: string,
    filterId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteFilterTeamUrl(teamName,filterId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteFilterTeamMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteFilterTeam>>, TError,{teamName: string;filterId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteFilterTeam>>, TError,{teamName: string;filterId: string}, TContext> => {

const mutationKey = ['platformDeleteFilterTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteFilterTeam>>, {teamName: string;filterId: string}> = (props) => {
          const {teamName,filterId} = props ?? {};

          return  platformDeleteFilterTeam(teamName,filterId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteFilterTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteFilterTeam>>>

    export type PlatformDeleteFilterTeamMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteFilterTeam = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteFilterTeam>>, TError,{teamName: string;filterId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteFilterTeam>>,
        TError,
        {teamName: string;filterId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteFilterTeamMutationOptions(options));
    }

/**
 * Get URLs to upload images for a given team
 */
export const getPlatformCreateTeamImagesUrl = (teamName: string,) => {




  return `/teams/${teamName}/images`
}

export const platformCreateTeamImages = async (teamName: string,
    platformCreateTeamImagesBody: PlatformCreateTeamImagesBody, options?: RequestInit) => {

  return customFetch<PlatformCreateTeamImages201>(getPlatformCreateTeamImagesUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreateTeamImagesBody,)
  }
);}




export const getPlatformCreateTeamImagesMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamImages>>, TError,{teamName: string;data: PlatformCreateTeamImagesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamImages>>, TError,{teamName: string;data: PlatformCreateTeamImagesBody}, TContext> => {

const mutationKey = ['platformCreateTeamImages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateTeamImages>>, {teamName: string;data: PlatformCreateTeamImagesBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateTeamImages(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateTeamImagesMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateTeamImages>>>
    export type PlatformCreateTeamImagesMutationBody = PlatformCreateTeamImagesBody
    export type PlatformCreateTeamImagesMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformCreateTeamImages = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamImages>>, TError,{teamName: string;data: PlatformCreateTeamImagesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateTeamImages>>,
        TError,
        {teamName: string;data: PlatformCreateTeamImagesBody},
        TContext
      > => {
      return useMutation(getPlatformCreateTeamImagesMutationOptions(options));
    }

/**
 * List of open invitations to the team
 */
export const getPlatformListTeamInvitationsUrl = (teamName: string,
    params?: PlatformListTeamInvitationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/invitations?${stringifiedParams}` : `/teams/${teamName}/invitations`
}

export const platformListTeamInvitations = async (teamName: string,
    params?: PlatformListTeamInvitationsParams, options?: RequestInit) => {

  return customFetch<PlatformListTeamInvitations200>(getPlatformListTeamInvitationsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListTeamInvitationsQueryKey = (teamName: string,
    params?: PlatformListTeamInvitationsParams,) => {
    return [
    `/teams/${teamName}/invitations`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListTeamInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof platformListTeamInvitations>>, TError = PlatformForbiddenResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListTeamInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeamInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTeamInvitationsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTeamInvitations>>> = ({ signal }) => platformListTeamInvitations(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListTeamInvitations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListTeamInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTeamInvitations>>>
export type PlatformListTeamInvitationsQueryError = PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformListTeamInvitations<TData = Awaited<ReturnType<typeof platformListTeamInvitations>>, TError = PlatformForbiddenResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListTeamInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeamInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListTeamInvitationsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Delete an invitation to the team, preventing the user becoming a team member
 */
export const getPlatformDeleteTeamInvitationUrl = (teamName: string,) => {




  return `/teams/${teamName}/invitations`
}

export const platformDeleteTeamInvitation = async (teamName: string,
    platformDeleteTeamInvitationBody: PlatformDeleteTeamInvitationBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteTeamInvitationUrl(teamName),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformDeleteTeamInvitationBody,)
  }
);}




export const getPlatformDeleteTeamInvitationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamInvitation>>, TError,{teamName: string;data: PlatformDeleteTeamInvitationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamInvitation>>, TError,{teamName: string;data: PlatformDeleteTeamInvitationBody}, TContext> => {

const mutationKey = ['platformDeleteTeamInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteTeamInvitation>>, {teamName: string;data: PlatformDeleteTeamInvitationBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformDeleteTeamInvitation(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteTeamInvitation>>>
    export type PlatformDeleteTeamInvitationMutationBody = PlatformDeleteTeamInvitationBody
    export type PlatformDeleteTeamInvitationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteTeamInvitation = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamInvitation>>, TError,{teamName: string;data: PlatformDeleteTeamInvitationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteTeamInvitation>>,
        TError,
        {teamName: string;data: PlatformDeleteTeamInvitationBody},
        TContext
      > => {
      return useMutation(getPlatformDeleteTeamInvitationMutationOptions(options));
    }

/**
 * Accept an invitation to the team, creating a user membership
 */
export const getPlatformAcceptTeamInvitationUrl = (teamName: string,) => {




  return `/teams/${teamName}/invitations/accept`
}

export const platformAcceptTeamInvitation = async (teamName: string,
    platformAcceptTeamInvitationBody: PlatformAcceptTeamInvitationBody, options?: RequestInit) => {

  return customFetch<PlatformMembershipWithTeam>(getPlatformAcceptTeamInvitationUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformAcceptTeamInvitationBody,)
  }
);}




export const getPlatformAcceptTeamInvitationMutationOptions = <TError = PlatformMembershipWithTeam | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAcceptTeamInvitation>>, TError,{teamName: string;data: PlatformAcceptTeamInvitationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAcceptTeamInvitation>>, TError,{teamName: string;data: PlatformAcceptTeamInvitationBody}, TContext> => {

const mutationKey = ['platformAcceptTeamInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAcceptTeamInvitation>>, {teamName: string;data: PlatformAcceptTeamInvitationBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformAcceptTeamInvitation(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAcceptTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof platformAcceptTeamInvitation>>>
    export type PlatformAcceptTeamInvitationMutationBody = PlatformAcceptTeamInvitationBody
    export type PlatformAcceptTeamInvitationMutationError = PlatformMembershipWithTeam | PlatformForbiddenResponse | PlatformInternalErrorResponse

    export const usePlatformAcceptTeamInvitation = <TError = PlatformMembershipWithTeam | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAcceptTeamInvitation>>, TError,{teamName: string;data: PlatformAcceptTeamInvitationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAcceptTeamInvitation>>,
        TError,
        {teamName: string;data: PlatformAcceptTeamInvitationBody},
        TContext
      > => {
      return useMutation(getPlatformAcceptTeamInvitationMutationOptions(options));
    }

/**
 * Get memberships to the team.
 */
export const getPlatformGetTeamMembershipsUrl = (teamName: string,
    params?: PlatformGetTeamMembershipsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/memberships?${stringifiedParams}` : `/teams/${teamName}/memberships`
}

export const platformGetTeamMemberships = async (teamName: string,
    params?: PlatformGetTeamMembershipsParams, options?: RequestInit) => {

  return customFetch<PlatformGetTeamMemberships200>(getPlatformGetTeamMembershipsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetTeamMembershipsQueryKey = (teamName: string,
    params?: PlatformGetTeamMembershipsParams,) => {
    return [
    `/teams/${teamName}/memberships`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetTeamMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTeamMemberships>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformGetTeamMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamMemberships>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTeamMembershipsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTeamMemberships>>> = ({ signal }) => platformGetTeamMemberships(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamMemberships>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTeamMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTeamMemberships>>>
export type PlatformGetTeamMembershipsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetTeamMemberships<TData = Awaited<ReturnType<typeof platformGetTeamMemberships>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformGetTeamMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamMemberships>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTeamMembershipsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Remove a user from the team
 */
export const getPlatformRemoveTeamMembershipUrl = (teamName: string,) => {




  return `/teams/${teamName}/memberships`
}

export const platformRemoveTeamMembership = async (teamName: string,
    platformRemoveTeamMembershipBody: PlatformRemoveTeamMembershipBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformRemoveTeamMembershipUrl(teamName),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformRemoveTeamMembershipBody,)
  }
);}




export const getPlatformRemoveTeamMembershipMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemoveTeamMembership>>, TError,{teamName: string;data: PlatformRemoveTeamMembershipBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformRemoveTeamMembership>>, TError,{teamName: string;data: PlatformRemoveTeamMembershipBody}, TContext> => {

const mutationKey = ['platformRemoveTeamMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformRemoveTeamMembership>>, {teamName: string;data: PlatformRemoveTeamMembershipBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformRemoveTeamMembership(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformRemoveTeamMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof platformRemoveTeamMembership>>>
    export type PlatformRemoveTeamMembershipMutationBody = PlatformRemoveTeamMembershipBody
    export type PlatformRemoveTeamMembershipMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformRemoveTeamMembership = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemoveTeamMembership>>, TError,{teamName: string;data: PlatformRemoveTeamMembershipBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformRemoveTeamMembership>>,
        TError,
        {teamName: string;data: PlatformRemoveTeamMembershipBody},
        TContext
      > => {
      return useMutation(getPlatformRemoveTeamMembershipMutationOptions(options));
    }

/**
 * Remove a user from the team
 * @deprecated
 */
export const getPlatformDeleteTeamMembershipUrl = (teamName: string,
    email: string,) => {




  return `/teams/${teamName}/memberships/${email}`
}

export const platformDeleteTeamMembership = async (teamName: string,
    email: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteTeamMembershipUrl(teamName,email),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteTeamMembershipMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamMembership>>, TError,{teamName: string;email: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamMembership>>, TError,{teamName: string;email: string}, TContext> => {

const mutationKey = ['platformDeleteTeamMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteTeamMembership>>, {teamName: string;email: string}> = (props) => {
          const {teamName,email} = props ?? {};

          return  platformDeleteTeamMembership(teamName,email,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteTeamMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteTeamMembership>>>

    export type PlatformDeleteTeamMembershipMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    /**
 * @deprecated
 */
export const usePlatformDeleteTeamMembership = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamMembership>>, TError,{teamName: string;email: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteTeamMembership>>,
        TError,
        {teamName: string;email: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteTeamMembershipMutationOptions(options));
    }

/**
 * List all notification destinations
 */
export const getPlatformListAllNotificationDestinationsUrl = (teamName: string,
    params?: PlatformListAllNotificationDestinationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/notifications/destinations?${stringifiedParams}` : `/teams/${teamName}/notifications/destinations`
}

export const platformListAllNotificationDestinations = async (teamName: string,
    params?: PlatformListAllNotificationDestinationsParams, options?: RequestInit) => {

  return customFetch<PlatformListAllNotificationDestinations200>(getPlatformListAllNotificationDestinationsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListAllNotificationDestinationsQueryKey = (teamName: string,
    params?: PlatformListAllNotificationDestinationsParams,) => {
    return [
    `/teams/${teamName}/notifications/destinations`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListAllNotificationDestinationsQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllNotificationDestinations>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListAllNotificationDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllNotificationDestinations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllNotificationDestinationsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllNotificationDestinations>>> = ({ signal }) => platformListAllNotificationDestinations(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllNotificationDestinations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllNotificationDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllNotificationDestinations>>>
export type PlatformListAllNotificationDestinationsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListAllNotificationDestinations<TData = Awaited<ReturnType<typeof platformListAllNotificationDestinations>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListAllNotificationDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllNotificationDestinations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllNotificationDestinationsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create notification destination
 */
export const getPlatformCreateNotificationDestinationUrl = (teamName: string,) => {




  return `/teams/${teamName}/notifications/destinations`
}

export const platformCreateNotificationDestination = async (teamName: string,
    platformNotificationDestinationCreate: PlatformNotificationDestinationCreate, options?: RequestInit) => {

  return customFetch<PlatformNotificationDestination>(getPlatformCreateNotificationDestinationUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformNotificationDestinationCreate,)
  }
);}




export const getPlatformCreateNotificationDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationCreate}, TContext> => {

const mutationKey = ['platformCreateNotificationDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateNotificationDestination>>, {teamName: string;data: PlatformNotificationDestinationCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateNotificationDestination(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateNotificationDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateNotificationDestination>>>
    export type PlatformCreateNotificationDestinationMutationBody = PlatformNotificationDestinationCreate
    export type PlatformCreateNotificationDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateNotificationDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateNotificationDestination>>,
        TError,
        {teamName: string;data: PlatformNotificationDestinationCreate},
        TContext
      > => {
      return useMutation(getPlatformCreateNotificationDestinationMutationOptions(options));
    }

/**
 * Test an unsaved notification destination
 */
export const getPlatformTestUnsavedNotificationDestinationUrl = (teamName: string,) => {




  return `/teams/${teamName}/notifications/destinations/test`
}

export const platformTestUnsavedNotificationDestination = async (teamName: string,
    platformNotificationDestinationData: PlatformNotificationDestinationData, options?: RequestInit) => {

  return customFetch<PlatformNotificationDestinationTestResponse>(getPlatformTestUnsavedNotificationDestinationUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformNotificationDestinationData,)
  }
);}




export const getPlatformTestUnsavedNotificationDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationData}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationData}, TContext> => {

const mutationKey = ['platformTestUnsavedNotificationDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>, {teamName: string;data: PlatformNotificationDestinationData}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformTestUnsavedNotificationDestination(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformTestUnsavedNotificationDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>>
    export type PlatformTestUnsavedNotificationDestinationMutationBody = PlatformNotificationDestinationData
    export type PlatformTestUnsavedNotificationDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformTestUnsavedNotificationDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationData}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>,
        TError,
        {teamName: string;data: PlatformNotificationDestinationData},
        TContext
      > => {
      return useMutation(getPlatformTestUnsavedNotificationDestinationMutationOptions(options));
    }

/**
 * Get notification destination
 */
export const getPlatformGetNotificationDestinationUrl = (teamName: string,
    notificationDestinationId: string,) => {




  return `/teams/${teamName}/notifications/destination/${notificationDestinationId}`
}

export const platformGetNotificationDestination = async (teamName: string,
    notificationDestinationId: string, options?: RequestInit) => {

  return customFetch<PlatformNotificationDestination>(getPlatformGetNotificationDestinationUrl(teamName,notificationDestinationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetNotificationDestinationQueryKey = (teamName: string,
    notificationDestinationId: string,) => {
    return [
    `/teams/${teamName}/notifications/destination/${notificationDestinationId}`
    ] as const;
    }


export const getPlatformGetNotificationDestinationQueryOptions = <TData = Awaited<ReturnType<typeof platformGetNotificationDestination>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    notificationDestinationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestination>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetNotificationDestinationQueryKey(teamName,notificationDestinationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetNotificationDestination>>> = ({ signal }) => platformGetNotificationDestination(teamName,notificationDestinationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && notificationDestinationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestination>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetNotificationDestinationQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetNotificationDestination>>>
export type PlatformGetNotificationDestinationQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetNotificationDestination<TData = Awaited<ReturnType<typeof platformGetNotificationDestination>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    notificationDestinationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestination>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetNotificationDestinationQueryOptions(teamName,notificationDestinationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a notification destination
 */
export const getPlatformUpdateNotificationDestinationUrl = (teamName: string,
    notificationDestinationId: string,) => {




  return `/teams/${teamName}/notifications/destination/${notificationDestinationId}`
}

export const platformUpdateNotificationDestination = async (teamName: string,
    notificationDestinationId: string,
    platformNotificationDestinationUpdate: PlatformNotificationDestinationUpdate, options?: RequestInit) => {

  return customFetch<PlatformNotificationDestination>(getPlatformUpdateNotificationDestinationUrl(teamName,notificationDestinationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformNotificationDestinationUpdate,)
  }
);}




export const getPlatformUpdateNotificationDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string;data: PlatformNotificationDestinationUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string;data: PlatformNotificationDestinationUpdate}, TContext> => {

const mutationKey = ['platformUpdateNotificationDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateNotificationDestination>>, {teamName: string;notificationDestinationId: string;data: PlatformNotificationDestinationUpdate}> = (props) => {
          const {teamName,notificationDestinationId,data} = props ?? {};

          return  platformUpdateNotificationDestination(teamName,notificationDestinationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateNotificationDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateNotificationDestination>>>
    export type PlatformUpdateNotificationDestinationMutationBody = PlatformNotificationDestinationUpdate
    export type PlatformUpdateNotificationDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateNotificationDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string;data: PlatformNotificationDestinationUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateNotificationDestination>>,
        TError,
        {teamName: string;notificationDestinationId: string;data: PlatformNotificationDestinationUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateNotificationDestinationMutationOptions(options));
    }

/**
 * Delete a notification destination
 */
export const getPlatformDeleteNotificationDestinationUrl = (teamName: string,
    notificationDestinationId: string,) => {




  return `/teams/${teamName}/notifications/destination/${notificationDestinationId}`
}

export const platformDeleteNotificationDestination = async (teamName: string,
    notificationDestinationId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteNotificationDestinationUrl(teamName,notificationDestinationId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteNotificationDestinationMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext> => {

const mutationKey = ['platformDeleteNotificationDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteNotificationDestination>>, {teamName: string;notificationDestinationId: string}> = (props) => {
          const {teamName,notificationDestinationId} = props ?? {};

          return  platformDeleteNotificationDestination(teamName,notificationDestinationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteNotificationDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteNotificationDestination>>>

    export type PlatformDeleteNotificationDestinationMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteNotificationDestination = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteNotificationDestination>>,
        TError,
        {teamName: string;notificationDestinationId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteNotificationDestinationMutationOptions(options));
    }

/**
 * Get notification destination alerts
 */
export const getPlatformGetNotificationDestinationAlertsUrl = (teamName: string,
    notificationDestinationId: string,
    params?: PlatformGetNotificationDestinationAlertsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/notifications/destination/${notificationDestinationId}/alerts?${stringifiedParams}` : `/teams/${teamName}/notifications/destination/${notificationDestinationId}/alerts`
}

export const platformGetNotificationDestinationAlerts = async (teamName: string,
    notificationDestinationId: string,
    params?: PlatformGetNotificationDestinationAlertsParams, options?: RequestInit) => {

  return customFetch<PlatformGetNotificationDestinationAlerts200>(getPlatformGetNotificationDestinationAlertsUrl(teamName,notificationDestinationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetNotificationDestinationAlertsQueryKey = (teamName: string,
    notificationDestinationId: string,
    params?: PlatformGetNotificationDestinationAlertsParams,) => {
    return [
    `/teams/${teamName}/notifications/destination/${notificationDestinationId}/alerts`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetNotificationDestinationAlertsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    notificationDestinationId: string,
    params?: PlatformGetNotificationDestinationAlertsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetNotificationDestinationAlertsQueryKey(teamName,notificationDestinationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>> = ({ signal }) => platformGetNotificationDestinationAlerts(teamName,notificationDestinationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && notificationDestinationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetNotificationDestinationAlertsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>>
export type PlatformGetNotificationDestinationAlertsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetNotificationDestinationAlerts<TData = Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    notificationDestinationId: string,
    params?: PlatformGetNotificationDestinationAlertsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetNotificationDestinationAlertsQueryOptions(teamName,notificationDestinationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Test a notification destination
 */
export const getPlatformTestNotificationDestinationUrl = (teamName: string,
    notificationDestinationId: string,) => {




  return `/teams/${teamName}/notifications/destination/${notificationDestinationId}/test`
}

export const platformTestNotificationDestination = async (teamName: string,
    notificationDestinationId: string, options?: RequestInit) => {

  return customFetch<PlatformNotificationDestinationTestResponse>(getPlatformTestNotificationDestinationUrl(teamName,notificationDestinationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformTestNotificationDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformTestNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext> => {

const mutationKey = ['platformTestNotificationDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformTestNotificationDestination>>, {teamName: string;notificationDestinationId: string}> = (props) => {
          const {teamName,notificationDestinationId} = props ?? {};

          return  platformTestNotificationDestination(teamName,notificationDestinationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformTestNotificationDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformTestNotificationDestination>>>

    export type PlatformTestNotificationDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformTestNotificationDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformTestNotificationDestination>>,
        TError,
        {teamName: string;notificationDestinationId: string},
        TContext
      > => {
      return useMutation(getPlatformTestNotificationDestinationMutationOptions(options));
    }

/**
 * Create an interactive onboarding for AWS
 */
export const getPlatformCreateAWSOnboardingUrl = (teamName: string,) => {




  return `/teams/${teamName}/onboardings/aws/oidc`
}

export const platformCreateAWSOnboarding = async (teamName: string,
    platformCreateAWSOnboardingBody: PlatformCreateAWSOnboardingBody, options?: RequestInit) => {

  return customFetch<PlatformOnboardingAWSCreateResponse>(getPlatformCreateAWSOnboardingUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreateAWSOnboardingBody,)
  }
);}




export const getPlatformCreateAWSOnboardingMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateAWSOnboarding>>, TError,{teamName: string;data: PlatformCreateAWSOnboardingBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateAWSOnboarding>>, TError,{teamName: string;data: PlatformCreateAWSOnboardingBody}, TContext> => {

const mutationKey = ['platformCreateAWSOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateAWSOnboarding>>, {teamName: string;data: PlatformCreateAWSOnboardingBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateAWSOnboarding(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateAWSOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateAWSOnboarding>>>
    export type PlatformCreateAWSOnboardingMutationBody = PlatformCreateAWSOnboardingBody
    export type PlatformCreateAWSOnboardingMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse

    export const usePlatformCreateAWSOnboarding = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateAWSOnboarding>>, TError,{teamName: string;data: PlatformCreateAWSOnboardingBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateAWSOnboarding>>,
        TError,
        {teamName: string;data: PlatformCreateAWSOnboardingBody},
        TContext
      > => {
      return useMutation(getPlatformCreateAWSOnboardingMutationOptions(options));
    }

/**
 * Query an interactive onboarding for AWS
 */
export const getPlatformGetAWSOnboardingUrl = (teamName: string,
    onboardingId: string,) => {




  return `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}`
}

export const platformGetAWSOnboarding = async (teamName: string,
    onboardingId: string, options?: RequestInit) => {

  return customFetch<PlatformOnboardingAWS>(getPlatformGetAWSOnboardingUrl(teamName,onboardingId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetAWSOnboardingQueryKey = (teamName: string,
    onboardingId: string,) => {
    return [
    `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}`
    ] as const;
    }


export const getPlatformGetAWSOnboardingQueryOptions = <TData = Awaited<ReturnType<typeof platformGetAWSOnboarding>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    onboardingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSOnboarding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetAWSOnboardingQueryKey(teamName,onboardingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetAWSOnboarding>>> = ({ signal }) => platformGetAWSOnboarding(teamName,onboardingId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && onboardingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSOnboarding>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetAWSOnboardingQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetAWSOnboarding>>>
export type PlatformGetAWSOnboardingQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetAWSOnboarding<TData = Awaited<ReturnType<typeof platformGetAWSOnboarding>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    onboardingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSOnboarding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetAWSOnboardingQueryOptions(teamName,onboardingId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update onboarding state
 */
export const getPlatformNotifyOnboardingUrl = (teamName: string,
    onboardingId: string,) => {




  return `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/notify`
}

export const platformNotifyOnboarding = async (teamName: string,
    onboardingId: string,
    platformOnboardingAWSNotification: PlatformOnboardingAWSNotification, options?: RequestInit) => {

  return customFetch<void>(getPlatformNotifyOnboardingUrl(teamName,onboardingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformOnboardingAWSNotification,)
  }
);}




export const getPlatformNotifyOnboardingMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformNotifyOnboarding>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSNotification}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformNotifyOnboarding>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSNotification}, TContext> => {

const mutationKey = ['platformNotifyOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformNotifyOnboarding>>, {teamName: string;onboardingId: string;data: PlatformOnboardingAWSNotification}> = (props) => {
          const {teamName,onboardingId,data} = props ?? {};

          return  platformNotifyOnboarding(teamName,onboardingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformNotifyOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof platformNotifyOnboarding>>>
    export type PlatformNotifyOnboardingMutationBody = PlatformOnboardingAWSNotification
    export type PlatformNotifyOnboardingMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse

    export const usePlatformNotifyOnboarding = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformNotifyOnboarding>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSNotification}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformNotifyOnboarding>>,
        TError,
        {teamName: string;onboardingId: string;data: PlatformOnboardingAWSNotification},
        TContext
      > => {
      return useMutation(getPlatformNotifyOnboardingMutationOptions(options));
    }

/**
 * Query AWS accounts under organization root
 */
export const getPlatformGetAWSAccountsInRootUrl = (teamName: string,
    onboardingId: string,) => {




  return `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/accounts`
}

export const platformGetAWSAccountsInRoot = async (teamName: string,
    onboardingId: string, options?: RequestInit) => {

  return customFetch<PlatformOnboardingAWSAccounts>(getPlatformGetAWSAccountsInRootUrl(teamName,onboardingId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetAWSAccountsInRootQueryKey = (teamName: string,
    onboardingId: string,) => {
    return [
    `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/accounts`
    ] as const;
    }


export const getPlatformGetAWSAccountsInRootQueryOptions = <TData = Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    onboardingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetAWSAccountsInRootQueryKey(teamName,onboardingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>> = ({ signal }) => platformGetAWSAccountsInRoot(teamName,onboardingId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && onboardingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetAWSAccountsInRootQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>>
export type PlatformGetAWSAccountsInRootQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetAWSAccountsInRoot<TData = Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    onboardingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetAWSAccountsInRootQueryOptions(teamName,onboardingId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Query AWS accounts under a specifc Organizational Unit
 */
export const getPlatformGetAWSAccountsInParentUrl = (teamName: string,
    onboardingId: string,
    awsOrgunitId: string,) => {




  return `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/accounts/${awsOrgunitId}`
}

export const platformGetAWSAccountsInParent = async (teamName: string,
    onboardingId: string,
    awsOrgunitId: string, options?: RequestInit) => {

  return customFetch<PlatformOnboardingAWSAccounts>(getPlatformGetAWSAccountsInParentUrl(teamName,onboardingId,awsOrgunitId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetAWSAccountsInParentQueryKey = (teamName: string,
    onboardingId: string,
    awsOrgunitId: string,) => {
    return [
    `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/accounts/${awsOrgunitId}`
    ] as const;
    }


export const getPlatformGetAWSAccountsInParentQueryOptions = <TData = Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    onboardingId: string,
    awsOrgunitId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetAWSAccountsInParentQueryKey(teamName,onboardingId,awsOrgunitId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>> = ({ signal }) => platformGetAWSAccountsInParent(teamName,onboardingId,awsOrgunitId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && onboardingId && awsOrgunitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetAWSAccountsInParentQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>>
export type PlatformGetAWSAccountsInParentQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetAWSAccountsInParent<TData = Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    onboardingId: string,
    awsOrgunitId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetAWSAccountsInParentQueryOptions(teamName,onboardingId,awsOrgunitId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Provision onboarding configuration into the cloud account
 */
export const getPlatformProvisionOnboardingConfigurationUrl = (teamName: string,
    onboardingId: string,) => {




  return `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/accounts/provision`
}

export const platformProvisionOnboardingConfiguration = async (teamName: string,
    onboardingId: string,
    platformOnboardingAWSProvision: PlatformOnboardingAWSProvision, options?: RequestInit) => {

  return customFetch<void>(getPlatformProvisionOnboardingConfigurationUrl(teamName,onboardingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformOnboardingAWSProvision,)
  }
);}




export const getPlatformProvisionOnboardingConfigurationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSProvision}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSProvision}, TContext> => {

const mutationKey = ['platformProvisionOnboardingConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>, {teamName: string;onboardingId: string;data: PlatformOnboardingAWSProvision}> = (props) => {
          const {teamName,onboardingId,data} = props ?? {};

          return  platformProvisionOnboardingConfiguration(teamName,onboardingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformProvisionOnboardingConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>>
    export type PlatformProvisionOnboardingConfigurationMutationBody = PlatformOnboardingAWSProvision
    export type PlatformProvisionOnboardingConfigurationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformProvisionOnboardingConfiguration = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSProvision}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>,
        TError,
        {teamName: string;onboardingId: string;data: PlatformOnboardingAWSProvision},
        TContext
      > => {
      return useMutation(getPlatformProvisionOnboardingConfigurationMutationOptions(options));
    }

/**
 * List all plugins for the team.
 */
export const getPlatformListPluginsByTeamUrl = (teamName: string,
    params?: PlatformListPluginsByTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/plugins?${stringifiedParams}` : `/teams/${teamName}/plugins`
}

export const platformListPluginsByTeam = async (teamName: string,
    params?: PlatformListPluginsByTeamParams, options?: RequestInit) => {

  return customFetch<PlatformListPluginsByTeam200>(getPlatformListPluginsByTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListPluginsByTeamQueryKey = (teamName: string,
    params?: PlatformListPluginsByTeamParams,) => {
    return [
    `/teams/${teamName}/plugins`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListPluginsByTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListPluginsByTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListPluginsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginsByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPluginsByTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPluginsByTeam>>> = ({ signal }) => platformListPluginsByTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPluginsByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPluginsByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPluginsByTeam>>>
export type PlatformListPluginsByTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListPluginsByTeam<TData = Awaited<ReturnType<typeof platformListPluginsByTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListPluginsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginsByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPluginsByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Delete plugins by team
 */
export const getPlatformDeletePluginsByTeamUrl = (teamName: string,) => {




  return `/teams/${teamName}/plugins`
}

export const platformDeletePluginsByTeam = async (teamName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeletePluginsByTeamUrl(teamName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeletePluginsByTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginsByTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginsByTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['platformDeletePluginsByTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeletePluginsByTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  platformDeletePluginsByTeam(teamName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeletePluginsByTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeletePluginsByTeam>>>

    export type PlatformDeletePluginsByTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformDeletePluginsByTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginsByTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeletePluginsByTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {
      return useMutation(getPlatformDeletePluginsByTeamMutationOptions(options));
    }

/**
 * Download an asset for a given plugin version as the current team.
 */
export const getPlatformDownloadPluginAssetByTeamUrl = (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {




  return `/teams/${teamName}/plugins/${pluginTeam}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`
}

export const platformDownloadPluginAssetByTeam = async (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: RequestInit) => {

  return customFetch<PlatformPluginAsset>(getPlatformDownloadPluginAssetByTeamUrl(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformDownloadPluginAssetByTeamQueryKey = (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {
    return [
    `/teams/${teamName}/plugins/${pluginTeam}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`
    ] as const;
    }


export const getPlatformDownloadPluginAssetByTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>, TError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformDownloadPluginAssetByTeamQueryKey(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>> = ({ signal }) => platformDownloadPluginAssetByTeam(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginTeam && pluginKind && pluginName && versionName && targetName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformDownloadPluginAssetByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>>
export type PlatformDownloadPluginAssetByTeamQueryError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse



export function usePlatformDownloadPluginAssetByTeam<TData = Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>, TError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformDownloadPluginAssetByTeamQueryOptions(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List Policies
 */
export const getPlatformListPoliciesUrl = (teamName: string,
    params?: PlatformListPoliciesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/policies?${stringifiedParams}` : `/teams/${teamName}/policies`
}

export const platformListPolicies = async (teamName: string,
    params?: PlatformListPoliciesParams, options?: RequestInit) => {

  return customFetch<PlatformListPolicies200>(getPlatformListPoliciesUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListPoliciesQueryKey = (teamName: string,
    params?: PlatformListPoliciesParams,) => {
    return [
    `/teams/${teamName}/policies`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListPoliciesQueryOptions = <TData = Awaited<ReturnType<typeof platformListPolicies>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(teamName: string,
    params?: PlatformListPoliciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPoliciesQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPolicies>>> = ({ signal }) => platformListPolicies(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPolicies>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPolicies>>>
export type PlatformListPoliciesQueryError = PlatformBadRequestResponse | PlatformNotFoundResponse



export function usePlatformListPolicies<TData = Awaited<ReturnType<typeof platformListPolicies>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(
 teamName: string,
    params?: PlatformListPoliciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPoliciesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create Policy
 */
export const getPlatformCreatePolicyUrl = (teamName: string,) => {




  return `/teams/${teamName}/policies`
}

export const platformCreatePolicy = async (teamName: string,
    platformCreateOrUpdatePolicy: PlatformCreateOrUpdatePolicy, options?: RequestInit) => {

  return customFetch<PlatformCreatePolicy201>(getPlatformCreatePolicyUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreateOrUpdatePolicy,)
  }
);}




export const getPlatformCreatePolicyMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePolicy>>, TError,{teamName: string;data: PlatformCreateOrUpdatePolicy}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreatePolicy>>, TError,{teamName: string;data: PlatformCreateOrUpdatePolicy}, TContext> => {

const mutationKey = ['platformCreatePolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreatePolicy>>, {teamName: string;data: PlatformCreateOrUpdatePolicy}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreatePolicy(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreatePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreatePolicy>>>
    export type PlatformCreatePolicyMutationBody = PlatformCreateOrUpdatePolicy
    export type PlatformCreatePolicyMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse

    export const usePlatformCreatePolicy = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePolicy>>, TError,{teamName: string;data: PlatformCreateOrUpdatePolicy}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreatePolicy>>,
        TError,
        {teamName: string;data: PlatformCreateOrUpdatePolicy},
        TContext
      > => {
      return useMutation(getPlatformCreatePolicyMutationOptions(options));
    }

/**
 * List All Frameworks
 */
export const getPlatformListAllFrameworksUrl = (teamName: string,
    params?: PlatformListAllFrameworksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/policies/frameworks?${stringifiedParams}` : `/teams/${teamName}/policies/frameworks`
}

export const platformListAllFrameworks = async (teamName: string,
    params?: PlatformListAllFrameworksParams, options?: RequestInit) => {

  return customFetch<PlatformListAllFrameworks200>(getPlatformListAllFrameworksUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListAllFrameworksQueryKey = (teamName: string,
    params?: PlatformListAllFrameworksParams,) => {
    return [
    `/teams/${teamName}/policies/frameworks`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListAllFrameworksQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllFrameworks>>, TError = PlatformNotFoundResponse>(teamName: string,
    params?: PlatformListAllFrameworksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllFrameworks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllFrameworksQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllFrameworks>>> = ({ signal }) => platformListAllFrameworks(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllFrameworks>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllFrameworksQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllFrameworks>>>
export type PlatformListAllFrameworksQueryError = PlatformNotFoundResponse



export function usePlatformListAllFrameworks<TData = Awaited<ReturnType<typeof platformListAllFrameworks>>, TError = PlatformNotFoundResponse>(
 teamName: string,
    params?: PlatformListAllFrameworksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllFrameworks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllFrameworksQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get Policy
 */
export const getPlatformGetPolicyUrl = (teamName: string,
    policyId: string,) => {




  return `/teams/${teamName}/policies/${policyId}`
}

export const platformGetPolicy = async (teamName: string,
    policyId: string, options?: RequestInit) => {

  return customFetch<PlatformGetPolicy200>(getPlatformGetPolicyUrl(teamName,policyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetPolicyQueryKey = (teamName: string,
    policyId: string,) => {
    return [
    `/teams/${teamName}/policies/${policyId}`
    ] as const;
    }


export const getPlatformGetPolicyQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPolicy>>, TError = PlatformNotFoundResponse>(teamName: string,
    policyId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicy>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPolicyQueryKey(teamName,policyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPolicy>>> = ({ signal }) => platformGetPolicy(teamName,policyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && policyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicy>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPolicy>>>
export type PlatformGetPolicyQueryError = PlatformNotFoundResponse



export function usePlatformGetPolicy<TData = Awaited<ReturnType<typeof platformGetPolicy>>, TError = PlatformNotFoundResponse>(
 teamName: string,
    policyId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicy>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPolicyQueryOptions(teamName,policyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update Policy
 */
export const getPlatformUpdatePolicyUrl = (teamName: string,
    policyId: string,) => {




  return `/teams/${teamName}/policies/${policyId}`
}

export const platformUpdatePolicy = async (teamName: string,
    policyId: string,
    platformCreateOrUpdatePolicy: PlatformCreateOrUpdatePolicy, options?: RequestInit) => {

  return customFetch<PlatformUpdatePolicy200>(getPlatformUpdatePolicyUrl(teamName,policyId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreateOrUpdatePolicy,)
  }
);}




export const getPlatformUpdatePolicyMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePolicy>>, TError,{teamName: string;policyId: string;data: PlatformCreateOrUpdatePolicy}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePolicy>>, TError,{teamName: string;policyId: string;data: PlatformCreateOrUpdatePolicy}, TContext> => {

const mutationKey = ['platformUpdatePolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdatePolicy>>, {teamName: string;policyId: string;data: PlatformCreateOrUpdatePolicy}> = (props) => {
          const {teamName,policyId,data} = props ?? {};

          return  platformUpdatePolicy(teamName,policyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdatePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdatePolicy>>>
    export type PlatformUpdatePolicyMutationBody = PlatformCreateOrUpdatePolicy
    export type PlatformUpdatePolicyMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformUpdatePolicy = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePolicy>>, TError,{teamName: string;policyId: string;data: PlatformCreateOrUpdatePolicy}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdatePolicy>>,
        TError,
        {teamName: string;policyId: string;data: PlatformCreateOrUpdatePolicy},
        TContext
      > => {
      return useMutation(getPlatformUpdatePolicyMutationOptions(options));
    }

/**
 * Delete Policy
 */
export const getPlatformDeletePolicyUrl = (teamName: string,
    policyId: string,) => {




  return `/teams/${teamName}/policies/${policyId}`
}

export const platformDeletePolicy = async (teamName: string,
    policyId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeletePolicyUrl(teamName,policyId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeletePolicyMutationOptions = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePolicy>>, TError,{teamName: string;policyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeletePolicy>>, TError,{teamName: string;policyId: string}, TContext> => {

const mutationKey = ['platformDeletePolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeletePolicy>>, {teamName: string;policyId: string}> = (props) => {
          const {teamName,policyId} = props ?? {};

          return  platformDeletePolicy(teamName,policyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeletePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeletePolicy>>>

    export type PlatformDeletePolicyMutationError = PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformDeletePolicy = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePolicy>>, TError,{teamName: string;policyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeletePolicy>>,
        TError,
        {teamName: string;policyId: string},
        TContext
      > => {
      return useMutation(getPlatformDeletePolicyMutationOptions(options));
    }

/**
 * List Policy Frameworks
 */
export const getPlatformListPolicyFrameworksUrl = (teamName: string,
    policyId: string,
    params?: PlatformListPolicyFrameworksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/policies/${policyId}/frameworks?${stringifiedParams}` : `/teams/${teamName}/policies/${policyId}/frameworks`
}

export const platformListPolicyFrameworks = async (teamName: string,
    policyId: string,
    params?: PlatformListPolicyFrameworksParams, options?: RequestInit) => {

  return customFetch<PlatformListPolicyFrameworks200>(getPlatformListPolicyFrameworksUrl(teamName,policyId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListPolicyFrameworksQueryKey = (teamName: string,
    policyId: string,
    params?: PlatformListPolicyFrameworksParams,) => {
    return [
    `/teams/${teamName}/policies/${policyId}/frameworks`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListPolicyFrameworksQueryOptions = <TData = Awaited<ReturnType<typeof platformListPolicyFrameworks>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(teamName: string,
    policyId: string,
    params?: PlatformListPolicyFrameworksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyFrameworks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPolicyFrameworksQueryKey(teamName,policyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPolicyFrameworks>>> = ({ signal }) => platformListPolicyFrameworks(teamName,policyId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && policyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyFrameworks>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPolicyFrameworksQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPolicyFrameworks>>>
export type PlatformListPolicyFrameworksQueryError = PlatformBadRequestResponse | PlatformNotFoundResponse



export function usePlatformListPolicyFrameworks<TData = Awaited<ReturnType<typeof platformListPolicyFrameworks>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(
 teamName: string,
    policyId: string,
    params?: PlatformListPolicyFrameworksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyFrameworks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPolicyFrameworksQueryOptions(teamName,policyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List Policy Rules
 */
export const getPlatformListPolicyRulesUrl = (teamName: string,
    policyId: string,
    params?: PlatformListPolicyRulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/policies/${policyId}/rules?${stringifiedParams}` : `/teams/${teamName}/policies/${policyId}/rules`
}

export const platformListPolicyRules = async (teamName: string,
    policyId: string,
    params?: PlatformListPolicyRulesParams, options?: RequestInit) => {

  return customFetch<PlatformListPolicyRules200>(getPlatformListPolicyRulesUrl(teamName,policyId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListPolicyRulesQueryKey = (teamName: string,
    policyId: string,
    params?: PlatformListPolicyRulesParams,) => {
    return [
    `/teams/${teamName}/policies/${policyId}/rules`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListPolicyRulesQueryOptions = <TData = Awaited<ReturnType<typeof platformListPolicyRules>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(teamName: string,
    policyId: string,
    params?: PlatformListPolicyRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPolicyRulesQueryKey(teamName,policyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPolicyRules>>> = ({ signal }) => platformListPolicyRules(teamName,policyId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && policyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRules>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPolicyRulesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPolicyRules>>>
export type PlatformListPolicyRulesQueryError = PlatformBadRequestResponse | PlatformNotFoundResponse



export function usePlatformListPolicyRules<TData = Awaited<ReturnType<typeof platformListPolicyRules>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(
 teamName: string,
    policyId: string,
    params?: PlatformListPolicyRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPolicyRulesQueryOptions(teamName,policyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List Policy Rule Details
 */
export const getPlatformListPolicyRuleDetailsUrl = (teamName: string,
    policyId: string,
    ruleId: string,
    params?: PlatformListPolicyRuleDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/policies/${policyId}/rules/${ruleId}/details?${stringifiedParams}` : `/teams/${teamName}/policies/${policyId}/rules/${ruleId}/details`
}

export const platformListPolicyRuleDetails = async (teamName: string,
    policyId: string,
    ruleId: string,
    params?: PlatformListPolicyRuleDetailsParams, options?: RequestInit) => {

  return customFetch<PlatformListPolicyRuleDetails200>(getPlatformListPolicyRuleDetailsUrl(teamName,policyId,ruleId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListPolicyRuleDetailsQueryKey = (teamName: string,
    policyId: string,
    ruleId: string,
    params?: PlatformListPolicyRuleDetailsParams,) => {
    return [
    `/teams/${teamName}/policies/${policyId}/rules/${ruleId}/details`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListPolicyRuleDetailsQueryOptions = <TData = Awaited<ReturnType<typeof platformListPolicyRuleDetails>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(teamName: string,
    policyId: string,
    ruleId: string,
    params?: PlatformListPolicyRuleDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRuleDetails>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPolicyRuleDetailsQueryKey(teamName,policyId,ruleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPolicyRuleDetails>>> = ({ signal }) => platformListPolicyRuleDetails(teamName,policyId,ruleId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && policyId && ruleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRuleDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPolicyRuleDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPolicyRuleDetails>>>
export type PlatformListPolicyRuleDetailsQueryError = PlatformBadRequestResponse | PlatformNotFoundResponse



export function usePlatformListPolicyRuleDetails<TData = Awaited<ReturnType<typeof platformListPolicyRuleDetails>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(
 teamName: string,
    policyId: string,
    ruleId: string,
    params?: PlatformListPolicyRuleDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRuleDetails>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPolicyRuleDetailsQueryOptions(teamName,policyId,ruleId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Toggle Policy status
 */
export const getPlatformTogglePolicyUrl = (teamName: string,
    policyId: string,
    params: PlatformTogglePolicyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/policies/${policyId}/toggle?${stringifiedParams}` : `/teams/${teamName}/policies/${policyId}/toggle`
}

export const platformTogglePolicy = async (teamName: string,
    policyId: string,
    params: PlatformTogglePolicyParams, options?: RequestInit) => {

  return customFetch<void>(getPlatformTogglePolicyUrl(teamName,policyId,params),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformTogglePolicyMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTogglePolicy>>, TError,{teamName: string;policyId: string;params: PlatformTogglePolicyParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformTogglePolicy>>, TError,{teamName: string;policyId: string;params: PlatformTogglePolicyParams}, TContext> => {

const mutationKey = ['platformTogglePolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformTogglePolicy>>, {teamName: string;policyId: string;params: PlatformTogglePolicyParams}> = (props) => {
          const {teamName,policyId,params} = props ?? {};

          return  platformTogglePolicy(teamName,policyId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformTogglePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof platformTogglePolicy>>>

    export type PlatformTogglePolicyMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformTogglePolicy = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTogglePolicy>>, TError,{teamName: string;policyId: string;params: PlatformTogglePolicyParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformTogglePolicy>>,
        TError,
        {teamName: string;policyId: string;params: PlatformTogglePolicyParams},
        TContext
      > => {
      return useMutation(getPlatformTogglePolicyMutationOptions(options));
    }

/**
 * Get Policy Violations History for defined period.
 */
export const getPlatformGetPolicyViolationsHistoryUrl = (teamName: string,
    policyId: string,
    params?: PlatformGetPolicyViolationsHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/policies/${policyId}/violations-history?${stringifiedParams}` : `/teams/${teamName}/policies/${policyId}/violations-history`
}

export const platformGetPolicyViolationsHistory = async (teamName: string,
    policyId: string,
    params?: PlatformGetPolicyViolationsHistoryParams, options?: RequestInit) => {

  return customFetch<PlatformGetPolicyViolationsHistory200>(getPlatformGetPolicyViolationsHistoryUrl(teamName,policyId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetPolicyViolationsHistoryQueryKey = (teamName: string,
    policyId: string,
    params?: PlatformGetPolicyViolationsHistoryParams,) => {
    return [
    `/teams/${teamName}/policies/${policyId}/violations-history`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetPolicyViolationsHistoryQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>, TError = PlatformBadRequestResponse>(teamName: string,
    policyId: string,
    params?: PlatformGetPolicyViolationsHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPolicyViolationsHistoryQueryKey(teamName,policyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>> = ({ signal }) => platformGetPolicyViolationsHistory(teamName,policyId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && policyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPolicyViolationsHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>>
export type PlatformGetPolicyViolationsHistoryQueryError = PlatformBadRequestResponse



export function usePlatformGetPolicyViolationsHistory<TData = Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>, TError = PlatformBadRequestResponse>(
 teamName: string,
    policyId: string,
    params?: PlatformGetPolicyViolationsHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPolicyViolationsHistoryQueryOptions(teamName,policyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List all queries
 */
export const getPlatformListAllQueriesTeamUrl = (teamName: string,
    params?: PlatformListAllQueriesTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["tag"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/queries?${stringifiedParams}` : `/teams/${teamName}/queries`
}

export const platformListAllQueriesTeam = async (teamName: string,
    params?: PlatformListAllQueriesTeamParams, options?: RequestInit) => {

  return customFetch<PlatformListAllQueriesTeam200>(getPlatformListAllQueriesTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListAllQueriesTeamQueryKey = (teamName: string,
    params?: PlatformListAllQueriesTeamParams,) => {
    return [
    `/teams/${teamName}/queries`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListAllQueriesTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllQueriesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListAllQueriesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllQueriesTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllQueriesTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllQueriesTeam>>> = ({ signal }) => platformListAllQueriesTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllQueriesTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllQueriesTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllQueriesTeam>>>
export type PlatformListAllQueriesTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListAllQueriesTeam<TData = Awaited<ReturnType<typeof platformListAllQueriesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListAllQueriesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllQueriesTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllQueriesTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Run an ad-hoc SQL query against any table.
Further filtering can optionally be applied on top of the raw SQL results using the optional parameters. Filtering can be useful in situations where a saved query needs to be further filtered, grouped or paginated, such as in dashboards or reports.

 */
export const getPlatformExecuteAdHocQueryTeamUrl = (teamName: string,
    params?: PlatformExecuteAdHocQueryTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["select","filter","filter_id","sort_by","sort_dir","group_by"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/queries/execute?${stringifiedParams}` : `/teams/${teamName}/queries/execute`
}

export const platformExecuteAdHocQueryTeam = async (teamName: string,
    platformExecuteAdHocQueryTeamBody: PlatformExecuteAdHocQueryTeamBody,
    params?: PlatformExecuteAdHocQueryTeamParams, options?: RequestInit) => {

  return customFetch<PlatformExecuteAdHocQueryTeam200>(getPlatformExecuteAdHocQueryTeamUrl(teamName,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformExecuteAdHocQueryTeamBody,)
  }
);}





export const getPlatformExecuteAdHocQueryTeamQueryKey = (teamName: string,
    platformExecuteAdHocQueryTeamBody?: PlatformExecuteAdHocQueryTeamBody,
    params?: PlatformExecuteAdHocQueryTeamParams,) => {
    return [
    `/teams/${teamName}/queries/execute`, ...(params ? [params] : []), platformExecuteAdHocQueryTeamBody
    ] as const;
    }


export const getPlatformExecuteAdHocQueryTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    platformExecuteAdHocQueryTeamBody: PlatformExecuteAdHocQueryTeamBody,
    params?: PlatformExecuteAdHocQueryTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformExecuteAdHocQueryTeamQueryKey(teamName,platformExecuteAdHocQueryTeamBody,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>> = ({ signal }) => platformExecuteAdHocQueryTeam(teamName,platformExecuteAdHocQueryTeamBody,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformExecuteAdHocQueryTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>>
export type PlatformExecuteAdHocQueryTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformExecuteAdHocQueryTeam<TData = Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    platformExecuteAdHocQueryTeamBody: PlatformExecuteAdHocQueryTeamBody,
    params?: PlatformExecuteAdHocQueryTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformExecuteAdHocQueryTeamQueryOptions(teamName,platformExecuteAdHocQueryTeamBody,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Save a query to execute later
 */
export const getPlatformSaveQueryTeamUrl = (teamName: string,) => {




  return `/teams/${teamName}/queries/save`
}

export const platformSaveQueryTeam = async (teamName: string,
    platformQueryCreate: PlatformQueryCreate, options?: RequestInit) => {

  return customFetch<PlatformQueryDetail>(getPlatformSaveQueryTeamUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformQueryCreate,)
  }
);}




export const getPlatformSaveQueryTeamMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSaveQueryTeam>>, TError,{teamName: string;data: PlatformQueryCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformSaveQueryTeam>>, TError,{teamName: string;data: PlatformQueryCreate}, TContext> => {

const mutationKey = ['platformSaveQueryTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformSaveQueryTeam>>, {teamName: string;data: PlatformQueryCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformSaveQueryTeam(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformSaveQueryTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformSaveQueryTeam>>>
    export type PlatformSaveQueryTeamMutationBody = PlatformQueryCreate
    export type PlatformSaveQueryTeamMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformSaveQueryTeam = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSaveQueryTeam>>, TError,{teamName: string;data: PlatformQueryCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformSaveQueryTeam>>,
        TError,
        {teamName: string;data: PlatformQueryCreate},
        TContext
      > => {
      return useMutation(getPlatformSaveQueryTeamMutationOptions(options));
    }

/**
 * List Query Tags
 */
export const getPlatformListQueryTagsTeamUrl = (teamName: string,
    params?: PlatformListQueryTagsTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/queries/tags?${stringifiedParams}` : `/teams/${teamName}/queries/tags`
}

export const platformListQueryTagsTeam = async (teamName: string,
    params?: PlatformListQueryTagsTeamParams, options?: RequestInit) => {

  return customFetch<PlatformListQueryTagsTeam200>(getPlatformListQueryTagsTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListQueryTagsTeamQueryKey = (teamName: string,
    params?: PlatformListQueryTagsTeamParams,) => {
    return [
    `/teams/${teamName}/queries/tags`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListQueryTagsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListQueryTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListQueryTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListQueryTagsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListQueryTagsTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListQueryTagsTeam>>> = ({ signal }) => platformListQueryTagsTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListQueryTagsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListQueryTagsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListQueryTagsTeam>>>
export type PlatformListQueryTagsTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListQueryTagsTeam<TData = Awaited<ReturnType<typeof platformListQueryTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListQueryTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListQueryTagsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListQueryTagsTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a saved query
 */
export const getPlatformGetSavedQueryTeamUrl = (teamName: string,
    queryId: string,) => {




  return `/teams/${teamName}/queries/${queryId}`
}

export const platformGetSavedQueryTeam = async (teamName: string,
    queryId: string, options?: RequestInit) => {

  return customFetch<PlatformQueryDetail>(getPlatformGetSavedQueryTeamUrl(teamName,queryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSavedQueryTeamQueryKey = (teamName: string,
    queryId: string,) => {
    return [
    `/teams/${teamName}/queries/${queryId}`
    ] as const;
    }


export const getPlatformGetSavedQueryTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSavedQueryTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    queryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSavedQueryTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSavedQueryTeamQueryKey(teamName,queryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSavedQueryTeam>>> = ({ signal }) => platformGetSavedQueryTeam(teamName,queryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && queryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSavedQueryTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSavedQueryTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSavedQueryTeam>>>
export type PlatformGetSavedQueryTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSavedQueryTeam<TData = Awaited<ReturnType<typeof platformGetSavedQueryTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    queryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSavedQueryTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSavedQueryTeamQueryOptions(teamName,queryId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a saved query
 */
export const getPlatformUpdateQueryTeamUrl = (teamName: string,
    queryId: string,) => {




  return `/teams/${teamName}/queries/${queryId}`
}

export const platformUpdateQueryTeam = async (teamName: string,
    queryId: string,
    platformQueryUpdate: PlatformQueryUpdate, options?: RequestInit) => {

  return customFetch<PlatformQueryDetail>(getPlatformUpdateQueryTeamUrl(teamName,queryId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformQueryUpdate,)
  }
);}




export const getPlatformUpdateQueryTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateQueryTeam>>, TError,{teamName: string;queryId: string;data: PlatformQueryUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateQueryTeam>>, TError,{teamName: string;queryId: string;data: PlatformQueryUpdate}, TContext> => {

const mutationKey = ['platformUpdateQueryTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateQueryTeam>>, {teamName: string;queryId: string;data: PlatformQueryUpdate}> = (props) => {
          const {teamName,queryId,data} = props ?? {};

          return  platformUpdateQueryTeam(teamName,queryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateQueryTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateQueryTeam>>>
    export type PlatformUpdateQueryTeamMutationBody = PlatformQueryUpdate
    export type PlatformUpdateQueryTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateQueryTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateQueryTeam>>, TError,{teamName: string;queryId: string;data: PlatformQueryUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateQueryTeam>>,
        TError,
        {teamName: string;queryId: string;data: PlatformQueryUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateQueryTeamMutationOptions(options));
    }

/**
 * Delete a saved query
 */
export const getPlatformDeleteSavedQueryTeamUrl = (teamName: string,
    queryId: string,) => {




  return `/teams/${teamName}/queries/${queryId}`
}

export const platformDeleteSavedQueryTeam = async (teamName: string,
    queryId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteSavedQueryTeamUrl(teamName,queryId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteSavedQueryTeamMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>, TError,{teamName: string;queryId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>, TError,{teamName: string;queryId: string}, TContext> => {

const mutationKey = ['platformDeleteSavedQueryTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>, {teamName: string;queryId: string}> = (props) => {
          const {teamName,queryId} = props ?? {};

          return  platformDeleteSavedQueryTeam(teamName,queryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteSavedQueryTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>>

    export type PlatformDeleteSavedQueryTeamMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteSavedQueryTeam = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>, TError,{teamName: string;queryId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>,
        TError,
        {teamName: string;queryId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteSavedQueryTeamMutationOptions(options));
    }

/**
 * Delete alert from saved query
 */
export const getPlatformDeleteAlertUrl = (teamName: string,
    queryId: string,) => {




  return `/teams/${teamName}/queries/${queryId}/alert`
}

export const platformDeleteAlert = async (teamName: string,
    queryId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteAlertUrl(teamName,queryId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteAlertMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteAlert>>, TError,{teamName: string;queryId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteAlert>>, TError,{teamName: string;queryId: string}, TContext> => {

const mutationKey = ['platformDeleteAlert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteAlert>>, {teamName: string;queryId: string}> = (props) => {
          const {teamName,queryId} = props ?? {};

          return  platformDeleteAlert(teamName,queryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteAlertMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteAlert>>>

    export type PlatformDeleteAlertMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteAlert = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteAlert>>, TError,{teamName: string;queryId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteAlert>>,
        TError,
        {teamName: string;queryId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteAlertMutationOptions(options));
    }

/**
 * Execute a saved query
 */
export const getPlatformExecuteSavedQueryTeamUrl = (teamName: string,
    queryId: string,
    params?: PlatformExecuteSavedQueryTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["select","filter","filter_id","sort_by","sort_dir","group_by"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/queries/${queryId}/execute?${stringifiedParams}` : `/teams/${teamName}/queries/${queryId}/execute`
}

export const platformExecuteSavedQueryTeam = async (teamName: string,
    queryId: string,
    params?: PlatformExecuteSavedQueryTeamParams, options?: RequestInit) => {

  return customFetch<PlatformExecuteSavedQueryTeam200>(getPlatformExecuteSavedQueryTeamUrl(teamName,queryId,params),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformExecuteSavedQueryTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>, TError,{teamName: string;queryId: string;params?: PlatformExecuteSavedQueryTeamParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>, TError,{teamName: string;queryId: string;params?: PlatformExecuteSavedQueryTeamParams}, TContext> => {

const mutationKey = ['platformExecuteSavedQueryTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>, {teamName: string;queryId: string;params?: PlatformExecuteSavedQueryTeamParams}> = (props) => {
          const {teamName,queryId,params} = props ?? {};

          return  platformExecuteSavedQueryTeam(teamName,queryId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformExecuteSavedQueryTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>>

    export type PlatformExecuteSavedQueryTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformExecuteSavedQueryTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>, TError,{teamName: string;queryId: string;params?: PlatformExecuteSavedQueryTeamParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>,
        TError,
        {teamName: string;queryId: string;params?: PlatformExecuteSavedQueryTeamParams},
        TContext
      > => {
      return useMutation(getPlatformExecuteSavedQueryTeamMutationOptions(options));
    }

/**
 * List Query Filters
 */
export const getPlatformQueryListFiltersTeamUrl = (teamName: string,
    queryId: string,
    params?: PlatformQueryListFiltersTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["tag"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/queries/${queryId}/filters?${stringifiedParams}` : `/teams/${teamName}/queries/${queryId}/filters`
}

export const platformQueryListFiltersTeam = async (teamName: string,
    queryId: string,
    params?: PlatformQueryListFiltersTeamParams, options?: RequestInit) => {

  return customFetch<PlatformQueryListFiltersTeam200>(getPlatformQueryListFiltersTeamUrl(teamName,queryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformQueryListFiltersTeamQueryKey = (teamName: string,
    queryId: string,
    params?: PlatformQueryListFiltersTeamParams,) => {
    return [
    `/teams/${teamName}/queries/${queryId}/filters`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformQueryListFiltersTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformQueryListFiltersTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    queryId: string,
    params?: PlatformQueryListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFiltersTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformQueryListFiltersTeamQueryKey(teamName,queryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformQueryListFiltersTeam>>> = ({ signal }) => platformQueryListFiltersTeam(teamName,queryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && queryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFiltersTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformQueryListFiltersTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformQueryListFiltersTeam>>>
export type PlatformQueryListFiltersTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformQueryListFiltersTeam<TData = Awaited<ReturnType<typeof platformQueryListFiltersTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    queryId: string,
    params?: PlatformQueryListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFiltersTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformQueryListFiltersTeamQueryOptions(teamName,queryId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Save Query Filter
 */
export const getPlatformQuerySaveFilterTeamUrl = (teamName: string,
    queryId: string,) => {




  return `/teams/${teamName}/queries/${queryId}/filters`
}

export const platformQuerySaveFilterTeam = async (teamName: string,
    queryId: string,
    platformFilterCreate: PlatformFilterCreate, options?: RequestInit) => {

  return customFetch<PlatformFilter>(getPlatformQuerySaveFilterTeamUrl(teamName,queryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformFilterCreate,)
  }
);}




export const getPlatformQuerySaveFilterTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>, TError,{teamName: string;queryId: string;data: PlatformFilterCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>, TError,{teamName: string;queryId: string;data: PlatformFilterCreate}, TContext> => {

const mutationKey = ['platformQuerySaveFilterTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>, {teamName: string;queryId: string;data: PlatformFilterCreate}> = (props) => {
          const {teamName,queryId,data} = props ?? {};

          return  platformQuerySaveFilterTeam(teamName,queryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformQuerySaveFilterTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>>
    export type PlatformQuerySaveFilterTeamMutationBody = PlatformFilterCreate
    export type PlatformQuerySaveFilterTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformQuerySaveFilterTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>, TError,{teamName: string;queryId: string;data: PlatformFilterCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>,
        TError,
        {teamName: string;queryId: string;data: PlatformFilterCreate},
        TContext
      > => {
      return useMutation(getPlatformQuerySaveFilterTeamMutationOptions(options));
    }

/**
 * List Filter Tags For A Saved Query
 */
export const getPlatformQueryListFilterTagsTeamUrl = (teamName: string,
    queryId: string,
    params?: PlatformQueryListFilterTagsTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/queries/${queryId}/filters/tags?${stringifiedParams}` : `/teams/${teamName}/queries/${queryId}/filters/tags`
}

export const platformQueryListFilterTagsTeam = async (teamName: string,
    queryId: string,
    params?: PlatformQueryListFilterTagsTeamParams, options?: RequestInit) => {

  return customFetch<PlatformQueryListFilterTagsTeam200>(getPlatformQueryListFilterTagsTeamUrl(teamName,queryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformQueryListFilterTagsTeamQueryKey = (teamName: string,
    queryId: string,
    params?: PlatformQueryListFilterTagsTeamParams,) => {
    return [
    `/teams/${teamName}/queries/${queryId}/filters/tags`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformQueryListFilterTagsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    queryId: string,
    params?: PlatformQueryListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformQueryListFilterTagsTeamQueryKey(teamName,queryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>> = ({ signal }) => platformQueryListFilterTagsTeam(teamName,queryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && queryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformQueryListFilterTagsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>>
export type PlatformQueryListFilterTagsTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformQueryListFilterTagsTeam<TData = Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    queryId: string,
    params?: PlatformQueryListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformQueryListFilterTagsTeamQueryOptions(teamName,queryId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List reports
 */
export const getPlatformListReportsUrl = (teamName: string,
    params?: PlatformListReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/reports?${stringifiedParams}` : `/teams/${teamName}/reports`
}

export const platformListReports = async (teamName: string,
    params?: PlatformListReportsParams, options?: RequestInit) => {

  return customFetch<PlatformListReports200>(getPlatformListReportsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListReportsQueryKey = (teamName: string,
    params?: PlatformListReportsParams,) => {
    return [
    `/teams/${teamName}/reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListReportsQueryOptions = <TData = Awaited<ReturnType<typeof platformListReports>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse>(teamName: string,
    params?: PlatformListReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListReportsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListReports>>> = ({ signal }) => platformListReports(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListReports>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListReportsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListReports>>>
export type PlatformListReportsQueryError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse



export function usePlatformListReports<TData = Awaited<ReturnType<typeof platformListReports>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse>(
 teamName: string,
    params?: PlatformListReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListReportsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create Report
 */
export const getPlatformCreateReportUrl = (teamName: string,) => {




  return `/teams/${teamName}/reports`
}

export const platformCreateReport = async (teamName: string,
    platformReportCreate: PlatformReportCreate, options?: RequestInit) => {

  return customFetch<PlatformCreateReport201>(getPlatformCreateReportUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformReportCreate,)
  }
);}




export const getPlatformCreateReportMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateReport>>, TError,{teamName: string;data: PlatformReportCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateReport>>, TError,{teamName: string;data: PlatformReportCreate}, TContext> => {

const mutationKey = ['platformCreateReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateReport>>, {teamName: string;data: PlatformReportCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateReport(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateReportMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateReport>>>
    export type PlatformCreateReportMutationBody = PlatformReportCreate
    export type PlatformCreateReportMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse

    export const usePlatformCreateReport = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateReport>>, TError,{teamName: string;data: PlatformReportCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateReport>>,
        TError,
        {teamName: string;data: PlatformReportCreate},
        TContext
      > => {
      return useMutation(getPlatformCreateReportMutationOptions(options));
    }

/**
 * Get Report
 */
export const getPlatformGetReportUrl = (teamName: string,
    reportId: string,) => {




  return `/teams/${teamName}/reports/${reportId}`
}

export const platformGetReport = async (teamName: string,
    reportId: string, options?: RequestInit) => {

  return customFetch<PlatformGetReport200>(getPlatformGetReportUrl(teamName,reportId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetReportQueryKey = (teamName: string,
    reportId: string,) => {
    return [
    `/teams/${teamName}/reports/${reportId}`
    ] as const;
    }


export const getPlatformGetReportQueryOptions = <TData = Awaited<ReturnType<typeof platformGetReport>>, TError = PlatformForbiddenResponse | PlatformNotFoundResponse>(teamName: string,
    reportId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetReportQueryKey(teamName,reportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetReport>>> = ({ signal }) => platformGetReport(teamName,reportId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && reportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetReport>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetReportQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetReport>>>
export type PlatformGetReportQueryError = PlatformForbiddenResponse | PlatformNotFoundResponse



export function usePlatformGetReport<TData = Awaited<ReturnType<typeof platformGetReport>>, TError = PlatformForbiddenResponse | PlatformNotFoundResponse>(
 teamName: string,
    reportId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetReportQueryOptions(teamName,reportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update Report
 */
export const getPlatformUpdateReportUrl = (teamName: string,
    reportId: string,) => {




  return `/teams/${teamName}/reports/${reportId}`
}

export const platformUpdateReport = async (teamName: string,
    reportId: string,
    platformReportUpdate: PlatformReportUpdate, options?: RequestInit) => {

  return customFetch<PlatformUpdateReport200>(getPlatformUpdateReportUrl(teamName,reportId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformReportUpdate,)
  }
);}




export const getPlatformUpdateReportMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReport>>, TError,{teamName: string;reportId: string;data: PlatformReportUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReport>>, TError,{teamName: string;reportId: string;data: PlatformReportUpdate}, TContext> => {

const mutationKey = ['platformUpdateReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateReport>>, {teamName: string;reportId: string;data: PlatformReportUpdate}> = (props) => {
          const {teamName,reportId,data} = props ?? {};

          return  platformUpdateReport(teamName,reportId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateReportMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateReport>>>
    export type PlatformUpdateReportMutationBody = PlatformReportUpdate
    export type PlatformUpdateReportMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformUpdateReport = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReport>>, TError,{teamName: string;reportId: string;data: PlatformReportUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateReport>>,
        TError,
        {teamName: string;reportId: string;data: PlatformReportUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateReportMutationOptions(options));
    }

/**
 * Delete Report
 */
export const getPlatformDeleteReportUrl = (teamName: string,
    reportId: string,) => {




  return `/teams/${teamName}/reports/${reportId}`
}

export const platformDeleteReport = async (teamName: string,
    reportId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteReportUrl(teamName,reportId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteReportMutationOptions = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReport>>, TError,{teamName: string;reportId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReport>>, TError,{teamName: string;reportId: string}, TContext> => {

const mutationKey = ['platformDeleteReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteReport>>, {teamName: string;reportId: string}> = (props) => {
          const {teamName,reportId} = props ?? {};

          return  platformDeleteReport(teamName,reportId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteReportMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteReport>>>

    export type PlatformDeleteReportMutationError = PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformDeleteReport = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReport>>, TError,{teamName: string;reportId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteReport>>,
        TError,
        {teamName: string;reportId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteReportMutationOptions(options));
    }

/**
 * List report templates
 */
export const getPlatformListReportTemplatesUrl = (teamName: string,
    params?: PlatformListReportTemplatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/reports/templates?${stringifiedParams}` : `/teams/${teamName}/reports/templates`
}

export const platformListReportTemplates = async (teamName: string,
    params?: PlatformListReportTemplatesParams, options?: RequestInit) => {

  return customFetch<PlatformListReportTemplates200>(getPlatformListReportTemplatesUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListReportTemplatesQueryKey = (teamName: string,
    params?: PlatformListReportTemplatesParams,) => {
    return [
    `/teams/${teamName}/reports/templates`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListReportTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof platformListReportTemplates>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse>(teamName: string,
    params?: PlatformListReportTemplatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListReportTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListReportTemplatesQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListReportTemplates>>> = ({ signal }) => platformListReportTemplates(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListReportTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListReportTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListReportTemplates>>>
export type PlatformListReportTemplatesQueryError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse



export function usePlatformListReportTemplates<TData = Awaited<ReturnType<typeof platformListReportTemplates>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse>(
 teamName: string,
    params?: PlatformListReportTemplatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListReportTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListReportTemplatesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create Report Template
 */
export const getPlatformCreateReportTemplateUrl = (teamName: string,) => {




  return `/teams/${teamName}/reports/templates`
}

export const platformCreateReportTemplate = async (teamName: string,
    platformReportTemplateCreateOrUpdate: PlatformReportTemplateCreateOrUpdate, options?: RequestInit) => {

  return customFetch<PlatformCreateReportTemplate201>(getPlatformCreateReportTemplateUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformReportTemplateCreateOrUpdate,)
  }
);}




export const getPlatformCreateReportTemplateMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateReportTemplate>>, TError,{teamName: string;data: PlatformReportTemplateCreateOrUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateReportTemplate>>, TError,{teamName: string;data: PlatformReportTemplateCreateOrUpdate}, TContext> => {

const mutationKey = ['platformCreateReportTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateReportTemplate>>, {teamName: string;data: PlatformReportTemplateCreateOrUpdate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateReportTemplate(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateReportTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateReportTemplate>>>
    export type PlatformCreateReportTemplateMutationBody = PlatformReportTemplateCreateOrUpdate
    export type PlatformCreateReportTemplateMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse

    export const usePlatformCreateReportTemplate = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateReportTemplate>>, TError,{teamName: string;data: PlatformReportTemplateCreateOrUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateReportTemplate>>,
        TError,
        {teamName: string;data: PlatformReportTemplateCreateOrUpdate},
        TContext
      > => {
      return useMutation(getPlatformCreateReportTemplateMutationOptions(options));
    }

/**
 * Get Report Template
 */
export const getPlatformGetReportTemplateUrl = (teamName: string,
    templateId: string,) => {




  return `/teams/${teamName}/reports/templates/${templateId}`
}

export const platformGetReportTemplate = async (teamName: string,
    templateId: string, options?: RequestInit) => {

  return customFetch<PlatformGetReportTemplate200>(getPlatformGetReportTemplateUrl(teamName,templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetReportTemplateQueryKey = (teamName: string,
    templateId: string,) => {
    return [
    `/teams/${teamName}/reports/templates/${templateId}`
    ] as const;
    }


export const getPlatformGetReportTemplateQueryOptions = <TData = Awaited<ReturnType<typeof platformGetReportTemplate>>, TError = PlatformForbiddenResponse | PlatformNotFoundResponse>(teamName: string,
    templateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetReportTemplate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetReportTemplateQueryKey(teamName,templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetReportTemplate>>> = ({ signal }) => platformGetReportTemplate(teamName,templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && templateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetReportTemplate>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetReportTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetReportTemplate>>>
export type PlatformGetReportTemplateQueryError = PlatformForbiddenResponse | PlatformNotFoundResponse



export function usePlatformGetReportTemplate<TData = Awaited<ReturnType<typeof platformGetReportTemplate>>, TError = PlatformForbiddenResponse | PlatformNotFoundResponse>(
 teamName: string,
    templateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetReportTemplate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetReportTemplateQueryOptions(teamName,templateId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update Report Template
 */
export const getPlatformUpdateReportTemplateUrl = (teamName: string,
    templateId: string,) => {




  return `/teams/${teamName}/reports/templates/${templateId}`
}

export const platformUpdateReportTemplate = async (teamName: string,
    templateId: string,
    platformReportTemplateCreateOrUpdate: PlatformReportTemplateCreateOrUpdate, options?: RequestInit) => {

  return customFetch<PlatformUpdateReportTemplate200>(getPlatformUpdateReportTemplateUrl(teamName,templateId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformReportTemplateCreateOrUpdate,)
  }
);}




export const getPlatformUpdateReportTemplateMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReportTemplate>>, TError,{teamName: string;templateId: string;data: PlatformReportTemplateCreateOrUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReportTemplate>>, TError,{teamName: string;templateId: string;data: PlatformReportTemplateCreateOrUpdate}, TContext> => {

const mutationKey = ['platformUpdateReportTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateReportTemplate>>, {teamName: string;templateId: string;data: PlatformReportTemplateCreateOrUpdate}> = (props) => {
          const {teamName,templateId,data} = props ?? {};

          return  platformUpdateReportTemplate(teamName,templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateReportTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateReportTemplate>>>
    export type PlatformUpdateReportTemplateMutationBody = PlatformReportTemplateCreateOrUpdate
    export type PlatformUpdateReportTemplateMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformUpdateReportTemplate = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReportTemplate>>, TError,{teamName: string;templateId: string;data: PlatformReportTemplateCreateOrUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateReportTemplate>>,
        TError,
        {teamName: string;templateId: string;data: PlatformReportTemplateCreateOrUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateReportTemplateMutationOptions(options));
    }

/**
 * Delete Report Template
 */
export const getPlatformDeleteReportTemplateUrl = (teamName: string,
    templateId: string,) => {




  return `/teams/${teamName}/reports/templates/${templateId}`
}

export const platformDeleteReportTemplate = async (teamName: string,
    templateId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteReportTemplateUrl(teamName,templateId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteReportTemplateMutationOptions = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReportTemplate>>, TError,{teamName: string;templateId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReportTemplate>>, TError,{teamName: string;templateId: string}, TContext> => {

const mutationKey = ['platformDeleteReportTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteReportTemplate>>, {teamName: string;templateId: string}> = (props) => {
          const {teamName,templateId} = props ?? {};

          return  platformDeleteReportTemplate(teamName,templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteReportTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteReportTemplate>>>

    export type PlatformDeleteReportTemplateMutationError = PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformDeleteReportTemplate = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReportTemplate>>, TError,{teamName: string;templateId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteReportTemplate>>,
        TError,
        {teamName: string;templateId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteReportTemplateMutationOptions(options));
    }

/**
 * Create a test destination connection.
 */
export const getPlatformCreateSyncDestinationTestConnectionUrl = (teamName: string,) => {




  return `/teams/${teamName}/sync-destination-test-connections`
}

export const platformCreateSyncDestinationTestConnection = async (teamName: string,
    platformSyncDestinationTestConnectionCreate: PlatformSyncDestinationTestConnectionCreate, options?: RequestInit) => {

  return customFetch<PlatformSyncDestinationTestConnection>(getPlatformCreateSyncDestinationTestConnectionUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSyncDestinationTestConnectionCreate,)
  }
);}




export const getPlatformCreateSyncDestinationTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>, TError,{teamName: string;data: PlatformSyncDestinationTestConnectionCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>, TError,{teamName: string;data: PlatformSyncDestinationTestConnectionCreate}, TContext> => {

const mutationKey = ['platformCreateSyncDestinationTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>, {teamName: string;data: PlatformSyncDestinationTestConnectionCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateSyncDestinationTestConnection(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateSyncDestinationTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>>
    export type PlatformCreateSyncDestinationTestConnectionMutationBody = PlatformSyncDestinationTestConnectionCreate
    export type PlatformCreateSyncDestinationTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformCreateSyncDestinationTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>, TError,{teamName: string;data: PlatformSyncDestinationTestConnectionCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>,
        TError,
        {teamName: string;data: PlatformSyncDestinationTestConnectionCreate},
        TContext
      > => {
      return useMutation(getPlatformCreateSyncDestinationTestConnectionMutationOptions(options));
    }

/**
 * Get a sync destination test connection.
 */
export const getPlatformGetSyncDestinationTestConnectionUrl = (teamName: string,
    syncDestinationTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}`
}

export const platformGetSyncDestinationTestConnection = async (teamName: string,
    syncDestinationTestConnectionId: string, options?: RequestInit) => {

  return customFetch<PlatformSyncDestinationTestConnection>(getPlatformGetSyncDestinationTestConnectionUrl(teamName,syncDestinationTestConnectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncDestinationTestConnectionQueryKey = (teamName: string,
    syncDestinationTestConnectionId: string,) => {
    return [
    `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}`
    ] as const;
    }


export const getPlatformGetSyncDestinationTestConnectionQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncDestinationTestConnectionQueryKey(teamName,syncDestinationTestConnectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>> = ({ signal }) => platformGetSyncDestinationTestConnection(teamName,syncDestinationTestConnectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncDestinationTestConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>>
export type PlatformGetSyncDestinationTestConnectionQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncDestinationTestConnection<TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncDestinationTestConnectionQueryOptions(teamName,syncDestinationTestConnectionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a sync destination test connection.
 */
export const getPlatformUpdateSyncTestConnectionForSyncDestinationUrl = (teamName: string,
    syncDestinationTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}`
}

export const platformUpdateSyncTestConnectionForSyncDestination = async (teamName: string,
    syncDestinationTestConnectionId: string,
    platformUpdateSyncTestConnectionForSyncDestinationBody: PlatformUpdateSyncTestConnectionForSyncDestinationBody, options?: RequestInit) => {

  return customFetch<PlatformSyncDestinationTestConnection>(getPlatformUpdateSyncTestConnectionForSyncDestinationUrl(teamName,syncDestinationTestConnectionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformUpdateSyncTestConnectionForSyncDestinationBody,)
  }
);}




export const getPlatformUpdateSyncTestConnectionForSyncDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncDestinationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncDestinationBody}, TContext> => {

const mutationKey = ['platformUpdateSyncTestConnectionForSyncDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>, {teamName: string;syncDestinationTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncDestinationBody}> = (props) => {
          const {teamName,syncDestinationTestConnectionId,data} = props ?? {};

          return  platformUpdateSyncTestConnectionForSyncDestination(teamName,syncDestinationTestConnectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncTestConnectionForSyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>>
    export type PlatformUpdateSyncTestConnectionForSyncDestinationMutationBody = PlatformUpdateSyncTestConnectionForSyncDestinationBody
    export type PlatformUpdateSyncTestConnectionForSyncDestinationMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncTestConnectionForSyncDestination = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncDestinationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>,
        TError,
        {teamName: string;syncDestinationTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncDestinationBody},
        TContext
      > => {
      return useMutation(getPlatformUpdateSyncTestConnectionForSyncDestinationMutationOptions(options));
    }

/**
 * Deprecated. Get logs for a sync destination test connection.
 * @deprecated
 */
export const getPlatformGetSyncDestinationTestConnectionLogsUrl = (teamName: string,
    syncDestinationTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/logs`
}

export const platformGetSyncDestinationTestConnectionLogs = async (teamName: string,
    syncDestinationTestConnectionId: string, options?: RequestInit) => {

  return customFetch<PlatformGetSyncDestinationTestConnectionLogs200One | string | void>(getPlatformGetSyncDestinationTestConnectionLogsUrl(teamName,syncDestinationTestConnectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncDestinationTestConnectionLogsQueryKey = (teamName: string,
    syncDestinationTestConnectionId: string,) => {
    return [
    `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/logs`
    ] as const;
    }


export const getPlatformGetSyncDestinationTestConnectionLogsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncDestinationTestConnectionLogsQueryKey(teamName,syncDestinationTestConnectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>> = ({ signal }) => platformGetSyncDestinationTestConnectionLogs(teamName,syncDestinationTestConnectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncDestinationTestConnectionLogsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>>
export type PlatformGetSyncDestinationTestConnectionLogsQueryError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse


/**
 * @deprecated
 */

export function usePlatformGetSyncDestinationTestConnectionLogs<TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncDestinationTestConnectionLogsQueryOptions(teamName,syncDestinationTestConnectionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get logs for a sync destination test connection.
 */
export const getPlatformGetSyncDestinationTestConnectionLogsQueryUrl = (teamName: string,
    syncDestinationTestConnectionId: string,
    params?: PlatformGetSyncDestinationTestConnectionLogsQueryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/logs/query?${stringifiedParams}` : `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/logs/query`
}

export const platformGetSyncDestinationTestConnectionLogsQuery = async (teamName: string,
    syncDestinationTestConnectionId: string,
    params?: PlatformGetSyncDestinationTestConnectionLogsQueryParams, options?: RequestInit) => {

  return customFetch<PlatformGetSyncDestinationTestConnectionLogsQuery200One | string | void>(getPlatformGetSyncDestinationTestConnectionLogsQueryUrl(teamName,syncDestinationTestConnectionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncDestinationTestConnectionLogsQueryQueryKey = (teamName: string,
    syncDestinationTestConnectionId: string,
    params?: PlatformGetSyncDestinationTestConnectionLogsQueryParams,) => {
    return [
    `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/logs/query`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetSyncDestinationTestConnectionLogsQueryQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsQuery>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationTestConnectionId: string,
    params?: PlatformGetSyncDestinationTestConnectionLogsQueryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsQuery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncDestinationTestConnectionLogsQueryQueryKey(teamName,syncDestinationTestConnectionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsQuery>>> = ({ signal }) => platformGetSyncDestinationTestConnectionLogsQuery(teamName,syncDestinationTestConnectionId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsQuery>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncDestinationTestConnectionLogsQueryQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsQuery>>>
export type PlatformGetSyncDestinationTestConnectionLogsQueryQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncDestinationTestConnectionLogsQuery<TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsQuery>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationTestConnectionId: string,
    params?: PlatformGetSyncDestinationTestConnectionLogsQueryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsQuery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncDestinationTestConnectionLogsQueryQueryOptions(teamName,syncDestinationTestConnectionId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get live logs for a sync destination test connection.
 */
export const getPlatformGetSyncDestinationTestConnectionLogsLiveUrl = (teamName: string,
    syncDestinationTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/logs/live`
}

export const platformGetSyncDestinationTestConnectionLogsLive = async (teamName: string,
    syncDestinationTestConnectionId: string, options?: RequestInit) => {

  return customFetch<string | void>(getPlatformGetSyncDestinationTestConnectionLogsLiveUrl(teamName,syncDestinationTestConnectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncDestinationTestConnectionLogsLiveQueryKey = (teamName: string,
    syncDestinationTestConnectionId: string,) => {
    return [
    `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/logs/live`
    ] as const;
    }


export const getPlatformGetSyncDestinationTestConnectionLogsLiveQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsLive>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsLive>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncDestinationTestConnectionLogsLiveQueryKey(teamName,syncDestinationTestConnectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsLive>>> = ({ signal }) => platformGetSyncDestinationTestConnectionLogsLive(teamName,syncDestinationTestConnectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsLive>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncDestinationTestConnectionLogsLiveQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsLive>>>
export type PlatformGetSyncDestinationTestConnectionLogsLiveQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncDestinationTestConnectionLogsLive<TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsLive>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogsLive>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncDestinationTestConnectionLogsLiveQueryOptions(teamName,syncDestinationTestConnectionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Promote a sync destination test connection to a sync destination.
 */
export const getPlatformPromoteSyncDestinationTestConnectionUrl = (teamName: string,
    syncDestinationTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/promote`
}

export const platformPromoteSyncDestinationTestConnection = async (teamName: string,
    syncDestinationTestConnectionId: string,
    platformPromoteSyncDestinationTestConnection: PlatformPromoteSyncDestinationTestConnection, options?: RequestInit) => {

  return customFetch<PlatformSyncDestination>(getPlatformPromoteSyncDestinationTestConnectionUrl(teamName,syncDestinationTestConnectionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformPromoteSyncDestinationTestConnection,)
  }
);}




export const getPlatformPromoteSyncDestinationTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformPromoteSyncDestinationTestConnection}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformPromoteSyncDestinationTestConnection}, TContext> => {

const mutationKey = ['platformPromoteSyncDestinationTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>, {teamName: string;syncDestinationTestConnectionId: string;data: PlatformPromoteSyncDestinationTestConnection}> = (props) => {
          const {teamName,syncDestinationTestConnectionId,data} = props ?? {};

          return  platformPromoteSyncDestinationTestConnection(teamName,syncDestinationTestConnectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformPromoteSyncDestinationTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>>
    export type PlatformPromoteSyncDestinationTestConnectionMutationBody = PlatformPromoteSyncDestinationTestConnection
    export type PlatformPromoteSyncDestinationTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformPromoteSyncDestinationTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformPromoteSyncDestinationTestConnection}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>,
        TError,
        {teamName: string;syncDestinationTestConnectionId: string;data: PlatformPromoteSyncDestinationTestConnection},
        TContext
      > => {
      return useMutation(getPlatformPromoteSyncDestinationTestConnectionMutationOptions(options));
    }

/**
 * List all sync destination definitions.
 */
export const getPlatformListSyncDestinationsUrl = (teamName: string,
    params?: PlatformListSyncDestinationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/sync-destinations?${stringifiedParams}` : `/teams/${teamName}/sync-destinations`
}

export const platformListSyncDestinations = async (teamName: string,
    params?: PlatformListSyncDestinationsParams, options?: RequestInit) => {

  return customFetch<PlatformListSyncDestinations200>(getPlatformListSyncDestinationsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListSyncDestinationsQueryKey = (teamName: string,
    params?: PlatformListSyncDestinationsParams,) => {
    return [
    `/teams/${teamName}/sync-destinations`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListSyncDestinationsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncDestinations>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListSyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncDestinationsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncDestinations>>> = ({ signal }) => platformListSyncDestinations(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncDestinations>>>
export type PlatformListSyncDestinationsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncDestinations<TData = Awaited<ReturnType<typeof platformListSyncDestinations>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListSyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncDestinationsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a single sync destination definition.
 */
export const getPlatformGetSyncDestinationUrl = (teamName: string,
    syncDestinationName: string,) => {




  return `/teams/${teamName}/sync-destinations/${syncDestinationName}`
}

export const platformGetSyncDestination = async (teamName: string,
    syncDestinationName: string, options?: RequestInit) => {

  return customFetch<PlatformSyncDestination>(getPlatformGetSyncDestinationUrl(teamName,syncDestinationName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncDestinationQueryKey = (teamName: string,
    syncDestinationName: string,) => {
    return [
    `/teams/${teamName}/sync-destinations/${syncDestinationName}`
    ] as const;
    }


export const getPlatformGetSyncDestinationQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncDestination>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestination>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncDestinationQueryKey(teamName,syncDestinationName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncDestination>>> = ({ signal }) => platformGetSyncDestination(teamName,syncDestinationName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestination>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncDestinationQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncDestination>>>
export type PlatformGetSyncDestinationQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncDestination<TData = Awaited<ReturnType<typeof platformGetSyncDestination>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestination>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncDestinationQueryOptions(teamName,syncDestinationName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a Sync Destination definition.
 */
export const getPlatformUpdateSyncDestinationUrl = (teamName: string,
    syncDestinationName: string,) => {




  return `/teams/${teamName}/sync-destinations/${syncDestinationName}`
}

export const platformUpdateSyncDestination = async (teamName: string,
    syncDestinationName: string,
    platformSyncDestinationUpdate: PlatformSyncDestinationUpdate, options?: RequestInit) => {

  return customFetch<PlatformSyncDestination>(getPlatformUpdateSyncDestinationUrl(teamName,syncDestinationName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSyncDestinationUpdate,)
  }
);}




export const getPlatformUpdateSyncDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdate}, TContext> => {

const mutationKey = ['platformUpdateSyncDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncDestination>>, {teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdate}> = (props) => {
          const {teamName,syncDestinationName,data} = props ?? {};

          return  platformUpdateSyncDestination(teamName,syncDestinationName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncDestination>>>
    export type PlatformUpdateSyncDestinationMutationBody = PlatformSyncDestinationUpdate
    export type PlatformUpdateSyncDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncDestination>>,
        TError,
        {teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateSyncDestinationMutationOptions(options));
    }

/**
 * Delete a Sync Destination definition. Any syncs relying on this destination must be deleted first.
 */
export const getPlatformDeleteSyncDestinationUrl = (teamName: string,
    syncDestinationName: string,) => {




  return `/teams/${teamName}/sync-destinations/${syncDestinationName}`
}

export const platformDeleteSyncDestination = async (teamName: string,
    syncDestinationName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteSyncDestinationUrl(teamName,syncDestinationName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteSyncDestinationMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext> => {

const mutationKey = ['platformDeleteSyncDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteSyncDestination>>, {teamName: string;syncDestinationName: string}> = (props) => {
          const {teamName,syncDestinationName} = props ?? {};

          return  platformDeleteSyncDestination(teamName,syncDestinationName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteSyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteSyncDestination>>>

    export type PlatformDeleteSyncDestinationMutationError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteSyncDestination = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteSyncDestination>>,
        TError,
        {teamName: string;syncDestinationName: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteSyncDestinationMutationOptions(options));
    }

/**
 * Run migrations on all syncs which use this Sync Destination.
 */
export const getPlatformMigrateSyncDestinationUrl = (teamName: string,
    syncDestinationName: string,) => {




  return `/teams/${teamName}/sync-destinations/${syncDestinationName}/migrate`
}

export const platformMigrateSyncDestination = async (teamName: string,
    syncDestinationName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformMigrateSyncDestinationUrl(teamName,syncDestinationName),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformMigrateSyncDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext> => {

const mutationKey = ['platformMigrateSyncDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformMigrateSyncDestination>>, {teamName: string;syncDestinationName: string}> = (props) => {
          const {teamName,syncDestinationName} = props ?? {};

          return  platformMigrateSyncDestination(teamName,syncDestinationName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformMigrateSyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformMigrateSyncDestination>>>

    export type PlatformMigrateSyncDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformMigrateSyncDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformMigrateSyncDestination>>,
        TError,
        {teamName: string;syncDestinationName: string},
        TContext
      > => {
      return useMutation(getPlatformMigrateSyncDestinationMutationOptions(options));
    }

/**
 * List all Syncs for a given sync destination.
 */
export const getPlatformListSyncDestinationSyncsUrl = (teamName: string,
    syncDestinationName: string,
    params?: PlatformListSyncDestinationSyncsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/sync-destinations/${syncDestinationName}/syncs?${stringifiedParams}` : `/teams/${teamName}/sync-destinations/${syncDestinationName}/syncs`
}

export const platformListSyncDestinationSyncs = async (teamName: string,
    syncDestinationName: string,
    params?: PlatformListSyncDestinationSyncsParams, options?: RequestInit) => {

  return customFetch<PlatformListSyncDestinationSyncs200>(getPlatformListSyncDestinationSyncsUrl(teamName,syncDestinationName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListSyncDestinationSyncsQueryKey = (teamName: string,
    syncDestinationName: string,
    params?: PlatformListSyncDestinationSyncsParams,) => {
    return [
    `/teams/${teamName}/sync-destinations/${syncDestinationName}/syncs`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListSyncDestinationSyncsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationName: string,
    params?: PlatformListSyncDestinationSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncDestinationSyncsQueryKey(teamName,syncDestinationName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>> = ({ signal }) => platformListSyncDestinationSyncs(teamName,syncDestinationName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncDestinationSyncsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>>
export type PlatformListSyncDestinationSyncsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncDestinationSyncs<TData = Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationName: string,
    params?: PlatformListSyncDestinationSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncDestinationSyncsQueryOptions(teamName,syncDestinationName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get test connection details for sync destination.
 */
export const getPlatformGetTestConnectionForSyncDestinationUrl = (teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-destinations/${syncDestinationName}/test-connections/${syncTestConnectionId}`
}

export const platformGetTestConnectionForSyncDestination = async (teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string, options?: RequestInit) => {

  return customFetch<PlatformSyncTestConnection>(getPlatformGetTestConnectionForSyncDestinationUrl(teamName,syncDestinationName,syncTestConnectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetTestConnectionForSyncDestinationQueryKey = (teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string,) => {
    return [
    `/teams/${teamName}/sync-destinations/${syncDestinationName}/test-connections/${syncTestConnectionId}`
    ] as const;
    }


export const getPlatformGetTestConnectionForSyncDestinationQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTestConnectionForSyncDestinationQueryKey(teamName,syncDestinationName,syncTestConnectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>> = ({ signal }) => platformGetTestConnectionForSyncDestination(teamName,syncDestinationName,syncTestConnectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationName && syncTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTestConnectionForSyncDestinationQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>>
export type PlatformGetTestConnectionForSyncDestinationQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetTestConnectionForSyncDestination<TData = Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTestConnectionForSyncDestinationQueryOptions(teamName,syncDestinationName,syncTestConnectionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a test source connection.
 */
export const getPlatformCreateSyncSourceTestConnectionUrl = (teamName: string,) => {




  return `/teams/${teamName}/sync-source-test-connections`
}

export const platformCreateSyncSourceTestConnection = async (teamName: string,
    platformSyncSourceTestConnectionCreate: PlatformSyncSourceTestConnectionCreate, options?: RequestInit) => {

  return customFetch<PlatformSyncSourceTestConnection>(getPlatformCreateSyncSourceTestConnectionUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSyncSourceTestConnectionCreate,)
  }
);}




export const getPlatformCreateSyncSourceTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>, TError,{teamName: string;data: PlatformSyncSourceTestConnectionCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>, TError,{teamName: string;data: PlatformSyncSourceTestConnectionCreate}, TContext> => {

const mutationKey = ['platformCreateSyncSourceTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>, {teamName: string;data: PlatformSyncSourceTestConnectionCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateSyncSourceTestConnection(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateSyncSourceTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>>
    export type PlatformCreateSyncSourceTestConnectionMutationBody = PlatformSyncSourceTestConnectionCreate
    export type PlatformCreateSyncSourceTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformCreateSyncSourceTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>, TError,{teamName: string;data: PlatformSyncSourceTestConnectionCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>,
        TError,
        {teamName: string;data: PlatformSyncSourceTestConnectionCreate},
        TContext
      > => {
      return useMutation(getPlatformCreateSyncSourceTestConnectionMutationOptions(options));
    }

/**
 * Get a sync source test connection.
 */
export const getPlatformGetSyncSourceTestConnectionUrl = (teamName: string,
    syncSourceTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}`
}

export const platformGetSyncSourceTestConnection = async (teamName: string,
    syncSourceTestConnectionId: string, options?: RequestInit) => {

  return customFetch<PlatformSyncSourceTestConnection>(getPlatformGetSyncSourceTestConnectionUrl(teamName,syncSourceTestConnectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncSourceTestConnectionQueryKey = (teamName: string,
    syncSourceTestConnectionId: string,) => {
    return [
    `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}`
    ] as const;
    }


export const getPlatformGetSyncSourceTestConnectionQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncSourceTestConnectionQueryKey(teamName,syncSourceTestConnectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>> = ({ signal }) => platformGetSyncSourceTestConnection(teamName,syncSourceTestConnectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncSourceTestConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>>
export type PlatformGetSyncSourceTestConnectionQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncSourceTestConnection<TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncSourceTestConnectionQueryOptions(teamName,syncSourceTestConnectionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a sync source test connection.
 */
export const getPlatformUpdateSyncTestConnectionForSyncSourceUrl = (teamName: string,
    syncSourceTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}`
}

export const platformUpdateSyncTestConnectionForSyncSource = async (teamName: string,
    syncSourceTestConnectionId: string,
    platformUpdateSyncTestConnectionForSyncSourceBody: PlatformUpdateSyncTestConnectionForSyncSourceBody, options?: RequestInit) => {

  return customFetch<PlatformSyncSourceTestConnection>(getPlatformUpdateSyncTestConnectionForSyncSourceUrl(teamName,syncSourceTestConnectionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformUpdateSyncTestConnectionForSyncSourceBody,)
  }
);}




export const getPlatformUpdateSyncTestConnectionForSyncSourceMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncSourceBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncSourceBody}, TContext> => {

const mutationKey = ['platformUpdateSyncTestConnectionForSyncSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>, {teamName: string;syncSourceTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncSourceBody}> = (props) => {
          const {teamName,syncSourceTestConnectionId,data} = props ?? {};

          return  platformUpdateSyncTestConnectionForSyncSource(teamName,syncSourceTestConnectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncTestConnectionForSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>>
    export type PlatformUpdateSyncTestConnectionForSyncSourceMutationBody = PlatformUpdateSyncTestConnectionForSyncSourceBody
    export type PlatformUpdateSyncTestConnectionForSyncSourceMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncTestConnectionForSyncSource = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncSourceBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>,
        TError,
        {teamName: string;syncSourceTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncSourceBody},
        TContext
      > => {
      return useMutation(getPlatformUpdateSyncTestConnectionForSyncSourceMutationOptions(options));
    }

/**
 * Deprecated. Get logs for a sync source test connection.
 * @deprecated
 */
export const getPlatformGetSyncSourceTestConnectionLogsUrl = (teamName: string,
    syncSourceTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/logs`
}

export const platformGetSyncSourceTestConnectionLogs = async (teamName: string,
    syncSourceTestConnectionId: string, options?: RequestInit) => {

  return customFetch<PlatformGetSyncSourceTestConnectionLogs200One | string | void>(getPlatformGetSyncSourceTestConnectionLogsUrl(teamName,syncSourceTestConnectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncSourceTestConnectionLogsQueryKey = (teamName: string,
    syncSourceTestConnectionId: string,) => {
    return [
    `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/logs`
    ] as const;
    }


export const getPlatformGetSyncSourceTestConnectionLogsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncSourceTestConnectionLogsQueryKey(teamName,syncSourceTestConnectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>> = ({ signal }) => platformGetSyncSourceTestConnectionLogs(teamName,syncSourceTestConnectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncSourceTestConnectionLogsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>>
export type PlatformGetSyncSourceTestConnectionLogsQueryError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse


/**
 * @deprecated
 */

export function usePlatformGetSyncSourceTestConnectionLogs<TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncSourceTestConnectionLogsQueryOptions(teamName,syncSourceTestConnectionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get logs for a sync source test connection.
 */
export const getPlatformGetSyncSourceTestConnectionLogsQueryUrl = (teamName: string,
    syncSourceTestConnectionId: string,
    params?: PlatformGetSyncSourceTestConnectionLogsQueryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/logs/query?${stringifiedParams}` : `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/logs/query`
}

export const platformGetSyncSourceTestConnectionLogsQuery = async (teamName: string,
    syncSourceTestConnectionId: string,
    params?: PlatformGetSyncSourceTestConnectionLogsQueryParams, options?: RequestInit) => {

  return customFetch<PlatformGetSyncSourceTestConnectionLogsQuery200One | string | void>(getPlatformGetSyncSourceTestConnectionLogsQueryUrl(teamName,syncSourceTestConnectionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncSourceTestConnectionLogsQueryQueryKey = (teamName: string,
    syncSourceTestConnectionId: string,
    params?: PlatformGetSyncSourceTestConnectionLogsQueryParams,) => {
    return [
    `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/logs/query`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetSyncSourceTestConnectionLogsQueryQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsQuery>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceTestConnectionId: string,
    params?: PlatformGetSyncSourceTestConnectionLogsQueryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsQuery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncSourceTestConnectionLogsQueryQueryKey(teamName,syncSourceTestConnectionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsQuery>>> = ({ signal }) => platformGetSyncSourceTestConnectionLogsQuery(teamName,syncSourceTestConnectionId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsQuery>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncSourceTestConnectionLogsQueryQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsQuery>>>
export type PlatformGetSyncSourceTestConnectionLogsQueryQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncSourceTestConnectionLogsQuery<TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsQuery>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceTestConnectionId: string,
    params?: PlatformGetSyncSourceTestConnectionLogsQueryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsQuery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncSourceTestConnectionLogsQueryQueryOptions(teamName,syncSourceTestConnectionId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get live logs for a sync source test connection.
 */
export const getPlatformGetSyncSourceTestConnectionLogsLiveUrl = (teamName: string,
    syncSourceTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/logs/live`
}

export const platformGetSyncSourceTestConnectionLogsLive = async (teamName: string,
    syncSourceTestConnectionId: string, options?: RequestInit) => {

  return customFetch<string | void>(getPlatformGetSyncSourceTestConnectionLogsLiveUrl(teamName,syncSourceTestConnectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncSourceTestConnectionLogsLiveQueryKey = (teamName: string,
    syncSourceTestConnectionId: string,) => {
    return [
    `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/logs/live`
    ] as const;
    }


export const getPlatformGetSyncSourceTestConnectionLogsLiveQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsLive>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsLive>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncSourceTestConnectionLogsLiveQueryKey(teamName,syncSourceTestConnectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsLive>>> = ({ signal }) => platformGetSyncSourceTestConnectionLogsLive(teamName,syncSourceTestConnectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsLive>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncSourceTestConnectionLogsLiveQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsLive>>>
export type PlatformGetSyncSourceTestConnectionLogsLiveQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncSourceTestConnectionLogsLive<TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsLive>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogsLive>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncSourceTestConnectionLogsLiveQueryOptions(teamName,syncSourceTestConnectionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Promote a sync source test connection to a sync source.
 */
export const getPlatformPromoteSyncSourceTestConnectionUrl = (teamName: string,
    syncSourceTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/promote`
}

export const platformPromoteSyncSourceTestConnection = async (teamName: string,
    syncSourceTestConnectionId: string,
    platformPromoteSyncSourceTestConnection: PlatformPromoteSyncSourceTestConnection, options?: RequestInit) => {

  return customFetch<PlatformSyncSource>(getPlatformPromoteSyncSourceTestConnectionUrl(teamName,syncSourceTestConnectionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformPromoteSyncSourceTestConnection,)
  }
);}




export const getPlatformPromoteSyncSourceTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformPromoteSyncSourceTestConnection}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformPromoteSyncSourceTestConnection}, TContext> => {

const mutationKey = ['platformPromoteSyncSourceTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>, {teamName: string;syncSourceTestConnectionId: string;data: PlatformPromoteSyncSourceTestConnection}> = (props) => {
          const {teamName,syncSourceTestConnectionId,data} = props ?? {};

          return  platformPromoteSyncSourceTestConnection(teamName,syncSourceTestConnectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformPromoteSyncSourceTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>>
    export type PlatformPromoteSyncSourceTestConnectionMutationBody = PlatformPromoteSyncSourceTestConnection
    export type PlatformPromoteSyncSourceTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformPromoteSyncSourceTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformPromoteSyncSourceTestConnection}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>,
        TError,
        {teamName: string;syncSourceTestConnectionId: string;data: PlatformPromoteSyncSourceTestConnection},
        TContext
      > => {
      return useMutation(getPlatformPromoteSyncSourceTestConnectionMutationOptions(options));
    }

/**
 * Create an integration test connection.
 */
export const getPlatformCreateV2SyncIntegrationTestConnectionUrl = (teamName: string,) => {




  return `/v2/teams/${teamName}/sync-integration-test-connections`
}

export const platformCreateV2SyncIntegrationTestConnection = async (teamName: string,
    platformSyncIntegrationTestConnectionCreateV2: PlatformSyncIntegrationTestConnectionCreateV2, options?: RequestInit) => {

  return customFetch<PlatformSyncIntegrationTestConnectionV2>(getPlatformCreateV2SyncIntegrationTestConnectionUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSyncIntegrationTestConnectionCreateV2,)
  }
);}




export const getPlatformCreateV2SyncIntegrationTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncIntegrationTestConnection>>, TError,{teamName: string;data: PlatformSyncIntegrationTestConnectionCreateV2}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncIntegrationTestConnection>>, TError,{teamName: string;data: PlatformSyncIntegrationTestConnectionCreateV2}, TContext> => {

const mutationKey = ['platformCreateV2SyncIntegrationTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateV2SyncIntegrationTestConnection>>, {teamName: string;data: PlatformSyncIntegrationTestConnectionCreateV2}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateV2SyncIntegrationTestConnection(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateV2SyncIntegrationTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateV2SyncIntegrationTestConnection>>>
    export type PlatformCreateV2SyncIntegrationTestConnectionMutationBody = PlatformSyncIntegrationTestConnectionCreateV2
    export type PlatformCreateV2SyncIntegrationTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformCreateV2SyncIntegrationTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncIntegrationTestConnection>>, TError,{teamName: string;data: PlatformSyncIntegrationTestConnectionCreateV2}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateV2SyncIntegrationTestConnection>>,
        TError,
        {teamName: string;data: PlatformSyncIntegrationTestConnectionCreateV2},
        TContext
      > => {
      return useMutation(getPlatformCreateV2SyncIntegrationTestConnectionMutationOptions(options));
    }

/**
 * List sync integrations
 */
export const getPlatformListV2SyncIntegrationsUrl = (teamName: string,
    params?: PlatformListV2SyncIntegrationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/teams/${teamName}/sync-integrations?${stringifiedParams}` : `/v2/teams/${teamName}/sync-integrations`
}

export const platformListV2SyncIntegrations = async (teamName: string,
    params?: PlatformListV2SyncIntegrationsParams, options?: RequestInit) => {

  return customFetch<PlatformListV2SyncIntegrations200>(getPlatformListV2SyncIntegrationsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListV2SyncIntegrationsQueryKey = (teamName: string,
    params?: PlatformListV2SyncIntegrationsParams,) => {
    return [
    `/v2/teams/${teamName}/sync-integrations`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListV2SyncIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof platformListV2SyncIntegrations>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListV2SyncIntegrationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListV2SyncIntegrations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListV2SyncIntegrationsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListV2SyncIntegrations>>> = ({ signal }) => platformListV2SyncIntegrations(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListV2SyncIntegrations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListV2SyncIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListV2SyncIntegrations>>>
export type PlatformListV2SyncIntegrationsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListV2SyncIntegrations<TData = Awaited<ReturnType<typeof platformListV2SyncIntegrations>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListV2SyncIntegrationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListV2SyncIntegrations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListV2SyncIntegrationsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a new integration associated with a completed test connection
 */
export const getPlatformCreateV2SyncIntegrationUrl = (teamName: string,) => {




  return `/v2/teams/${teamName}/sync-integrations`
}

export const platformCreateV2SyncIntegration = async (teamName: string,
    platformSyncIntegrationCreateV2: PlatformSyncIntegrationCreateV2, options?: RequestInit) => {

  return customFetch<PlatformSyncIntegrationV2>(getPlatformCreateV2SyncIntegrationUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSyncIntegrationCreateV2,)
  }
);}




export const getPlatformCreateV2SyncIntegrationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncIntegration>>, TError,{teamName: string;data: PlatformSyncIntegrationCreateV2}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncIntegration>>, TError,{teamName: string;data: PlatformSyncIntegrationCreateV2}, TContext> => {

const mutationKey = ['platformCreateV2SyncIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateV2SyncIntegration>>, {teamName: string;data: PlatformSyncIntegrationCreateV2}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateV2SyncIntegration(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateV2SyncIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateV2SyncIntegration>>>
    export type PlatformCreateV2SyncIntegrationMutationBody = PlatformSyncIntegrationCreateV2
    export type PlatformCreateV2SyncIntegrationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateV2SyncIntegration = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncIntegration>>, TError,{teamName: string;data: PlatformSyncIntegrationCreateV2}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateV2SyncIntegration>>,
        TError,
        {teamName: string;data: PlatformSyncIntegrationCreateV2},
        TContext
      > => {
      return useMutation(getPlatformCreateV2SyncIntegrationMutationOptions(options));
    }

/**
 * Get a sync integration by name
 */
export const getPlatformGetV2SyncIntegrationUrl = (teamName: string,
    syncName: string,) => {




  return `/v2/teams/${teamName}/sync-integrations/${syncName}`
}

export const platformGetV2SyncIntegration = async (teamName: string,
    syncName: string, options?: RequestInit) => {

  return customFetch<PlatformSyncIntegrationExpandedV2>(getPlatformGetV2SyncIntegrationUrl(teamName,syncName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetV2SyncIntegrationQueryKey = (teamName: string,
    syncName: string,) => {
    return [
    `/v2/teams/${teamName}/sync-integrations/${syncName}`
    ] as const;
    }


export const getPlatformGetV2SyncIntegrationQueryOptions = <TData = Awaited<ReturnType<typeof platformGetV2SyncIntegration>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetV2SyncIntegration>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetV2SyncIntegrationQueryKey(teamName,syncName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetV2SyncIntegration>>> = ({ signal }) => platformGetV2SyncIntegration(teamName,syncName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetV2SyncIntegration>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetV2SyncIntegrationQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetV2SyncIntegration>>>
export type PlatformGetV2SyncIntegrationQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetV2SyncIntegration<TData = Awaited<ReturnType<typeof platformGetV2SyncIntegration>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetV2SyncIntegration>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetV2SyncIntegrationQueryOptions(teamName,syncName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update attributes of an integration
 */
export const getPlatformUpdateV2SyncIntegrationUrl = (teamName: string,
    syncName: string,) => {




  return `/v2/teams/${teamName}/sync-integrations/${syncName}`
}

export const platformUpdateV2SyncIntegration = async (teamName: string,
    syncName: string,
    platformSyncIntegrationUpdateV2: PlatformSyncIntegrationUpdateV2, options?: RequestInit) => {

  return customFetch<PlatformSyncIntegrationV2>(getPlatformUpdateV2SyncIntegrationUrl(teamName,syncName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSyncIntegrationUpdateV2,)
  }
);}




export const getPlatformUpdateV2SyncIntegrationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateV2SyncIntegration>>, TError,{teamName: string;syncName: string;data: PlatformSyncIntegrationUpdateV2}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateV2SyncIntegration>>, TError,{teamName: string;syncName: string;data: PlatformSyncIntegrationUpdateV2}, TContext> => {

const mutationKey = ['platformUpdateV2SyncIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateV2SyncIntegration>>, {teamName: string;syncName: string;data: PlatformSyncIntegrationUpdateV2}> = (props) => {
          const {teamName,syncName,data} = props ?? {};

          return  platformUpdateV2SyncIntegration(teamName,syncName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateV2SyncIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateV2SyncIntegration>>>
    export type PlatformUpdateV2SyncIntegrationMutationBody = PlatformSyncIntegrationUpdateV2
    export type PlatformUpdateV2SyncIntegrationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateV2SyncIntegration = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateV2SyncIntegration>>, TError,{teamName: string;syncName: string;data: PlatformSyncIntegrationUpdateV2}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateV2SyncIntegration>>,
        TError,
        {teamName: string;syncName: string;data: PlatformSyncIntegrationUpdateV2},
        TContext
      > => {
      return useMutation(getPlatformUpdateV2SyncIntegrationMutationOptions(options));
    }

/**
 * Delete an integration
 */
export const getPlatformDeleteV2SyncIntegrationUrl = (teamName: string,
    syncName: string,) => {




  return `/v2/teams/${teamName}/sync-integrations/${syncName}`
}

export const platformDeleteV2SyncIntegration = async (teamName: string,
    syncName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteV2SyncIntegrationUrl(teamName,syncName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteV2SyncIntegrationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteV2SyncIntegration>>, TError,{teamName: string;syncName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteV2SyncIntegration>>, TError,{teamName: string;syncName: string}, TContext> => {

const mutationKey = ['platformDeleteV2SyncIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteV2SyncIntegration>>, {teamName: string;syncName: string}> = (props) => {
          const {teamName,syncName} = props ?? {};

          return  platformDeleteV2SyncIntegration(teamName,syncName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteV2SyncIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteV2SyncIntegration>>>

    export type PlatformDeleteV2SyncIntegrationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteV2SyncIntegration = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteV2SyncIntegration>>, TError,{teamName: string;syncName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteV2SyncIntegration>>,
        TError,
        {teamName: string;syncName: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteV2SyncIntegrationMutationOptions(options));
    }

/**
 * List all sync source definitions.
 */
export const getPlatformListSyncSourcesUrl = (teamName: string,
    params?: PlatformListSyncSourcesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/sync-sources?${stringifiedParams}` : `/teams/${teamName}/sync-sources`
}

export const platformListSyncSources = async (teamName: string,
    params?: PlatformListSyncSourcesParams, options?: RequestInit) => {

  return customFetch<PlatformListSyncSources200>(getPlatformListSyncSourcesUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListSyncSourcesQueryKey = (teamName: string,
    params?: PlatformListSyncSourcesParams,) => {
    return [
    `/teams/${teamName}/sync-sources`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListSyncSourcesQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncSources>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListSyncSourcesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSources>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncSourcesQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncSources>>> = ({ signal }) => platformListSyncSources(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSources>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncSources>>>
export type PlatformListSyncSourcesQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncSources<TData = Awaited<ReturnType<typeof platformListSyncSources>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListSyncSourcesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSources>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncSourcesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a single sync source definition.
 */
export const getPlatformGetSyncSourceUrl = (teamName: string,
    syncSourceName: string,) => {




  return `/teams/${teamName}/sync-sources/${syncSourceName}`
}

export const platformGetSyncSource = async (teamName: string,
    syncSourceName: string, options?: RequestInit) => {

  return customFetch<PlatformSyncSource>(getPlatformGetSyncSourceUrl(teamName,syncSourceName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncSourceQueryKey = (teamName: string,
    syncSourceName: string,) => {
    return [
    `/teams/${teamName}/sync-sources/${syncSourceName}`
    ] as const;
    }


export const getPlatformGetSyncSourceQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncSource>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSource>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncSourceQueryKey(teamName,syncSourceName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncSource>>> = ({ signal }) => platformGetSyncSource(teamName,syncSourceName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSource>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncSourceQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncSource>>>
export type PlatformGetSyncSourceQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncSource<TData = Awaited<ReturnType<typeof platformGetSyncSource>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSource>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncSourceQueryOptions(teamName,syncSourceName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a Sync Source definition.
 */
export const getPlatformUpdateSyncSourceUrl = (teamName: string,
    syncSourceName: string,) => {




  return `/teams/${teamName}/sync-sources/${syncSourceName}`
}

export const platformUpdateSyncSource = async (teamName: string,
    syncSourceName: string,
    platformSyncSourceUpdate: PlatformSyncSourceUpdate, options?: RequestInit) => {

  return customFetch<PlatformSyncSource>(getPlatformUpdateSyncSourceUrl(teamName,syncSourceName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSyncSourceUpdate,)
  }
);}




export const getPlatformUpdateSyncSourceMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncSource>>, TError,{teamName: string;syncSourceName: string;data: PlatformSyncSourceUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncSource>>, TError,{teamName: string;syncSourceName: string;data: PlatformSyncSourceUpdate}, TContext> => {

const mutationKey = ['platformUpdateSyncSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncSource>>, {teamName: string;syncSourceName: string;data: PlatformSyncSourceUpdate}> = (props) => {
          const {teamName,syncSourceName,data} = props ?? {};

          return  platformUpdateSyncSource(teamName,syncSourceName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncSource>>>
    export type PlatformUpdateSyncSourceMutationBody = PlatformSyncSourceUpdate
    export type PlatformUpdateSyncSourceMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncSource = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncSource>>, TError,{teamName: string;syncSourceName: string;data: PlatformSyncSourceUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncSource>>,
        TError,
        {teamName: string;syncSourceName: string;data: PlatformSyncSourceUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateSyncSourceMutationOptions(options));
    }

/**
 * Delete a Sync Source definition. Any syncs relying on this source must be deleted first.
 */
export const getPlatformDeleteSyncSourceUrl = (teamName: string,
    syncSourceName: string,) => {




  return `/teams/${teamName}/sync-sources/${syncSourceName}`
}

export const platformDeleteSyncSource = async (teamName: string,
    syncSourceName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteSyncSourceUrl(teamName,syncSourceName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteSyncSourceMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext> => {

const mutationKey = ['platformDeleteSyncSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteSyncSource>>, {teamName: string;syncSourceName: string}> = (props) => {
          const {teamName,syncSourceName} = props ?? {};

          return  platformDeleteSyncSource(teamName,syncSourceName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteSyncSource>>>

    export type PlatformDeleteSyncSourceMutationError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteSyncSource = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteSyncSource>>,
        TError,
        {teamName: string;syncSourceName: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteSyncSourceMutationOptions(options));
    }

/**
 * Run migrations on all syncs which use this Sync Source.
 */
export const getPlatformMigrateSyncSourceUrl = (teamName: string,
    syncSourceName: string,) => {




  return `/teams/${teamName}/sync-sources/${syncSourceName}/migrate`
}

export const platformMigrateSyncSource = async (teamName: string,
    syncSourceName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformMigrateSyncSourceUrl(teamName,syncSourceName),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformMigrateSyncSourceMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext> => {

const mutationKey = ['platformMigrateSyncSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformMigrateSyncSource>>, {teamName: string;syncSourceName: string}> = (props) => {
          const {teamName,syncSourceName} = props ?? {};

          return  platformMigrateSyncSource(teamName,syncSourceName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformMigrateSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof platformMigrateSyncSource>>>

    export type PlatformMigrateSyncSourceMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformMigrateSyncSource = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformMigrateSyncSource>>,
        TError,
        {teamName: string;syncSourceName: string},
        TContext
      > => {
      return useMutation(getPlatformMigrateSyncSourceMutationOptions(options));
    }

/**
 * List all Syncs for a given sync source.
 */
export const getPlatformListSyncSourceSyncsUrl = (teamName: string,
    syncSourceName: string,
    params?: PlatformListSyncSourceSyncsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/sync-sources/${syncSourceName}/syncs?${stringifiedParams}` : `/teams/${teamName}/sync-sources/${syncSourceName}/syncs`
}

export const platformListSyncSourceSyncs = async (teamName: string,
    syncSourceName: string,
    params?: PlatformListSyncSourceSyncsParams, options?: RequestInit) => {

  return customFetch<PlatformListSyncSourceSyncs200>(getPlatformListSyncSourceSyncsUrl(teamName,syncSourceName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListSyncSourceSyncsQueryKey = (teamName: string,
    syncSourceName: string,
    params?: PlatformListSyncSourceSyncsParams,) => {
    return [
    `/teams/${teamName}/sync-sources/${syncSourceName}/syncs`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListSyncSourceSyncsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncSourceSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceName: string,
    params?: PlatformListSyncSourceSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSourceSyncs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncSourceSyncsQueryKey(teamName,syncSourceName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncSourceSyncs>>> = ({ signal }) => platformListSyncSourceSyncs(teamName,syncSourceName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSourceSyncs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncSourceSyncsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncSourceSyncs>>>
export type PlatformListSyncSourceSyncsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncSourceSyncs<TData = Awaited<ReturnType<typeof platformListSyncSourceSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceName: string,
    params?: PlatformListSyncSourceSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSourceSyncs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncSourceSyncsQueryOptions(teamName,syncSourceName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get test connection details for sync source.
 */
export const getPlatformGetTestConnectionForSyncSourceUrl = (teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string,) => {




  return `/teams/${teamName}/sync-sources/${syncSourceName}/test-connections/${syncTestConnectionId}`
}

export const platformGetTestConnectionForSyncSource = async (teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string, options?: RequestInit) => {

  return customFetch<PlatformSyncTestConnection>(getPlatformGetTestConnectionForSyncSourceUrl(teamName,syncSourceName,syncTestConnectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetTestConnectionForSyncSourceQueryKey = (teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string,) => {
    return [
    `/teams/${teamName}/sync-sources/${syncSourceName}/test-connections/${syncTestConnectionId}`
    ] as const;
    }


export const getPlatformGetTestConnectionForSyncSourceQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTestConnectionForSyncSourceQueryKey(teamName,syncSourceName,syncTestConnectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>> = ({ signal }) => platformGetTestConnectionForSyncSource(teamName,syncSourceName,syncTestConnectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceName && syncTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTestConnectionForSyncSourceQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>>
export type PlatformGetTestConnectionForSyncSourceQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetTestConnectionForSyncSource<TData = Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTestConnectionForSyncSourceQueryOptions(teamName,syncSourceName,syncTestConnectionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List all sync transformer definitions.
 */
export const getPlatformListSyncTransformersUrl = (teamName: string,
    params?: PlatformListSyncTransformersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/sync-transformers?${stringifiedParams}` : `/teams/${teamName}/sync-transformers`
}

export const platformListSyncTransformers = async (teamName: string,
    params?: PlatformListSyncTransformersParams, options?: RequestInit) => {

  return customFetch<PlatformListSyncTransformers200>(getPlatformListSyncTransformersUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListSyncTransformersQueryKey = (teamName: string,
    params?: PlatformListSyncTransformersParams,) => {
    return [
    `/teams/${teamName}/sync-transformers`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListSyncTransformersQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncTransformers>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListSyncTransformersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncTransformersQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncTransformers>>> = ({ signal }) => platformListSyncTransformers(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformers>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncTransformersQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncTransformers>>>
export type PlatformListSyncTransformersQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncTransformers<TData = Awaited<ReturnType<typeof platformListSyncTransformers>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListSyncTransformersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncTransformersQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a single sync transformer definition.
 */
export const getPlatformGetSyncTransformerUrl = (teamName: string,
    syncTransformerName: string,) => {




  return `/teams/${teamName}/sync-transformers/${syncTransformerName}`
}

export const platformGetSyncTransformer = async (teamName: string,
    syncTransformerName: string, options?: RequestInit) => {

  return customFetch<PlatformSyncTransformer>(getPlatformGetSyncTransformerUrl(teamName,syncTransformerName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncTransformerQueryKey = (teamName: string,
    syncTransformerName: string,) => {
    return [
    `/teams/${teamName}/sync-transformers/${syncTransformerName}`
    ] as const;
    }


export const getPlatformGetSyncTransformerQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncTransformer>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTransformerName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncTransformerQueryKey(teamName,syncTransformerName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncTransformer>>> = ({ signal }) => platformGetSyncTransformer(teamName,syncTransformerName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncTransformerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformer>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncTransformerQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncTransformer>>>
export type PlatformGetSyncTransformerQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncTransformer<TData = Awaited<ReturnType<typeof platformGetSyncTransformer>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTransformerName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncTransformerQueryOptions(teamName,syncTransformerName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a Sync Transformer definition.
 */
export const getPlatformUpdateSyncTransformerUrl = (teamName: string,
    syncTransformerName: string,) => {




  return `/teams/${teamName}/sync-transformers/${syncTransformerName}`
}

export const platformUpdateSyncTransformer = async (teamName: string,
    syncTransformerName: string,
    platformSyncTransformerUpdate: PlatformSyncTransformerUpdate, options?: RequestInit) => {

  return customFetch<PlatformSyncTransformer>(getPlatformUpdateSyncTransformerUrl(teamName,syncTransformerName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSyncTransformerUpdate,)
  }
);}




export const getPlatformUpdateSyncTransformerMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTransformer>>, TError,{teamName: string;syncTransformerName: string;data: PlatformSyncTransformerUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTransformer>>, TError,{teamName: string;syncTransformerName: string;data: PlatformSyncTransformerUpdate}, TContext> => {

const mutationKey = ['platformUpdateSyncTransformer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncTransformer>>, {teamName: string;syncTransformerName: string;data: PlatformSyncTransformerUpdate}> = (props) => {
          const {teamName,syncTransformerName,data} = props ?? {};

          return  platformUpdateSyncTransformer(teamName,syncTransformerName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncTransformerMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncTransformer>>>
    export type PlatformUpdateSyncTransformerMutationBody = PlatformSyncTransformerUpdate
    export type PlatformUpdateSyncTransformerMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncTransformer = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTransformer>>, TError,{teamName: string;syncTransformerName: string;data: PlatformSyncTransformerUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncTransformer>>,
        TError,
        {teamName: string;syncTransformerName: string;data: PlatformSyncTransformerUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateSyncTransformerMutationOptions(options));
    }

/**
 * Delete a Sync Transformer definition. Any syncs relying on this transformer must be deleted first.
 */
export const getPlatformDeleteSyncTransformerUrl = (teamName: string,
    syncTransformerName: string,) => {




  return `/teams/${teamName}/sync-transformers/${syncTransformerName}`
}

export const platformDeleteSyncTransformer = async (teamName: string,
    syncTransformerName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteSyncTransformerUrl(teamName,syncTransformerName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteSyncTransformerMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncTransformer>>, TError,{teamName: string;syncTransformerName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncTransformer>>, TError,{teamName: string;syncTransformerName: string}, TContext> => {

const mutationKey = ['platformDeleteSyncTransformer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteSyncTransformer>>, {teamName: string;syncTransformerName: string}> = (props) => {
          const {teamName,syncTransformerName} = props ?? {};

          return  platformDeleteSyncTransformer(teamName,syncTransformerName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteSyncTransformerMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteSyncTransformer>>>

    export type PlatformDeleteSyncTransformerMutationError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteSyncTransformer = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncTransformer>>, TError,{teamName: string;syncTransformerName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteSyncTransformer>>,
        TError,
        {teamName: string;syncTransformerName: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteSyncTransformerMutationOptions(options));
    }

/**
 * List all Syncs for a given sync transformer.
 */
export const getPlatformListSyncTransformerSyncsUrl = (teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/sync-transformers/${syncTransformerName}/syncs?${stringifiedParams}` : `/teams/${teamName}/sync-transformers/${syncTransformerName}/syncs`
}

export const platformListSyncTransformerSyncs = async (teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncsParams, options?: RequestInit) => {

  return customFetch<PlatformListSyncTransformerSyncs200>(getPlatformListSyncTransformerSyncsUrl(teamName,syncTransformerName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListSyncTransformerSyncsQueryKey = (teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncsParams,) => {
    return [
    `/teams/${teamName}/sync-transformers/${syncTransformerName}/syncs`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListSyncTransformerSyncsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncTransformerSyncsQueryKey(teamName,syncTransformerName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>> = ({ signal }) => platformListSyncTransformerSyncs(teamName,syncTransformerName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncTransformerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncTransformerSyncsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>>
export type PlatformListSyncTransformerSyncsQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncTransformerSyncs<TData = Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncTransformerSyncsQueryOptions(teamName,syncTransformerName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List all Sync Destinations for a given sync transformer.
 */
export const getPlatformListSyncTransformerSyncDestinationsUrl = (teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncDestinationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/sync-transformers/${syncTransformerName}/sync-destinations?${stringifiedParams}` : `/teams/${teamName}/sync-transformers/${syncTransformerName}/sync-destinations`
}

export const platformListSyncTransformerSyncDestinations = async (teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncDestinationsParams, options?: RequestInit) => {

  return customFetch<PlatformListSyncTransformerSyncDestinations200>(getPlatformListSyncTransformerSyncDestinationsUrl(teamName,syncTransformerName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListSyncTransformerSyncDestinationsQueryKey = (teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncDestinationsParams,) => {
    return [
    `/teams/${teamName}/sync-transformers/${syncTransformerName}/sync-destinations`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListSyncTransformerSyncDestinationsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncTransformerSyncDestinationsQueryKey(teamName,syncTransformerName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>> = ({ signal }) => platformListSyncTransformerSyncDestinations(teamName,syncTransformerName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncTransformerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncTransformerSyncDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>>
export type PlatformListSyncTransformerSyncDestinationsQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncTransformerSyncDestinations<TData = Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncTransformerSyncDestinationsQueryOptions(teamName,syncTransformerName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List all version upgrades for syncs
 */
export const getPlatformListSyncUpgradesUrl = (teamName: string,
    params?: PlatformListSyncUpgradesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/sync-upgrades?${stringifiedParams}` : `/teams/${teamName}/sync-upgrades`
}

export const platformListSyncUpgrades = async (teamName: string,
    params?: PlatformListSyncUpgradesParams, options?: RequestInit) => {

  return customFetch<PlatformListSyncUpgrades200>(getPlatformListSyncUpgradesUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListSyncUpgradesQueryKey = (teamName: string,
    params?: PlatformListSyncUpgradesParams,) => {
    return [
    `/teams/${teamName}/sync-upgrades`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListSyncUpgradesQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncUpgrades>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListSyncUpgradesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncUpgrades>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncUpgradesQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncUpgrades>>> = ({ signal }) => platformListSyncUpgrades(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncUpgrades>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncUpgradesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncUpgrades>>>
export type PlatformListSyncUpgradesQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncUpgrades<TData = Awaited<ReturnType<typeof platformListSyncUpgrades>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListSyncUpgradesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncUpgrades>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncUpgradesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List all Syncs.
 */
export const getPlatformListSyncsUrl = (teamName: string,
    params?: PlatformListSyncsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/syncs?${stringifiedParams}` : `/teams/${teamName}/syncs`
}

export const platformListSyncs = async (teamName: string,
    params?: PlatformListSyncsParams, options?: RequestInit) => {

  return customFetch<PlatformListSyncs200>(getPlatformListSyncsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListSyncsQueryKey = (teamName: string,
    params?: PlatformListSyncsParams,) => {
    return [
    `/teams/${teamName}/syncs`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListSyncsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncs>>> = ({ signal }) => platformListSyncs(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncs>>>
export type PlatformListSyncsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncs<TData = Awaited<ReturnType<typeof platformListSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create new Sync definition. Sync runs can be scheduled automatically, or triggered manually after sync is created.
 */
export const getPlatformCreateSyncUrl = (teamName: string,) => {




  return `/teams/${teamName}/syncs`
}

export const platformCreateSync = async (teamName: string,
    platformSyncCreate: PlatformSyncCreate, options?: RequestInit) => {

  return customFetch<PlatformSync>(getPlatformCreateSyncUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSyncCreate,)
  }
);}




export const getPlatformCreateSyncMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSync>>, TError,{teamName: string;data: PlatformSyncCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateSync>>, TError,{teamName: string;data: PlatformSyncCreate}, TContext> => {

const mutationKey = ['platformCreateSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateSync>>, {teamName: string;data: PlatformSyncCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateSync(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateSyncMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateSync>>>
    export type PlatformCreateSyncMutationBody = PlatformSyncCreate
    export type PlatformCreateSyncMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateSync = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSync>>, TError,{teamName: string;data: PlatformSyncCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateSync>>,
        TError,
        {teamName: string;data: PlatformSyncCreate},
        TContext
      > => {
      return useMutation(getPlatformCreateSyncMutationOptions(options));
    }

/**
 * Get a Sync
 */
export const getPlatformGetSyncUrl = (teamName: string,
    syncName: string,) => {




  return `/teams/${teamName}/syncs/${syncName}`
}

export const platformGetSync = async (teamName: string,
    syncName: string, options?: RequestInit) => {

  return customFetch<PlatformSync>(getPlatformGetSyncUrl(teamName,syncName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncQueryKey = (teamName: string,
    syncName: string,) => {
    return [
    `/teams/${teamName}/syncs/${syncName}`
    ] as const;
    }


export const getPlatformGetSyncQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSync>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSync>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncQueryKey(teamName,syncName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSync>>> = ({ signal }) => platformGetSync(teamName,syncName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSync>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSync>>>
export type PlatformGetSyncQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSync<TData = Awaited<ReturnType<typeof platformGetSync>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSync>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncQueryOptions(teamName,syncName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a Sync
 */
export const getPlatformUpdateSyncUrl = (teamName: string,
    syncName: string,) => {




  return `/teams/${teamName}/syncs/${syncName}`
}

export const platformUpdateSync = async (teamName: string,
    syncName: string,
    platformSyncUpdate: PlatformSyncUpdate, options?: RequestInit) => {

  return customFetch<PlatformSync>(getPlatformUpdateSyncUrl(teamName,syncName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSyncUpdate,)
  }
);}




export const getPlatformUpdateSyncMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSync>>, TError,{teamName: string;syncName: string;data: PlatformSyncUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSync>>, TError,{teamName: string;syncName: string;data: PlatformSyncUpdate}, TContext> => {

const mutationKey = ['platformUpdateSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSync>>, {teamName: string;syncName: string;data: PlatformSyncUpdate}> = (props) => {
          const {teamName,syncName,data} = props ?? {};

          return  platformUpdateSync(teamName,syncName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSync>>>
    export type PlatformUpdateSyncMutationBody = PlatformSyncUpdate
    export type PlatformUpdateSyncMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSync = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSync>>, TError,{teamName: string;syncName: string;data: PlatformSyncUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSync>>,
        TError,
        {teamName: string;syncName: string;data: PlatformSyncUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateSyncMutationOptions(options));
    }

/**
 * Delete Sync. This will delete Sync configuration and all associated sync runs, but will not delete the associated source and destination(s). These will need to be deleted separately.
 */
export const getPlatformDeleteSyncUrl = (teamName: string,
    syncName: string,) => {




  return `/teams/${teamName}/syncs/${syncName}`
}

export const platformDeleteSync = async (teamName: string,
    syncName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteSyncUrl(teamName,syncName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteSyncMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSync>>, TError,{teamName: string;syncName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSync>>, TError,{teamName: string;syncName: string}, TContext> => {

const mutationKey = ['platformDeleteSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteSync>>, {teamName: string;syncName: string}> = (props) => {
          const {teamName,syncName} = props ?? {};

          return  platformDeleteSync(teamName,syncName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteSyncMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteSync>>>

    export type PlatformDeleteSyncMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteSync = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSync>>, TError,{teamName: string;syncName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteSync>>,
        TError,
        {teamName: string;syncName: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteSyncMutationOptions(options));
    }

/**
 * List all Sync Runs.
 */
export const getPlatformListSyncRunsUrl = (teamName: string,
    syncName: string,
    params?: PlatformListSyncRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/syncs/${syncName}/runs?${stringifiedParams}` : `/teams/${teamName}/syncs/${syncName}/runs`
}

export const platformListSyncRuns = async (teamName: string,
    syncName: string,
    params?: PlatformListSyncRunsParams, options?: RequestInit) => {

  return customFetch<PlatformListSyncRuns200>(getPlatformListSyncRunsUrl(teamName,syncName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListSyncRunsQueryKey = (teamName: string,
    syncName: string,
    params?: PlatformListSyncRunsParams,) => {
    return [
    `/teams/${teamName}/syncs/${syncName}/runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListSyncRunsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncRuns>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    params?: PlatformListSyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncRunsQueryKey(teamName,syncName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncRuns>>> = ({ signal }) => platformListSyncRuns(teamName,syncName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncRunsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncRuns>>>
export type PlatformListSyncRunsQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncRuns<TData = Awaited<ReturnType<typeof platformListSyncRuns>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    params?: PlatformListSyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncRunsQueryOptions(teamName,syncName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create new SyncRun. This will trigger a manual job run.
 */
export const getPlatformCreateSyncRunUrl = (teamName: string,
    syncName: string,) => {




  return `/teams/${teamName}/syncs/${syncName}/runs`
}

export const platformCreateSyncRun = async (teamName: string,
    syncName: string, options?: RequestInit) => {

  return customFetch<PlatformSyncRun>(getPlatformCreateSyncRunUrl(teamName,syncName),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformCreateSyncRunMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRun>>, TError,{teamName: string;syncName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRun>>, TError,{teamName: string;syncName: string}, TContext> => {

const mutationKey = ['platformCreateSyncRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateSyncRun>>, {teamName: string;syncName: string}> = (props) => {
          const {teamName,syncName} = props ?? {};

          return  platformCreateSyncRun(teamName,syncName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateSyncRunMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateSyncRun>>>

    export type PlatformCreateSyncRunMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateSyncRun = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRun>>, TError,{teamName: string;syncName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateSyncRun>>,
        TError,
        {teamName: string;syncName: string},
        TContext
      > => {
      return useMutation(getPlatformCreateSyncRunMutationOptions(options));
    }

/**
 * Get a Sync Run.
 */
export const getPlatformGetSyncRunUrl = (teamName: string,
    syncName: string,
    syncRunId: string,) => {




  return `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}`
}

export const platformGetSyncRun = async (teamName: string,
    syncName: string,
    syncRunId: string, options?: RequestInit) => {

  return customFetch<PlatformSyncRunDetails>(getPlatformGetSyncRunUrl(teamName,syncName,syncRunId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncRunQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,) => {
    return [
    `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}`
    ] as const;
    }


export const getPlatformGetSyncRunQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRun>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRun>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunQueryKey(teamName,syncName,syncRunId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRun>>> = ({ signal }) => platformGetSyncRun(teamName,syncName,syncRunId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRun>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRun>>>
export type PlatformGetSyncRunQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRun<TData = Awaited<ReturnType<typeof platformGetSyncRun>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRun>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunQueryOptions(teamName,syncName,syncRunId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a SyncRun
 */
export const getPlatformUpdateSyncRunUrl = (teamName: string,
    syncName: string,
    syncRunId: string,) => {




  return `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}`
}

export const platformUpdateSyncRun = async (teamName: string,
    syncName: string,
    syncRunId: string,
    platformUpdateSyncRunBody: PlatformUpdateSyncRunBody, options?: RequestInit) => {

  return customFetch<PlatformSyncRun>(getPlatformUpdateSyncRunUrl(teamName,syncName,syncRunId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformUpdateSyncRunBody,)
  }
);}




export const getPlatformUpdateSyncRunMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncRun>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformUpdateSyncRunBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncRun>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformUpdateSyncRunBody}, TContext> => {

const mutationKey = ['platformUpdateSyncRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncRun>>, {teamName: string;syncName: string;syncRunId: string;data: PlatformUpdateSyncRunBody}> = (props) => {
          const {teamName,syncName,syncRunId,data} = props ?? {};

          return  platformUpdateSyncRun(teamName,syncName,syncRunId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncRunMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncRun>>>
    export type PlatformUpdateSyncRunMutationBody = PlatformUpdateSyncRunBody
    export type PlatformUpdateSyncRunMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncRun = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncRun>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformUpdateSyncRunBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncRun>>,
        TError,
        {teamName: string;syncName: string;syncRunId: string;data: PlatformUpdateSyncRunBody},
        TContext
      > => {
      return useMutation(getPlatformUpdateSyncRunMutationOptions(options));
    }

/**
 * Deprecated. Get logs for a sync run.
 */
export const getPlatformGetSyncRunLogsUrl = (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs?${stringifiedParams}` : `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs`
}

export const platformGetSyncRunLogs = async (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsParams, options?: RequestInit) => {

  return customFetch<PlatformGetSyncRunLogs200One | string | void>(getPlatformGetSyncRunLogsUrl(teamName,syncName,syncRunId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncRunLogsQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsParams,) => {
    return [
    `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetSyncRunLogsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunLogsQueryKey(teamName,syncName,syncRunId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunLogs>>> = ({ signal }) => platformGetSyncRunLogs(teamName,syncName,syncRunId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunLogsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunLogs>>>
export type PlatformGetSyncRunLogsQueryError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunLogs<TData = Awaited<ReturnType<typeof platformGetSyncRunLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunLogsQueryOptions(teamName,syncName,syncRunId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get logs for a sync run.
 */
export const getPlatformGetSyncRunLogsQueryUrl = (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsQueryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs/query?${stringifiedParams}` : `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs/query`
}

export const platformGetSyncRunLogsQuery = async (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsQueryParams, options?: RequestInit) => {

  return customFetch<PlatformGetSyncRunLogsQuery200One | string | void>(getPlatformGetSyncRunLogsQueryUrl(teamName,syncName,syncRunId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncRunLogsQueryQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsQueryParams,) => {
    return [
    `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs/query`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetSyncRunLogsQueryQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunLogsQuery>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsQueryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogsQuery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunLogsQueryQueryKey(teamName,syncName,syncRunId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunLogsQuery>>> = ({ signal }) => platformGetSyncRunLogsQuery(teamName,syncName,syncRunId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogsQuery>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunLogsQueryQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunLogsQuery>>>
export type PlatformGetSyncRunLogsQueryQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunLogsQuery<TData = Awaited<ReturnType<typeof platformGetSyncRunLogsQuery>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsQueryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogsQuery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunLogsQueryQueryOptions(teamName,syncName,syncRunId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get live logs for a sync run.
 */
export const getPlatformGetSyncRunLogsLiveUrl = (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsLiveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs/live?${stringifiedParams}` : `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs/live`
}

export const platformGetSyncRunLogsLive = async (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsLiveParams, options?: RequestInit) => {

  return customFetch<string | void>(getPlatformGetSyncRunLogsLiveUrl(teamName,syncName,syncRunId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncRunLogsLiveQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsLiveParams,) => {
    return [
    `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs/live`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetSyncRunLogsLiveQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunLogsLive>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsLiveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogsLive>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunLogsLiveQueryKey(teamName,syncName,syncRunId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunLogsLive>>> = ({ signal }) => platformGetSyncRunLogsLive(teamName,syncName,syncRunId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogsLive>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunLogsLiveQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunLogsLive>>>
export type PlatformGetSyncRunLogsLiveQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunLogsLive<TData = Awaited<ReturnType<typeof platformGetSyncRunLogsLive>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsLiveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogsLive>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunLogsLiveQueryOptions(teamName,syncName,syncRunId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a new sync run progress update.
 */
export const getPlatformCreateSyncRunProgressUrl = (teamName: string,
    syncName: string,
    syncRunId: string,) => {




  return `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/progress`
}

export const platformCreateSyncRunProgress = async (teamName: string,
    syncName: string,
    syncRunId: string,
    platformCreateSyncRunProgressBody: PlatformCreateSyncRunProgressBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformCreateSyncRunProgressUrl(teamName,syncName,syncRunId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreateSyncRunProgressBody,)
  }
);}




export const getPlatformCreateSyncRunProgressMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRunProgress>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformCreateSyncRunProgressBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRunProgress>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformCreateSyncRunProgressBody}, TContext> => {

const mutationKey = ['platformCreateSyncRunProgress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateSyncRunProgress>>, {teamName: string;syncName: string;syncRunId: string;data: PlatformCreateSyncRunProgressBody}> = (props) => {
          const {teamName,syncName,syncRunId,data} = props ?? {};

          return  platformCreateSyncRunProgress(teamName,syncName,syncRunId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateSyncRunProgressMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateSyncRunProgress>>>
    export type PlatformCreateSyncRunProgressMutationBody = PlatformCreateSyncRunProgressBody
    export type PlatformCreateSyncRunProgressMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateSyncRunProgress = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRunProgress>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformCreateSyncRunProgressBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateSyncRunProgress>>,
        TError,
        {teamName: string;syncName: string;syncRunId: string;data: PlatformCreateSyncRunProgressBody},
        TContext
      > => {
      return useMutation(getPlatformCreateSyncRunProgressMutationOptions(options));
    }

/**
 * Get statistics on a Sync Run
 */
export const getPlatformGetSyncRunStatsUrl = (teamName: string,
    syncName: string,
    syncRunId: string,) => {




  return `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/stats`
}

export const platformGetSyncRunStats = async (teamName: string,
    syncName: string,
    syncRunId: string, options?: RequestInit) => {

  return customFetch<PlatformSyncRunStats>(getPlatformGetSyncRunStatsUrl(teamName,syncName,syncRunId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncRunStatsQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,) => {
    return [
    `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/stats`
    ] as const;
    }


export const getPlatformGetSyncRunStatsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunStats>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunStatsQueryKey(teamName,syncName,syncRunId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunStats>>> = ({ signal }) => platformGetSyncRunStats(teamName,syncName,syncRunId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunStats>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunStatsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunStats>>>
export type PlatformGetSyncRunStatsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunStats<TData = Awaited<ReturnType<typeof platformGetSyncRunStats>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunStatsQueryOptions(teamName,syncName,syncRunId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get table details on a Sync Run
 */
export const getPlatformGetSyncRunTablesUrl = (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunTablesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/tables?${stringifiedParams}` : `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/tables`
}

export const platformGetSyncRunTables = async (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunTablesParams, options?: RequestInit) => {

  return customFetch<PlatformGetSyncRunTables200>(getPlatformGetSyncRunTablesUrl(teamName,syncName,syncRunId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncRunTablesQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunTablesParams,) => {
    return [
    `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/tables`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetSyncRunTablesQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunTables>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunTables>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunTablesQueryKey(teamName,syncName,syncRunId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunTables>>> = ({ signal }) => platformGetSyncRunTables(teamName,syncName,syncRunId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunTables>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunTablesQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunTables>>>
export type PlatformGetSyncRunTablesQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunTables<TData = Awaited<ReturnType<typeof platformGetSyncRunTables>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunTables>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunTablesQueryOptions(teamName,syncName,syncRunId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get connector credentials for a sync run.
 */
export const getPlatformGetSyncRunConnectorCredentialsUrl = (teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,) => {




  return `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/credentials`
}

export const platformGetSyncRunConnectorCredentials = async (teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: RequestInit) => {

  return customFetch<PlatformGetSyncRunConnectorCredentials200>(getPlatformGetSyncRunConnectorCredentialsUrl(teamName,syncName,syncRunId,connectorId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncRunConnectorCredentialsQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,) => {
    return [
    `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/credentials`
    ] as const;
    }


export const getPlatformGetSyncRunConnectorCredentialsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunConnectorCredentialsQueryKey(teamName,syncName,syncRunId,connectorId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>> = ({ signal }) => platformGetSyncRunConnectorCredentials(teamName,syncName,syncRunId,connectorId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunConnectorCredentialsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>>
export type PlatformGetSyncRunConnectorCredentialsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunConnectorCredentials<TData = Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunConnectorCredentialsQueryOptions(teamName,syncName,syncRunId,connectorId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get connector identity for a sync run.
 */
export const getPlatformGetSyncRunConnectorIdentityUrl = (teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,) => {




  return `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/identity`
}

export const platformGetSyncRunConnectorIdentity = async (teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: RequestInit) => {

  return customFetch<PlatformGetSyncRunConnectorIdentity200>(getPlatformGetSyncRunConnectorIdentityUrl(teamName,syncName,syncRunId,connectorId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetSyncRunConnectorIdentityQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,) => {
    return [
    `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/identity`
    ] as const;
    }


export const getPlatformGetSyncRunConnectorIdentityQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunConnectorIdentityQueryKey(teamName,syncName,syncRunId,connectorId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>> = ({ signal }) => platformGetSyncRunConnectorIdentity(teamName,syncName,syncRunId,connectorId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunConnectorIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>>
export type PlatformGetSyncRunConnectorIdentityQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunConnectorIdentity<TData = Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunConnectorIdentityQueryOptions(teamName,syncName,syncRunId,connectorId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get connector credentials for a test connection
 */
export const getPlatformGetTestConnectionConnectorCredentialsUrl = (teamName: string,
    syncTestConnectionId: string,
    connectorId: string,) => {




  return `/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/credentials`
}

export const platformGetTestConnectionConnectorCredentials = async (teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: RequestInit) => {

  return customFetch<PlatformGetTestConnectionConnectorCredentials200>(getPlatformGetTestConnectionConnectorCredentialsUrl(teamName,syncTestConnectionId,connectorId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetTestConnectionConnectorCredentialsQueryKey = (teamName: string,
    syncTestConnectionId: string,
    connectorId: string,) => {
    return [
    `/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/credentials`
    ] as const;
    }


export const getPlatformGetTestConnectionConnectorCredentialsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTestConnectionConnectorCredentialsQueryKey(teamName,syncTestConnectionId,connectorId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>> = ({ signal }) => platformGetTestConnectionConnectorCredentials(teamName,syncTestConnectionId,connectorId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncTestConnectionId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTestConnectionConnectorCredentialsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>>
export type PlatformGetTestConnectionConnectorCredentialsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetTestConnectionConnectorCredentials<TData = Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTestConnectionConnectorCredentialsQueryOptions(teamName,syncTestConnectionId,connectorId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get connector identity for a test connection.
 */
export const getPlatformGetTestConnectionConnectorIdentityUrl = (teamName: string,
    syncTestConnectionId: string,
    connectorId: string,) => {




  return `/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/identity`
}

export const platformGetTestConnectionConnectorIdentity = async (teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: RequestInit) => {

  return customFetch<PlatformGetTestConnectionConnectorIdentity200>(getPlatformGetTestConnectionConnectorIdentityUrl(teamName,syncTestConnectionId,connectorId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetTestConnectionConnectorIdentityQueryKey = (teamName: string,
    syncTestConnectionId: string,
    connectorId: string,) => {
    return [
    `/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/identity`
    ] as const;
    }


export const getPlatformGetTestConnectionConnectorIdentityQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTestConnectionConnectorIdentityQueryKey(teamName,syncTestConnectionId,connectorId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>> = ({ signal }) => platformGetTestConnectionConnectorIdentity(teamName,syncTestConnectionId,connectorId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncTestConnectionId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTestConnectionConnectorIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>>
export type PlatformGetTestConnectionConnectorIdentityQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetTestConnectionConnectorIdentity<TData = Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTestConnectionConnectorIdentityQueryOptions(teamName,syncTestConnectionId,connectorId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List Tables
 */
export const getPlatformListTablesTeamUrl = (teamName: string,
    params?: PlatformListTablesTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/tables?${stringifiedParams}` : `/teams/${teamName}/tables`
}

export const platformListTablesTeam = async (teamName: string,
    params?: PlatformListTablesTeamParams, options?: RequestInit) => {

  return customFetch<PlatformListTablesTeam200>(getPlatformListTablesTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListTablesTeamQueryKey = (teamName: string,
    params?: PlatformListTablesTeamParams,) => {
    return [
    `/teams/${teamName}/tables`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListTablesTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListTablesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListTablesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTablesTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTablesTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTablesTeam>>> = ({ signal }) => platformListTablesTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListTablesTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListTablesTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTablesTeam>>>
export type PlatformListTablesTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListTablesTeam<TData = Awaited<ReturnType<typeof platformListTablesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListTablesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTablesTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListTablesTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List Table Rows
 */
export const getPlatformTableListRowsTeamUrl = (teamName: string,
    tableName: string,
    params?: PlatformTableListRowsTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["select","filter","filter_id","sort_by","sort_dir","group_by"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/tables/${tableName}/data?${stringifiedParams}` : `/teams/${teamName}/tables/${tableName}/data`
}

export const platformTableListRowsTeam = async (teamName: string,
    tableName: string,
    params?: PlatformTableListRowsTeamParams, options?: RequestInit) => {

  return customFetch<PlatformTableListRowsTeam200>(getPlatformTableListRowsTeamUrl(teamName,tableName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformTableListRowsTeamQueryKey = (teamName: string,
    tableName: string,
    params?: PlatformTableListRowsTeamParams,) => {
    return [
    `/teams/${teamName}/tables/${tableName}/data`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformTableListRowsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListRowsTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    params?: PlatformTableListRowsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRowsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListRowsTeamQueryKey(teamName,tableName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListRowsTeam>>> = ({ signal }) => platformTableListRowsTeam(teamName,tableName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListRowsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListRowsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListRowsTeam>>>
export type PlatformTableListRowsTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListRowsTeam<TData = Awaited<ReturnType<typeof platformTableListRowsTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    params?: PlatformTableListRowsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRowsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListRowsTeamQueryOptions(teamName,tableName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get Table row
 */
export const getPlatformTableRowByIdTeamUrl = (teamName: string,
    tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter","filter_id"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/tables/${tableName}/data/${tableRowId}?${stringifiedParams}` : `/teams/${teamName}/tables/${tableName}/data/${tableRowId}`
}

export const platformTableRowByIdTeam = async (teamName: string,
    tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdTeamParams, options?: RequestInit) => {

  return customFetch<PlatformTableRowByIdTeam200>(getPlatformTableRowByIdTeamUrl(teamName,tableName,tableRowId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformTableRowByIdTeamQueryKey = (teamName: string,
    tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdTeamParams,) => {
    return [
    `/teams/${teamName}/tables/${tableName}/data/${tableRowId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformTableRowByIdTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableRowByIdTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableRowByIdTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableRowByIdTeamQueryKey(teamName,tableName,tableRowId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableRowByIdTeam>>> = ({ signal }) => platformTableRowByIdTeam(teamName,tableName,tableRowId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && tableName && tableRowId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableRowByIdTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableRowByIdTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableRowByIdTeam>>>
export type PlatformTableRowByIdTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableRowByIdTeam<TData = Awaited<ReturnType<typeof platformTableRowByIdTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableRowByIdTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableRowByIdTeamQueryOptions(teamName,tableName,tableRowId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get Table Schema
 */
export const getPlatformTableSchemaTeamUrl = (teamName: string,
    tableName: string,) => {




  return `/teams/${teamName}/tables/${tableName}/schema`
}

export const platformTableSchemaTeam = async (teamName: string,
    tableName: string, options?: RequestInit) => {

  return customFetch<PlatformTableSchemaTeam200>(getPlatformTableSchemaTeamUrl(teamName,tableName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformTableSchemaTeamQueryKey = (teamName: string,
    tableName: string,) => {
    return [
    `/teams/${teamName}/tables/${tableName}/schema`
    ] as const;
    }


export const getPlatformTableSchemaTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableSchemaTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableSchemaTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableSchemaTeamQueryKey(teamName,tableName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableSchemaTeam>>> = ({ signal }) => platformTableSchemaTeam(teamName,tableName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableSchemaTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableSchemaTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableSchemaTeam>>>
export type PlatformTableSchemaTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableSchemaTeam<TData = Awaited<ReturnType<typeof platformTableSchemaTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableSchemaTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableSchemaTeamQueryOptions(teamName,tableName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get Table Schemas
 */
export const getPlatformBatchTableSchemasTeamUrl = (teamName: string,
    params: PlatformBatchTableSchemasTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/tables/schemas?${stringifiedParams}` : `/teams/${teamName}/tables/schemas`
}

export const platformBatchTableSchemasTeam = async (teamName: string,
    params: PlatformBatchTableSchemasTeamParams, options?: RequestInit) => {

  return customFetch<PlatformBatchTableSchemasTeam200>(getPlatformBatchTableSchemasTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformBatchTableSchemasTeamQueryKey = (teamName: string,
    params?: PlatformBatchTableSchemasTeamParams,) => {
    return [
    `/teams/${teamName}/tables/schemas`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformBatchTableSchemasTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params: PlatformBatchTableSchemasTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformBatchTableSchemasTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>> = ({ signal }) => platformBatchTableSchemasTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformBatchTableSchemasTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>>
export type PlatformBatchTableSchemasTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformBatchTableSchemasTeam<TData = Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params: PlatformBatchTableSchemasTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformBatchTableSchemasTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get Table Columns
 */
export const getPlatformTableListColumnsTeamUrl = (teamName: string,
    tableName: string,
    params?: PlatformTableListColumnsTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/tables/${tableName}/columns?${stringifiedParams}` : `/teams/${teamName}/tables/${tableName}/columns`
}

export const platformTableListColumnsTeam = async (teamName: string,
    tableName: string,
    params?: PlatformTableListColumnsTeamParams, options?: RequestInit) => {

  return customFetch<PlatformTableListColumnsTeam200>(getPlatformTableListColumnsTeamUrl(teamName,tableName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformTableListColumnsTeamQueryKey = (teamName: string,
    tableName: string,
    params?: PlatformTableListColumnsTeamParams,) => {
    return [
    `/teams/${teamName}/tables/${tableName}/columns`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformTableListColumnsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListColumnsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    params?: PlatformTableListColumnsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListColumnsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListColumnsTeamQueryKey(teamName,tableName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListColumnsTeam>>> = ({ signal }) => platformTableListColumnsTeam(teamName,tableName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListColumnsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListColumnsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListColumnsTeam>>>
export type PlatformTableListColumnsTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListColumnsTeam<TData = Awaited<ReturnType<typeof platformTableListColumnsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    params?: PlatformTableListColumnsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListColumnsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListColumnsTeamQueryOptions(teamName,tableName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get Table Column Values
 */
export const getPlatformTableColumnListValuesTeamUrl = (teamName: string,
    tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/tables/${tableName}/columns/${columnName}/values?${stringifiedParams}` : `/teams/${teamName}/tables/${tableName}/columns/${columnName}/values`
}

export const platformTableColumnListValuesTeam = async (teamName: string,
    tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesTeamParams, options?: RequestInit) => {

  return customFetch<PlatformTableColumnListValuesTeam200>(getPlatformTableColumnListValuesTeamUrl(teamName,tableName,columnName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformTableColumnListValuesTeamQueryKey = (teamName: string,
    tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesTeamParams,) => {
    return [
    `/teams/${teamName}/tables/${tableName}/columns/${columnName}/values`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformTableColumnListValuesTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableColumnListValuesTeamQueryKey(teamName,tableName,columnName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>> = ({ signal }) => platformTableColumnListValuesTeam(teamName,tableName,columnName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && tableName && columnName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableColumnListValuesTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>>
export type PlatformTableColumnListValuesTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableColumnListValuesTeam<TData = Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableColumnListValuesTeamQueryOptions(teamName,tableName,columnName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List Table Filters
 */
export const getPlatformTableListFiltersTeamUrl = (teamName: string,
    tableName: string,
    params?: PlatformTableListFiltersTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["tag"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/tables/${tableName}/filters?${stringifiedParams}` : `/teams/${teamName}/tables/${tableName}/filters`
}

export const platformTableListFiltersTeam = async (teamName: string,
    tableName: string,
    params?: PlatformTableListFiltersTeamParams, options?: RequestInit) => {

  return customFetch<PlatformTableListFiltersTeam200>(getPlatformTableListFiltersTeamUrl(teamName,tableName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformTableListFiltersTeamQueryKey = (teamName: string,
    tableName: string,
    params?: PlatformTableListFiltersTeamParams,) => {
    return [
    `/teams/${teamName}/tables/${tableName}/filters`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformTableListFiltersTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListFiltersTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    params?: PlatformTableListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFiltersTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListFiltersTeamQueryKey(teamName,tableName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListFiltersTeam>>> = ({ signal }) => platformTableListFiltersTeam(teamName,tableName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListFiltersTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListFiltersTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListFiltersTeam>>>
export type PlatformTableListFiltersTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListFiltersTeam<TData = Awaited<ReturnType<typeof platformTableListFiltersTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    params?: PlatformTableListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFiltersTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListFiltersTeamQueryOptions(teamName,tableName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Save Table Filter
 */
export const getPlatformTableSaveFilterTeamUrl = (teamName: string,
    tableName: string,) => {




  return `/teams/${teamName}/tables/${tableName}/filters`
}

export const platformTableSaveFilterTeam = async (teamName: string,
    tableName: string,
    platformFilterCreate: PlatformFilterCreate, options?: RequestInit) => {

  return customFetch<PlatformFilter>(getPlatformTableSaveFilterTeamUrl(teamName,tableName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformFilterCreate,)
  }
);}




export const getPlatformTableSaveFilterTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTableSaveFilterTeam>>, TError,{teamName: string;tableName: string;data: PlatformFilterCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformTableSaveFilterTeam>>, TError,{teamName: string;tableName: string;data: PlatformFilterCreate}, TContext> => {

const mutationKey = ['platformTableSaveFilterTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformTableSaveFilterTeam>>, {teamName: string;tableName: string;data: PlatformFilterCreate}> = (props) => {
          const {teamName,tableName,data} = props ?? {};

          return  platformTableSaveFilterTeam(teamName,tableName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformTableSaveFilterTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformTableSaveFilterTeam>>>
    export type PlatformTableSaveFilterTeamMutationBody = PlatformFilterCreate
    export type PlatformTableSaveFilterTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformTableSaveFilterTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTableSaveFilterTeam>>, TError,{teamName: string;tableName: string;data: PlatformFilterCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformTableSaveFilterTeam>>,
        TError,
        {teamName: string;tableName: string;data: PlatformFilterCreate},
        TContext
      > => {
      return useMutation(getPlatformTableSaveFilterTeamMutationOptions(options));
    }

/**
 * List Filter Tags For A Table
 */
export const getPlatformTableListFilterTagsTeamUrl = (teamName: string,
    tableName: string,
    params?: PlatformTableListFilterTagsTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/tables/${tableName}/filters/tags?${stringifiedParams}` : `/teams/${teamName}/tables/${tableName}/filters/tags`
}

export const platformTableListFilterTagsTeam = async (teamName: string,
    tableName: string,
    params?: PlatformTableListFilterTagsTeamParams, options?: RequestInit) => {

  return customFetch<PlatformTableListFilterTagsTeam200>(getPlatformTableListFilterTagsTeamUrl(teamName,tableName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformTableListFilterTagsTeamQueryKey = (teamName: string,
    tableName: string,
    params?: PlatformTableListFilterTagsTeamParams,) => {
    return [
    `/teams/${teamName}/tables/${tableName}/filters/tags`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformTableListFilterTagsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    params?: PlatformTableListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListFilterTagsTeamQueryKey(teamName,tableName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>> = ({ signal }) => platformTableListFilterTagsTeam(teamName,tableName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListFilterTagsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>>
export type PlatformTableListFilterTagsTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListFilterTagsTeam<TData = Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    params?: PlatformTableListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListFilterTagsTeamQueryOptions(teamName,tableName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List Table Relations
 */
export const getPlatformTableListRelationsTeamUrl = (teamName: string,
    tableName: string,
    params?: PlatformTableListRelationsTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/tables/${tableName}/relations?${stringifiedParams}` : `/teams/${teamName}/tables/${tableName}/relations`
}

export const platformTableListRelationsTeam = async (teamName: string,
    tableName: string,
    params?: PlatformTableListRelationsTeamParams, options?: RequestInit) => {

  return customFetch<PlatformTableListRelationsTeam200>(getPlatformTableListRelationsTeamUrl(teamName,tableName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformTableListRelationsTeamQueryKey = (teamName: string,
    tableName: string,
    params?: PlatformTableListRelationsTeamParams,) => {
    return [
    `/teams/${teamName}/tables/${tableName}/relations`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformTableListRelationsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListRelationsTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    params?: PlatformTableListRelationsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRelationsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListRelationsTeamQueryKey(teamName,tableName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListRelationsTeam>>> = ({ signal }) => platformTableListRelationsTeam(teamName,tableName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListRelationsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListRelationsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListRelationsTeam>>>
export type PlatformTableListRelationsTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformTableListRelationsTeam<TData = Awaited<ReturnType<typeof platformTableListRelationsTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    params?: PlatformTableListRelationsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRelationsTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListRelationsTeamQueryOptions(teamName,tableName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a summary of usage for the specified time range.
 */
export const getPlatformGetTeamUsageSummaryUrl = (teamName: string,
    params?: PlatformGetTeamUsageSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/usage-summary?${stringifiedParams}` : `/teams/${teamName}/usage-summary`
}

export const platformGetTeamUsageSummary = async (teamName: string,
    params?: PlatformGetTeamUsageSummaryParams, options?: RequestInit) => {

  return customFetch<PlatformUsageSummary>(getPlatformGetTeamUsageSummaryUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetTeamUsageSummaryQueryKey = (teamName: string,
    params?: PlatformGetTeamUsageSummaryParams,) => {
    return [
    `/teams/${teamName}/usage-summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetTeamUsageSummaryQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTeamUsageSummary>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformGetTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamUsageSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTeamUsageSummaryQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTeamUsageSummary>>> = ({ signal }) => platformGetTeamUsageSummary(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamUsageSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTeamUsageSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTeamUsageSummary>>>
export type PlatformGetTeamUsageSummaryQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetTeamUsageSummary<TData = Awaited<ReturnType<typeof platformGetTeamUsageSummary>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformGetTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamUsageSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTeamUsageSummaryQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a grouped summary of usage for the specified time range.
 */
export const getPlatformGetGroupedTeamUsageSummaryUrl = (teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: PlatformGetGroupedTeamUsageSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/usage-summary/${groupBy}?${stringifiedParams}` : `/teams/${teamName}/usage-summary/${groupBy}`
}

export const platformGetGroupedTeamUsageSummary = async (teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: PlatformGetGroupedTeamUsageSummaryParams, options?: RequestInit) => {

  return customFetch<PlatformUsageSummary>(getPlatformGetGroupedTeamUsageSummaryUrl(teamName,groupBy,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetGroupedTeamUsageSummaryQueryKey = (teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: PlatformGetGroupedTeamUsageSummaryParams,) => {
    return [
    `/teams/${teamName}/usage-summary/${groupBy}`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetGroupedTeamUsageSummaryQueryOptions = <TData = Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: PlatformGetGroupedTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetGroupedTeamUsageSummaryQueryKey(teamName,groupBy,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>> = ({ signal }) => platformGetGroupedTeamUsageSummary(teamName,groupBy,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && groupBy), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetGroupedTeamUsageSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>>
export type PlatformGetGroupedTeamUsageSummaryQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetGroupedTeamUsageSummary<TData = Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: PlatformGetGroupedTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetGroupedTeamUsageSummaryQueryOptions(teamName,groupBy,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List all users in the current team.
 */
export const getPlatformListUsersByTeamUrl = (teamName: string,
    params?: PlatformListUsersByTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/users?${stringifiedParams}` : `/teams/${teamName}/users`
}

export const platformListUsersByTeam = async (teamName: string,
    params?: PlatformListUsersByTeamParams, options?: RequestInit) => {

  return customFetch<PlatformListUsersByTeam200>(getPlatformListUsersByTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListUsersByTeamQueryKey = (teamName: string,
    params?: PlatformListUsersByTeamParams,) => {
    return [
    `/teams/${teamName}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListUsersByTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListUsersByTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListUsersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListUsersByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListUsersByTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListUsersByTeam>>> = ({ signal }) => platformListUsersByTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListUsersByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListUsersByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListUsersByTeam>>>
export type PlatformListUsersByTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListUsersByTeam<TData = Awaited<ReturnType<typeof platformListUsersByTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListUsersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListUsersByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListUsersByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a URL to upload image that will be publicly accessible
 */
export const getPlatformUploadImageUrl = () => {




  return `/upload/image`
}

export const platformUploadImage = async (platformUploadImageBody: PlatformUploadImageBody, options?: RequestInit) => {

  return customFetch<PlatformImageURL>(getPlatformUploadImageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformUploadImageBody,)
  }
);}




export const getPlatformUploadImageMutationOptions = <TError = PlatformBadRequestResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadImage>>, TError,{data: PlatformUploadImageBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUploadImage>>, TError,{data: PlatformUploadImageBody}, TContext> => {

const mutationKey = ['platformUploadImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUploadImage>>, {data: PlatformUploadImageBody}> = (props) => {
          const {data} = props ?? {};

          return  platformUploadImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof platformUploadImage>>>
    export type PlatformUploadImageMutationBody = PlatformUploadImageBody
    export type PlatformUploadImageMutationError = PlatformBadRequestResponse | PlatformInternalErrorResponse

    export const usePlatformUploadImage = <TError = PlatformBadRequestResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadImage>>, TError,{data: PlatformUploadImageBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUploadImage>>,
        TError,
        {data: PlatformUploadImageBody},
        TContext
      > => {
      return useMutation(getPlatformUploadImageMutationOptions(options));
    }

/**
 * Get the current authenticated user from the OAuth token

 */
export const getPlatformGetCurrentUserUrl = () => {




  return `/user`
}

export const platformGetCurrentUser = async ( options?: RequestInit) => {

  return customFetch<PlatformGetCurrentUser200>(getPlatformGetCurrentUserUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetCurrentUserQueryKey = () => {
    return [
    `/user`
    ] as const;
    }


export const getPlatformGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof platformGetCurrentUser>>, TError = PlatformGetCurrentUser401 | PlatformForbiddenResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetCurrentUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetCurrentUser>>> = ({ signal }) => platformGetCurrentUser({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUser>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetCurrentUser>>>
export type PlatformGetCurrentUserQueryError = PlatformGetCurrentUser401 | PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformGetCurrentUser<TData = Awaited<ReturnType<typeof platformGetCurrentUser>>, TError = PlatformGetCurrentUser401 | PlatformForbiddenResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update attributes for the current authenticated user from the OAuth token
 */
export const getPlatformUpdateCurrentUserUrl = () => {




  return `/user`
}

export const platformUpdateCurrentUser = async (platformUpdateCurrentUserBody: PlatformUpdateCurrentUserBody, options?: RequestInit) => {

  return customFetch<PlatformUser>(getPlatformUpdateCurrentUserUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformUpdateCurrentUserBody,)
  }
);}




export const getPlatformUpdateCurrentUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCurrentUser>>, TError,{data: PlatformUpdateCurrentUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCurrentUser>>, TError,{data: PlatformUpdateCurrentUserBody}, TContext> => {

const mutationKey = ['platformUpdateCurrentUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateCurrentUser>>, {data: PlatformUpdateCurrentUserBody}> = (props) => {
          const {data} = props ?? {};

          return  platformUpdateCurrentUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateCurrentUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateCurrentUser>>>
    export type PlatformUpdateCurrentUserMutationBody = PlatformUpdateCurrentUserBody
    export type PlatformUpdateCurrentUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateCurrentUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCurrentUser>>, TError,{data: PlatformUpdateCurrentUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateCurrentUser>>,
        TError,
        {data: PlatformUpdateCurrentUserBody},
        TContext
      > => {
      return useMutation(getPlatformUpdateCurrentUserMutationOptions(options));
    }

/**
 * Send an anonymous event
 */
export const getPlatformSendAnonymousEventUrl = () => {




  return `/user/anon-event`
}

export const platformSendAnonymousEvent = async (platformSendAnonymousEventBody: PlatformSendAnonymousEventBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformSendAnonymousEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSendAnonymousEventBody,)
  }
);}




export const getPlatformSendAnonymousEventMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSendAnonymousEvent>>, TError,{data: PlatformSendAnonymousEventBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformSendAnonymousEvent>>, TError,{data: PlatformSendAnonymousEventBody}, TContext> => {

const mutationKey = ['platformSendAnonymousEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformSendAnonymousEvent>>, {data: PlatformSendAnonymousEventBody}> = (props) => {
          const {data} = props ?? {};

          return  platformSendAnonymousEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformSendAnonymousEventMutationResult = NonNullable<Awaited<ReturnType<typeof platformSendAnonymousEvent>>>
    export type PlatformSendAnonymousEventMutationBody = PlatformSendAnonymousEventBody
    export type PlatformSendAnonymousEventMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformSendAnonymousEvent = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSendAnonymousEvent>>, TError,{data: PlatformSendAnonymousEventBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformSendAnonymousEvent>>,
        TError,
        {data: PlatformSendAnonymousEventBody},
        TContext
      > => {
      return useMutation(getPlatformSendAnonymousEventMutationOptions(options));
    }

/**
 * Authenticate a user with password
 */
export const getPlatformAuthenticateLocalUserUrl = () => {




  return `/user/authenticate`
}

export const platformAuthenticateLocalUser = async (platformAuthenticateLocalUserBody: PlatformAuthenticateLocalUserBody, options?: RequestInit) => {

  return customFetch<PlatformAuthenticateLocalUser200>(getPlatformAuthenticateLocalUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformAuthenticateLocalUserBody,)
  }
);}




export const getPlatformAuthenticateLocalUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateLocalUser>>, TError,{data: PlatformAuthenticateLocalUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateLocalUser>>, TError,{data: PlatformAuthenticateLocalUserBody}, TContext> => {

const mutationKey = ['platformAuthenticateLocalUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateLocalUser>>, {data: PlatformAuthenticateLocalUserBody}> = (props) => {
          const {data} = props ?? {};

          return  platformAuthenticateLocalUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateLocalUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateLocalUser>>>
    export type PlatformAuthenticateLocalUserMutationBody = PlatformAuthenticateLocalUserBody
    export type PlatformAuthenticateLocalUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateLocalUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateLocalUser>>, TError,{data: PlatformAuthenticateLocalUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateLocalUser>>,
        TError,
        {data: PlatformAuthenticateLocalUserBody},
        TContext
      > => {
      return useMutation(getPlatformAuthenticateLocalUserMutationOptions(options));
    }

/**
 * Change user password
 */
export const getPlatformChangeLocalUserPasswordUrl = () => {




  return `/user/change-password`
}

export const platformChangeLocalUserPassword = async (platformChangeLocalUserPasswordBody: PlatformChangeLocalUserPasswordBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformChangeLocalUserPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformChangeLocalUserPasswordBody,)
  }
);}




export const getPlatformChangeLocalUserPasswordMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformChangeLocalUserPassword>>, TError,{data: PlatformChangeLocalUserPasswordBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformChangeLocalUserPassword>>, TError,{data: PlatformChangeLocalUserPasswordBody}, TContext> => {

const mutationKey = ['platformChangeLocalUserPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformChangeLocalUserPassword>>, {data: PlatformChangeLocalUserPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  platformChangeLocalUserPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformChangeLocalUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof platformChangeLocalUserPassword>>>
    export type PlatformChangeLocalUserPasswordMutationBody = PlatformChangeLocalUserPasswordBody
    export type PlatformChangeLocalUserPasswordMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformChangeLocalUserPassword = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformChangeLocalUserPassword>>, TError,{data: PlatformChangeLocalUserPasswordBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformChangeLocalUserPassword>>,
        TError,
        {data: PlatformChangeLocalUserPasswordBody},
        TContext
      > => {
      return useMutation(getPlatformChangeLocalUserPasswordMutationOptions(options));
    }

/**
 * Update customer details
 */
export const getPlatformUpdateCustomerUrl = () => {




  return `/user/customer`
}

export const platformUpdateCustomer = async (platformUpdateCustomerBody: PlatformUpdateCustomerBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformUpdateCustomerUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformUpdateCustomerBody,)
  }
);}




export const getPlatformUpdateCustomerMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomer>>, TError,{data: PlatformUpdateCustomerBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomer>>, TError,{data: PlatformUpdateCustomerBody}, TContext> => {

const mutationKey = ['platformUpdateCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateCustomer>>, {data: PlatformUpdateCustomerBody}> = (props) => {
          const {data} = props ?? {};

          return  platformUpdateCustomer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateCustomer>>>
    export type PlatformUpdateCustomerMutationBody = PlatformUpdateCustomerBody
    export type PlatformUpdateCustomerMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateCustomer = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomer>>, TError,{data: PlatformUpdateCustomerBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateCustomer>>,
        TError,
        {data: PlatformUpdateCustomerBody},
        TContext
      > => {
      return useMutation(getPlatformUpdateCustomerMutationOptions(options));
    }

/**
 * Send a user event
 */
export const getPlatformSendUserEventUrl = () => {




  return `/user/event`
}

export const platformSendUserEvent = async (platformSendUserEventBody: PlatformSendUserEventBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformSendUserEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSendUserEventBody,)
  }
);}




export const getPlatformSendUserEventMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSendUserEvent>>, TError,{data: PlatformSendUserEventBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformSendUserEvent>>, TError,{data: PlatformSendUserEventBody}, TContext> => {

const mutationKey = ['platformSendUserEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformSendUserEvent>>, {data: PlatformSendUserEventBody}> = (props) => {
          const {data} = props ?? {};

          return  platformSendUserEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformSendUserEventMutationResult = NonNullable<Awaited<ReturnType<typeof platformSendUserEvent>>>
    export type PlatformSendUserEventMutationBody = PlatformSendUserEventBody
    export type PlatformSendUserEventMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformSendUserEvent = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSendUserEvent>>, TError,{data: PlatformSendUserEventBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformSendUserEvent>>,
        TError,
        {data: PlatformSendUserEventBody},
        TContext
      > => {
      return useMutation(getPlatformSendUserEventMutationOptions(options));
    }

/**
 * List of the current user's unaccepted invitations
 */
export const getPlatformListCurrentUserInvitationsUrl = (params?: PlatformListCurrentUserInvitationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/user/invitations?${stringifiedParams}` : `/user/invitations`
}

export const platformListCurrentUserInvitations = async (params?: PlatformListCurrentUserInvitationsParams, options?: RequestInit) => {

  return customFetch<PlatformListCurrentUserInvitations200>(getPlatformListCurrentUserInvitationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListCurrentUserInvitationsQueryKey = (params?: PlatformListCurrentUserInvitationsParams,) => {
    return [
    `/user/invitations`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListCurrentUserInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof platformListCurrentUserInvitations>>, TError = PlatformNotFoundResponse | PlatformInternalErrorResponse>(params?: PlatformListCurrentUserInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListCurrentUserInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListCurrentUserInvitationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListCurrentUserInvitations>>> = ({ signal }) => platformListCurrentUserInvitations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListCurrentUserInvitations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListCurrentUserInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListCurrentUserInvitations>>>
export type PlatformListCurrentUserInvitationsQueryError = PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListCurrentUserInvitations<TData = Awaited<ReturnType<typeof platformListCurrentUserInvitations>>, TError = PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 params?: PlatformListCurrentUserInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListCurrentUserInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListCurrentUserInvitationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Verify a one time password for MFA
 */
export const getPlatformUserTOTPVerifyUrl = () => {




  return `/user/totp/verify`
}

export const platformUserTOTPVerify = async (platformUserTOTPVerifyBody: PlatformUserTOTPVerifyBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformUserTOTPVerifyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformUserTOTPVerifyBody,)
  }
);}




export const getPlatformUserTOTPVerifyMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUserTOTPVerify>>, TError,{data: PlatformUserTOTPVerifyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUserTOTPVerify>>, TError,{data: PlatformUserTOTPVerifyBody}, TContext> => {

const mutationKey = ['platformUserTOTPVerify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUserTOTPVerify>>, {data: PlatformUserTOTPVerifyBody}> = (props) => {
          const {data} = props ?? {};

          return  platformUserTOTPVerify(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUserTOTPVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof platformUserTOTPVerify>>>
    export type PlatformUserTOTPVerifyMutationBody = PlatformUserTOTPVerifyBody
    export type PlatformUserTOTPVerifyMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformUserTOTPVerify = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUserTOTPVerify>>, TError,{data: PlatformUserTOTPVerifyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUserTOTPVerify>>,
        TError,
        {data: PlatformUserTOTPVerifyBody},
        TContext
      > => {
      return useMutation(getPlatformUserTOTPVerifyMutationOptions(options));
    }

/**
 * Set up MFA for the current user
 */
export const getPlatformUserTOTPSetupUrl = () => {




  return `/user/totp`
}

export const platformUserTOTPSetup = async ( options?: RequestInit) => {

  return customFetch<PlatformUserTOTPSetup200>(getPlatformUserTOTPSetupUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformUserTOTPSetupMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUserTOTPSetup>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUserTOTPSetup>>, TError,void, TContext> => {

const mutationKey = ['platformUserTOTPSetup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUserTOTPSetup>>, void> = () => {


          return  platformUserTOTPSetup(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUserTOTPSetupMutationResult = NonNullable<Awaited<ReturnType<typeof platformUserTOTPSetup>>>

    export type PlatformUserTOTPSetupMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUserTOTPSetup = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUserTOTPSetup>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUserTOTPSetup>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPlatformUserTOTPSetupMutationOptions(options));
    }

/**
 * Disable MFA for the current user
 */
export const getPlatformUserTOTPDeleteUrl = () => {




  return `/user/totp`
}

export const platformUserTOTPDelete = async ( options?: RequestInit) => {

  return customFetch<void>(getPlatformUserTOTPDeleteUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformUserTOTPDeleteMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUserTOTPDelete>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUserTOTPDelete>>, TError,void, TContext> => {

const mutationKey = ['platformUserTOTPDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUserTOTPDelete>>, void> = () => {


          return  platformUserTOTPDelete(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUserTOTPDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof platformUserTOTPDelete>>>

    export type PlatformUserTOTPDeleteMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse

    export const usePlatformUserTOTPDelete = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUserTOTPDelete>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUserTOTPDelete>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPlatformUserTOTPDeleteMutationOptions(options));
    }

/**
 * Get the current authenticated local user
 */
export const getPlatformGetCurrentLocalUserUrl = () => {




  return `/user/local`
}

export const platformGetCurrentLocalUser = async ( options?: RequestInit) => {

  return customFetch<PlatformLocalUserWithTeams>(getPlatformGetCurrentLocalUserUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetCurrentLocalUserQueryKey = () => {
    return [
    `/user/local`
    ] as const;
    }


export const getPlatformGetCurrentLocalUserQueryOptions = <TData = Awaited<ReturnType<typeof platformGetCurrentLocalUser>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentLocalUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetCurrentLocalUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetCurrentLocalUser>>> = ({ signal }) => platformGetCurrentLocalUser({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentLocalUser>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetCurrentLocalUserQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetCurrentLocalUser>>>
export type PlatformGetCurrentLocalUserQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformGetCurrentLocalUser<TData = Awaited<ReturnType<typeof platformGetCurrentLocalUser>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentLocalUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetCurrentLocalUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Start a session using ID token
 */
export const getPlatformLoginUserUrl = () => {




  return `/user/login`
}

export const platformLoginUser = async (platformLoginUserBody: PlatformLoginUserBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformLoginUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformLoginUserBody,)
  }
);}




export const getPlatformLoginUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformLoginUser>>, TError,{data: PlatformLoginUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformLoginUser>>, TError,{data: PlatformLoginUserBody}, TContext> => {

const mutationKey = ['platformLoginUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformLoginUser>>, {data: PlatformLoginUserBody}> = (props) => {
          const {data} = props ?? {};

          return  platformLoginUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformLoginUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformLoginUser>>>
    export type PlatformLoginUserMutationBody = PlatformLoginUserBody
    export type PlatformLoginUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse

    export const usePlatformLoginUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformLoginUser>>, TError,{data: PlatformLoginUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformLoginUser>>,
        TError,
        {data: PlatformLoginUserBody},
        TContext
      > => {
      return useMutation(getPlatformLoginUserMutationOptions(options));
    }

/**
 * Logout a session
 */
export const getPlatformLogoutUserUrl = () => {




  return `/user/login`
}

export const platformLogoutUser = async ( options?: RequestInit) => {

  return customFetch<void>(getPlatformLogoutUserUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformLogoutUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformLogoutUser>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformLogoutUser>>, TError,void, TContext> => {

const mutationKey = ['platformLogoutUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformLogoutUser>>, void> = () => {


          return  platformLogoutUser(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformLogoutUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformLogoutUser>>>

    export type PlatformLogoutUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse

    export const usePlatformLogoutUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformLogoutUser>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformLogoutUser>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPlatformLogoutUserMutationOptions(options));
    }

/**
 * Get memberships that the user has accepted.
 */
export const getPlatformGetCurrentUserMembershipsUrl = (params?: PlatformGetCurrentUserMembershipsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/user/memberships?${stringifiedParams}` : `/user/memberships`
}

export const platformGetCurrentUserMemberships = async (params?: PlatformGetCurrentUserMembershipsParams, options?: RequestInit) => {

  return customFetch<PlatformGetCurrentUserMemberships200>(getPlatformGetCurrentUserMembershipsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetCurrentUserMembershipsQueryKey = (params?: PlatformGetCurrentUserMembershipsParams,) => {
    return [
    `/user/memberships`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetCurrentUserMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(params?: PlatformGetCurrentUserMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetCurrentUserMembershipsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>> = ({ signal }) => platformGetCurrentUserMemberships(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetCurrentUserMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>>
export type PlatformGetCurrentUserMembershipsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformGetCurrentUserMemberships<TData = Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(
 params?: PlatformGetCurrentUserMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetCurrentUserMembershipsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Reset user password with token
 */
export const getPlatformResetLocalUserPasswordUrl = () => {




  return `/user/reset-password-token`
}

export const platformResetLocalUserPassword = async (platformResetLocalUserPasswordBody: PlatformResetLocalUserPasswordBody, options?: RequestInit) => {

  return customFetch<void>(getPlatformResetLocalUserPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformResetLocalUserPasswordBody,)
  }
);}




export const getPlatformResetLocalUserPasswordMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformResetLocalUserPassword>>, TError,{data: PlatformResetLocalUserPasswordBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformResetLocalUserPassword>>, TError,{data: PlatformResetLocalUserPasswordBody}, TContext> => {

const mutationKey = ['platformResetLocalUserPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformResetLocalUserPassword>>, {data: PlatformResetLocalUserPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  platformResetLocalUserPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformResetLocalUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof platformResetLocalUserPassword>>>
    export type PlatformResetLocalUserPasswordMutationBody = PlatformResetLocalUserPasswordBody
    export type PlatformResetLocalUserPasswordMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformResetLocalUserPassword = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformResetLocalUserPassword>>, TError,{data: PlatformResetLocalUserPasswordBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformResetLocalUserPassword>>,
        TError,
        {data: PlatformResetLocalUserPasswordBody},
        TContext
      > => {
      return useMutation(getPlatformResetLocalUserPasswordMutationOptions(options));
    }

/**
 * Start a CLI session and create a custom token
 */
export const getPlatformCreateUserTokenUrl = () => {




  return `/user/token`
}

export const platformCreateUserToken = async ( options?: RequestInit) => {

  return customFetch<PlatformCreateUserToken201>(getPlatformCreateUserTokenUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPlatformCreateUserTokenMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateUserToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateUserToken>>, TError,void, TContext> => {

const mutationKey = ['platformCreateUserToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateUserToken>>, void> = () => {


          return  platformCreateUserToken(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateUserTokenMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateUserToken>>>

    export type PlatformCreateUserTokenMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse

    export const usePlatformCreateUserToken = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateUserToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateUserToken>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPlatformCreateUserTokenMutationOptions(options));
    }

/**
 * Delete user
 */
export const getPlatformDeleteUserUrl = (userId: string,) => {




  return `/users/${userId}`
}

export const platformDeleteUser = async (userId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteUserUrl(userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['platformDeleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  platformDeleteUser(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteUser>>>

    export type PlatformDeleteUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteUser>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteUserMutationOptions(options));
    }

/**
 * Performs authentication and authorization for our image registry.
 */
export const getPlatformAuthRegistryRequestUrl = (params?: PlatformAuthRegistryRequestParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/registry/auth?${stringifiedParams}` : `/registry/auth`
}

export const platformAuthRegistryRequest = async (params?: PlatformAuthRegistryRequestParams, options?: RequestInit) => {

  return customFetch<PlatformRegistryAuthToken>(getPlatformAuthRegistryRequestUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformAuthRegistryRequestQueryKey = (params?: PlatformAuthRegistryRequestParams,) => {
    return [
    `/registry/auth`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformAuthRegistryRequestQueryOptions = <TData = Awaited<ReturnType<typeof platformAuthRegistryRequest>>, TError = PlatformDockerErrorResponse>(params?: PlatformAuthRegistryRequestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAuthRegistryRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformAuthRegistryRequestQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAuthRegistryRequest>>> = ({ signal }) => platformAuthRegistryRequest(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformAuthRegistryRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformAuthRegistryRequestQueryResult = NonNullable<Awaited<ReturnType<typeof platformAuthRegistryRequest>>>
export type PlatformAuthRegistryRequestQueryError = PlatformDockerErrorResponse



export function usePlatformAuthRegistryRequest<TData = Awaited<ReturnType<typeof platformAuthRegistryRequest>>, TError = PlatformDockerErrorResponse>(
 params?: PlatformAuthRegistryRequestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAuthRegistryRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformAuthRegistryRequestQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a test destination connection.
 */
export const getPlatformCreateV2SyncDestinationTestConnectionUrl = (teamName: string,) => {




  return `/v2/teams/${teamName}/sync-destination-test-connections`
}

export const platformCreateV2SyncDestinationTestConnection = async (teamName: string,
    platformCreateSyncDestinationTestConnectionV2: PlatformCreateSyncDestinationTestConnectionV2, options?: RequestInit) => {

  return customFetch<PlatformSyncDestinationTestConnectionV2>(getPlatformCreateV2SyncDestinationTestConnectionUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreateSyncDestinationTestConnectionV2,)
  }
);}




export const getPlatformCreateV2SyncDestinationTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncDestinationTestConnection>>, TError,{teamName: string;data: PlatformCreateSyncDestinationTestConnectionV2}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncDestinationTestConnection>>, TError,{teamName: string;data: PlatformCreateSyncDestinationTestConnectionV2}, TContext> => {

const mutationKey = ['platformCreateV2SyncDestinationTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateV2SyncDestinationTestConnection>>, {teamName: string;data: PlatformCreateSyncDestinationTestConnectionV2}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateV2SyncDestinationTestConnection(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateV2SyncDestinationTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateV2SyncDestinationTestConnection>>>
    export type PlatformCreateV2SyncDestinationTestConnectionMutationBody = PlatformCreateSyncDestinationTestConnectionV2
    export type PlatformCreateV2SyncDestinationTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformCreateV2SyncDestinationTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncDestinationTestConnection>>, TError,{teamName: string;data: PlatformCreateSyncDestinationTestConnectionV2}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateV2SyncDestinationTestConnection>>,
        TError,
        {teamName: string;data: PlatformCreateSyncDestinationTestConnectionV2},
        TContext
      > => {
      return useMutation(getPlatformCreateV2SyncDestinationTestConnectionMutationOptions(options));
    }

/**
 * Create sync destination based on test connection.
 */
export const getPlatformCreateV2SyncDestinationUrl = (teamName: string,) => {




  return `/v2/teams/${teamName}/sync-destinations`
}

export const platformCreateV2SyncDestination = async (teamName: string,
    platformCreateSyncDestinationV2: PlatformCreateSyncDestinationV2, options?: RequestInit) => {

  return customFetch<PlatformSyncDestinationV2>(getPlatformCreateV2SyncDestinationUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformCreateSyncDestinationV2,)
  }
);}




export const getPlatformCreateV2SyncDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncDestination>>, TError,{teamName: string;data: PlatformCreateSyncDestinationV2}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncDestination>>, TError,{teamName: string;data: PlatformCreateSyncDestinationV2}, TContext> => {

const mutationKey = ['platformCreateV2SyncDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateV2SyncDestination>>, {teamName: string;data: PlatformCreateSyncDestinationV2}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateV2SyncDestination(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateV2SyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateV2SyncDestination>>>
    export type PlatformCreateV2SyncDestinationMutationBody = PlatformCreateSyncDestinationV2
    export type PlatformCreateV2SyncDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateV2SyncDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateV2SyncDestination>>, TError,{teamName: string;data: PlatformCreateSyncDestinationV2}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateV2SyncDestination>>,
        TError,
        {teamName: string;data: PlatformCreateSyncDestinationV2},
        TContext
      > => {
      return useMutation(getPlatformCreateV2SyncDestinationMutationOptions(options));
    }

/**
 * List all sync destination definitions.
 */
export const getPlatformGetV2SyncDestinationsUrl = (teamName: string,
    params?: PlatformGetV2SyncDestinationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/teams/${teamName}/sync-destinations?${stringifiedParams}` : `/v2/teams/${teamName}/sync-destinations`
}

export const platformGetV2SyncDestinations = async (teamName: string,
    params?: PlatformGetV2SyncDestinationsParams, options?: RequestInit) => {

  return customFetch<PlatformGetV2SyncDestinations200>(getPlatformGetV2SyncDestinationsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetV2SyncDestinationsQueryKey = (teamName: string,
    params?: PlatformGetV2SyncDestinationsParams,) => {
    return [
    `/v2/teams/${teamName}/sync-destinations`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformGetV2SyncDestinationsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetV2SyncDestinations>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformGetV2SyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetV2SyncDestinations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetV2SyncDestinationsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetV2SyncDestinations>>> = ({ signal }) => platformGetV2SyncDestinations(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetV2SyncDestinations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetV2SyncDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetV2SyncDestinations>>>
export type PlatformGetV2SyncDestinationsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetV2SyncDestinations<TData = Awaited<ReturnType<typeof platformGetV2SyncDestinations>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformGetV2SyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetV2SyncDestinations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetV2SyncDestinationsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a single sync destination definition.
 */
export const getPlatformGetV2SyncDestinationUrl = (teamName: string,
    syncDestinationName: string,) => {




  return `/v2/teams/${teamName}/sync-destinations/${syncDestinationName}`
}

export const platformGetV2SyncDestination = async (teamName: string,
    syncDestinationName: string, options?: RequestInit) => {

  return customFetch<PlatformSyncDestinationV2>(getPlatformGetV2SyncDestinationUrl(teamName,syncDestinationName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetV2SyncDestinationQueryKey = (teamName: string,
    syncDestinationName: string,) => {
    return [
    `/v2/teams/${teamName}/sync-destinations/${syncDestinationName}`
    ] as const;
    }


export const getPlatformGetV2SyncDestinationQueryOptions = <TData = Awaited<ReturnType<typeof platformGetV2SyncDestination>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetV2SyncDestination>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetV2SyncDestinationQueryKey(teamName,syncDestinationName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetV2SyncDestination>>> = ({ signal }) => platformGetV2SyncDestination(teamName,syncDestinationName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetV2SyncDestination>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetV2SyncDestinationQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetV2SyncDestination>>>
export type PlatformGetV2SyncDestinationQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetV2SyncDestination<TData = Awaited<ReturnType<typeof platformGetV2SyncDestination>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetV2SyncDestination>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetV2SyncDestinationQueryOptions(teamName,syncDestinationName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a Sync Destination definition.
 */
export const getPlatformPatchV2SyncDestinationUrl = (teamName: string,
    syncDestinationName: string,) => {




  return `/v2/teams/${teamName}/sync-destinations/${syncDestinationName}`
}

export const platformPatchV2SyncDestination = async (teamName: string,
    syncDestinationName: string,
    platformSyncDestinationUpdateV2: PlatformSyncDestinationUpdateV2, options?: RequestInit) => {

  return customFetch<PlatformSyncDestination>(getPlatformPatchV2SyncDestinationUrl(teamName,syncDestinationName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformSyncDestinationUpdateV2,)
  }
);}




export const getPlatformPatchV2SyncDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPatchV2SyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdateV2}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformPatchV2SyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdateV2}, TContext> => {

const mutationKey = ['platformPatchV2SyncDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformPatchV2SyncDestination>>, {teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdateV2}> = (props) => {
          const {teamName,syncDestinationName,data} = props ?? {};

          return  platformPatchV2SyncDestination(teamName,syncDestinationName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformPatchV2SyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformPatchV2SyncDestination>>>
    export type PlatformPatchV2SyncDestinationMutationBody = PlatformSyncDestinationUpdateV2
    export type PlatformPatchV2SyncDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformPatchV2SyncDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPatchV2SyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdateV2}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformPatchV2SyncDestination>>,
        TError,
        {teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdateV2},
        TContext
      > => {
      return useMutation(getPlatformPatchV2SyncDestinationMutationOptions(options));
    }

/**
 * Delete a Sync Destination definition. Any syncs relying on this destination must be deleted first.
 */
export const getPlatformDeleteV2SyncDestinationUrl = (teamName: string,
    syncDestinationName: string,) => {




  return `/v2/teams/${teamName}/sync-destinations/${syncDestinationName}`
}

export const platformDeleteV2SyncDestination = async (teamName: string,
    syncDestinationName: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteV2SyncDestinationUrl(teamName,syncDestinationName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteV2SyncDestinationMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteV2SyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteV2SyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext> => {

const mutationKey = ['platformDeleteV2SyncDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteV2SyncDestination>>, {teamName: string;syncDestinationName: string}> = (props) => {
          const {teamName,syncDestinationName} = props ?? {};

          return  platformDeleteV2SyncDestination(teamName,syncDestinationName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteV2SyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteV2SyncDestination>>>

    export type PlatformDeleteV2SyncDestinationMutationError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteV2SyncDestination = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteV2SyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteV2SyncDestination>>,
        TError,
        {teamName: string;syncDestinationName: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteV2SyncDestinationMutationOptions(options));
    }

/**
 * List all permissions
 */
export const getPlatformListAllRBACPermissionsUrl = (teamName: string,
    params?: PlatformListAllRBACPermissionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/rbac/permissions?${stringifiedParams}` : `/teams/${teamName}/rbac/permissions`
}

export const platformListAllRBACPermissions = async (teamName: string,
    params?: PlatformListAllRBACPermissionsParams, options?: RequestInit) => {

  return customFetch<PlatformListAllRBACPermissions200>(getPlatformListAllRBACPermissionsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListAllRBACPermissionsQueryKey = (teamName: string,
    params?: PlatformListAllRBACPermissionsParams,) => {
    return [
    `/teams/${teamName}/rbac/permissions`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListAllRBACPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllRBACPermissions>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListAllRBACPermissionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllRBACPermissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllRBACPermissionsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllRBACPermissions>>> = ({ signal }) => platformListAllRBACPermissions(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllRBACPermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllRBACPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllRBACPermissions>>>
export type PlatformListAllRBACPermissionsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListAllRBACPermissions<TData = Awaited<ReturnType<typeof platformListAllRBACPermissions>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListAllRBACPermissionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllRBACPermissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllRBACPermissionsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a permission
 */
export const getPlatformCreateRBACPermissionUrl = (teamName: string,) => {




  return `/teams/${teamName}/rbac/permissions`
}

export const platformCreateRBACPermission = async (teamName: string,
    platformRBACPermissionCreate: PlatformRBACPermissionCreate, options?: RequestInit) => {

  return customFetch<PlatformRBACPermission>(getPlatformCreateRBACPermissionUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformRBACPermissionCreate,)
  }
);}




export const getPlatformCreateRBACPermissionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateRBACPermission>>, TError,{teamName: string;data: PlatformRBACPermissionCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateRBACPermission>>, TError,{teamName: string;data: PlatformRBACPermissionCreate}, TContext> => {

const mutationKey = ['platformCreateRBACPermission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateRBACPermission>>, {teamName: string;data: PlatformRBACPermissionCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateRBACPermission(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateRBACPermissionMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateRBACPermission>>>
    export type PlatformCreateRBACPermissionMutationBody = PlatformRBACPermissionCreate
    export type PlatformCreateRBACPermissionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateRBACPermission = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateRBACPermission>>, TError,{teamName: string;data: PlatformRBACPermissionCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateRBACPermission>>,
        TError,
        {teamName: string;data: PlatformRBACPermissionCreate},
        TContext
      > => {
      return useMutation(getPlatformCreateRBACPermissionMutationOptions(options));
    }

/**
 * Get a permission
 */
export const getPlatformGetRBACPermissionUrl = (teamName: string,
    permissionId: string,) => {




  return `/teams/${teamName}/rbac/permissions/${permissionId}`
}

export const platformGetRBACPermission = async (teamName: string,
    permissionId: string, options?: RequestInit) => {

  return customFetch<PlatformRBACPermission>(getPlatformGetRBACPermissionUrl(teamName,permissionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetRBACPermissionQueryKey = (teamName: string,
    permissionId: string,) => {
    return [
    `/teams/${teamName}/rbac/permissions/${permissionId}`
    ] as const;
    }


export const getPlatformGetRBACPermissionQueryOptions = <TData = Awaited<ReturnType<typeof platformGetRBACPermission>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    permissionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetRBACPermission>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetRBACPermissionQueryKey(teamName,permissionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetRBACPermission>>> = ({ signal }) => platformGetRBACPermission(teamName,permissionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && permissionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetRBACPermission>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetRBACPermissionQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetRBACPermission>>>
export type PlatformGetRBACPermissionQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetRBACPermission<TData = Awaited<ReturnType<typeof platformGetRBACPermission>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    permissionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetRBACPermission>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetRBACPermissionQueryOptions(teamName,permissionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a permission
 */
export const getPlatformUpdateRBACPermissionUrl = (teamName: string,
    permissionId: string,) => {




  return `/teams/${teamName}/rbac/permissions/${permissionId}`
}

export const platformUpdateRBACPermission = async (teamName: string,
    permissionId: string,
    platformRBACPermissionUpdate: PlatformRBACPermissionUpdate, options?: RequestInit) => {

  return customFetch<PlatformRBACPermission>(getPlatformUpdateRBACPermissionUrl(teamName,permissionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformRBACPermissionUpdate,)
  }
);}




export const getPlatformUpdateRBACPermissionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateRBACPermission>>, TError,{teamName: string;permissionId: string;data: PlatformRBACPermissionUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateRBACPermission>>, TError,{teamName: string;permissionId: string;data: PlatformRBACPermissionUpdate}, TContext> => {

const mutationKey = ['platformUpdateRBACPermission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateRBACPermission>>, {teamName: string;permissionId: string;data: PlatformRBACPermissionUpdate}> = (props) => {
          const {teamName,permissionId,data} = props ?? {};

          return  platformUpdateRBACPermission(teamName,permissionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateRBACPermissionMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateRBACPermission>>>
    export type PlatformUpdateRBACPermissionMutationBody = PlatformRBACPermissionUpdate
    export type PlatformUpdateRBACPermissionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateRBACPermission = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateRBACPermission>>, TError,{teamName: string;permissionId: string;data: PlatformRBACPermissionUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateRBACPermission>>,
        TError,
        {teamName: string;permissionId: string;data: PlatformRBACPermissionUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateRBACPermissionMutationOptions(options));
    }

/**
 * Delete a permission
 */
export const getPlatformDeleteRBACPermissionUrl = (teamName: string,
    permissionId: string,) => {




  return `/teams/${teamName}/rbac/permissions/${permissionId}`
}

export const platformDeleteRBACPermission = async (teamName: string,
    permissionId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteRBACPermissionUrl(teamName,permissionId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteRBACPermissionMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteRBACPermission>>, TError,{teamName: string;permissionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteRBACPermission>>, TError,{teamName: string;permissionId: string}, TContext> => {

const mutationKey = ['platformDeleteRBACPermission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteRBACPermission>>, {teamName: string;permissionId: string}> = (props) => {
          const {teamName,permissionId} = props ?? {};

          return  platformDeleteRBACPermission(teamName,permissionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteRBACPermissionMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteRBACPermission>>>

    export type PlatformDeleteRBACPermissionMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteRBACPermission = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteRBACPermission>>, TError,{teamName: string;permissionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteRBACPermission>>,
        TError,
        {teamName: string;permissionId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteRBACPermissionMutationOptions(options));
    }

/**
 * List all roles
 */
export const getPlatformListAllRBACRolesUrl = (teamName: string,
    params?: PlatformListAllRBACRolesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sort_by","sort_dir"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/rbac/roles?${stringifiedParams}` : `/teams/${teamName}/rbac/roles`
}

export const platformListAllRBACRoles = async (teamName: string,
    params?: PlatformListAllRBACRolesParams, options?: RequestInit) => {

  return customFetch<PlatformListAllRBACRoles200>(getPlatformListAllRBACRolesUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListAllRBACRolesQueryKey = (teamName: string,
    params?: PlatformListAllRBACRolesParams,) => {
    return [
    `/teams/${teamName}/rbac/roles`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListAllRBACRolesQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllRBACRoles>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListAllRBACRolesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllRBACRoles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllRBACRolesQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllRBACRoles>>> = ({ signal }) => platformListAllRBACRoles(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllRBACRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllRBACRolesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllRBACRoles>>>
export type PlatformListAllRBACRolesQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListAllRBACRoles<TData = Awaited<ReturnType<typeof platformListAllRBACRoles>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListAllRBACRolesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllRBACRoles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllRBACRolesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a role
 */
export const getPlatformCreateRBACRoleUrl = (teamName: string,) => {




  return `/teams/${teamName}/rbac/roles`
}

export const platformCreateRBACRole = async (teamName: string,
    platformRBACRoleCreate: PlatformRBACRoleCreate, options?: RequestInit) => {

  return customFetch<PlatformRBACRole>(getPlatformCreateRBACRoleUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformRBACRoleCreate,)
  }
);}




export const getPlatformCreateRBACRoleMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateRBACRole>>, TError,{teamName: string;data: PlatformRBACRoleCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateRBACRole>>, TError,{teamName: string;data: PlatformRBACRoleCreate}, TContext> => {

const mutationKey = ['platformCreateRBACRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateRBACRole>>, {teamName: string;data: PlatformRBACRoleCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateRBACRole(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateRBACRoleMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateRBACRole>>>
    export type PlatformCreateRBACRoleMutationBody = PlatformRBACRoleCreate
    export type PlatformCreateRBACRoleMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateRBACRole = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateRBACRole>>, TError,{teamName: string;data: PlatformRBACRoleCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateRBACRole>>,
        TError,
        {teamName: string;data: PlatformRBACRoleCreate},
        TContext
      > => {
      return useMutation(getPlatformCreateRBACRoleMutationOptions(options));
    }

/**
 * Get a role
 */
export const getPlatformGetRBACRoleUrl = (teamName: string,
    roleId: string,) => {




  return `/teams/${teamName}/rbac/roles/${roleId}`
}

export const platformGetRBACRole = async (teamName: string,
    roleId: string, options?: RequestInit) => {

  return customFetch<PlatformRBACRole>(getPlatformGetRBACRoleUrl(teamName,roleId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetRBACRoleQueryKey = (teamName: string,
    roleId: string,) => {
    return [
    `/teams/${teamName}/rbac/roles/${roleId}`
    ] as const;
    }


export const getPlatformGetRBACRoleQueryOptions = <TData = Awaited<ReturnType<typeof platformGetRBACRole>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    roleId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetRBACRole>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetRBACRoleQueryKey(teamName,roleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetRBACRole>>> = ({ signal }) => platformGetRBACRole(teamName,roleId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && roleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetRBACRole>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetRBACRoleQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetRBACRole>>>
export type PlatformGetRBACRoleQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetRBACRole<TData = Awaited<ReturnType<typeof platformGetRBACRole>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    roleId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetRBACRole>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetRBACRoleQueryOptions(teamName,roleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a role (custom roles only)
 */
export const getPlatformUpdateRBACRoleUrl = (teamName: string,
    roleId: string,) => {




  return `/teams/${teamName}/rbac/roles/${roleId}`
}

export const platformUpdateRBACRole = async (teamName: string,
    roleId: string,
    platformRBACRoleUpdate: PlatformRBACRoleUpdate, options?: RequestInit) => {

  return customFetch<PlatformRBACRole>(getPlatformUpdateRBACRoleUrl(teamName,roleId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      platformRBACRoleUpdate,)
  }
);}




export const getPlatformUpdateRBACRoleMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateRBACRole>>, TError,{teamName: string;roleId: string;data: PlatformRBACRoleUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateRBACRole>>, TError,{teamName: string;roleId: string;data: PlatformRBACRoleUpdate}, TContext> => {

const mutationKey = ['platformUpdateRBACRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateRBACRole>>, {teamName: string;roleId: string;data: PlatformRBACRoleUpdate}> = (props) => {
          const {teamName,roleId,data} = props ?? {};

          return  platformUpdateRBACRole(teamName,roleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateRBACRoleMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateRBACRole>>>
    export type PlatformUpdateRBACRoleMutationBody = PlatformRBACRoleUpdate
    export type PlatformUpdateRBACRoleMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateRBACRole = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateRBACRole>>, TError,{teamName: string;roleId: string;data: PlatformRBACRoleUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateRBACRole>>,
        TError,
        {teamName: string;roleId: string;data: PlatformRBACRoleUpdate},
        TContext
      > => {
      return useMutation(getPlatformUpdateRBACRoleMutationOptions(options));
    }

/**
 * Delete a role
 */
export const getPlatformDeleteRBACRoleUrl = (teamName: string,
    roleId: string,) => {




  return `/teams/${teamName}/rbac/roles/${roleId}`
}

export const platformDeleteRBACRole = async (teamName: string,
    roleId: string, options?: RequestInit) => {

  return customFetch<void>(getPlatformDeleteRBACRoleUrl(teamName,roleId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getPlatformDeleteRBACRoleMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteRBACRole>>, TError,{teamName: string;roleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteRBACRole>>, TError,{teamName: string;roleId: string}, TContext> => {

const mutationKey = ['platformDeleteRBACRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteRBACRole>>, {teamName: string;roleId: string}> = (props) => {
          const {teamName,roleId} = props ?? {};

          return  platformDeleteRBACRole(teamName,roleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteRBACRoleMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteRBACRole>>>

    export type PlatformDeleteRBACRoleMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteRBACRole = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteRBACRole>>, TError,{teamName: string;roleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteRBACRole>>,
        TError,
        {teamName: string;roleId: string},
        TContext
      > => {
      return useMutation(getPlatformDeleteRBACRoleMutationOptions(options));
    }


export const getPlatformListAuditLogsResponseMock = (overrideResponse: Partial<Extract<PlatformListAuditLogs200, object>> = {}): PlatformListAuditLogs200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), user: {created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, user_ip_address: faker.string.alpha({length: {min: 10, max: 20}}), team_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), event_type: faker.string.alpha({length: {min: 10, max: 20}}), entity_display_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), event_details: faker.helpers.arrayElement([{}, undefined]), is_success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetAuditLogResponseMock = (overrideResponse: Partial<Extract<PlatformAuditLogEvent, object>> = {}): PlatformAuditLogEvent => ({id: faker.string.uuid(), user: {created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, user_ip_address: faker.string.alpha({length: {min: 10, max: 20}}), team_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), event_type: faker.string.alpha({length: {min: 10, max: 20}}), entity_display_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), event_details: faker.helpers.arrayElement([{}, undefined]), is_success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformGetOpenAPIJSONResponseMock = (): PlatformGetOpenAPIJSON200 => ({})

export const getPlatformAssetViewGetStatusResponseMock = (overrideResponse: Partial<Extract<PlatformAssetViewGetStatus200, object>> = {}): PlatformAssetViewGetStatus200 => ({is_running: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformAssetViewListLogsResponseMock = (overrideResponse: Partial<Extract<PlatformAssetViewListLogs200, object>> = {}): PlatformAssetViewListLogs200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), type: faker.helpers.arrayElement(Object.values(PlatformAssetViewRunType)), triggered_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), error_message: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', finished_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformManageGetSAMLResponseMock = (overrideResponse: Partial<Extract<PlatformSAMLConfig, object>> = {}): PlatformSAMLConfig => ({platform_base_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_sso_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_entity_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), platform_metadata_download_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_certificate_download_url: faker.internet.url(), metadata_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), metadata_xml: faker.helpers.arrayElement([faker.internet.url(), undefined]), logout_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), role_group_key: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), role_mappings: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}})))
      }, undefined]), default_roles: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), disable_access_if_no_role_group: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), enabled: faker.datatype.boolean(), can_enable: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformManageUpdateSAMLResponseMock = (overrideResponse: Partial<Extract<PlatformSAMLConfig, object>> = {}): PlatformSAMLConfig => ({platform_base_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_sso_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_entity_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), platform_metadata_download_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_certificate_download_url: faker.internet.url(), metadata_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), metadata_xml: faker.helpers.arrayElement([faker.internet.url(), undefined]), logout_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), role_group_key: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), role_mappings: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}})))
      }, undefined]), default_roles: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), disable_access_if_no_role_group: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), enabled: faker.datatype.boolean(), can_enable: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformManageGetPlatformRegistryResponseMock = (overrideResponse: Partial<Extract<PlatformManageGetPlatformRegistry200, object>> = {}): PlatformManageGetPlatformRegistry200 => ({installation_id: faker.string.alpha({length: {min: 10, max: 20}}), activation_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), team_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), api_key_last_four: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_activated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), next_activation_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), offline_license_registered_to: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), offline_license_expires_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), ...overrideResponse})

export const getPlatformManageRegisterPlatformResponseMock = (overrideResponse: Partial<Extract<PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205, object>> = {}): PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205 => (faker.helpers.arrayElement([{team_name: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse}, {error: faker.string.alpha({length: {min: 10, max: 20}}), button_text: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), button_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), ...overrideResponse}]))

export const getPlatformManageRegisterPlatformWithOfflineLicenseResponseMock = (overrideResponse: Partial<Extract<PlatformManageRegisterPlatformWithOfflineLicense200, object>> = {}): PlatformManageRegisterPlatformWithOfflineLicense200 => ({registered_to: faker.string.alpha({length: {min: 10, max: 20}}), expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformGetSettingsResponseMock = (overrideResponse: Partial<Extract<PlatformSettings, object>> = {}): PlatformSettings => ({enforce_mfa: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformUpdateSettingsResponseMock = (overrideResponse: Partial<Extract<PlatformSettings, object>> = {}): PlatformSettings => ({enforce_mfa: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformManageListAllTeamsResponseMock = (overrideResponse: Partial<Extract<PlatformManageListAllTeams200, object>> = {}): PlatformManageListAllTeams200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), display_name: faker.string.alpha({length: {min: 10, max: 255}}), internal: faker.datatype.boolean()})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformManageGetTeamResponseMock = (overrideResponse: Partial<Extract<PlatformTeam, object>> = {}): PlatformTeam => ({created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), display_name: faker.string.alpha({length: {min: 10, max: 255}}), internal: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformManageListTeamMembersResponseMock = (overrideResponse: Partial<Extract<PlatformManageListTeamMembers200, object>> = {}): PlatformManageListTeamMembers200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({roles: faker.helpers.arrayElements(Object.values(PlatformRBACDefaultRole)), customRoles: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), permissions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', number_of_affected_roles: faker.number.int(), number_of_affected_users: faker.number.int()})), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), undefined]), user: {created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformListLocalUsersResponseMock = (overrideResponse: Partial<Extract<PlatformListLocalUsers200, object>> = {}): PlatformListLocalUsers200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])},...{roles: faker.helpers.arrayElements(['admin:write','admin:read'] as const), enabled: faker.datatype.boolean(), provider: faker.helpers.arrayElement(Object.values(PlatformLocalUserProvider)), tracking_opted_in: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), mfa_configured: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformAddLocalUserResponseMock = (): PlatformLocalUser => ({...{created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])},...{roles: faker.helpers.arrayElements(['admin:write','admin:read'] as const), enabled: faker.datatype.boolean(), provider: faker.helpers.arrayElement(Object.values(PlatformLocalUserProvider)), tracking_opted_in: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), mfa_configured: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},})

export const getPlatformGetLocalUserResponseMock = (): PlatformLocalUserWithTeams => ({...{...{created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])},...{roles: faker.helpers.arrayElements(['admin:write','admin:read'] as const), enabled: faker.datatype.boolean(), provider: faker.helpers.arrayElement(Object.values(PlatformLocalUserProvider)), tracking_opted_in: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), mfa_configured: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},},...{teams: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({roles: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}))},})

export const getPlatformUpdateLocalUserResponseMock = (): PlatformLocalUser => ({...{created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])},...{roles: faker.helpers.arrayElements(['admin:write','admin:read'] as const), enabled: faker.datatype.boolean(), provider: faker.helpers.arrayElement(Object.values(PlatformLocalUserProvider)), tracking_opted_in: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), mfa_configured: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},})

export const getPlatformCreateLocalUserResetTokenResponseMock = (overrideResponse: Partial<Extract<PlatformCreateLocalUserResetToken200, object>> = {}): PlatformCreateLocalUserResetToken200 => ({reset_token: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getPlatformGetPlatformInfoResponseMock = (overrideResponse: Partial<Extract<PlatformGetPlatformInfo200, object>> = {}): PlatformGetPlatformInfo200 => ({public_ips: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), ...overrideResponse})

export const getPlatformListPlatformVersionsResponseMock = (overrideResponse: Partial<Extract<PlatformListPlatformVersions200, object>> = {}): PlatformListPlatformVersions200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformListPluginsResponseMock = (overrideResponse: Partial<Extract<PlatformListPlugins200, object>> = {}): PlatformListPlugins200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int()},...{latest_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), pinned_version: faker.helpers.arrayElement([{name: faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), range: faker.helpers.fromRegExp("^[^~]?v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), initialized: faker.datatype.boolean(), mirroring: faker.datatype.boolean()}, undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreatePluginResponseMock = (overrideResponse: Partial<Extract<PlatformPlugin, object>> = {}): PlatformPlugin => ({team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int(), ...overrideResponse})

export const getPlatformGetPluginResponseMock = (): PlatformListPlugin => ({...{team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int()},...{latest_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), pinned_version: faker.helpers.arrayElement([{name: faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), range: faker.helpers.fromRegExp("^[^~]?v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), initialized: faker.datatype.boolean(), mirroring: faker.datatype.boolean()}, undefined])},})

export const getPlatformUpdatePluginResponseMock = (overrideResponse: Partial<Extract<PlatformPlugin, object>> = {}): PlatformPlugin => ({team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int(), ...overrideResponse})

export const getPlatformListPluginVersionsResponseMock = (overrideResponse: Partial<Extract<PlatformListPluginVersions200, object>> = {}): PlatformListPluginVersions200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', published_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), message: faker.string.alpha({length: {min: 10, max: 20}}), draft: faker.datatype.boolean(), retracted: faker.datatype.boolean(), protocols: faker.helpers.arrayElements([3] as const), supported_targets: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), checksums: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), package_type: faker.helpers.arrayElement(Object.values(PlatformPluginPackageType))},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetPluginVersionResponseMock = (): PlatformPluginVersionDetails => ({...{...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', published_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), message: faker.string.alpha({length: {min: 10, max: 20}}), draft: faker.datatype.boolean(), retracted: faker.datatype.boolean(), protocols: faker.helpers.arrayElements([3] as const), supported_targets: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), checksums: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), package_type: faker.helpers.arrayElement(Object.values(PlatformPluginPackageType))},...{spec_json_schema: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), connector_required: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), connector_types: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined])},},...{example_config: faker.string.alpha({length: {min: 10, max: 20}}), ui_base_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ui_base_url_v2: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},})

export const getPlatformCreatePluginVersionResponseMock = (): PlatformPluginVersion => (faker.helpers.arrayElement([{...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', published_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), message: faker.string.alpha({length: {min: 10, max: 20}}), draft: faker.datatype.boolean(), retracted: faker.datatype.boolean(), protocols: faker.helpers.arrayElements([3] as const), supported_targets: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), checksums: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), package_type: faker.helpers.arrayElement(Object.values(PlatformPluginPackageType))},...{spec_json_schema: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), connector_required: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), connector_types: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined])},}, {...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', published_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), message: faker.string.alpha({length: {min: 10, max: 20}}), draft: faker.datatype.boolean(), retracted: faker.datatype.boolean(), protocols: faker.helpers.arrayElements([3] as const), supported_targets: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), checksums: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), package_type: faker.helpers.arrayElement(Object.values(PlatformPluginPackageType))},...{spec_json_schema: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), connector_required: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), connector_types: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined])},}]))

export const getPlatformUpdatePluginVersionResponseMock = (): PlatformPluginVersion => ({...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', published_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), message: faker.string.alpha({length: {min: 10, max: 20}}), draft: faker.datatype.boolean(), retracted: faker.datatype.boolean(), protocols: faker.helpers.arrayElements([3] as const), supported_targets: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), checksums: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), package_type: faker.helpers.arrayElement(Object.values(PlatformPluginPackageType))},...{spec_json_schema: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), connector_required: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), connector_types: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined])},})

export const getPlatformDownloadPluginAssetResponseMock = (overrideResponse: Partial<Extract<PlatformPluginAsset, object>> = {}): PlatformPluginAsset => ({checksum: faker.string.alpha({length: {min: 10, max: 20}}), location: faker.internet.url(), ...overrideResponse})

export const getPlatformUploadPluginAssetResponseMock = (overrideResponse: Partial<Extract<PlatformReleaseURL, object>> = {}): PlatformReleaseURL => ({url: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getPlatformListPluginVersionDocsResponseMock = (overrideResponse: Partial<Extract<PlatformListPluginVersionDocs200, object>> = {}): PlatformListPluginVersionDocs200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.helpers.fromRegExp("^[\\w,\\s-]+$"), content: faker.string.alpha({length: {min: 10, max: 20}})})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreatePluginVersionDocsResponseMock = (overrideResponse: Partial<Extract<PlatformCreatePluginVersionDocs201, object>> = {}): PlatformCreatePluginVersionDocs201 => ({names: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[\\w,\\s-]+$"))), undefined]), ...overrideResponse})

export const getPlatformReplacePluginVersionDocsResponseMock = (overrideResponse: Partial<Extract<PlatformReplacePluginVersionDocs201, object>> = {}): PlatformReplacePluginVersionDocs201 => ({names: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[\\w,\\s-]+$"))), undefined]), ...overrideResponse})

export const getPlatformListPluginVersionTablesResponseMock = (overrideResponse: Partial<Extract<PlatformListPluginVersionTables200, object>> = {}): PlatformListPluginVersionTables200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({description: faker.string.alpha({length: {min: 10, max: 20}}), is_incremental: faker.datatype.boolean(), name: faker.helpers.fromRegExp("^[a-z](_?[a-z0-9]+)+$"), parent: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), relations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), title: faker.string.alpha({length: {min: 10, max: 20}}), is_paid: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreatePluginVersionTablesResponseMock = (overrideResponse: Partial<Extract<PlatformCreatePluginVersionTables201, object>> = {}): PlatformCreatePluginVersionTables201 => ({names: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-z](_?[a-z0-9]+)+$"))), undefined]), ...overrideResponse})

export const getPlatformGetPluginVersionTableResponseMock = (overrideResponse: Partial<Extract<PlatformPluginTableDetails, object>> = {}): PlatformPluginTableDetails => ({columns: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({description: faker.string.alpha({length: {min: 10, max: 20}}), incremental_key: faker.datatype.boolean(), name: faker.string.alpha({length: {min: 10, max: 20}}), not_null: faker.datatype.boolean(), primary_key: faker.datatype.boolean(), type: faker.string.alpha({length: {min: 10, max: 20}}), type_schema: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), unique: faker.datatype.boolean()})), description: faker.string.alpha({length: {min: 10, max: 20}}), is_incremental: faker.datatype.boolean(), name: faker.string.alpha({length: {min: 10, max: 20}}), parent: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), relations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), title: faker.string.alpha({length: {min: 10, max: 20}}), is_paid: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), permissions_needed: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), ...overrideResponse})

export const getPlatformUploadPluginUIAssetsResponseMock = (overrideResponse: Partial<Extract<PlatformUploadPluginUIAssets201, object>> = {}): PlatformUploadPluginUIAssets201 => ({ui_id: faker.string.alpha({length: {min: 10, max: 20}}), assets: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), upload_url: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getPlatformListTeamsResponseMock = (overrideResponse: Partial<Extract<PlatformListTeams200, object>> = {}): PlatformListTeams200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), display_name: faker.string.alpha({length: {min: 10, max: 255}}), internal: faker.datatype.boolean()})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreateTeamResponseMock = (overrideResponse: Partial<Extract<PlatformTeam, object>> = {}): PlatformTeam => ({created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), display_name: faker.string.alpha({length: {min: 10, max: 255}}), internal: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformGetTeamByNameResponseMock = (overrideResponse: Partial<Extract<PlatformTeam, object>> = {}): PlatformTeam => ({created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), display_name: faker.string.alpha({length: {min: 10, max: 255}}), internal: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformUpdateTeamResponseMock = (overrideResponse: Partial<Extract<PlatformTeam, object>> = {}): PlatformTeam => ({created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), display_name: faker.string.alpha({length: {min: 10, max: 255}}), internal: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformListAllAlertsResponseMock = (overrideResponse: Partial<Extract<PlatformListAllAlerts200, object>> = {}): PlatformListAllAlerts200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha({length: {min: 10, max: 20}}), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int(), last_evaluated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), triggered_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', notification_destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), enabled: faker.datatype.boolean(), url: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}))})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformTestUnsavedAlertResponseMock = (overrideResponse: Partial<Extract<PlatformTestUnsavedAlert200, object>> = {}): PlatformTestUnsavedAlert200 => ({results: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({destination_id: faker.string.alpha({length: {min: 10, max: 20}}), error: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), response: {is_success: faker.datatype.boolean(), http_status_code: faker.number.int(), http_status: faker.string.alpha({length: {min: 10, max: 20}}), http_body: faker.string.alpha({length: {min: 10, max: 20}}), http_headers: {
        [faker.string.alphanumeric(5)]: faker.string.alpha({length: {min: 10, max: 20}})
      }}})), ...overrideResponse})

export const getPlatformListTeamAPIKeysResponseMock = (overrideResponse: Partial<Extract<PlatformListTeamAPIKeys200, object>> = {}): PlatformListTeamAPIKeys200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.helpers.fromRegExp("^(?:[a-zA-Z0-9][a-zA-Z0-9- ]*)?[a-zA-Z0-9]$"), created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), id: faker.string.uuid(), key: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z', last_access_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), expired: faker.datatype.boolean(), roles: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({team: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), undefined]), role: faker.helpers.arrayElement(Object.values(PlatformAPIKeyRole))}))})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, allowed_roles: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({team: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), undefined]), role: faker.helpers.arrayElement(Object.values(PlatformAPIKeyRole))})), ...overrideResponse})

export const getPlatformCreateTeamAPIKeyResponseMock = (overrideResponse: Partial<Extract<PlatformAPIKey, object>> = {}): PlatformAPIKey => ({name: faker.helpers.fromRegExp("^(?:[a-zA-Z0-9][a-zA-Z0-9- ]*)?[a-zA-Z0-9]$"), created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), id: faker.string.uuid(), key: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z', last_access_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), expired: faker.datatype.boolean(), roles: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({team: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), undefined]), role: faker.helpers.arrayElement(Object.values(PlatformAPIKeyRole))})), ...overrideResponse})

export const getPlatformListConnectorsResponseMock = (overrideResponse: Partial<Extract<PlatformListConnectors200, object>> = {}): PlatformListConnectors200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), type: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(PlatformConnectorStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreateConnectorResponseMock = (overrideResponse: Partial<Extract<PlatformConnector, object>> = {}): PlatformConnector => ({id: faker.string.uuid(), type: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(PlatformConnectorStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformGetConnectorResponseMock = (overrideResponse: Partial<Extract<PlatformConnector, object>> = {}): PlatformConnector => ({id: faker.string.uuid(), type: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(PlatformConnectorStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformUpdateConnectorResponseMock = (overrideResponse: Partial<Extract<PlatformConnector, object>> = {}): PlatformConnector => ({id: faker.string.uuid(), type: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(PlatformConnectorStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformGetConnectorAuthStatusAWSResponseMock = (overrideResponse: Partial<Extract<PlatformGetConnectorAuthStatusAWS200, object>> = {}): PlatformGetConnectorAuthStatusAWS200 => ({role_arn: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), external_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ...overrideResponse})

export const getPlatformAuthenticateConnectorAWSResponseMock = (overrideResponse: Partial<Extract<PlatformConnectorAuthResponseAWS, object>> = {}): PlatformConnectorAuthResponseAWS => ({redirect_url: faker.string.alpha({length: {min: 10, max: 20}}), role_template_url: faker.string.alpha({length: {min: 10, max: 20}}), suggested_external_id: faker.string.alpha({length: {min: 10, max: 20}}), suggested_policy_arns: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), ...overrideResponse})

export const getPlatformGetConnectorAuthStatusGCPResponseMock = (overrideResponse: Partial<Extract<PlatformGetConnectorAuthStatusGCP200, object>> = {}): PlatformGetConnectorAuthStatusGCP200 => ({service_account: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ...overrideResponse})

export const getPlatformAuthenticateConnectorGCPResponseMock = (overrideResponse: Partial<Extract<PlatformConnectorAuthResponseGCP, object>> = {}): PlatformConnectorAuthResponseGCP => ({service_account: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getPlatformAuthenticateConnectorOAuthResponseMock = (overrideResponse: Partial<Extract<PlatformConnectorAuthResponseOAuth, object>> = {}): PlatformConnectorAuthResponseOAuth => ({redirect_url: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getPlatformAuthenticateConnectorFinishOAuthResponseMock = (overrideResponse: Partial<Extract<PlatformConnectorAuthResponseOAuth | void, object>> = {}): PlatformConnectorAuthResponseOAuth | void => ({redirect_url: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getPlatformCreateConversationResponseMock = (overrideResponse: Partial<Extract<PlatformConversation, object>> = {}): PlatformConversation => ({id: faker.string.uuid(), title: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), messages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), role: faker.helpers.arrayElement(['user','assistant','system'] as const), content: faker.string.alpha({length: {min: 10, max: 20}}), query_context: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), message_type: faker.helpers.arrayElement(['error','message','tool_use','tool_result'] as const), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', end_turn: faker.datatype.boolean(), mode: faker.helpers.arrayElement(['ask','sql'] as const)})), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformGetConversationResponseMock = (overrideResponse: Partial<Extract<PlatformConversation, object>> = {}): PlatformConversation => ({id: faker.string.uuid(), title: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), messages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), role: faker.helpers.arrayElement(['user','assistant','system'] as const), content: faker.string.alpha({length: {min: 10, max: 20}}), query_context: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), message_type: faker.helpers.arrayElement(['error','message','tool_use','tool_result'] as const), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', end_turn: faker.datatype.boolean(), mode: faker.helpers.arrayElement(['ask','sql'] as const)})), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformSendMessageResponseMock = (overrideResponse: Partial<Extract<PlatformConversationMessage, object>> = {}): PlatformConversationMessage => ({id: faker.string.uuid(), role: faker.helpers.arrayElement(['user','assistant','system'] as const), content: faker.string.alpha({length: {min: 10, max: 20}}), query_context: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), message_type: faker.helpers.arrayElement(['error','message','tool_use','tool_result'] as const), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', end_turn: faker.datatype.boolean(), mode: faker.helpers.arrayElement(['ask','sql'] as const), ...overrideResponse})

export const getPlatformListAllCustomColumnsResponseMock = (overrideResponse: Partial<Extract<PlatformListAllCustomColumns200, object>> = {}): PlatformListAllCustomColumns200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table_name: faker.string.alpha({length: {min: 10, max: 20}}), column_name: faker.string.alpha({length: {min: 10, max: 20}}), label: faker.string.alpha({length: {min: 10, max: 20}}), column_type: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformCustomColumnColumnType)), undefined]), value_type: faker.helpers.arrayElement(Object.values(PlatformCustomColumnValueType)), value_expr: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$")})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformSaveCustomColumnResponseMock = (overrideResponse: Partial<Extract<PlatformCustomColumn, object>> = {}): PlatformCustomColumn => ({id: faker.string.uuid(), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table_name: faker.string.alpha({length: {min: 10, max: 20}}), column_name: faker.string.alpha({length: {min: 10, max: 20}}), label: faker.string.alpha({length: {min: 10, max: 20}}), column_type: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformCustomColumnColumnType)), undefined]), value_type: faker.helpers.arrayElement(Object.values(PlatformCustomColumnValueType)), value_expr: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), ...overrideResponse})

export const getPlatformGetCustomColumnResponseMock = (overrideResponse: Partial<Extract<PlatformCustomColumn, object>> = {}): PlatformCustomColumn => ({id: faker.string.uuid(), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table_name: faker.string.alpha({length: {min: 10, max: 20}}), column_name: faker.string.alpha({length: {min: 10, max: 20}}), label: faker.string.alpha({length: {min: 10, max: 20}}), column_type: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformCustomColumnColumnType)), undefined]), value_type: faker.helpers.arrayElement(Object.values(PlatformCustomColumnValueType)), value_expr: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), ...overrideResponse})

export const getPlatformUpdateCustomColumnResponseMock = (overrideResponse: Partial<Extract<PlatformCustomColumn, object>> = {}): PlatformCustomColumn => ({id: faker.string.uuid(), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table_name: faker.string.alpha({length: {min: 10, max: 20}}), column_name: faker.string.alpha({length: {min: 10, max: 20}}), label: faker.string.alpha({length: {min: 10, max: 20}}), column_type: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformCustomColumnColumnType)), undefined]), value_type: faker.helpers.arrayElement(Object.values(PlatformCustomColumnValueType)), value_expr: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), ...overrideResponse})

export const getPlatformPutCustomColumnDataResponseMock = (overrideResponse: Partial<Extract<PlatformPutCustomColumnData202, object>> = {}): PlatformPutCustomColumnData202 => ({data: {created_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}, ...overrideResponse})

export const getPlatformPutCustomColumnValuesResponseMock = (): PlatformPutCustomColumnValues200 => ({})

export const getPlatformListFiltersTeamResponseMock = (overrideResponse: Partial<Extract<PlatformListFiltersTeam200, object>> = {}): PlatformListFiltersTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), expression: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformListFilterTagsTeamResponseMock = (overrideResponse: Partial<Extract<PlatformListFilterTagsTeam200, object>> = {}): PlatformListFilterTagsTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetFilterByIDTeamResponseMock = (overrideResponse: Partial<Extract<PlatformFilter, object>> = {}): PlatformFilter => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), expression: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformUpdateFilterTeamResponseMock = (overrideResponse: Partial<Extract<PlatformFilter, object>> = {}): PlatformFilter => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), expression: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformCreateTeamImagesResponseMock = (overrideResponse: Partial<Extract<PlatformCreateTeamImages201, object>> = {}): PlatformCreateTeamImages201 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), checksum: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}}), upload_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), required_headers: {
        [faker.string.alphanumeric(5)]: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}})))
      }})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformListTeamInvitationsResponseMock = (overrideResponse: Partial<Extract<PlatformListTeamInvitations200, object>> = {}): PlatformListTeamInvitations200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), email: faker.internet.email(), role: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformAcceptTeamInvitationResponseMock = (overrideResponse: Partial<Extract<PlatformMembershipWithTeam, object>> = {}): PlatformMembershipWithTeam => ({roles: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), team: {created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), display_name: faker.string.alpha({length: {min: 10, max: 255}}), internal: faker.datatype.boolean()}, ...overrideResponse})

export const getPlatformGetTeamMembershipsResponseMock = (overrideResponse: Partial<Extract<PlatformGetTeamMemberships200, object>> = {}): PlatformGetTeamMemberships200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({roles: faker.helpers.arrayElements(Object.values(PlatformRBACDefaultRole)), customRoles: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), permissions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', number_of_affected_roles: faker.number.int(), number_of_affected_users: faker.number.int()})), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), undefined]), user: {created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformListAllNotificationDestinationsResponseMock = (overrideResponse: Partial<Extract<PlatformListAllNotificationDestinations200, object>> = {}): PlatformListAllNotificationDestinations200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), enabled: faker.datatype.boolean(), url: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreateNotificationDestinationResponseMock = (overrideResponse: Partial<Extract<PlatformNotificationDestination, object>> = {}): PlatformNotificationDestination => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), enabled: faker.datatype.boolean(), url: faker.string.alpha({length: {min: 10, max: 20}}), http_headers: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.string.alpha({length: {min: 10, max: 20}})
      }, undefined]), http_body: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformTestUnsavedNotificationDestinationResponseMock = (overrideResponse: Partial<Extract<PlatformNotificationDestinationTestResponse, object>> = {}): PlatformNotificationDestinationTestResponse => ({is_success: faker.datatype.boolean(), http_status_code: faker.number.int(), http_status: faker.string.alpha({length: {min: 10, max: 20}}), http_body: faker.string.alpha({length: {min: 10, max: 20}}), http_headers: {
        [faker.string.alphanumeric(5)]: faker.string.alpha({length: {min: 10, max: 20}})
      }, ...overrideResponse})

export const getPlatformGetNotificationDestinationResponseMock = (overrideResponse: Partial<Extract<PlatformNotificationDestination, object>> = {}): PlatformNotificationDestination => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), enabled: faker.datatype.boolean(), url: faker.string.alpha({length: {min: 10, max: 20}}), http_headers: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.string.alpha({length: {min: 10, max: 20}})
      }, undefined]), http_body: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformUpdateNotificationDestinationResponseMock = (overrideResponse: Partial<Extract<PlatformNotificationDestination, object>> = {}): PlatformNotificationDestination => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), enabled: faker.datatype.boolean(), url: faker.string.alpha({length: {min: 10, max: 20}}), http_headers: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.string.alpha({length: {min: 10, max: 20}})
      }, undefined]), http_body: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformGetNotificationDestinationAlertsResponseMock = (overrideResponse: Partial<Extract<PlatformGetNotificationDestinationAlerts200, object>> = {}): PlatformGetNotificationDestinationAlerts200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha({length: {min: 10, max: 20}}), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int(), last_evaluated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), triggered_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', notification_destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), enabled: faker.datatype.boolean(), url: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}))})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformTestNotificationDestinationResponseMock = (overrideResponse: Partial<Extract<PlatformNotificationDestinationTestResponse, object>> = {}): PlatformNotificationDestinationTestResponse => ({is_success: faker.datatype.boolean(), http_status_code: faker.number.int(), http_status: faker.string.alpha({length: {min: 10, max: 20}}), http_body: faker.string.alpha({length: {min: 10, max: 20}}), http_headers: {
        [faker.string.alphanumeric(5)]: faker.string.alpha({length: {min: 10, max: 20}})
      }, ...overrideResponse})

export const getPlatformCreateAWSOnboardingResponseMock = (overrideResponse: Partial<Extract<PlatformOnboardingAWSCreateResponse, object>> = {}): PlatformOnboardingAWSCreateResponse => ({id: faker.string.uuid(), region: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), stack_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 128}}), undefined]), issuer_url: faker.string.alpha({length: {min: 10, max: 20}}), audience: faker.string.alpha({length: {min: 10, max: 20}}), subject: faker.string.alpha({length: {min: 10, max: 20}}), notify_path: faker.string.alpha({length: {min: 10, max: 20}}), template_url: faker.string.alpha({length: {min: 10, max: 20}}), notify_token: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getPlatformGetAWSOnboardingResponseMock = (overrideResponse: Partial<Extract<PlatformOnboardingAWS, object>> = {}): PlatformOnboardingAWS => ({id: faker.string.uuid(), stage: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', issuer_url: faker.string.alpha({length: {min: 10, max: 20}}), audience: faker.string.alpha({length: {min: 10, max: 20}}), subject: faker.string.alpha({length: {min: 10, max: 20}}), management_role_arn: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), failure_reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), sync_role_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), organizational_units: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), ...overrideResponse})

export const getPlatformGetAWSAccountsInRootResponseMock = (overrideResponse: Partial<Extract<PlatformOnboardingAWSAccounts, object>> = {}): PlatformOnboardingAWSAccounts => ({id: faker.string.alpha({length: {min: 10, max: 20}}), arn: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), type: faker.helpers.arrayElement(['OU','account','root'] as const), name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), children: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), arn: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), type: faker.helpers.arrayElement(['OU','account','root'] as const), name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), children: faker.helpers.arrayElement([[], undefined])})), undefined]), ...overrideResponse})

export const getPlatformGetAWSAccountsInParentResponseMock = (overrideResponse: Partial<Extract<PlatformOnboardingAWSAccounts, object>> = {}): PlatformOnboardingAWSAccounts => ({id: faker.string.alpha({length: {min: 10, max: 20}}), arn: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), type: faker.helpers.arrayElement(['OU','account','root'] as const), name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), children: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), arn: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), type: faker.helpers.arrayElement(['OU','account','root'] as const), name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), children: faker.helpers.arrayElement([[], undefined])})), undefined]), ...overrideResponse})

export const getPlatformListPluginsByTeamResponseMock = (overrideResponse: Partial<Extract<PlatformListPluginsByTeam200, object>> = {}): PlatformListPluginsByTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int()})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformDownloadPluginAssetByTeamResponseMock = (overrideResponse: Partial<Extract<PlatformPluginAsset, object>> = {}): PlatformPluginAsset => ({checksum: faker.string.alpha({length: {min: 10, max: 20}}), location: faker.internet.url(), ...overrideResponse})

export const getPlatformListPoliciesResponseMock = (overrideResponse: Partial<Extract<PlatformListPolicies200, object>> = {}): PlatformListPolicies200 => ({policies: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(['paused','active'] as const), framework_ids: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.uuid())), filter_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), evaluated_resources: faker.helpers.arrayElement([faker.number.int(), undefined]), rule_violations: faker.helpers.arrayElement([faker.number.int(), undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_by2: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreatePolicyResponseMock = (overrideResponse: Partial<Extract<PlatformCreatePolicy201, object>> = {}): PlatformCreatePolicy201 => ({data: {id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(['paused','active'] as const), framework_ids: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.uuid())), filter_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), evaluated_resources: faker.helpers.arrayElement([faker.number.int(), undefined]), rule_violations: faker.helpers.arrayElement([faker.number.int(), undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_by2: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, ...overrideResponse})

export const getPlatformListAllFrameworksResponseMock = (overrideResponse: Partial<Extract<PlatformListAllFrameworks200, object>> = {}): PlatformListAllFrameworks200 => ({frameworks: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), label: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetPolicyResponseMock = (overrideResponse: Partial<Extract<PlatformGetPolicy200, object>> = {}): PlatformGetPolicy200 => ({data: {id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(['paused','active'] as const), framework_ids: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.uuid())), filter_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), evaluated_resources: faker.helpers.arrayElement([faker.number.int(), undefined]), rule_violations: faker.helpers.arrayElement([faker.number.int(), undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_by2: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, ...overrideResponse})

export const getPlatformUpdatePolicyResponseMock = (overrideResponse: Partial<Extract<PlatformUpdatePolicy200, object>> = {}): PlatformUpdatePolicy200 => ({data: {id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(['paused','active'] as const), framework_ids: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.uuid())), filter_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), evaluated_resources: faker.helpers.arrayElement([faker.number.int(), undefined]), rule_violations: faker.helpers.arrayElement([faker.number.int(), undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_by2: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, ...overrideResponse})

export const getPlatformListPolicyFrameworksResponseMock = (overrideResponse: Partial<Extract<PlatformListPolicyFrameworks200, object>> = {}): PlatformListPolicyFrameworks200 => ({frameworks: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), label: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformListPolicyRulesResponseMock = (overrideResponse: Partial<Extract<PlatformListPolicyRules200, object>> = {}): PlatformListPolicyRules200 => ({rules: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), framework_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), framework_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), risk: faker.helpers.arrayElement([faker.helpers.arrayElement(['critical','high','medium','low'] as const), undefined]), category: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), violations: faker.helpers.arrayElement([faker.number.int(), undefined]), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), remediation: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), learn_more_link: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformListPolicyRuleDetailsResponseMock = (overrideResponse: Partial<Extract<PlatformListPolicyRuleDetails200, object>> = {}): PlatformListPolicyRuleDetails200 => ({details: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), account: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), cloud: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), region: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetPolicyViolationsHistoryResponseMock = (overrideResponse: Partial<Extract<PlatformGetPolicyViolationsHistory200, object>> = {}): PlatformGetPolicyViolationsHistory200 => ({details: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), rule_violations: faker.number.int(), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), ...overrideResponse})

export const getPlatformListAllQueriesTeamResponseMock = (overrideResponse: Partial<Extract<PlatformListAllQueriesTeam200, object>> = {}): PlatformListAllQueriesTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', alert_configured: faker.datatype.boolean(), alert: faker.helpers.arrayElement([{id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha({length: {min: 10, max: 20}}), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int(), last_evaluated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), triggered_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', num_destinations: faker.number.int()}, undefined]), view_name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^(saved_query_view_[a-zA-Z0-9_]+|)$"), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformExecuteAdHocQueryTeamResponseMock = (overrideResponse: Partial<Extract<PlatformExecuteAdHocQueryTeam200, object>> = {}): PlatformExecuteAdHocQueryTeam200 => ({data: {query: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), columns: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), type: faker.string.alpha({length: {min: 10, max: 20}})})), rows: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({}))))}, metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformSaveQueryTeamResponseMock = (overrideResponse: Partial<Extract<PlatformQueryDetail, object>> = {}): PlatformQueryDetail => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', alert_configured: faker.datatype.boolean(), alert: faker.helpers.arrayElement([{id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha({length: {min: 10, max: 20}}), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int(), last_evaluated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), triggered_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', notification_destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), enabled: faker.datatype.boolean(), url: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}))}, undefined]), view_name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^(saved_query_view_[a-zA-Z0-9_]+|)$"), undefined]), ...overrideResponse})

export const getPlatformListQueryTagsTeamResponseMock = (overrideResponse: Partial<Extract<PlatformListQueryTagsTeam200, object>> = {}): PlatformListQueryTagsTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetSavedQueryTeamResponseMock = (overrideResponse: Partial<Extract<PlatformQueryDetail, object>> = {}): PlatformQueryDetail => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', alert_configured: faker.datatype.boolean(), alert: faker.helpers.arrayElement([{id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha({length: {min: 10, max: 20}}), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int(), last_evaluated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), triggered_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', notification_destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), enabled: faker.datatype.boolean(), url: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}))}, undefined]), view_name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^(saved_query_view_[a-zA-Z0-9_]+|)$"), undefined]), ...overrideResponse})

export const getPlatformUpdateQueryTeamResponseMock = (overrideResponse: Partial<Extract<PlatformQueryDetail, object>> = {}): PlatformQueryDetail => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', alert_configured: faker.datatype.boolean(), alert: faker.helpers.arrayElement([{id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha({length: {min: 10, max: 20}}), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int(), last_evaluated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), triggered_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', notification_destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), enabled: faker.datatype.boolean(), url: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}))}, undefined]), view_name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^(saved_query_view_[a-zA-Z0-9_]+|)$"), undefined]), ...overrideResponse})

export const getPlatformExecuteSavedQueryTeamResponseMock = (overrideResponse: Partial<Extract<PlatformExecuteSavedQueryTeam200, object>> = {}): PlatformExecuteSavedQueryTeam200 => ({data: {query: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), columns: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), type: faker.string.alpha({length: {min: 10, max: 20}})})), rows: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({}))))}, metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformQueryListFiltersTeamResponseMock = (overrideResponse: Partial<Extract<PlatformQueryListFiltersTeam200, object>> = {}): PlatformQueryListFiltersTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), expression: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformQuerySaveFilterTeamResponseMock = (overrideResponse: Partial<Extract<PlatformFilter, object>> = {}): PlatformFilter => (faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), expression: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse}, {id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), expression: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse}]))

export const getPlatformQueryListFilterTagsTeamResponseMock = (overrideResponse: Partial<Extract<PlatformQueryListFilterTagsTeam200, object>> = {}): PlatformQueryListFilterTagsTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformListReportsResponseMock = (overrideResponse: Partial<Extract<PlatformListReports200, object>> = {}): PlatformListReports200 => ({reports: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), title: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), content: faker.string.alpha({length: {min: 10, max: 20}}), private: faker.datatype.boolean(), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreateReportResponseMock = (overrideResponse: Partial<Extract<PlatformCreateReport201, object>> = {}): PlatformCreateReport201 => ({data: {id: faker.string.uuid(), title: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), content: faker.string.alpha({length: {min: 10, max: 20}}), private: faker.datatype.boolean(), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, ...overrideResponse})

export const getPlatformGetReportResponseMock = (overrideResponse: Partial<Extract<PlatformGetReport200, object>> = {}): PlatformGetReport200 => ({data: {id: faker.string.uuid(), title: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), content: faker.string.alpha({length: {min: 10, max: 20}}), private: faker.datatype.boolean(), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, ...overrideResponse})

export const getPlatformUpdateReportResponseMock = (overrideResponse: Partial<Extract<PlatformUpdateReport200, object>> = {}): PlatformUpdateReport200 => ({data: {id: faker.string.uuid(), title: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), content: faker.string.alpha({length: {min: 10, max: 20}}), private: faker.datatype.boolean(), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, ...overrideResponse})

export const getPlatformListReportTemplatesResponseMock = (overrideResponse: Partial<Extract<PlatformListReportTemplates200, object>> = {}): PlatformListReportTemplates200 => ({templates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), title: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), content: faker.string.alpha({length: {min: 10, max: 20}}), visible: faker.datatype.boolean(), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreateReportTemplateResponseMock = (overrideResponse: Partial<Extract<PlatformCreateReportTemplate201, object>> = {}): PlatformCreateReportTemplate201 => ({data: {id: faker.string.uuid(), title: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), content: faker.string.alpha({length: {min: 10, max: 20}}), visible: faker.datatype.boolean(), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, ...overrideResponse})

export const getPlatformGetReportTemplateResponseMock = (overrideResponse: Partial<Extract<PlatformGetReportTemplate200, object>> = {}): PlatformGetReportTemplate200 => ({data: {id: faker.string.uuid(), title: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), content: faker.string.alpha({length: {min: 10, max: 20}}), visible: faker.datatype.boolean(), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, ...overrideResponse})

export const getPlatformUpdateReportTemplateResponseMock = (overrideResponse: Partial<Extract<PlatformUpdateReportTemplate200, object>> = {}): PlatformUpdateReportTemplate200 => ({data: {id: faker.string.uuid(), title: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), content: faker.string.alpha({length: {min: 10, max: 20}}), visible: faker.datatype.boolean(), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, ...overrideResponse})

export const getPlatformCreateSyncDestinationTestConnectionResponseMock = (overrideResponse: Partial<Extract<PlatformSyncDestinationTestConnection, object>> = {}): PlatformSyncDestinationTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp("^cloudquery/[^/]+"), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ...overrideResponse})

export const getPlatformGetSyncDestinationTestConnectionResponseMock = (overrideResponse: Partial<Extract<PlatformSyncDestinationTestConnection, object>> = {}): PlatformSyncDestinationTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp("^cloudquery/[^/]+"), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ...overrideResponse})

export const getPlatformUpdateSyncTestConnectionForSyncDestinationResponseMock = (overrideResponse: Partial<Extract<PlatformSyncDestinationTestConnection, object>> = {}): PlatformSyncDestinationTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp("^cloudquery/[^/]+"), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ...overrideResponse})

export const getPlatformGetSyncDestinationTestConnectionLogsResponseMock = (overrideResponse: Partial<Extract<PlatformGetSyncDestinationTestConnectionLogs200One | string | void, object>> = {}): PlatformGetSyncDestinationTestConnectionLogs200One | string | void => (faker.helpers.arrayElement([{location: faker.internet.url(), ...overrideResponse}, faker.word.sample()]))

export const getPlatformGetSyncDestinationTestConnectionLogsQueryResponseMock = (overrideResponse: Partial<Extract<PlatformGetSyncDestinationTestConnectionLogsQuery200One | string | void, object>> = {}): PlatformGetSyncDestinationTestConnectionLogsQuery200One | string | void => (faker.helpers.arrayElement([{data: {query: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), columns: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), type: faker.string.alpha({length: {min: 10, max: 20}})})), rows: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({}))))}, metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse}, faker.word.sample()]))

export const getPlatformGetSyncDestinationTestConnectionLogsLiveResponseMock = (): string | void => (faker.word.sample())

export const getPlatformPromoteSyncDestinationTestConnectionResponseMock = (): PlatformSyncDestination => (faker.helpers.arrayElement([{...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), write_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), migrate_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$")))},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},}, {...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), write_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), migrate_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$")))},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},}]))

export const getPlatformListSyncDestinationsResponseMock = (overrideResponse: Partial<Extract<PlatformListSyncDestinations200, object>> = {}): PlatformListSyncDestinations200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), write_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), migrate_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$")))},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetSyncDestinationResponseMock = (): PlatformSyncDestination => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), write_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), migrate_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$")))},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},})

export const getPlatformUpdateSyncDestinationResponseMock = (): PlatformSyncDestination => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), write_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), migrate_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$")))},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},})

export const getPlatformListSyncDestinationSyncsResponseMock = (overrideResponse: Partial<Extract<PlatformListSyncDestinationSyncs200, object>> = {}): PlatformListSyncDestinationSyncs200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), source: faker.string.alpha({length: {min: 10, max: 20}}), destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha({length: {min: 10, max: 20}}), cpu: faker.string.alpha({length: {min: 10, max: 20}}), memory: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},...{last_run: faker.helpers.arrayElement([{id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), migration: faker.datatype.boolean(), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), ingested: faker.datatype.boolean()}, undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetTestConnectionForSyncDestinationResponseMock = (overrideResponse: Partial<Extract<PlatformSyncTestConnection, object>> = {}): PlatformSyncTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp("^cloudquery/[^/]+"), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), plugin_kind: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginKind)), undefined]), ...overrideResponse})

export const getPlatformCreateSyncSourceTestConnectionResponseMock = (overrideResponse: Partial<Extract<PlatformSyncSourceTestConnection, object>> = {}): PlatformSyncSourceTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp("^cloudquery/[^/]+"), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), ...overrideResponse})

export const getPlatformGetSyncSourceTestConnectionResponseMock = (overrideResponse: Partial<Extract<PlatformSyncSourceTestConnection, object>> = {}): PlatformSyncSourceTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp("^cloudquery/[^/]+"), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), ...overrideResponse})

export const getPlatformUpdateSyncTestConnectionForSyncSourceResponseMock = (overrideResponse: Partial<Extract<PlatformSyncSourceTestConnection, object>> = {}): PlatformSyncSourceTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp("^cloudquery/[^/]+"), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), ...overrideResponse})

export const getPlatformGetSyncSourceTestConnectionLogsResponseMock = (overrideResponse: Partial<Extract<PlatformGetSyncSourceTestConnectionLogs200One | string | void, object>> = {}): PlatformGetSyncSourceTestConnectionLogs200One | string | void => (faker.helpers.arrayElement([{location: faker.internet.url(), ...overrideResponse}, faker.word.sample()]))

export const getPlatformGetSyncSourceTestConnectionLogsQueryResponseMock = (overrideResponse: Partial<Extract<PlatformGetSyncSourceTestConnectionLogsQuery200One | string | void, object>> = {}): PlatformGetSyncSourceTestConnectionLogsQuery200One | string | void => (faker.helpers.arrayElement([{data: {query: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), columns: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), type: faker.string.alpha({length: {min: 10, max: 20}})})), rows: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({}))))}, metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse}, faker.word.sample()]))

export const getPlatformGetSyncSourceTestConnectionLogsLiveResponseMock = (): string | void => (faker.word.sample())

export const getPlatformPromoteSyncSourceTestConnectionResponseMock = (): PlatformSyncSource => (faker.helpers.arrayElement([{...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), skip_tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},}, {...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), skip_tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},}]))

export const getPlatformCreateV2SyncIntegrationTestConnectionResponseMock = (overrideResponse: Partial<Extract<PlatformSyncIntegrationTestConnectionV2, object>> = {}): PlatformSyncIntegrationTestConnectionV2 => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp("^cloudquery/[^/]+"), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), ...overrideResponse})

export const getPlatformListV2SyncIntegrationsResponseMock = (overrideResponse: Partial<Extract<PlatformListV2SyncIntegrations200, object>> = {}): PlatformListV2SyncIntegrations200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), undefined]), source: faker.helpers.arrayElement([{test_connection_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), skip_tables: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])}, undefined]), plugin: faker.helpers.arrayElement([{team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int()}, undefined]), schedule: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), disabled: faker.datatype.boolean(), cpu: faker.string.alpha({length: {min: 10, max: 20}}), memory: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},...{last_run: faker.helpers.arrayElement([{id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), migration: faker.datatype.boolean(), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), ingested: faker.datatype.boolean()}, undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreateV2SyncIntegrationResponseMock = (overrideResponse: Partial<Extract<PlatformSyncIntegrationV2, object>> = {}): PlatformSyncIntegrationV2 => ({name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), undefined]), source: faker.helpers.arrayElement([{test_connection_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), skip_tables: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])}, undefined]), plugin: faker.helpers.arrayElement([{team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int()}, undefined]), schedule: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), disabled: faker.datatype.boolean(), cpu: faker.string.alpha({length: {min: 10, max: 20}}), memory: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ...overrideResponse})

export const getPlatformGetV2SyncIntegrationResponseMock = (): PlatformSyncIntegrationExpandedV2 => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), undefined]), source: faker.helpers.arrayElement([{test_connection_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), skip_tables: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])}, undefined]), plugin: faker.helpers.arrayElement([{team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int()}, undefined]), schedule: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), disabled: faker.datatype.boolean(), cpu: faker.string.alpha({length: {min: 10, max: 20}}), memory: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},...{last_run: faker.helpers.arrayElement([{id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), migration: faker.datatype.boolean(), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), ingested: faker.datatype.boolean()}, undefined])},})

export const getPlatformUpdateV2SyncIntegrationResponseMock = (overrideResponse: Partial<Extract<PlatformSyncIntegrationV2, object>> = {}): PlatformSyncIntegrationV2 => ({name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), undefined]), source: faker.helpers.arrayElement([{test_connection_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), skip_tables: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])}, undefined]), plugin: faker.helpers.arrayElement([{team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int()}, undefined]), schedule: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), disabled: faker.datatype.boolean(), cpu: faker.string.alpha({length: {min: 10, max: 20}}), memory: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ...overrideResponse})

export const getPlatformListSyncSourcesResponseMock = (overrideResponse: Partial<Extract<PlatformListSyncSources200, object>> = {}): PlatformListSyncSources200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), skip_tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetSyncSourceResponseMock = (): PlatformSyncSource => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), skip_tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},})

export const getPlatformUpdateSyncSourceResponseMock = (): PlatformSyncSource => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), skip_tables: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},})

export const getPlatformListSyncSourceSyncsResponseMock = (overrideResponse: Partial<Extract<PlatformListSyncSourceSyncs200, object>> = {}): PlatformListSyncSourceSyncs200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), source: faker.string.alpha({length: {min: 10, max: 20}}), destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha({length: {min: 10, max: 20}}), cpu: faker.string.alpha({length: {min: 10, max: 20}}), memory: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},...{last_run: faker.helpers.arrayElement([{id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), migration: faker.datatype.boolean(), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), ingested: faker.datatype.boolean()}, undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetTestConnectionForSyncSourceResponseMock = (overrideResponse: Partial<Extract<PlatformSyncTestConnection, object>> = {}): PlatformSyncTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp("^cloudquery/[^/]+"), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), plugin_kind: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginKind)), undefined]), ...overrideResponse})

export const getPlatformListSyncTransformersResponseMock = (overrideResponse: Partial<Extract<PlatformListSyncTransformers200, object>> = {}): PlatformListSyncTransformers200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean()},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetSyncTransformerResponseMock = (): PlatformSyncTransformer => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean()},})

export const getPlatformUpdateSyncTransformerResponseMock = (): PlatformSyncTransformer => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean()},})

export const getPlatformListSyncTransformerSyncsResponseMock = (overrideResponse: Partial<Extract<PlatformListSyncTransformerSyncs200, object>> = {}): PlatformListSyncTransformerSyncs200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), source: faker.string.alpha({length: {min: 10, max: 20}}), destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha({length: {min: 10, max: 20}}), cpu: faker.string.alpha({length: {min: 10, max: 20}}), memory: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformListSyncTransformerSyncDestinationsResponseMock = (overrideResponse: Partial<Extract<PlatformListSyncTransformerSyncDestinations200, object>> = {}): PlatformListSyncTransformerSyncDestinations200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), write_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), migrate_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$")))},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformListSyncUpgradesResponseMock = (overrideResponse: Partial<Extract<PlatformListSyncUpgrades200, object>> = {}): PlatformListSyncUpgrades200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), prev_version: faker.string.alpha({length: {min: 10, max: 20}}), new_version: faker.string.alpha({length: {min: 10, max: 20}}), platform_version: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', sync_source_destination_names: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), sync_source_destination_display_names: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}})))})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformListSyncsResponseMock = (overrideResponse: Partial<Extract<PlatformListSyncs200, object>> = {}): PlatformListSyncs200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), source: faker.string.alpha({length: {min: 10, max: 20}}), destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha({length: {min: 10, max: 20}}), cpu: faker.string.alpha({length: {min: 10, max: 20}}), memory: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},...{last_run: faker.helpers.arrayElement([{id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), migration: faker.datatype.boolean(), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), ingested: faker.datatype.boolean()}, undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreateSyncResponseMock = (overrideResponse: Partial<Extract<PlatformSync, object>> = {}): PlatformSync => ({name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), source: faker.string.alpha({length: {min: 10, max: 20}}), destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha({length: {min: 10, max: 20}}), cpu: faker.string.alpha({length: {min: 10, max: 20}}), memory: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ...overrideResponse})

export const getPlatformGetSyncResponseMock = (overrideResponse: Partial<Extract<PlatformSync, object>> = {}): PlatformSync => ({name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), source: faker.string.alpha({length: {min: 10, max: 20}}), destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha({length: {min: 10, max: 20}}), cpu: faker.string.alpha({length: {min: 10, max: 20}}), memory: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ...overrideResponse})

export const getPlatformUpdateSyncResponseMock = (overrideResponse: Partial<Extract<PlatformSync, object>> = {}): PlatformSync => ({name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), source: faker.string.alpha({length: {min: 10, max: 20}}), destinations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha({length: {min: 10, max: 20}}), cpu: faker.string.alpha({length: {min: 10, max: 20}}), memory: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ...overrideResponse})

export const getPlatformListSyncRunsResponseMock = (overrideResponse: Partial<Extract<PlatformListSyncRuns200, object>> = {}): PlatformListSyncRuns200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({sync_name: faker.string.alpha({length: {min: 10, max: 20}}), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), ingested: faker.datatype.boolean()})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreateSyncRunResponseMock = (overrideResponse: Partial<Extract<PlatformSyncRun, object>> = {}): PlatformSyncRun => ({sync_name: faker.string.alpha({length: {min: 10, max: 20}}), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), ingested: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformGetSyncRunResponseMock = (): PlatformSyncRunDetails => ({...{sync_name: faker.string.alpha({length: {min: 10, max: 20}}), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), ingested: faker.datatype.boolean()},...{cpu_seconds: faker.helpers.arrayElement([faker.number.float({fractionDigits: 2}), undefined]), memory_byte_seconds: faker.helpers.arrayElement([faker.number.float({fractionDigits: 2}), undefined]), network_egress_bytes: faker.helpers.arrayElement([faker.number.float({fractionDigits: 2}), undefined])},})

export const getPlatformUpdateSyncRunResponseMock = (overrideResponse: Partial<Extract<PlatformSyncRun, object>> = {}): PlatformSyncRun => ({sync_name: faker.string.alpha({length: {min: 10, max: 20}}), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), ingested: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformGetSyncRunLogsResponseMock = (overrideResponse: Partial<Extract<PlatformGetSyncRunLogs200One | string | void, object>> = {}): PlatformGetSyncRunLogs200One | string | void => (faker.helpers.arrayElement([{location: faker.internet.url(), ...overrideResponse}, faker.word.sample()]))

export const getPlatformGetSyncRunLogsQueryResponseMock = (overrideResponse: Partial<Extract<PlatformGetSyncRunLogsQuery200One | string | void, object>> = {}): PlatformGetSyncRunLogsQuery200One | string | void => (faker.helpers.arrayElement([{data: {query: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), columns: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), type: faker.string.alpha({length: {min: 10, max: 20}})})), rows: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({}))))}, metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse}, faker.word.sample()]))

export const getPlatformGetSyncRunLogsLiveResponseMock = (): string | void => (faker.word.sample())

export const getPlatformGetSyncRunStatsResponseMock = (overrideResponse: Partial<Extract<PlatformSyncRunStats, object>> = {}): PlatformSyncRunStats => ({completed_tables: faker.number.int(), started_at: faker.date.past().toISOString().slice(0, 19) + 'Z', last_completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), resources: faker.number.int(), errors: faker.number.int(), panics: faker.number.int(), ...overrideResponse})

export const getPlatformGetSyncRunTablesResponseMock = (overrideResponse: Partial<Extract<PlatformGetSyncRunTables200, object>> = {}): PlatformGetSyncRunTables200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({service_name: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), started_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), resources: faker.helpers.arrayElement([faker.number.int(), undefined]), errors: faker.helpers.arrayElement([faker.number.int(), undefined]), panics: faker.helpers.arrayElement([faker.number.int(), undefined]), runtime_seconds: faker.helpers.arrayElement([faker.number.int(), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetSyncRunConnectorCredentialsResponseMock = (overrideResponse: Partial<Extract<PlatformGetSyncRunConnectorCredentials200, object>> = {}): PlatformGetSyncRunConnectorCredentials200 => ({aws: faker.helpers.arrayElement([{access_key_id: faker.string.alpha({length: {min: 10, max: 20}}), secret_access_key: faker.string.alpha({length: {min: 10, max: 20}}), session_token: faker.string.alpha({length: {min: 10, max: 20}}), source: faker.string.alpha({length: {min: 10, max: 20}}), can_expire: faker.datatype.boolean(), expires: faker.date.past().toISOString().slice(0, 19) + 'Z'}, undefined]), oauth: faker.helpers.arrayElement([{access_token: faker.string.alpha({length: {min: 10, max: 20}}), expires: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, undefined]), ...overrideResponse})

export const getPlatformGetSyncRunConnectorIdentityResponseMock = (overrideResponse: Partial<Extract<PlatformGetSyncRunConnectorIdentity200, object>> = {}): PlatformGetSyncRunConnectorIdentity200 => ({aws: faker.helpers.arrayElement([{role_arn: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), ...overrideResponse})

export const getPlatformGetTestConnectionConnectorCredentialsResponseMock = (overrideResponse: Partial<Extract<PlatformGetTestConnectionConnectorCredentials200, object>> = {}): PlatformGetTestConnectionConnectorCredentials200 => ({aws: faker.helpers.arrayElement([{access_key_id: faker.string.alpha({length: {min: 10, max: 20}}), secret_access_key: faker.string.alpha({length: {min: 10, max: 20}}), session_token: faker.string.alpha({length: {min: 10, max: 20}}), source: faker.string.alpha({length: {min: 10, max: 20}}), can_expire: faker.datatype.boolean(), expires: faker.date.past().toISOString().slice(0, 19) + 'Z'}, undefined]), oauth: faker.helpers.arrayElement([{access_token: faker.string.alpha({length: {min: 10, max: 20}}), expires: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])}, undefined]), ...overrideResponse})

export const getPlatformGetTestConnectionConnectorIdentityResponseMock = (overrideResponse: Partial<Extract<PlatformGetTestConnectionConnectorIdentity200, object>> = {}): PlatformGetTestConnectionConnectorIdentity200 => ({aws: faker.helpers.arrayElement([{role_arn: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), ...overrideResponse})

export const getPlatformListTablesTeamResponseMock = (overrideResponse: Partial<Extract<PlatformListTablesTeam200, object>> = {}): PlatformListTablesTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), total_rows: faker.helpers.arrayElement([faker.number.int(), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformTableListRowsTeamResponseMock = (overrideResponse: Partial<Extract<PlatformTableListRowsTeam200, object>> = {}): PlatformTableListRowsTeam200 => ({data: {query: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), columns: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), type: faker.string.alpha({length: {min: 10, max: 20}})})), rows: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({}))))}, metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformTableRowByIdTeamResponseMock = (overrideResponse: Partial<Extract<PlatformTableRowByIdTeam200, object>> = {}): PlatformTableRowByIdTeam200 => ({data: {}, matches: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({key: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.string.alpha({length: {min: 10, max: 20}}), start_index: faker.helpers.arrayElement([faker.number.int(), undefined]), end_index: faker.helpers.arrayElement([faker.number.int(), undefined])})), ...overrideResponse})

export const getPlatformTableSchemaTeamResponseMock = (overrideResponse: Partial<Extract<PlatformTableSchemaTeam200, object>> = {}): PlatformTableSchemaTeam200 => ({schema: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), type: faker.string.alpha({length: {min: 10, max: 20}}), default_kind: faker.string.alpha({length: {min: 10, max: 20}}), default_expression: faker.string.alpha({length: {min: 10, max: 20}}), comment: faker.string.alpha({length: {min: 10, max: 20}}), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind)), nullable: faker.datatype.boolean()})), default_columns: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), ...overrideResponse})

export const getPlatformBatchTableSchemasTeamResponseMock = (overrideResponse: Partial<Extract<PlatformBatchTableSchemasTeam200, object>> = {}): PlatformBatchTableSchemasTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({table_name: faker.string.alpha({length: {min: 10, max: 20}}), schema: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), type: faker.string.alpha({length: {min: 10, max: 20}}), default_kind: faker.string.alpha({length: {min: 10, max: 20}}), default_expression: faker.string.alpha({length: {min: 10, max: 20}}), comment: faker.string.alpha({length: {min: 10, max: 20}}), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind)), nullable: faker.datatype.boolean()})), default_columns: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}})))})), ...overrideResponse})

export const getPlatformTableListColumnsTeamResponseMock = (overrideResponse: Partial<Extract<PlatformTableListColumnsTeam200, object>> = {}): PlatformTableListColumnsTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind)), nullable: faker.datatype.boolean()})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformTableColumnListValuesTeamResponseMock = (overrideResponse: Partial<Extract<PlatformTableColumnListValuesTeam200, object>> = {}): PlatformTableColumnListValuesTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind))})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformTableListFiltersTeamResponseMock = (overrideResponse: Partial<Extract<PlatformTableListFiltersTeam200, object>> = {}): PlatformTableListFiltersTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), expression: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformTableSaveFilterTeamResponseMock = (overrideResponse: Partial<Extract<PlatformFilter, object>> = {}): PlatformFilter => (faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), expression: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse}, {id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), expression: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), table: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse}]))

export const getPlatformTableListFilterTagsTeamResponseMock = (overrideResponse: Partial<Extract<PlatformTableListFilterTagsTeam200, object>> = {}): PlatformTableListFilterTagsTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformTableListRelationsTeamResponseMock = (overrideResponse: Partial<Extract<PlatformTableListRelationsTeam200, object>> = {}): PlatformTableListRelationsTeam200 => ({data: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({table_name: faker.string.alpha({length: {min: 10, max: 20}}), label: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getPlatformGetTeamUsageSummaryResponseMock = (overrideResponse: Partial<Extract<PlatformUsageSummary, object>> = {}): PlatformUsageSummary => ({groups: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.string.alpha({length: {min: 10, max: 20}})})), values: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({timestamp: faker.date.past().toISOString().slice(0, 19) + 'Z', paid_rows: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), undefined]), cloud_vcpu_seconds: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), undefined]), cloud_vram_byte_seconds: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), undefined]), cloud_egress_bytes: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), undefined])})), metadata: {start: faker.date.past().toISOString().slice(0, 19) + 'Z', end: faker.date.past().toISOString().slice(0, 19) + 'Z', aggregation_period: faker.helpers.arrayElement(['day','month'] as const), metrics: faker.helpers.arrayElements(['paid_rows','cloud_egress_bytes','cloud_vcpu_seconds','cloud_vram_byte_seconds'] as const)}, ...overrideResponse})

export const getPlatformGetGroupedTeamUsageSummaryResponseMock = (overrideResponse: Partial<Extract<PlatformUsageSummary, object>> = {}): PlatformUsageSummary => ({groups: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.string.alpha({length: {min: 10, max: 20}})})), values: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({timestamp: faker.date.past().toISOString().slice(0, 19) + 'Z', paid_rows: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), undefined]), cloud_vcpu_seconds: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), undefined]), cloud_vram_byte_seconds: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), undefined]), cloud_egress_bytes: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), undefined])})), metadata: {start: faker.date.past().toISOString().slice(0, 19) + 'Z', end: faker.date.past().toISOString().slice(0, 19) + 'Z', aggregation_period: faker.helpers.arrayElement(['day','month'] as const), metrics: faker.helpers.arrayElements(['paid_rows','cloud_egress_bytes','cloud_vcpu_seconds','cloud_vram_byte_seconds'] as const)}, ...overrideResponse})

export const getPlatformListUsersByTeamResponseMock = (overrideResponse: Partial<Extract<PlatformListUsersByTeam200, object>> = {}): PlatformListUsersByTeam200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformUploadImageResponseMock = (overrideResponse: Partial<Extract<PlatformImageURL, object>> = {}): PlatformImageURL => ({upload_url: faker.string.alpha({length: {min: 10, max: 20}}), download_url: faker.string.alpha({length: {min: 10, max: 20}}), required_headers: {
        [faker.string.alphanumeric(5)]: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}})))
      }, ...overrideResponse})

export const getPlatformGetCurrentUserResponseMock = (): PlatformGetCurrentUser200 => ({...{created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])},...{event_identifiers: faker.helpers.arrayElement([{}, undefined]), group_identifier: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), registered_team_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), registered_team_internal: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},})

export const getPlatformUpdateCurrentUserResponseMock = (overrideResponse: Partial<Extract<PlatformUser, object>> = {}): PlatformUser => ({created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), ...overrideResponse})

export const getPlatformAuthenticateLocalUserResponseMock = (overrideResponse: Partial<Extract<PlatformAuthenticateLocalUser200, object>> = {}): PlatformAuthenticateLocalUser200 => ({id_token: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getPlatformListCurrentUserInvitationsResponseMock = (overrideResponse: Partial<Extract<PlatformListCurrentUserInvitations200, object>> = {}): PlatformListCurrentUserInvitations200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), email: faker.internet.email(), role: faker.string.alpha({length: {min: 10, max: 20}}), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z'},...{token: faker.string.uuid()},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformUserTOTPSetupResponseMock = (overrideResponse: Partial<Extract<PlatformUserTOTPSetup200, object>> = {}): PlatformUserTOTPSetup200 => ({url: faker.string.alpha({length: {min: 10, max: 20}}), secret: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getPlatformGetCurrentLocalUserResponseMock = (): PlatformLocalUserWithTeams => ({...{...{created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), id: faker.string.uuid(), email: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), undefined]), updated_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), last_login_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined])},...{roles: faker.helpers.arrayElements(['admin:write','admin:read'] as const), enabled: faker.datatype.boolean(), provider: faker.helpers.arrayElement(Object.values(PlatformLocalUserProvider)), tracking_opted_in: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), mfa_configured: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},},...{teams: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({roles: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}))},})

export const getPlatformGetCurrentUserMembershipsResponseMock = (overrideResponse: Partial<Extract<PlatformGetCurrentUserMemberships200, object>> = {}): PlatformGetCurrentUserMemberships200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({roles: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), team: {created_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), display_name: faker.string.alpha({length: {min: 10, max: 255}}), internal: faker.datatype.boolean()}})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreateUserTokenResponseMock = (overrideResponse: Partial<Extract<PlatformCreateUserToken201, object>> = {}): PlatformCreateUserToken201 => ({custom_token: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getPlatformAuthRegistryRequestResponseMock = (overrideResponse: Partial<Extract<PlatformRegistryAuthToken, object>> = {}): PlatformRegistryAuthToken => ({access_token: faker.string.alpha({length: {min: 10, max: 20}}), token: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getPlatformCreateV2SyncDestinationTestConnectionResponseMock = (overrideResponse: Partial<Extract<PlatformSyncDestinationTestConnectionV2, object>> = {}): PlatformSyncDestinationTestConnectionV2 => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp("^cloudquery/[^/]+"), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp("^v[0-9]+\\.[0-9]+\\.[0-9]+(-[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?(\\+[0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*)?$"), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), ...overrideResponse})

export const getPlatformCreateV2SyncDestinationResponseMock = (): PlatformSyncDestinationV2 => (faker.helpers.arrayElement([{...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), write_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), migrate_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$")))},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), disabled: faker.datatype.boolean(), last_run: faker.helpers.arrayElement([{sync_name: faker.string.alpha({length: {min: 10, max: 20}}), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), ingested: faker.datatype.boolean()}, undefined]), plugin: faker.helpers.arrayElement([{team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int()}, undefined])},}, {...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), write_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), migrate_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$")))},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), disabled: faker.datatype.boolean(), last_run: faker.helpers.arrayElement([{sync_name: faker.string.alpha({length: {min: 10, max: 20}}), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), ingested: faker.datatype.boolean()}, undefined]), plugin: faker.helpers.arrayElement([{team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int()}, undefined])},}]))

export const getPlatformGetV2SyncDestinationsResponseMock = (overrideResponse: Partial<Extract<PlatformGetV2SyncDestinations200, object>> = {}): PlatformGetV2SyncDestinations200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), write_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), migrate_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$")))},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), disabled: faker.datatype.boolean(), last_run: faker.helpers.arrayElement([{sync_name: faker.string.alpha({length: {min: 10, max: 20}}), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), ingested: faker.datatype.boolean()}, undefined]), plugin: faker.helpers.arrayElement([{team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int()}, undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformGetV2SyncDestinationResponseMock = (): PlatformSyncDestinationV2 => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), write_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), migrate_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$")))},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), disabled: faker.datatype.boolean(), last_run: faker.helpers.arrayElement([{sync_name: faker.string.alpha({length: {min: 10, max: 20}}), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), total_rows: faker.number.int(), warnings: faker.number.int(), errors: faker.number.int(), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), ingested: faker.datatype.boolean()}, undefined]), plugin: faker.helpers.arrayElement([{team_name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), name: faker.helpers.fromRegExp("^[a-z](-?[a-z0-9]+)+$"), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', homepage: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), logo: faker.string.alpha({length: {min: 10, max: 20}}), display_name: faker.string.alpha({length: {min: 1, max: 50}}), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), short_description: faker.string.alpha({length: {min: 1, max: 512}}), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp("^\\d+(?:\\.\\d{1,10})?$"), free_rows_per_month: faker.number.int()}, undefined])},})

export const getPlatformPatchV2SyncDestinationResponseMock = (): PlatformSyncDestination => ({...{name: faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$"), display_name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}\\p{N}_][a-zA-Z\\p{L}\\p{N}_ \\-'\\(\\)\\[\\]]*$"), path: faker.helpers.fromRegExp("^cloudquery/[^/]+"), version: faker.string.alpha({length: {min: 10, max: 20}}), write_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), migrate_mode: faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), sync_group_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: {}, env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])})), last_update_source: faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp("^[a-zA-Z0-9_-]+$")))},...{created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', env: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha({length: {min: 10, max: 20}})})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined])},})

export const getPlatformListAllRBACPermissionsResponseMock = (overrideResponse: Partial<Extract<PlatformListAllRBACPermissions200, object>> = {}): PlatformListAllRBACPermissions200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', number_of_affected_roles: faker.number.int(), number_of_affected_users: faker.number.int()})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreateRBACPermissionResponseMock = (overrideResponse: Partial<Extract<PlatformRBACPermission, object>> = {}): PlatformRBACPermission => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', number_of_affected_roles: faker.number.int(), number_of_affected_users: faker.number.int(), ...overrideResponse})

export const getPlatformGetRBACPermissionResponseMock = (overrideResponse: Partial<Extract<PlatformRBACPermission, object>> = {}): PlatformRBACPermission => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', number_of_affected_roles: faker.number.int(), number_of_affected_users: faker.number.int(), ...overrideResponse})

export const getPlatformUpdateRBACPermissionResponseMock = (overrideResponse: Partial<Extract<PlatformRBACPermission, object>> = {}): PlatformRBACPermission => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', number_of_affected_roles: faker.number.int(), number_of_affected_users: faker.number.int(), ...overrideResponse})

export const getPlatformListAllRBACRolesResponseMock = (overrideResponse: Partial<Extract<PlatformListAllRBACRoles200, object>> = {}): PlatformListAllRBACRoles200 => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), permissions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', number_of_affected_roles: faker.number.int(), number_of_affected_users: faker.number.int()})), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z'})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int(), undefined]), last_page: faker.helpers.arrayElement([faker.number.int(), undefined]), page_size: faker.number.int(), time_ms: faker.helpers.arrayElement([faker.number.int(), undefined])}, ...overrideResponse})

export const getPlatformCreateRBACRoleResponseMock = (overrideResponse: Partial<Extract<PlatformRBACRole, object>> = {}): PlatformRBACRole => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), permissions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', number_of_affected_roles: faker.number.int(), number_of_affected_users: faker.number.int()})), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformGetRBACRoleResponseMock = (overrideResponse: Partial<Extract<PlatformRBACRole, object>> = {}): PlatformRBACRole => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), permissions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', number_of_affected_roles: faker.number.int(), number_of_affected_users: faker.number.int()})), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getPlatformUpdateRBACRoleResponseMock = (overrideResponse: Partial<Extract<PlatformRBACRole, object>> = {}): PlatformRBACRole => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), permissions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), query: faker.string.alpha({length: {min: 10, max: 20}}), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', number_of_affected_roles: faker.number.int(), number_of_affected_users: faker.number.int()})), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp("^[a-zA-Z\\p{L}][a-zA-Z\\p{L} \\-']*$"), email: faker.string.alpha({length: {min: 10, max: 20}})}, created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})


export const getPlatformIndexMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.get('*/', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getPlatformListAuditLogsMockHandler = (overrideResponse?: PlatformListAuditLogs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAuditLogs200> | PlatformListAuditLogs200), options?: RequestHandlerOptions) => {
  return http.get('*/audit-logs', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListAuditLogsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetAuditLogMockHandler = (overrideResponse?: PlatformAuditLogEvent | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformAuditLogEvent> | PlatformAuditLogEvent), options?: RequestHandlerOptions) => {
  return http.get('*/audit-logs/:id', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetAuditLogResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformHealthCheckHeadMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.head>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.head('*/healthcheck', async (info: Parameters<Parameters<typeof http.head>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getPlatformHealthCheckMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.get('*/healthcheck', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getPlatformGetOpenAPIJSONMockHandler = (overrideResponse?: PlatformGetOpenAPIJSON200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetOpenAPIJSON200> | PlatformGetOpenAPIJSON200), options?: RequestHandlerOptions) => {
  return http.get('*/openapi.json', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetOpenAPIJSONResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformAssetViewGetStatusMockHandler = (overrideResponse?: PlatformAssetViewGetStatus200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformAssetViewGetStatus200> | PlatformAssetViewGetStatus200), options?: RequestHandlerOptions) => {
  return http.get('*/manage/assetview', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformAssetViewGetStatusResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformAssetViewTriggerMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/manage/assetview', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 201
      })
  }, options)
}

export const getPlatformAssetViewListLogsMockHandler = (overrideResponse?: PlatformAssetViewListLogs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformAssetViewListLogs200> | PlatformAssetViewListLogs200), options?: RequestHandlerOptions) => {
  return http.get('*/manage/assetview/logs', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformAssetViewListLogsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformManageGetSAMLMockHandler = (overrideResponse?: PlatformSAMLConfig | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSAMLConfig> | PlatformSAMLConfig), options?: RequestHandlerOptions) => {
  return http.get('*/manage/auth/saml', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformManageGetSAMLResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformManageUpdateSAMLMockHandler = (overrideResponse?: PlatformSAMLConfig | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSAMLConfig> | PlatformSAMLConfig), options?: RequestHandlerOptions) => {
  return http.patch('*/manage/auth/saml', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformManageUpdateSAMLResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformManageGetPlatformRegistryMockHandler = (overrideResponse?: PlatformManageGetPlatformRegistry200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformManageGetPlatformRegistry200> | PlatformManageGetPlatformRegistry200), options?: RequestHandlerOptions) => {
  return http.get('*/manage/register-platform', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformManageGetPlatformRegistryResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformManageRegisterPlatformMockHandler = (overrideResponse?: PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205> | PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205), options?: RequestHandlerOptions) => {
  return http.post('*/manage/register-platform', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformManageRegisterPlatformResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformManageRegisterPlatformWithOfflineLicenseMockHandler = (overrideResponse?: PlatformManageRegisterPlatformWithOfflineLicense200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformManageRegisterPlatformWithOfflineLicense200> | PlatformManageRegisterPlatformWithOfflineLicense200), options?: RequestHandlerOptions) => {
  return http.post('*/manage/register-platform/offline', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformManageRegisterPlatformWithOfflineLicenseResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetSettingsMockHandler = (overrideResponse?: PlatformSettings | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSettings> | PlatformSettings), options?: RequestHandlerOptions) => {
  return http.get('*/manage/settings', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSettingsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateSettingsMockHandler = (overrideResponse?: PlatformSettings | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSettings> | PlatformSettings), options?: RequestHandlerOptions) => {
  return http.patch('*/manage/settings', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateSettingsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformManageListAllTeamsMockHandler = (overrideResponse?: PlatformManageListAllTeams200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformManageListAllTeams200> | PlatformManageListAllTeams200), options?: RequestHandlerOptions) => {
  return http.get('*/manage/teams', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformManageListAllTeamsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformManageGetTeamMockHandler = (overrideResponse?: PlatformTeam | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTeam> | PlatformTeam), options?: RequestHandlerOptions) => {
  return http.get('*/manage/teams/:teamName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformManageGetTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformManageDeleteTeamMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/manage/teams/:teamName', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformManageListTeamMembersMockHandler = (overrideResponse?: PlatformManageListTeamMembers200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformManageListTeamMembers200> | PlatformManageListTeamMembers200), options?: RequestHandlerOptions) => {
  return http.get('*/manage/teams/:teamName/members', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformManageListTeamMembersResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformManageAddTeamMemberMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.put('*/manage/teams/:teamName/members', async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformManageRemoveTeamMemberMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/manage/teams/:teamName/members', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListLocalUsersMockHandler = (overrideResponse?: PlatformListLocalUsers200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListLocalUsers200> | PlatformListLocalUsers200), options?: RequestHandlerOptions) => {
  return http.get('*/manage/users', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListLocalUsersResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformAddLocalUserMockHandler = (overrideResponse?: PlatformLocalUser | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformLocalUser> | PlatformLocalUser), options?: RequestHandlerOptions) => {
  return http.post('*/manage/users/add', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformAddLocalUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetLocalUserMockHandler = (overrideResponse?: PlatformLocalUserWithTeams | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformLocalUserWithTeams> | PlatformLocalUserWithTeams), options?: RequestHandlerOptions) => {
  return http.get('*/manage/users/:userId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetLocalUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateLocalUserMockHandler = (overrideResponse?: PlatformLocalUser | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformLocalUser> | PlatformLocalUser), options?: RequestHandlerOptions) => {
  return http.patch('*/manage/users/:userId', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateLocalUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteLocalUserMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/manage/users/:userId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformCreateLocalUserResetTokenMockHandler = (overrideResponse?: PlatformCreateLocalUserResetToken200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreateLocalUserResetToken200> | PlatformCreateLocalUserResetToken200), options?: RequestHandlerOptions) => {
  return http.post('*/manage/users/:userId/reset', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateLocalUserResetTokenResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformManageUserTOTPDeleteMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/manage/users/:userId/totp', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformGetPlatformInfoMockHandler = (overrideResponse?: PlatformGetPlatformInfo200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetPlatformInfo200> | PlatformGetPlatformInfo200), options?: RequestHandlerOptions) => {
  return http.get('*/platform-info', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetPlatformInfoResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListPlatformVersionsMockHandler = (overrideResponse?: PlatformListPlatformVersions200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPlatformVersions200> | PlatformListPlatformVersions200), options?: RequestHandlerOptions) => {
  return http.get('*/platform-versions', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListPlatformVersionsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListPluginsMockHandler = (overrideResponse?: PlatformListPlugins200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPlugins200> | PlatformListPlugins200), options?: RequestHandlerOptions) => {
  return http.get('*/plugins', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListPluginsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreatePluginMockHandler = (overrideResponse?: PlatformPlugin | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformPlugin> | PlatformPlugin), options?: RequestHandlerOptions) => {
  return http.post('*/plugins', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreatePluginResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetPluginMockHandler = (overrideResponse?: PlatformListPlugin | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPlugin> | PlatformListPlugin), options?: RequestHandlerOptions) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetPluginResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdatePluginMockHandler = (overrideResponse?: PlatformPlugin | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformPlugin> | PlatformPlugin), options?: RequestHandlerOptions) => {
  return http.patch('*/plugins/:teamName/:pluginKind/:pluginName', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdatePluginResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeletePluginByTeamAndPluginNameMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/plugins/:teamName/:pluginKind/:pluginName', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListPluginVersionsMockHandler = (overrideResponse?: PlatformListPluginVersions200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPluginVersions200> | PlatformListPluginVersions200), options?: RequestHandlerOptions) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListPluginVersionsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetPluginVersionMockHandler = (overrideResponse?: PlatformPluginVersionDetails | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformPluginVersionDetails> | PlatformPluginVersionDetails), options?: RequestHandlerOptions) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetPluginVersionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreatePluginVersionMockHandler = (overrideResponse?: PlatformPluginVersion | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformPluginVersion> | PlatformPluginVersion), options?: RequestHandlerOptions) => {
  return http.put('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName', async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreatePluginVersionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdatePluginVersionMockHandler = (overrideResponse?: PlatformPluginVersion | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformPluginVersion> | PlatformPluginVersion), options?: RequestHandlerOptions) => {
  return http.patch('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdatePluginVersionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDownloadPluginAssetMockHandler = (overrideResponse?: PlatformPluginAsset | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformPluginAsset> | PlatformPluginAsset), options?: RequestHandlerOptions) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/assets/:targetName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformDownloadPluginAssetResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUploadPluginAssetMockHandler = (overrideResponse?: PlatformReleaseURL | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformReleaseURL> | PlatformReleaseURL), options?: RequestHandlerOptions) => {
  return http.post('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/assets/:targetName', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUploadPluginAssetResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformListPluginVersionDocsMockHandler = (overrideResponse?: PlatformListPluginVersionDocs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPluginVersionDocs200> | PlatformListPluginVersionDocs200), options?: RequestHandlerOptions) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/docs', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListPluginVersionDocsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreatePluginVersionDocsMockHandler = (overrideResponse?: PlatformCreatePluginVersionDocs201 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformCreatePluginVersionDocs201> | PlatformCreatePluginVersionDocs201), options?: RequestHandlerOptions) => {
  return http.put('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/docs', async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreatePluginVersionDocsResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformReplacePluginVersionDocsMockHandler = (overrideResponse?: PlatformReplacePluginVersionDocs201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformReplacePluginVersionDocs201> | PlatformReplacePluginVersionDocs201), options?: RequestHandlerOptions) => {
  return http.post('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/docs', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformReplacePluginVersionDocsResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformDeletePluginVersionDocsMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/docs', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListPluginVersionTablesMockHandler = (overrideResponse?: PlatformListPluginVersionTables200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPluginVersionTables200> | PlatformListPluginVersionTables200), options?: RequestHandlerOptions) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/tables', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListPluginVersionTablesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreatePluginVersionTablesMockHandler = (overrideResponse?: PlatformCreatePluginVersionTables201 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformCreatePluginVersionTables201> | PlatformCreatePluginVersionTables201), options?: RequestHandlerOptions) => {
  return http.put('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/tables', async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreatePluginVersionTablesResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformDeletePluginVersionTablesMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/tables', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformGetPluginVersionTableMockHandler = (overrideResponse?: PlatformPluginTableDetails | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformPluginTableDetails> | PlatformPluginTableDetails), options?: RequestHandlerOptions) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/tables/:tableName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetPluginVersionTableResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUploadPluginUIAssetsMockHandler = (overrideResponse?: PlatformUploadPluginUIAssets201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformUploadPluginUIAssets201> | PlatformUploadPluginUIAssets201), options?: RequestHandlerOptions) => {
  return http.post('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/uiassets', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUploadPluginUIAssetsResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformFinalizePluginUIAssetUploadMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.put('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/uiassets', async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformRemovePluginUIAssetsMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/uiassets', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListTeamsMockHandler = (overrideResponse?: PlatformListTeams200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListTeams200> | PlatformListTeams200), options?: RequestHandlerOptions) => {
  return http.get('*/teams', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListTeamsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateTeamMockHandler = (overrideResponse?: PlatformTeam | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformTeam> | PlatformTeam), options?: RequestHandlerOptions) => {
  return http.post('*/teams', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateTeamResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetTeamByNameMockHandler = (overrideResponse?: PlatformTeam | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTeam> | PlatformTeam), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetTeamByNameResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateTeamMockHandler = (overrideResponse?: PlatformTeam | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformTeam> | PlatformTeam), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteTeamMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListAllAlertsMockHandler = (overrideResponse?: PlatformListAllAlerts200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllAlerts200> | PlatformListAllAlerts200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/alerts', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListAllAlertsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTestUnsavedAlertMockHandler = (overrideResponse?: PlatformTestUnsavedAlert200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformTestUnsavedAlert200> | PlatformTestUnsavedAlert200), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/alerts/test', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTestUnsavedAlertResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListTeamAPIKeysMockHandler = (overrideResponse?: PlatformListTeamAPIKeys200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListTeamAPIKeys200> | PlatformListTeamAPIKeys200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/apikeys', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListTeamAPIKeysResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateTeamAPIKeyMockHandler = (overrideResponse?: PlatformAPIKey | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformAPIKey> | PlatformAPIKey), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/apikeys', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateTeamAPIKeyResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformDeleteTeamAPIKeyMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/apikeys/:apikeyId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListConnectorsMockHandler = (overrideResponse?: PlatformListConnectors200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListConnectors200> | PlatformListConnectors200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/connectors', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListConnectorsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateConnectorMockHandler = (overrideResponse?: PlatformConnector | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformConnector> | PlatformConnector), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/connectors', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateConnectorResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetConnectorMockHandler = (overrideResponse?: PlatformConnector | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformConnector> | PlatformConnector), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/connectors/:connectorId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetConnectorResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateConnectorMockHandler = (overrideResponse?: PlatformConnector | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformConnector> | PlatformConnector), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/connectors/:connectorId', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateConnectorResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformRevokeConnectorMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/connectors/:connectorId/authenticate', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformGetConnectorAuthStatusAWSMockHandler = (overrideResponse?: PlatformGetConnectorAuthStatusAWS200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetConnectorAuthStatusAWS200> | PlatformGetConnectorAuthStatusAWS200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/connectors/:connectorId/authenticate/aws', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetConnectorAuthStatusAWSResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformAuthenticateConnectorAWSMockHandler = (overrideResponse?: PlatformConnectorAuthResponseAWS | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformConnectorAuthResponseAWS> | PlatformConnectorAuthResponseAWS), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/connectors/:connectorId/authenticate/aws', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformAuthenticateConnectorAWSResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformAuthenticateConnectorFinishAWSMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/connectors/:connectorId/authenticate/aws', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformGetConnectorAuthStatusGCPMockHandler = (overrideResponse?: PlatformGetConnectorAuthStatusGCP200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetConnectorAuthStatusGCP200> | PlatformGetConnectorAuthStatusGCP200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/connectors/:connectorId/authenticate/gcp', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetConnectorAuthStatusGCPResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformAuthenticateConnectorGCPMockHandler = (overrideResponse?: PlatformConnectorAuthResponseGCP | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformConnectorAuthResponseGCP> | PlatformConnectorAuthResponseGCP), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/connectors/:connectorId/authenticate/gcp', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformAuthenticateConnectorGCPResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformAuthenticateConnectorFinishGCPMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/connectors/:connectorId/authenticate/gcp/finish', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformAuthenticateConnectorOAuthMockHandler = (overrideResponse?: PlatformConnectorAuthResponseOAuth | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformConnectorAuthResponseOAuth> | PlatformConnectorAuthResponseOAuth), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/connectors/:connectorId/authenticate/oauth', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformAuthenticateConnectorOAuthResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformAuthenticateConnectorFinishOAuthMockHandler = (overrideResponse?: PlatformConnectorAuthResponseOAuth | void | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformConnectorAuthResponseOAuth | void> | PlatformConnectorAuthResponseOAuth | void), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/connectors/:connectorId/authenticate/oauth', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformAuthenticateConnectorFinishOAuthResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateConversationMockHandler = (overrideResponse?: PlatformConversation | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformConversation> | PlatformConversation), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/conversations', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateConversationResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetConversationMockHandler = (overrideResponse?: PlatformConversation | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformConversation> | PlatformConversation), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/conversations/:conversationId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetConversationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformSendMessageMockHandler = (overrideResponse?: PlatformConversationMessage | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformConversationMessage> | PlatformConversationMessage), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/conversations/:conversationId', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformSendMessageResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformListAllCustomColumnsMockHandler = (overrideResponse?: PlatformListAllCustomColumns200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllCustomColumns200> | PlatformListAllCustomColumns200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/custom-columns', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListAllCustomColumnsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformSaveCustomColumnMockHandler = (overrideResponse?: PlatformCustomColumn | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCustomColumn> | PlatformCustomColumn), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/custom-columns', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformSaveCustomColumnResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetCustomColumnMockHandler = (overrideResponse?: PlatformCustomColumn | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformCustomColumn> | PlatformCustomColumn), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/custom-columns/:customColumnId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetCustomColumnResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateCustomColumnMockHandler = (overrideResponse?: PlatformCustomColumn | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformCustomColumn> | PlatformCustomColumn), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/custom-columns/:customColumnId', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateCustomColumnResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteCustomColumnMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/custom-columns/:customColumnId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformPutCustomColumnDataMockHandler = (overrideResponse?: PlatformPutCustomColumnData202 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformPutCustomColumnData202> | PlatformPutCustomColumnData202), options?: RequestHandlerOptions) => {
  return http.put('*/teams/:teamName/custom-columns/:customColumnId/import', async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformPutCustomColumnDataResponseMock(),
      { status: 202
      })
  }, options)
}

export const getPlatformPutCustomColumnValuesMockHandler = (overrideResponse?: PlatformPutCustomColumnValues200 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformPutCustomColumnValues200> | PlatformPutCustomColumnValues200), options?: RequestHandlerOptions) => {
  return http.put('*/teams/:teamName/custom-columns/:customColumnId/values', async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformPutCustomColumnValuesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListFiltersTeamMockHandler = (overrideResponse?: PlatformListFiltersTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListFiltersTeam200> | PlatformListFiltersTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/filters', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListFiltersTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListFilterTagsTeamMockHandler = (overrideResponse?: PlatformListFilterTagsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListFilterTagsTeam200> | PlatformListFilterTagsTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/filters/tags', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListFilterTagsTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetFilterByIDTeamMockHandler = (overrideResponse?: PlatformFilter | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformFilter> | PlatformFilter), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/filters/:filterId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetFilterByIDTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateFilterTeamMockHandler = (overrideResponse?: PlatformFilter | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformFilter> | PlatformFilter), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/filters/:filterId', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateFilterTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteFilterTeamMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/filters/:filterId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformCreateTeamImagesMockHandler = (overrideResponse?: PlatformCreateTeamImages201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreateTeamImages201> | PlatformCreateTeamImages201), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/images', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateTeamImagesResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformListTeamInvitationsMockHandler = (overrideResponse?: PlatformListTeamInvitations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListTeamInvitations200> | PlatformListTeamInvitations200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/invitations', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListTeamInvitationsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteTeamInvitationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/invitations', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformAcceptTeamInvitationMockHandler = (overrideResponse?: PlatformMembershipWithTeam | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformMembershipWithTeam> | PlatformMembershipWithTeam), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/invitations/accept', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformAcceptTeamInvitationResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetTeamMembershipsMockHandler = (overrideResponse?: PlatformGetTeamMemberships200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetTeamMemberships200> | PlatformGetTeamMemberships200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/memberships', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetTeamMembershipsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformRemoveTeamMembershipMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/memberships', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformDeleteTeamMembershipMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/memberships/:email', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListAllNotificationDestinationsMockHandler = (overrideResponse?: PlatformListAllNotificationDestinations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllNotificationDestinations200> | PlatformListAllNotificationDestinations200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/notifications/destinations', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListAllNotificationDestinationsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateNotificationDestinationMockHandler = (overrideResponse?: PlatformNotificationDestination | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformNotificationDestination> | PlatformNotificationDestination), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/notifications/destinations', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateNotificationDestinationResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformTestUnsavedNotificationDestinationMockHandler = (overrideResponse?: PlatformNotificationDestinationTestResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformNotificationDestinationTestResponse> | PlatformNotificationDestinationTestResponse), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/notifications/destinations/test', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTestUnsavedNotificationDestinationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetNotificationDestinationMockHandler = (overrideResponse?: PlatformNotificationDestination | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformNotificationDestination> | PlatformNotificationDestination), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/notifications/destination/:notificationDestinationId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetNotificationDestinationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateNotificationDestinationMockHandler = (overrideResponse?: PlatformNotificationDestination | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformNotificationDestination> | PlatformNotificationDestination), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/notifications/destination/:notificationDestinationId', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateNotificationDestinationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteNotificationDestinationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/notifications/destination/:notificationDestinationId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformGetNotificationDestinationAlertsMockHandler = (overrideResponse?: PlatformGetNotificationDestinationAlerts200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetNotificationDestinationAlerts200> | PlatformGetNotificationDestinationAlerts200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/notifications/destination/:notificationDestinationId/alerts', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetNotificationDestinationAlertsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTestNotificationDestinationMockHandler = (overrideResponse?: PlatformNotificationDestinationTestResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformNotificationDestinationTestResponse> | PlatformNotificationDestinationTestResponse), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/notifications/destination/:notificationDestinationId/test', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTestNotificationDestinationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateAWSOnboardingMockHandler = (overrideResponse?: PlatformOnboardingAWSCreateResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformOnboardingAWSCreateResponse> | PlatformOnboardingAWSCreateResponse), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/onboardings/aws/oidc', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateAWSOnboardingResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetAWSOnboardingMockHandler = (overrideResponse?: PlatformOnboardingAWS | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformOnboardingAWS> | PlatformOnboardingAWS), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/onboardings/aws/oidc/:onboardingId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetAWSOnboardingResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformNotifyOnboardingMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/onboardings/aws/oidc/:onboardingId/notify', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 202
      })
  }, options)
}

export const getPlatformGetAWSAccountsInRootMockHandler = (overrideResponse?: PlatformOnboardingAWSAccounts | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformOnboardingAWSAccounts> | PlatformOnboardingAWSAccounts), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/onboardings/aws/oidc/:onboardingId/accounts', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetAWSAccountsInRootResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetAWSAccountsInParentMockHandler = (overrideResponse?: PlatformOnboardingAWSAccounts | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformOnboardingAWSAccounts> | PlatformOnboardingAWSAccounts), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/onboardings/aws/oidc/:onboardingId/accounts/:awsOrgunitId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetAWSAccountsInParentResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformProvisionOnboardingConfigurationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/onboardings/aws/oidc/:onboardingId/accounts/provision', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 202
      })
  }, options)
}

export const getPlatformListPluginsByTeamMockHandler = (overrideResponse?: PlatformListPluginsByTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPluginsByTeam200> | PlatformListPluginsByTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/plugins', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListPluginsByTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeletePluginsByTeamMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/plugins', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformDownloadPluginAssetByTeamMockHandler = (overrideResponse?: PlatformPluginAsset | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformPluginAsset> | PlatformPluginAsset), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/plugins/:pluginTeam/:pluginKind/:pluginName/versions/:versionName/assets/:targetName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformDownloadPluginAssetByTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListPoliciesMockHandler = (overrideResponse?: PlatformListPolicies200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPolicies200> | PlatformListPolicies200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/policies', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListPoliciesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreatePolicyMockHandler = (overrideResponse?: PlatformCreatePolicy201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreatePolicy201> | PlatformCreatePolicy201), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/policies', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreatePolicyResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformListAllFrameworksMockHandler = (overrideResponse?: PlatformListAllFrameworks200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllFrameworks200> | PlatformListAllFrameworks200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/policies/frameworks', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListAllFrameworksResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetPolicyMockHandler = (overrideResponse?: PlatformGetPolicy200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetPolicy200> | PlatformGetPolicy200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/policies/:policyId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetPolicyResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdatePolicyMockHandler = (overrideResponse?: PlatformUpdatePolicy200 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformUpdatePolicy200> | PlatformUpdatePolicy200), options?: RequestHandlerOptions) => {
  return http.put('*/teams/:teamName/policies/:policyId', async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdatePolicyResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeletePolicyMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/policies/:policyId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListPolicyFrameworksMockHandler = (overrideResponse?: PlatformListPolicyFrameworks200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPolicyFrameworks200> | PlatformListPolicyFrameworks200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/policies/:policyId/frameworks', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListPolicyFrameworksResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListPolicyRulesMockHandler = (overrideResponse?: PlatformListPolicyRules200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPolicyRules200> | PlatformListPolicyRules200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/policies/:policyId/rules', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListPolicyRulesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListPolicyRuleDetailsMockHandler = (overrideResponse?: PlatformListPolicyRuleDetails200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPolicyRuleDetails200> | PlatformListPolicyRuleDetails200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/policies/:policyId/rules/:ruleId/details', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListPolicyRuleDetailsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTogglePolicyMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/policies/:policyId/toggle', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getPlatformGetPolicyViolationsHistoryMockHandler = (overrideResponse?: PlatformGetPolicyViolationsHistory200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetPolicyViolationsHistory200> | PlatformGetPolicyViolationsHistory200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/policies/:policyId/violations-history', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetPolicyViolationsHistoryResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListAllQueriesTeamMockHandler = (overrideResponse?: PlatformListAllQueriesTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllQueriesTeam200> | PlatformListAllQueriesTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/queries', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListAllQueriesTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformExecuteAdHocQueryTeamMockHandler = (overrideResponse?: PlatformExecuteAdHocQueryTeam200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformExecuteAdHocQueryTeam200> | PlatformExecuteAdHocQueryTeam200), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/queries/execute', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformExecuteAdHocQueryTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformSaveQueryTeamMockHandler = (overrideResponse?: PlatformQueryDetail | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformQueryDetail> | PlatformQueryDetail), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/queries/save', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformSaveQueryTeamResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformListQueryTagsTeamMockHandler = (overrideResponse?: PlatformListQueryTagsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListQueryTagsTeam200> | PlatformListQueryTagsTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/queries/tags', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListQueryTagsTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetSavedQueryTeamMockHandler = (overrideResponse?: PlatformQueryDetail | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformQueryDetail> | PlatformQueryDetail), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/queries/:queryId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSavedQueryTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateQueryTeamMockHandler = (overrideResponse?: PlatformQueryDetail | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformQueryDetail> | PlatformQueryDetail), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/queries/:queryId', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateQueryTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteSavedQueryTeamMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/queries/:queryId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformDeleteAlertMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/queries/:queryId/alert', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformExecuteSavedQueryTeamMockHandler = (overrideResponse?: PlatformExecuteSavedQueryTeam200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformExecuteSavedQueryTeam200> | PlatformExecuteSavedQueryTeam200), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/queries/:queryId/execute', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformExecuteSavedQueryTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformQueryListFiltersTeamMockHandler = (overrideResponse?: PlatformQueryListFiltersTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformQueryListFiltersTeam200> | PlatformQueryListFiltersTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/queries/:queryId/filters', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformQueryListFiltersTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformQuerySaveFilterTeamMockHandler = (overrideResponse?: PlatformFilter | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformFilter> | PlatformFilter), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/queries/:queryId/filters', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformQuerySaveFilterTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformQueryListFilterTagsTeamMockHandler = (overrideResponse?: PlatformQueryListFilterTagsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformQueryListFilterTagsTeam200> | PlatformQueryListFilterTagsTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/queries/:queryId/filters/tags', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformQueryListFilterTagsTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListReportsMockHandler = (overrideResponse?: PlatformListReports200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListReports200> | PlatformListReports200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/reports', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListReportsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateReportMockHandler = (overrideResponse?: PlatformCreateReport201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreateReport201> | PlatformCreateReport201), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/reports', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateReportResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetReportMockHandler = (overrideResponse?: PlatformGetReport200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetReport200> | PlatformGetReport200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/reports/:reportId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetReportResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateReportMockHandler = (overrideResponse?: PlatformUpdateReport200 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformUpdateReport200> | PlatformUpdateReport200), options?: RequestHandlerOptions) => {
  return http.put('*/teams/:teamName/reports/:reportId', async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateReportResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteReportMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/reports/:reportId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListReportTemplatesMockHandler = (overrideResponse?: PlatformListReportTemplates200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListReportTemplates200> | PlatformListReportTemplates200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/reports/templates', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListReportTemplatesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateReportTemplateMockHandler = (overrideResponse?: PlatformCreateReportTemplate201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreateReportTemplate201> | PlatformCreateReportTemplate201), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/reports/templates', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateReportTemplateResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetReportTemplateMockHandler = (overrideResponse?: PlatformGetReportTemplate200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetReportTemplate200> | PlatformGetReportTemplate200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/reports/templates/:templateId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetReportTemplateResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateReportTemplateMockHandler = (overrideResponse?: PlatformUpdateReportTemplate200 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformUpdateReportTemplate200> | PlatformUpdateReportTemplate200), options?: RequestHandlerOptions) => {
  return http.put('*/teams/:teamName/reports/templates/:templateId', async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateReportTemplateResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteReportTemplateMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/reports/templates/:templateId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformCreateSyncDestinationTestConnectionMockHandler = (overrideResponse?: PlatformSyncDestinationTestConnection | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncDestinationTestConnection> | PlatformSyncDestinationTestConnection), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/sync-destination-test-connections', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateSyncDestinationTestConnectionResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetSyncDestinationTestConnectionMockHandler = (overrideResponse?: PlatformSyncDestinationTestConnection | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncDestinationTestConnection> | PlatformSyncDestinationTestConnection), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-destination-test-connections/:syncDestinationTestConnectionId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncDestinationTestConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateSyncTestConnectionForSyncDestinationMockHandler = (overrideResponse?: PlatformSyncDestinationTestConnection | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncDestinationTestConnection> | PlatformSyncDestinationTestConnection), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/sync-destination-test-connections/:syncDestinationTestConnectionId', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateSyncTestConnectionForSyncDestinationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetSyncDestinationTestConnectionLogsMockHandler = (overrideResponse?: PlatformGetSyncDestinationTestConnectionLogs200One | string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncDestinationTestConnectionLogs200One | string | void> | PlatformGetSyncDestinationTestConnectionLogs200One | string | void), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-destination-test-connections/:syncDestinationTestConnectionId/logs', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);

  const resolvedBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncDestinationTestConnectionLogsResponseMock();
    return typeof resolvedBody === 'string'
      ? HttpResponse.text(resolvedBody, { status: 200 })
      : HttpResponse.json(resolvedBody, { status: 200 })
  }, options)
}

export const getPlatformGetSyncDestinationTestConnectionLogsQueryMockHandler = (overrideResponse?: PlatformGetSyncDestinationTestConnectionLogsQuery200One | string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncDestinationTestConnectionLogsQuery200One | string | void> | PlatformGetSyncDestinationTestConnectionLogsQuery200One | string | void), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-destination-test-connections/:syncDestinationTestConnectionId/logs/query', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);

  const resolvedBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncDestinationTestConnectionLogsQueryResponseMock();
    return typeof resolvedBody === 'string'
      ? HttpResponse.text(resolvedBody, { status: 200 })
      : HttpResponse.json(resolvedBody, { status: 200 })
  }, options)
}

export const getPlatformGetSyncDestinationTestConnectionLogsLiveMockHandler = (overrideResponse?: string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<string | void> | string | void), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-destination-test-connections/:syncDestinationTestConnectionId/logs/live', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);

  const resolvedBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncDestinationTestConnectionLogsLiveResponseMock();
    return typeof resolvedBody === 'string'
      ? HttpResponse.text(resolvedBody, { status: 200 })
      : HttpResponse.json(resolvedBody, { status: 200 })
  }, options)
}

export const getPlatformPromoteSyncDestinationTestConnectionMockHandler = (overrideResponse?: PlatformSyncDestination | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncDestination> | PlatformSyncDestination), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/sync-destination-test-connections/:syncDestinationTestConnectionId/promote', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformPromoteSyncDestinationTestConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListSyncDestinationsMockHandler = (overrideResponse?: PlatformListSyncDestinations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncDestinations200> | PlatformListSyncDestinations200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-destinations', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListSyncDestinationsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetSyncDestinationMockHandler = (overrideResponse?: PlatformSyncDestination | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncDestination> | PlatformSyncDestination), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-destinations/:syncDestinationName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncDestinationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateSyncDestinationMockHandler = (overrideResponse?: PlatformSyncDestination | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncDestination> | PlatformSyncDestination), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/sync-destinations/:syncDestinationName', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateSyncDestinationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteSyncDestinationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/sync-destinations/:syncDestinationName', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformMigrateSyncDestinationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/sync-destinations/:syncDestinationName/migrate', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListSyncDestinationSyncsMockHandler = (overrideResponse?: PlatformListSyncDestinationSyncs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncDestinationSyncs200> | PlatformListSyncDestinationSyncs200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-destinations/:syncDestinationName/syncs', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListSyncDestinationSyncsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetTestConnectionForSyncDestinationMockHandler = (overrideResponse?: PlatformSyncTestConnection | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncTestConnection> | PlatformSyncTestConnection), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-destinations/:syncDestinationName/test-connections/:syncTestConnectionId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetTestConnectionForSyncDestinationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateSyncSourceTestConnectionMockHandler = (overrideResponse?: PlatformSyncSourceTestConnection | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncSourceTestConnection> | PlatformSyncSourceTestConnection), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/sync-source-test-connections', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateSyncSourceTestConnectionResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetSyncSourceTestConnectionMockHandler = (overrideResponse?: PlatformSyncSourceTestConnection | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncSourceTestConnection> | PlatformSyncSourceTestConnection), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-source-test-connections/:syncSourceTestConnectionId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncSourceTestConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateSyncTestConnectionForSyncSourceMockHandler = (overrideResponse?: PlatformSyncSourceTestConnection | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncSourceTestConnection> | PlatformSyncSourceTestConnection), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/sync-source-test-connections/:syncSourceTestConnectionId', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateSyncTestConnectionForSyncSourceResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetSyncSourceTestConnectionLogsMockHandler = (overrideResponse?: PlatformGetSyncSourceTestConnectionLogs200One | string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncSourceTestConnectionLogs200One | string | void> | PlatformGetSyncSourceTestConnectionLogs200One | string | void), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-source-test-connections/:syncSourceTestConnectionId/logs', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);

  const resolvedBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncSourceTestConnectionLogsResponseMock();
    return typeof resolvedBody === 'string'
      ? HttpResponse.text(resolvedBody, { status: 200 })
      : HttpResponse.json(resolvedBody, { status: 200 })
  }, options)
}

export const getPlatformGetSyncSourceTestConnectionLogsQueryMockHandler = (overrideResponse?: PlatformGetSyncSourceTestConnectionLogsQuery200One | string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncSourceTestConnectionLogsQuery200One | string | void> | PlatformGetSyncSourceTestConnectionLogsQuery200One | string | void), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-source-test-connections/:syncSourceTestConnectionId/logs/query', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);

  const resolvedBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncSourceTestConnectionLogsQueryResponseMock();
    return typeof resolvedBody === 'string'
      ? HttpResponse.text(resolvedBody, { status: 200 })
      : HttpResponse.json(resolvedBody, { status: 200 })
  }, options)
}

export const getPlatformGetSyncSourceTestConnectionLogsLiveMockHandler = (overrideResponse?: string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<string | void> | string | void), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-source-test-connections/:syncSourceTestConnectionId/logs/live', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);

  const resolvedBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncSourceTestConnectionLogsLiveResponseMock();
    return typeof resolvedBody === 'string'
      ? HttpResponse.text(resolvedBody, { status: 200 })
      : HttpResponse.json(resolvedBody, { status: 200 })
  }, options)
}

export const getPlatformPromoteSyncSourceTestConnectionMockHandler = (overrideResponse?: PlatformSyncSource | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncSource> | PlatformSyncSource), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/sync-source-test-connections/:syncSourceTestConnectionId/promote', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformPromoteSyncSourceTestConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateV2SyncIntegrationTestConnectionMockHandler = (overrideResponse?: PlatformSyncIntegrationTestConnectionV2 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncIntegrationTestConnectionV2> | PlatformSyncIntegrationTestConnectionV2), options?: RequestHandlerOptions) => {
  return http.post('*/v2/teams/:teamName/sync-integration-test-connections', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateV2SyncIntegrationTestConnectionResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformListV2SyncIntegrationsMockHandler = (overrideResponse?: PlatformListV2SyncIntegrations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListV2SyncIntegrations200> | PlatformListV2SyncIntegrations200), options?: RequestHandlerOptions) => {
  return http.get('*/v2/teams/:teamName/sync-integrations', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListV2SyncIntegrationsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateV2SyncIntegrationMockHandler = (overrideResponse?: PlatformSyncIntegrationV2 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncIntegrationV2> | PlatformSyncIntegrationV2), options?: RequestHandlerOptions) => {
  return http.post('*/v2/teams/:teamName/sync-integrations', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateV2SyncIntegrationResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetV2SyncIntegrationMockHandler = (overrideResponse?: PlatformSyncIntegrationExpandedV2 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncIntegrationExpandedV2> | PlatformSyncIntegrationExpandedV2), options?: RequestHandlerOptions) => {
  return http.get('*/v2/teams/:teamName/sync-integrations/:syncName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetV2SyncIntegrationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateV2SyncIntegrationMockHandler = (overrideResponse?: PlatformSyncIntegrationV2 | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncIntegrationV2> | PlatformSyncIntegrationV2), options?: RequestHandlerOptions) => {
  return http.patch('*/v2/teams/:teamName/sync-integrations/:syncName', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateV2SyncIntegrationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteV2SyncIntegrationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/v2/teams/:teamName/sync-integrations/:syncName', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListSyncSourcesMockHandler = (overrideResponse?: PlatformListSyncSources200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncSources200> | PlatformListSyncSources200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-sources', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListSyncSourcesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetSyncSourceMockHandler = (overrideResponse?: PlatformSyncSource | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncSource> | PlatformSyncSource), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-sources/:syncSourceName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncSourceResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateSyncSourceMockHandler = (overrideResponse?: PlatformSyncSource | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncSource> | PlatformSyncSource), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/sync-sources/:syncSourceName', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateSyncSourceResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteSyncSourceMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/sync-sources/:syncSourceName', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformMigrateSyncSourceMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/sync-sources/:syncSourceName/migrate', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListSyncSourceSyncsMockHandler = (overrideResponse?: PlatformListSyncSourceSyncs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncSourceSyncs200> | PlatformListSyncSourceSyncs200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-sources/:syncSourceName/syncs', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListSyncSourceSyncsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetTestConnectionForSyncSourceMockHandler = (overrideResponse?: PlatformSyncTestConnection | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncTestConnection> | PlatformSyncTestConnection), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-sources/:syncSourceName/test-connections/:syncTestConnectionId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetTestConnectionForSyncSourceResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListSyncTransformersMockHandler = (overrideResponse?: PlatformListSyncTransformers200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncTransformers200> | PlatformListSyncTransformers200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-transformers', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListSyncTransformersResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetSyncTransformerMockHandler = (overrideResponse?: PlatformSyncTransformer | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncTransformer> | PlatformSyncTransformer), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-transformers/:syncTransformerName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncTransformerResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateSyncTransformerMockHandler = (overrideResponse?: PlatformSyncTransformer | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncTransformer> | PlatformSyncTransformer), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/sync-transformers/:syncTransformerName', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateSyncTransformerResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteSyncTransformerMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/sync-transformers/:syncTransformerName', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListSyncTransformerSyncsMockHandler = (overrideResponse?: PlatformListSyncTransformerSyncs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncTransformerSyncs200> | PlatformListSyncTransformerSyncs200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-transformers/:syncTransformerName/syncs', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListSyncTransformerSyncsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListSyncTransformerSyncDestinationsMockHandler = (overrideResponse?: PlatformListSyncTransformerSyncDestinations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncTransformerSyncDestinations200> | PlatformListSyncTransformerSyncDestinations200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-transformers/:syncTransformerName/sync-destinations', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListSyncTransformerSyncDestinationsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListSyncUpgradesMockHandler = (overrideResponse?: PlatformListSyncUpgrades200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncUpgrades200> | PlatformListSyncUpgrades200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/sync-upgrades', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListSyncUpgradesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListSyncsMockHandler = (overrideResponse?: PlatformListSyncs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncs200> | PlatformListSyncs200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListSyncsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateSyncMockHandler = (overrideResponse?: PlatformSync | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSync> | PlatformSync), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/syncs', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateSyncResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetSyncMockHandler = (overrideResponse?: PlatformSync | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSync> | PlatformSync), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/:syncName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateSyncMockHandler = (overrideResponse?: PlatformSync | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSync> | PlatformSync), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/syncs/:syncName', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateSyncResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteSyncMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/syncs/:syncName', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListSyncRunsMockHandler = (overrideResponse?: PlatformListSyncRuns200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncRuns200> | PlatformListSyncRuns200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListSyncRunsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateSyncRunMockHandler = (overrideResponse?: PlatformSyncRun | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncRun> | PlatformSyncRun), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/syncs/:syncName/runs', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateSyncRunResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetSyncRunMockHandler = (overrideResponse?: PlatformSyncRunDetails | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncRunDetails> | PlatformSyncRunDetails), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncRunResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateSyncRunMockHandler = (overrideResponse?: PlatformSyncRun | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncRun> | PlatformSyncRun), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/syncs/:syncName/runs/:syncRunId', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateSyncRunResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetSyncRunLogsMockHandler = (overrideResponse?: PlatformGetSyncRunLogs200One | string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncRunLogs200One | string | void> | PlatformGetSyncRunLogs200One | string | void), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/logs', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);

  const resolvedBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncRunLogsResponseMock();
    return typeof resolvedBody === 'string'
      ? HttpResponse.text(resolvedBody, { status: 200 })
      : HttpResponse.json(resolvedBody, { status: 200 })
  }, options)
}

export const getPlatformGetSyncRunLogsQueryMockHandler = (overrideResponse?: PlatformGetSyncRunLogsQuery200One | string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncRunLogsQuery200One | string | void> | PlatformGetSyncRunLogsQuery200One | string | void), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/logs/query', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);

  const resolvedBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncRunLogsQueryResponseMock();
    return typeof resolvedBody === 'string'
      ? HttpResponse.text(resolvedBody, { status: 200 })
      : HttpResponse.json(resolvedBody, { status: 200 })
  }, options)
}

export const getPlatformGetSyncRunLogsLiveMockHandler = (overrideResponse?: string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<string | void> | string | void), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/logs/live', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);

  const resolvedBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncRunLogsLiveResponseMock();
    return typeof resolvedBody === 'string'
      ? HttpResponse.text(resolvedBody, { status: 200 })
      : HttpResponse.json(resolvedBody, { status: 200 })
  }, options)
}

export const getPlatformCreateSyncRunProgressMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/progress', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformGetSyncRunStatsMockHandler = (overrideResponse?: PlatformSyncRunStats | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncRunStats> | PlatformSyncRunStats), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/stats', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncRunStatsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetSyncRunTablesMockHandler = (overrideResponse?: PlatformGetSyncRunTables200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncRunTables200> | PlatformGetSyncRunTables200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/tables', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncRunTablesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetSyncRunConnectorCredentialsMockHandler = (overrideResponse?: PlatformGetSyncRunConnectorCredentials200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncRunConnectorCredentials200> | PlatformGetSyncRunConnectorCredentials200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/connector/:connectorId/credentials', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncRunConnectorCredentialsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetSyncRunConnectorIdentityMockHandler = (overrideResponse?: PlatformGetSyncRunConnectorIdentity200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncRunConnectorIdentity200> | PlatformGetSyncRunConnectorIdentity200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/connector/:connectorId/identity', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetSyncRunConnectorIdentityResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetTestConnectionConnectorCredentialsMockHandler = (overrideResponse?: PlatformGetTestConnectionConnectorCredentials200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetTestConnectionConnectorCredentials200> | PlatformGetTestConnectionConnectorCredentials200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/test-connections/:syncTestConnectionId/connector/:connectorId/credentials', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetTestConnectionConnectorCredentialsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetTestConnectionConnectorIdentityMockHandler = (overrideResponse?: PlatformGetTestConnectionConnectorIdentity200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetTestConnectionConnectorIdentity200> | PlatformGetTestConnectionConnectorIdentity200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/syncs/test-connections/:syncTestConnectionId/connector/:connectorId/identity', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetTestConnectionConnectorIdentityResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListTablesTeamMockHandler = (overrideResponse?: PlatformListTablesTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListTablesTeam200> | PlatformListTablesTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/tables', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListTablesTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTableListRowsTeamMockHandler = (overrideResponse?: PlatformTableListRowsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListRowsTeam200> | PlatformTableListRowsTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/tables/:tableName/data', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTableListRowsTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTableRowByIdTeamMockHandler = (overrideResponse?: PlatformTableRowByIdTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableRowByIdTeam200> | PlatformTableRowByIdTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/tables/:tableName/data/:tableRowId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTableRowByIdTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTableSchemaTeamMockHandler = (overrideResponse?: PlatformTableSchemaTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableSchemaTeam200> | PlatformTableSchemaTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/tables/:tableName/schema', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTableSchemaTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformBatchTableSchemasTeamMockHandler = (overrideResponse?: PlatformBatchTableSchemasTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformBatchTableSchemasTeam200> | PlatformBatchTableSchemasTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/tables/schemas', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformBatchTableSchemasTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTableListColumnsTeamMockHandler = (overrideResponse?: PlatformTableListColumnsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListColumnsTeam200> | PlatformTableListColumnsTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/tables/:tableName/columns', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTableListColumnsTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTableColumnListValuesTeamMockHandler = (overrideResponse?: PlatformTableColumnListValuesTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableColumnListValuesTeam200> | PlatformTableColumnListValuesTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/tables/:tableName/columns/:columnName/values', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTableColumnListValuesTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTableListFiltersTeamMockHandler = (overrideResponse?: PlatformTableListFiltersTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListFiltersTeam200> | PlatformTableListFiltersTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/tables/:tableName/filters', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTableListFiltersTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTableSaveFilterTeamMockHandler = (overrideResponse?: PlatformFilter | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformFilter> | PlatformFilter), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/tables/:tableName/filters', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTableSaveFilterTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTableListFilterTagsTeamMockHandler = (overrideResponse?: PlatformTableListFilterTagsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListFilterTagsTeam200> | PlatformTableListFilterTagsTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/tables/:tableName/filters/tags', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTableListFilterTagsTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformTableListRelationsTeamMockHandler = (overrideResponse?: PlatformTableListRelationsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListRelationsTeam200> | PlatformTableListRelationsTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/tables/:tableName/relations', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformTableListRelationsTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetTeamUsageSummaryMockHandler = (overrideResponse?: PlatformUsageSummary | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformUsageSummary> | PlatformUsageSummary), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/usage-summary', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetTeamUsageSummaryResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetGroupedTeamUsageSummaryMockHandler = (overrideResponse?: PlatformUsageSummary | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformUsageSummary> | PlatformUsageSummary), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/usage-summary/:groupBy', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetGroupedTeamUsageSummaryResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformListUsersByTeamMockHandler = (overrideResponse?: PlatformListUsersByTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListUsersByTeam200> | PlatformListUsersByTeam200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/users', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListUsersByTeamResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUploadImageMockHandler = (overrideResponse?: PlatformImageURL | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformImageURL> | PlatformImageURL), options?: RequestHandlerOptions) => {
  return http.post('*/upload/image', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUploadImageResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetCurrentUserMockHandler = (overrideResponse?: PlatformGetCurrentUser200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetCurrentUser200> | PlatformGetCurrentUser200), options?: RequestHandlerOptions) => {
  return http.get('*/user', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetCurrentUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateCurrentUserMockHandler = (overrideResponse?: PlatformUser | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformUser> | PlatformUser), options?: RequestHandlerOptions) => {
  return http.patch('*/user', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateCurrentUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformSendAnonymousEventMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/user/anon-event', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformAuthenticateLocalUserMockHandler = (overrideResponse?: PlatformAuthenticateLocalUser200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformAuthenticateLocalUser200> | PlatformAuthenticateLocalUser200), options?: RequestHandlerOptions) => {
  return http.post('*/user/authenticate', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformAuthenticateLocalUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformChangeLocalUserPasswordMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/user/change-password', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformUpdateCustomerMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.patch('*/user/customer', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 201
      })
  }, options)
}

export const getPlatformSendUserEventMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/user/event', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListCurrentUserInvitationsMockHandler = (overrideResponse?: PlatformListCurrentUserInvitations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListCurrentUserInvitations200> | PlatformListCurrentUserInvitations200), options?: RequestHandlerOptions) => {
  return http.get('*/user/invitations', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListCurrentUserInvitationsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUserTOTPVerifyMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/user/totp/verify', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformUserTOTPSetupMockHandler = (overrideResponse?: PlatformUserTOTPSetup200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformUserTOTPSetup200> | PlatformUserTOTPSetup200), options?: RequestHandlerOptions) => {
  return http.post('*/user/totp', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUserTOTPSetupResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUserTOTPDeleteMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/user/totp', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformGetCurrentLocalUserMockHandler = (overrideResponse?: PlatformLocalUserWithTeams | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformLocalUserWithTeams> | PlatformLocalUserWithTeams), options?: RequestHandlerOptions) => {
  return http.get('*/user/local', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetCurrentLocalUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformLoginUserMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/user/login', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformLogoutUserMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/user/login', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformGetCurrentUserMembershipsMockHandler = (overrideResponse?: PlatformGetCurrentUserMemberships200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetCurrentUserMemberships200> | PlatformGetCurrentUserMemberships200), options?: RequestHandlerOptions) => {
  return http.get('*/user/memberships', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetCurrentUserMembershipsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformResetLocalUserPasswordMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/user/reset-password-token', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformCreateUserTokenMockHandler = (overrideResponse?: PlatformCreateUserToken201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreateUserToken201> | PlatformCreateUserToken201), options?: RequestHandlerOptions) => {
  return http.post('*/user/token', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateUserTokenResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformDeleteUserMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/users/:userId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformAuthRegistryRequestMockHandler = (overrideResponse?: PlatformRegistryAuthToken | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformRegistryAuthToken> | PlatformRegistryAuthToken), options?: RequestHandlerOptions) => {
  return http.get('*/registry/auth', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformAuthRegistryRequestResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateV2SyncDestinationTestConnectionMockHandler = (overrideResponse?: PlatformSyncDestinationTestConnectionV2 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncDestinationTestConnectionV2> | PlatformSyncDestinationTestConnectionV2), options?: RequestHandlerOptions) => {
  return http.post('*/v2/teams/:teamName/sync-destination-test-connections', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateV2SyncDestinationTestConnectionResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformCreateV2SyncDestinationMockHandler = (overrideResponse?: PlatformSyncDestinationV2 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncDestinationV2> | PlatformSyncDestinationV2), options?: RequestHandlerOptions) => {
  return http.post('*/v2/teams/:teamName/sync-destinations', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateV2SyncDestinationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetV2SyncDestinationsMockHandler = (overrideResponse?: PlatformGetV2SyncDestinations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetV2SyncDestinations200> | PlatformGetV2SyncDestinations200), options?: RequestHandlerOptions) => {
  return http.get('*/v2/teams/:teamName/sync-destinations', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetV2SyncDestinationsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformGetV2SyncDestinationMockHandler = (overrideResponse?: PlatformSyncDestinationV2 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncDestinationV2> | PlatformSyncDestinationV2), options?: RequestHandlerOptions) => {
  return http.get('*/v2/teams/:teamName/sync-destinations/:syncDestinationName', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetV2SyncDestinationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformPatchV2SyncDestinationMockHandler = (overrideResponse?: PlatformSyncDestination | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncDestination> | PlatformSyncDestination), options?: RequestHandlerOptions) => {
  return http.patch('*/v2/teams/:teamName/sync-destinations/:syncDestinationName', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformPatchV2SyncDestinationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteV2SyncDestinationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/v2/teams/:teamName/sync-destinations/:syncDestinationName', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListAllRBACPermissionsMockHandler = (overrideResponse?: PlatformListAllRBACPermissions200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllRBACPermissions200> | PlatformListAllRBACPermissions200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/rbac/permissions', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListAllRBACPermissionsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateRBACPermissionMockHandler = (overrideResponse?: PlatformRBACPermission | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformRBACPermission> | PlatformRBACPermission), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/rbac/permissions', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateRBACPermissionResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetRBACPermissionMockHandler = (overrideResponse?: PlatformRBACPermission | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformRBACPermission> | PlatformRBACPermission), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/rbac/permissions/:permissionId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetRBACPermissionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateRBACPermissionMockHandler = (overrideResponse?: PlatformRBACPermission | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformRBACPermission> | PlatformRBACPermission), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/rbac/permissions/:permissionId', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateRBACPermissionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteRBACPermissionMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/rbac/permissions/:permissionId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getPlatformListAllRBACRolesMockHandler = (overrideResponse?: PlatformListAllRBACRoles200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllRBACRoles200> | PlatformListAllRBACRoles200), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/rbac/roles', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformListAllRBACRolesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformCreateRBACRoleMockHandler = (overrideResponse?: PlatformRBACRole | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformRBACRole> | PlatformRBACRole), options?: RequestHandlerOptions) => {
  return http.post('*/teams/:teamName/rbac/roles', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformCreateRBACRoleResponseMock(),
      { status: 201
      })
  }, options)
}

export const getPlatformGetRBACRoleMockHandler = (overrideResponse?: PlatformRBACRole | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformRBACRole> | PlatformRBACRole), options?: RequestHandlerOptions) => {
  return http.get('*/teams/:teamName/rbac/roles/:roleId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformGetRBACRoleResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformUpdateRBACRoleMockHandler = (overrideResponse?: PlatformRBACRole | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformRBACRole> | PlatformRBACRole), options?: RequestHandlerOptions) => {
  return http.patch('*/teams/:teamName/rbac/roles/:roleId', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {await delay(300);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getPlatformUpdateRBACRoleResponseMock(),
      { status: 200
      })
  }, options)
}

export const getPlatformDeleteRBACRoleMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/teams/:teamName/rbac/roles/:roleId', async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}
export const getCloudQueryPlatformOpenAPISpecMock = () => [
  getPlatformIndexMockHandler(),
  getPlatformListAuditLogsMockHandler(),
  getPlatformGetAuditLogMockHandler(),
  getPlatformHealthCheckHeadMockHandler(),
  getPlatformHealthCheckMockHandler(),
  getPlatformGetOpenAPIJSONMockHandler(),
  getPlatformAssetViewGetStatusMockHandler(),
  getPlatformAssetViewTriggerMockHandler(),
  getPlatformAssetViewListLogsMockHandler(),
  getPlatformManageGetSAMLMockHandler(),
  getPlatformManageUpdateSAMLMockHandler(),
  getPlatformManageGetPlatformRegistryMockHandler(),
  getPlatformManageRegisterPlatformMockHandler(),
  getPlatformManageRegisterPlatformWithOfflineLicenseMockHandler(),
  getPlatformGetSettingsMockHandler(),
  getPlatformUpdateSettingsMockHandler(),
  getPlatformManageListAllTeamsMockHandler(),
  getPlatformManageGetTeamMockHandler(),
  getPlatformManageDeleteTeamMockHandler(),
  getPlatformManageListTeamMembersMockHandler(),
  getPlatformManageAddTeamMemberMockHandler(),
  getPlatformManageRemoveTeamMemberMockHandler(),
  getPlatformListLocalUsersMockHandler(),
  getPlatformAddLocalUserMockHandler(),
  getPlatformGetLocalUserMockHandler(),
  getPlatformUpdateLocalUserMockHandler(),
  getPlatformDeleteLocalUserMockHandler(),
  getPlatformCreateLocalUserResetTokenMockHandler(),
  getPlatformManageUserTOTPDeleteMockHandler(),
  getPlatformGetPlatformInfoMockHandler(),
  getPlatformListPlatformVersionsMockHandler(),
  getPlatformListPluginsMockHandler(),
  getPlatformCreatePluginMockHandler(),
  getPlatformGetPluginMockHandler(),
  getPlatformUpdatePluginMockHandler(),
  getPlatformDeletePluginByTeamAndPluginNameMockHandler(),
  getPlatformListPluginVersionsMockHandler(),
  getPlatformGetPluginVersionMockHandler(),
  getPlatformCreatePluginVersionMockHandler(),
  getPlatformUpdatePluginVersionMockHandler(),
  getPlatformDownloadPluginAssetMockHandler(),
  getPlatformUploadPluginAssetMockHandler(),
  getPlatformListPluginVersionDocsMockHandler(),
  getPlatformCreatePluginVersionDocsMockHandler(),
  getPlatformReplacePluginVersionDocsMockHandler(),
  getPlatformDeletePluginVersionDocsMockHandler(),
  getPlatformListPluginVersionTablesMockHandler(),
  getPlatformCreatePluginVersionTablesMockHandler(),
  getPlatformDeletePluginVersionTablesMockHandler(),
  getPlatformGetPluginVersionTableMockHandler(),
  getPlatformUploadPluginUIAssetsMockHandler(),
  getPlatformFinalizePluginUIAssetUploadMockHandler(),
  getPlatformRemovePluginUIAssetsMockHandler(),
  getPlatformListTeamsMockHandler(),
  getPlatformCreateTeamMockHandler(),
  getPlatformGetTeamByNameMockHandler(),
  getPlatformUpdateTeamMockHandler(),
  getPlatformDeleteTeamMockHandler(),
  getPlatformListAllAlertsMockHandler(),
  getPlatformTestUnsavedAlertMockHandler(),
  getPlatformListTeamAPIKeysMockHandler(),
  getPlatformCreateTeamAPIKeyMockHandler(),
  getPlatformDeleteTeamAPIKeyMockHandler(),
  getPlatformListConnectorsMockHandler(),
  getPlatformCreateConnectorMockHandler(),
  getPlatformGetConnectorMockHandler(),
  getPlatformUpdateConnectorMockHandler(),
  getPlatformRevokeConnectorMockHandler(),
  getPlatformGetConnectorAuthStatusAWSMockHandler(),
  getPlatformAuthenticateConnectorAWSMockHandler(),
  getPlatformAuthenticateConnectorFinishAWSMockHandler(),
  getPlatformGetConnectorAuthStatusGCPMockHandler(),
  getPlatformAuthenticateConnectorGCPMockHandler(),
  getPlatformAuthenticateConnectorFinishGCPMockHandler(),
  getPlatformAuthenticateConnectorOAuthMockHandler(),
  getPlatformAuthenticateConnectorFinishOAuthMockHandler(),
  getPlatformCreateConversationMockHandler(),
  getPlatformGetConversationMockHandler(),
  getPlatformSendMessageMockHandler(),
  getPlatformListAllCustomColumnsMockHandler(),
  getPlatformSaveCustomColumnMockHandler(),
  getPlatformGetCustomColumnMockHandler(),
  getPlatformUpdateCustomColumnMockHandler(),
  getPlatformDeleteCustomColumnMockHandler(),
  getPlatformPutCustomColumnDataMockHandler(),
  getPlatformPutCustomColumnValuesMockHandler(),
  getPlatformListFiltersTeamMockHandler(),
  getPlatformListFilterTagsTeamMockHandler(),
  getPlatformGetFilterByIDTeamMockHandler(),
  getPlatformUpdateFilterTeamMockHandler(),
  getPlatformDeleteFilterTeamMockHandler(),
  getPlatformCreateTeamImagesMockHandler(),
  getPlatformListTeamInvitationsMockHandler(),
  getPlatformDeleteTeamInvitationMockHandler(),
  getPlatformAcceptTeamInvitationMockHandler(),
  getPlatformGetTeamMembershipsMockHandler(),
  getPlatformRemoveTeamMembershipMockHandler(),
  getPlatformDeleteTeamMembershipMockHandler(),
  getPlatformListAllNotificationDestinationsMockHandler(),
  getPlatformCreateNotificationDestinationMockHandler(),
  getPlatformTestUnsavedNotificationDestinationMockHandler(),
  getPlatformGetNotificationDestinationMockHandler(),
  getPlatformUpdateNotificationDestinationMockHandler(),
  getPlatformDeleteNotificationDestinationMockHandler(),
  getPlatformGetNotificationDestinationAlertsMockHandler(),
  getPlatformTestNotificationDestinationMockHandler(),
  getPlatformCreateAWSOnboardingMockHandler(),
  getPlatformGetAWSOnboardingMockHandler(),
  getPlatformNotifyOnboardingMockHandler(),
  getPlatformGetAWSAccountsInRootMockHandler(),
  getPlatformGetAWSAccountsInParentMockHandler(),
  getPlatformProvisionOnboardingConfigurationMockHandler(),
  getPlatformListPluginsByTeamMockHandler(),
  getPlatformDeletePluginsByTeamMockHandler(),
  getPlatformDownloadPluginAssetByTeamMockHandler(),
  getPlatformListPoliciesMockHandler(),
  getPlatformCreatePolicyMockHandler(),
  getPlatformListAllFrameworksMockHandler(),
  getPlatformGetPolicyMockHandler(),
  getPlatformUpdatePolicyMockHandler(),
  getPlatformDeletePolicyMockHandler(),
  getPlatformListPolicyFrameworksMockHandler(),
  getPlatformListPolicyRulesMockHandler(),
  getPlatformListPolicyRuleDetailsMockHandler(),
  getPlatformTogglePolicyMockHandler(),
  getPlatformGetPolicyViolationsHistoryMockHandler(),
  getPlatformListAllQueriesTeamMockHandler(),
  getPlatformExecuteAdHocQueryTeamMockHandler(),
  getPlatformSaveQueryTeamMockHandler(),
  getPlatformListQueryTagsTeamMockHandler(),
  getPlatformGetSavedQueryTeamMockHandler(),
  getPlatformUpdateQueryTeamMockHandler(),
  getPlatformDeleteSavedQueryTeamMockHandler(),
  getPlatformDeleteAlertMockHandler(),
  getPlatformExecuteSavedQueryTeamMockHandler(),
  getPlatformQueryListFiltersTeamMockHandler(),
  getPlatformQuerySaveFilterTeamMockHandler(),
  getPlatformQueryListFilterTagsTeamMockHandler(),
  getPlatformListReportsMockHandler(),
  getPlatformCreateReportMockHandler(),
  getPlatformGetReportMockHandler(),
  getPlatformUpdateReportMockHandler(),
  getPlatformDeleteReportMockHandler(),
  getPlatformListReportTemplatesMockHandler(),
  getPlatformCreateReportTemplateMockHandler(),
  getPlatformGetReportTemplateMockHandler(),
  getPlatformUpdateReportTemplateMockHandler(),
  getPlatformDeleteReportTemplateMockHandler(),
  getPlatformCreateSyncDestinationTestConnectionMockHandler(),
  getPlatformGetSyncDestinationTestConnectionMockHandler(),
  getPlatformUpdateSyncTestConnectionForSyncDestinationMockHandler(),
  getPlatformGetSyncDestinationTestConnectionLogsMockHandler(),
  getPlatformGetSyncDestinationTestConnectionLogsQueryMockHandler(),
  getPlatformGetSyncDestinationTestConnectionLogsLiveMockHandler(),
  getPlatformPromoteSyncDestinationTestConnectionMockHandler(),
  getPlatformListSyncDestinationsMockHandler(),
  getPlatformGetSyncDestinationMockHandler(),
  getPlatformUpdateSyncDestinationMockHandler(),
  getPlatformDeleteSyncDestinationMockHandler(),
  getPlatformMigrateSyncDestinationMockHandler(),
  getPlatformListSyncDestinationSyncsMockHandler(),
  getPlatformGetTestConnectionForSyncDestinationMockHandler(),
  getPlatformCreateSyncSourceTestConnectionMockHandler(),
  getPlatformGetSyncSourceTestConnectionMockHandler(),
  getPlatformUpdateSyncTestConnectionForSyncSourceMockHandler(),
  getPlatformGetSyncSourceTestConnectionLogsMockHandler(),
  getPlatformGetSyncSourceTestConnectionLogsQueryMockHandler(),
  getPlatformGetSyncSourceTestConnectionLogsLiveMockHandler(),
  getPlatformPromoteSyncSourceTestConnectionMockHandler(),
  getPlatformCreateV2SyncIntegrationTestConnectionMockHandler(),
  getPlatformListV2SyncIntegrationsMockHandler(),
  getPlatformCreateV2SyncIntegrationMockHandler(),
  getPlatformGetV2SyncIntegrationMockHandler(),
  getPlatformUpdateV2SyncIntegrationMockHandler(),
  getPlatformDeleteV2SyncIntegrationMockHandler(),
  getPlatformListSyncSourcesMockHandler(),
  getPlatformGetSyncSourceMockHandler(),
  getPlatformUpdateSyncSourceMockHandler(),
  getPlatformDeleteSyncSourceMockHandler(),
  getPlatformMigrateSyncSourceMockHandler(),
  getPlatformListSyncSourceSyncsMockHandler(),
  getPlatformGetTestConnectionForSyncSourceMockHandler(),
  getPlatformListSyncTransformersMockHandler(),
  getPlatformGetSyncTransformerMockHandler(),
  getPlatformUpdateSyncTransformerMockHandler(),
  getPlatformDeleteSyncTransformerMockHandler(),
  getPlatformListSyncTransformerSyncsMockHandler(),
  getPlatformListSyncTransformerSyncDestinationsMockHandler(),
  getPlatformListSyncUpgradesMockHandler(),
  getPlatformListSyncsMockHandler(),
  getPlatformCreateSyncMockHandler(),
  getPlatformGetSyncMockHandler(),
  getPlatformUpdateSyncMockHandler(),
  getPlatformDeleteSyncMockHandler(),
  getPlatformListSyncRunsMockHandler(),
  getPlatformCreateSyncRunMockHandler(),
  getPlatformGetSyncRunMockHandler(),
  getPlatformUpdateSyncRunMockHandler(),
  getPlatformGetSyncRunLogsMockHandler(),
  getPlatformGetSyncRunLogsQueryMockHandler(),
  getPlatformGetSyncRunLogsLiveMockHandler(),
  getPlatformCreateSyncRunProgressMockHandler(),
  getPlatformGetSyncRunStatsMockHandler(),
  getPlatformGetSyncRunTablesMockHandler(),
  getPlatformGetSyncRunConnectorCredentialsMockHandler(),
  getPlatformGetSyncRunConnectorIdentityMockHandler(),
  getPlatformGetTestConnectionConnectorCredentialsMockHandler(),
  getPlatformGetTestConnectionConnectorIdentityMockHandler(),
  getPlatformListTablesTeamMockHandler(),
  getPlatformTableListRowsTeamMockHandler(),
  getPlatformTableRowByIdTeamMockHandler(),
  getPlatformTableSchemaTeamMockHandler(),
  getPlatformBatchTableSchemasTeamMockHandler(),
  getPlatformTableListColumnsTeamMockHandler(),
  getPlatformTableColumnListValuesTeamMockHandler(),
  getPlatformTableListFiltersTeamMockHandler(),
  getPlatformTableSaveFilterTeamMockHandler(),
  getPlatformTableListFilterTagsTeamMockHandler(),
  getPlatformTableListRelationsTeamMockHandler(),
  getPlatformGetTeamUsageSummaryMockHandler(),
  getPlatformGetGroupedTeamUsageSummaryMockHandler(),
  getPlatformListUsersByTeamMockHandler(),
  getPlatformUploadImageMockHandler(),
  getPlatformGetCurrentUserMockHandler(),
  getPlatformUpdateCurrentUserMockHandler(),
  getPlatformSendAnonymousEventMockHandler(),
  getPlatformAuthenticateLocalUserMockHandler(),
  getPlatformChangeLocalUserPasswordMockHandler(),
  getPlatformUpdateCustomerMockHandler(),
  getPlatformSendUserEventMockHandler(),
  getPlatformListCurrentUserInvitationsMockHandler(),
  getPlatformUserTOTPVerifyMockHandler(),
  getPlatformUserTOTPSetupMockHandler(),
  getPlatformUserTOTPDeleteMockHandler(),
  getPlatformGetCurrentLocalUserMockHandler(),
  getPlatformLoginUserMockHandler(),
  getPlatformLogoutUserMockHandler(),
  getPlatformGetCurrentUserMembershipsMockHandler(),
  getPlatformResetLocalUserPasswordMockHandler(),
  getPlatformCreateUserTokenMockHandler(),
  getPlatformDeleteUserMockHandler(),
  getPlatformAuthRegistryRequestMockHandler(),
  getPlatformCreateV2SyncDestinationTestConnectionMockHandler(),
  getPlatformCreateV2SyncDestinationMockHandler(),
  getPlatformGetV2SyncDestinationsMockHandler(),
  getPlatformGetV2SyncDestinationMockHandler(),
  getPlatformPatchV2SyncDestinationMockHandler(),
  getPlatformDeleteV2SyncDestinationMockHandler(),
  getPlatformListAllRBACPermissionsMockHandler(),
  getPlatformCreateRBACPermissionMockHandler(),
  getPlatformGetRBACPermissionMockHandler(),
  getPlatformUpdateRBACPermissionMockHandler(),
  getPlatformDeleteRBACPermissionMockHandler(),
  getPlatformListAllRBACRolesMockHandler(),
  getPlatformCreateRBACRoleMockHandler(),
  getPlatformGetRBACRoleMockHandler(),
  getPlatformUpdateRBACRoleMockHandler(),
  getPlatformDeleteRBACRoleMockHandler()
]
